import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources for different languages
const resources = {
  ko: {
    translation: {
      // Header Section
      "header.intro": "Intro",
      "header.demo": "Demo",
      "header.video": "logl movie",

      // Hero Section
      "hero.title": "언어 장벽을 없애고",
      "hero.description": "find your",
      "hero.demo": "데모 체험하기",
      "hero.prop1": "검증된 로컬 서비스",
      "hero.prop2": "실시간 AI 번역",
      "hero.prop3": "다양한 로컬 커뮤니티",

      // Introduction Section
      "introduction.title": "이런 고민 해본적 있나요?",
      "introduction.fst.role": "local",
      "introduction.snd.role": "global",

      "introduction.fst.name": "지민",
      "introduction.fst.location": "서울 대한민국",
      "introduction.fst.tag": "#외국어학습",
      "introduction.fst.story": '"영어 공부도 열심히 하고 어학연수까지 다녀왔는데... 쓸 데가 없으니 다 까먹었어요. 일상에서 쓸 기회만 있으면 좋겠어요😢"',

      "introduction.snd.name": "Sophie",
      "introduction.snd.location": "수원 대한민국",
      "introduction.snd.tag": "#현지인친구만들기",
      "introduction.snd.story": '"한국 와서 6개월 됐는데 아직도 같은 나라 친구들하고만 놀아요. 한국 친구들이랑 진짜 친해지고 싶은데 어떻게 시작해야 할지 모르겠어요."',

      "introduction.trd.name": "Carlos",
      "introduction.trd.location": "전주 대한민국",
      "introduction.trd.tag": "#로컬생활정보",
      "introduction.trd.story": '"유튜브 봐도 커뮤니티 들어가 봐도 우리 동네 정보는 없더라고요. 은행 개설, 통신사, 병원... 처음 정착할 때 정확한 최신 정보 어디서 얻죠?"',
      
      // App Menu Section
      "appMenu.home.local.title": "홈",
      "appMenu.home.local.subtitle": "우리 동네 글로벌 허브 되기",
      "appMenu.home.local.description": "내가 아는 동네 정보로 외국인 이웃들을 도우며 우리 지역을 진짜 글로벌 커뮤니티로 만들어보세요",
      "appMenu.home.local.points": [
        "숨겨진 맛집, 병원, 편의시설을 외국인에게 소개하기",
        "실시간 동네 소식과 이벤트 정보 공유하기",
        "글로벌 지수 높이며 우리 동네 국제화 선도하기",
      ],
      "appMenu.home.local.tip": "당신이 아는 작은 정보가 누군가에겐 소중한 생활 가이드가 됩니다",

      "appMenu.home.global.title": "home",
      "appMenu.home.global.subtitle": "한국 생활 맞춤 대시보드",
      "appMenu.home.global.description": "오늘 날씨부터 동네 인기글까지, 한국 생활에 꼭 필요한 정보를 한 화면에서 확인하세요",
      "appMenu.home.global.points": [
        "현지 날씨와 외출 팁으로 하루 계획 세우기",
        "우리 동네 실시간 소식과 도움 요청 먼저 확인하기",
        "한국인들 사이에서 인기인 글로벌 이야기 놓치지 않기",
      ],
      "appMenu.home.global.tip": "매일 5분 확인으로 한국 생활이 훨씬 편해집니다",

      "appMenu.mingl.local.title": "mingl",
      "appMenu.mingl.local.subtitle": "글로벌 친구와 대화하기",
      "appMenu.mingl.local.description": "외국인 질문에 답하고, 언어를 배우며 함께 문화를 나눠보세요",
      "appMenu.mingl.local.points": [
        "한국 생활 팁 공유하고 보람 느끼기",
        "자연스럽게 외국어 실력 향상하기",
        "다양한 문화권 친구들 사귀기"
      ],
      "appMenu.mingl.local.tip": "외국인 질문에 답하고, 언어를 배우며 함께 문화를 나눠보세요",

      "appMenu.mingl.global.title": "mingl",
      "appMenu.mingl.global.subtitle": "한국인과 자연스럽게 소통하기",
      "appMenu.mingl.global.description": "실시간 번역으로 언어 걱정 없이 한국 생활을 질문하고, 현지 친구를 만들어보세요",
      "appMenu.mingl.global.points": [
        "한국 생활 궁금증 실시간으로 해결하기",
        "AI 번역으로 언어 부담 없는 자연스러운 대화",
        "외국인 게토 벗어나 진짜 한국인 친구 사귀기"
      ],
      "appMenu.mingl.global.tip": "한국 문화를 배우며 현지 커뮤니티에 자연스럽게 스며들기",

      "appMenu.connect.local.title": "connect",
      "appMenu.connect.local.subtitle": "외국인 이웃 도와주고 친구만들기",
      "appMenu.connect.local.description": "우리 동네 외국인의 실생활 문제를 해결해주고 글로벌 네트워크를 만들어보세요",
      "appMenu.connect.local.points": [
        "은행, 집, 서류 등 실질적 생활 도움 제공",
        "도움을 주며 자연스럽게 글로벌 인맥 형성",
        "동네 글로벌 앰버서더로 의미있는 역할"
      ],
      "appMenu.connect.local.tip": "작은 도움으로 시작해서 진짜 글로벌 친구 관계 만들기",

      "appMenu.connect.global.title": "connect",
      "appMenu.connect.global.subtitle": "한국인 이웃과 문제 해결하기",
      "appMenu.connect.global.description": "은행, 집, 비자 등 급한 생활 문제를 신뢰할 수 있는 현지인과 함께 해결하세요",
      "appMenu.connect.global.points": [
        "은행 개설, 집 구하기 등 구체적 생활 문제 해결",
        "에이전트 없이 이웃과 캐주얼하게 도움 요청",
        "외국인 게토 벗어나 진짜 현지 생활 적응"
      ],
      "appMenu.connect.global.tip": "급한 문제일수록 현지 이웃의 도움이 가장 빠르고 확실",

      "appMenu.talk.local.title": "talk",
      "appMenu.talk.local.subtitle": "외국인 이웃과 실시간 대화하기",
      "appMenu.talk.local.description": "AI 번역으로 언어 걱정 없이 외국인과 1:1 채팅하며 진짜 글로벌 친구가 되어보세요",
      "appMenu.talk.local.points": [
        "AI 실시간 번역으로 언어 실력 상관없이 자연스러운 대화",
        "Connect 도움 요청에서 시작된 인연을 지속적인 우정으로 발전",
        "외국인 이웃의 한국 생활 고민을 직접 상담하고 조언",
      ],
      "appMenu.talk.local.tip": "작은 도움 대화가 평생 글로벌 인맥으로 이어집니다",

      "appMenu.talk.global.title": "talk",
      "appMenu.talk.global.subtitle": "한국인과 편안하게 소통하기",
      "appMenu.talk.global.description": "언어 장벽 없이 한국인 이웃과 실시간 채팅하며 궁금한 것을 바로바로 해결하세요",
      "appMenu.talk.global.points": [
        "한국 생활 궁금증을 한국인에게 직접 물어보고 즉시 답변 받기",
        "AI 번역으로 한국어 못해도 자연스럽고 편안한 대화 가능",
        "Connect에서 만난 도움 주는 이웃과 지속적인 소통으로 진짜 친구 되기",
      ],
      "appMenu.talk.global.tip": "작은 질문부터 시작해서 한국 생활의 든든한 조력자를 만드세요",

      "appMenu.passport.local.title": "passport",
      "appMenu.passport.local.subtitle": "나만의 글로벌 스토리 만들기",
      "appMenu.passport.local.description": "외국인 친구들과의 활동과 경험을 기록하며 여권 없이도 글로벌 정체성을 구축하세요",
      "appMenu.passport.local.points": [
        "우리 동네 글로벌 활동 타임라인 시각화하기",
        "외국인 도움 기록으로 글로벌 앰버서더 포트폴리오 구축",
        "언어 능력과 문화 교류 경험 체계적으로 관리",
      ],
      "appMenu.passport.local.tip": "작은 도움도 기록하며 나만의 글로벌 여정 스토리가 완성",

      "appMenu.passport.global.title": "passport",
      "appMenu.passport.global.subtitle": "글로벌 정체성 - 디지털 명함",
      "appMenu.passport.global.description": "나의 다국적 경험과 여정을 시각적으로 보여주며 신뢰할 수 있는 프로필을 만드세요",
      "appMenu.passport.global.points": [
        "거주 이력과 글로벌 경험 한눈에 시각화",
        "언어 능력과 문화적 배경으로 신뢰성 구축",
        "비슷한 경험 가진 사람들과 자연스럽게 연결"
      ],
      "appMenu.passport.global.tip": "상세한 프로필일수록 더 나은 현지 도움과 진정한 친구를 만날 수 있어요",

      // Demo Section
      "common.viewAll": "전체보기",
      "common.minutesAgo": "분 전",

      "home.tag": "플리마켓",
      "home.greeting_01": "Carlos 님",
      "home.greeting_02": "오늘 하루도",
      
      "home.weather.maxTemp": "최고 15°",
      "home.weather.minTemp": "최저 10°",

      "home.weather.morning": "☀️",
      "home.weather.morningWeather": "청명함",
      "home.weather.afternoon": "🌘",
      "home.weather.afternoonWeather": "흐림",
      "home.weather.fineDust": "💨",
      "home.weather.fineDustLevel": "보통",

      "home.mytown.title": "실시간 우리동네",
      "home.mytown.places.0.name": "은행나무시장",
      "home.mytown.places.0.address": "금천구 시흥동",
      "home.mytown.places.1.name": "관악산",
      "home.mytown.places.1.address": "관악구 신림동",
      "home.mytown.places.2.name": "안양천다목적광장",
      "home.mytown.places.2.address": "금천구 독선동",

      "home.events.title": "우리동네 이벤트",
      "home.events.post_title": "독산동 플리마켓 진행합니다",
      "home.events.address": "금천구 독산동",

      "mingl.posts.0.category": "생활정보",
      "mingl.posts.0.title": "금천구청역 순대차 아저씨 어디있나요?",
      "mingl.posts.0.content": "진짜 인생순대였는데, 요즘 통 안보이시네요. 어디계신지 모르겠어요",

      "mingl.posts.1.category": "생활정보",
      "mingl.posts.1.title": "독산동 재래시장 장보기 꿀팁",
      "mingl.posts.1.content": "독산 전통시장에서 자주 장을 보는데, 요일별로 가격 차이가 좀 있네요. 어떻게 장보는게 좋을까요?",

      "mingl.posts.2.category": "일상",
      "mingl.posts.2.title": "가산디지털단지 근처 점심 뭐 먹을까?",
      "mingl.posts.2.content": "오늘따라 메뉴 정하기 너무 힘드네요. 가산역 근처 직장인들은 어떻게 먹고 있나요?",

      "mingl.posts.3.category": "취미/모임",
      "mingl.posts.3.title": "가산역 보드게임 모임 사람 구해요",
      "mingl.posts.3.content": "매주 금요일 저녁에 가산역 근처에서 보드게임 모임을 하고 있습니다. 참여해주실 분 구합니다.",

      "mingl.posts.4.category": "여행/나들이",
      "mingl.posts.4.title": "호암산 둘레길 주말 산책 코스 추천",
      "mingl.posts.4.content": "이번 주말에 가볍게 산책할 만한 곳 찾다가 호암산 둘레길을 알게 되었어요. 이번에 제가 발견한 가볍게 산책하듯이 즐길 수 있는 코스를 추천합니다",

      "mingl.posts.5.category": "일상",
      "mingl.posts.5.title": "독산동 근처 조용한 카페 추천해주세요",
      "mingl.posts.5.content": "독산동에서 조용하게 작업할 수 있는 카페 찾고 있어요. 와이파이 잘 되고 콘센트 있는 곳 있으면 추천 부탁드립니다",

      "mingl.posts.6.category": "생활정보",
      "mingl.posts.6.title": "가산동 근처 헬스장 추천 부탁드려요",
      "mingl.posts.6.content": "가산디지털단지 근처에서 헬스장 다니는 분 계신가요? 월 회비나 시설 좋은 곳 있으면 추천 부탁드립니다",

      "mingl.posts.7.category": "취미/모임",
      "mingl.posts.7.title": "관악산 등산 모임 같이 가실 분 구해요",
      "mingl.posts.7.content": "이번 주말에 관악산 등산 가려고 하는데 같이 가실 분 구합니다. 초보자 환영이고 편하게 산책하듯이 갈 예정입니다",

      "connect.titles.0": "언어교환",
      "connect.titles.1": "생활적응",
      "connect.titles.2": "중고거래",
      "connect.titles.3": "구인·구직",
      "connect.titles.3.category": "아르바이트",


      "connect.posts.0.title": "한국어-일본어 비즈니스 회화 서로 언어교환하실 분 구해요!",
      "connect.posts.0.reward": "일본어",
      "connect.posts.0.reward_detail": "동일시간 협의",
      "connect.posts.0.location": "성북동 카페",

      "connect.posts.1.title": "스페인어 원어민 구해요! 대화 연습 도와주세요~",
      "connect.posts.1.reward": "상품권",
      "connect.posts.1.reward_detail": "50,000원 / 건",
      "connect.posts.1.location": "금천구청역",

      "connect.posts.2.title": "인천공항에서 서울-마포역까지 지하철 안내해 주실 분 구해요",
      "connect.posts.2.reward": "물건",
      "connect.posts.2.reward_detail": "스페인 와인",
      "connect.posts.2.location": "인천공항",

      "connect.posts.3.title": "원룸 계약서 작성하는데 함께 가실 분 있나요?",
      "connect.posts.3.reward": "현금",
      "connect.posts.3.reward_detail": "10,000원 / 시급",
      "connect.posts.3.location": "서울 영등포 양천역",

      "connect.posts.4.title": "몽키드라이버 하루만 빌려주세요! 제가 만든 깍두기 한접시 드려요",
      "connect.posts.4.reward": "물건",
      "connect.posts.4.reward_detail": "직접담근 깍두기",
      "connect.posts.4.location": "마포구 서교동",

      "connect.posts.5.title": "자전거 판매합니다! 사용감 적어요",
      "connect.posts.5.reward": "가격",
      "connect.posts.5.reward_detail": "50,000원",
      "connect.posts.5.location": "신촌역 근처",

      "connect.posts.6.title": "박람회 단기 알바 모집합니다. 영어 가능자 우대",
      "connect.posts.6.reward": "업무",
      "connect.posts.6.reward_detail": "박람회 현장 지원 및 영어 안내",
      "connect.posts.6.location": "코엑스",

      "connect.posts.7.title": "스페인어 가능 바리스타 구합니다. 스페인어 원어민 외국인 우선 채용합니다!",
      "connect.posts.7.reward": "시급",
      "connect.posts.7.reward_detail": "10,000원 부터",
      "connect.posts.7.location": "이태원 카페",

      "passport.introduction": "한국 예능을 보고 한국어를 독학하기 시작했고, 멕시코에서 열린 한국어 말하기 대회에서 1등을 하면서 한국행을 결심했습니다!",
      "passport.gender": "성별",
      "passport.gender_detail": "남성",
      "passport.birth": "생년월일",
      "passport.birth_detail": "1994.04.24",
      "passport.nationality": "국적",
      "passport.nationality_detail": "Mexico",
      "passport.mother_tongue": "모국어",
      "passport.mother_tongue_detail": "Spanish",
      "passport.language": "외국어",
      "passport.language_detail.0": "Korean",
      "passport.language_detail.1": "English",
      "passport.edit": "편집하기",
      "passport.share": "공유하기",

      // Positioned Mobile Demo Section
      "positionedMobileDemo.home.description": "‘우리동네 뉴스’처럼 내 동네의 지금을 한 번에 체크하세요",
      "positionedMobileDemo.home.features.0.description": "내 동네의 실시간 소식과 이벤트를 놓치지 않고 확인",
      "positionedMobileDemo.home.features.1.description": "특정 장소를 중심으로 주민들의 일상과 소소한 이야기들을 탐색",
      "positionedMobileDemo.home.features.2.description": "축제, 모임, 이벤트 등 내가 있는 지역의 크고 작은 활동에 쉽게 합류",

      "positionedMobileDemo.mingl.description": "우리동네 실제 일상을 장소 기반으로 탐색하고 공유하세요",
      "positionedMobileDemo.mingl.features.0.description": "질문·정보·소식·추천을 자유롭게 공유하며 자연스러운 교류",
      "positionedMobileDemo.mingl.features.1.description": "실시간 번역으로 언어 장벽 없는 진정한 글로벌 소통",
      "positionedMobileDemo.mingl.features.2.description": "로컬의 시선으로 본 세계, 글로벌의 시선으로 본 로컬",

      "positionedMobileDemo.connect.description": "도움을 주고받는 순간, 이어져보세요",
      "positionedMobileDemo.connect.features.0.description": "필요한 도움을 바로 구하고 받을 수 있는 동네 기반 매칭",
      "positionedMobileDemo.connect.features.1.description": "내 상황에 맞는 ‘안전하고 믿을 수 있는’ 사람을 스스로 선택",
      "positionedMobileDemo.connect.features.2.description": "대화 → 교류 → 지속적인 로컬·글로벌 관계로 확장",

      "positionedMobileDemo.talk.description": "AI 번역으로 언어 걱정 없이 글로벌 친구를 만나보세요",
      "positionedMobileDemo.talk.features.0.description": "AI 실시간 번역으로 언어 실력 상관없이 자연스러운 대화",
      "positionedMobileDemo.talk.features.1.description": "한국 생활 궁금증을 한국인에게 직접 물어보고 즉시 답변 받기",
      "positionedMobileDemo.talk.features.2.description": "Connect 도움 요청에서 시작된 인연을 지속적인 우정으로 발전",

      "positionedMobileDemo.passport.description": "내 글로벌 이력을 담은 디지털 명함을 만들어보세요",
      "positionedMobileDemo.passport.features.0.description": "지역별 거주 이력과 활동을 타임라인으로 기록",
      "positionedMobileDemo.passport.features.1.description": "언어 능력과 소통 스타일을 명확하게 표현",
      "positionedMobileDemo.passport.features.2.description": "비슷한 경험 가진 사람들과 자연스럽게 연결",

      // Logl Video Section
      "loglVideo.title": "logl 소개 영상",
      "loglVideo.description": "logl이 뭔지 궁금하다면? 영상부터 만나보세요!",
      "loglVideo.watch": "영상 보러 가기",
    }
  },
  en: {
    translation: {
      // Header Section
      "header.intro": "Intro",
      "header.demo": "Demo",
      "header.video": "logl movie",

      // Hero Section
      "hero.title": "Break Bubbles,",
      "hero.description": "find your",
      "hero.demo": "Try Interactive Demo",
      "hero.prop1": "Verified Local Services",
      "hero.prop2": "Real-time AI Translation",
      "hero.prop3": "Diverse Local Communities",

      // Introduction Section
      "introduction.title": "Have you ever had this problem?",
      "introduction.fst.local": "local",
      "introduction.snd.global": "global",

      "introduction.fst.name": "Jimin",
      "introduction.fst.location": "Seoul, South Korea",
      "introduction.fst.tag": "#Language Learning",
      "introduction.fst.story": '"I\'ve studied English and attended language schools, but I\'ve forgotten everything. I wish I had more opportunities to use it in everyday life😢"',

      "introduction.snd.name": "Sophie",
      "introduction.snd.location": "Suwon, South Korea",
      "introduction.snd.tag": "#Making Friends with Locals",
      "introduction.snd.story": '"I\'ve been in Korea for 6 months, but I still only hang out with friends from my own country. I want to get closer to Korean friends, but I don\'t know how to start."',

      "introduction.trd.name": "Carlos",
      "introduction.trd.location": "Jeonju, South Korea",
      "introduction.trd.tag": "#Local Life Information",
      "introduction.trd.story": '"I can\'t find any information about my neighborhood on YouTube or community sites. I need information about banks, telecom companies, hospitals... I don\'t know where to get the latest information when I settle down."',

      // App Menu Section
      "appMenu.home.local.title": "Home",
      "appMenu.home.local.subtitle": "Turn Our Neighborhood into a Global Hub",
      "appMenu.home.local.description": "Use what you know about your area to help foreign neighbors and grow a truly global community.",
      "appMenu.home.local.points": [
        "Introduce hidden gems, clinics, and everyday facilities to foreigners",
        "Share real-time local news and event info",
        "Lead our neighborhood’s internationalization by raising its global index"
      ],
      "appMenu.home.local.tip": "Your small piece of local knowledge can be someone’s essential life guide.",

      "appMenu.home.global.title": "Home",
      "appMenu.home.global.subtitle": "A Dashboard Tailored for Life in Korea",
      "appMenu.home.global.description": "From today’s weather to trending local posts—see everything you need for life in Korea on one screen.",
      "appMenu.home.global.points": [
        "Plan your day with local weather and outing tips",
        "Check real-time neighborhood updates and help requests first",
        "Don’t miss global stories popular among Koreans"
      ],
      "appMenu.home.global.tip": "Just 5 minutes a day makes life in Korea much easier.",

      "appMenu.mingl.local.title": "mingl",
      "appMenu.mingl.local.subtitle": "Chat with Global Friends",
      "appMenu.mingl.local.description": "Answer foreigners’ questions, learn languages, and share cultures together.",
      "appMenu.mingl.local.points": [
        "Share Korea life tips and feel the impact you make",
        "Improve your foreign-language skills naturally",
        "Make friends from diverse cultures"
      ],
      "appMenu.mingl.local.tip": "Answer questions, learn languages, and share culture together.",

      "appMenu.mingl.global.title": "mingl",
      "appMenu.mingl.global.subtitle": "Communicate Naturally with Koreans",
      "appMenu.mingl.global.description": "Ask about life in Korea without language barriers using real-time translation, and make local friends.",
      "appMenu.mingl.global.points": [
        "Get your questions about life in Korea answered on the spot",
        "Enjoy natural conversations with AI translation—no language stress",
        "Break out of the expat bubble and make real Korean friends"
      ],
      "appMenu.mingl.global.tip": "Learn Korean culture and blend into the local community naturally.",

      "appMenu.connect.local.title": "connect",
      "appMenu.connect.local.subtitle": "Help Foreign Neighbors & Make Friends",
      "appMenu.connect.local.description": "Solve real-life challenges for foreigners in your area and build a global network.",
      "appMenu.connect.local.points": [
        "Provide practical help with banking, housing, and paperwork",
        "Form a global network naturally through helping",
        "Play a meaningful role as a neighborhood global ambassador"
      ],
      "appMenu.connect.local.tip": "Start with small help—grow into real global friendships.",

      "appMenu.connect.global.title": "connect",
      "appMenu.connect.global.subtitle": "Solve Problems with Local Neighbors",
      "appMenu.connect.global.description": "Handle urgent needs—banking, housing, visas—together with trustworthy locals.",
      "appMenu.connect.global.points": [
        "Tackle concrete tasks like opening a bank account or finding housing",
        "Ask neighbors for casual help—no agency needed",
        "Move beyond the expat bubble and adapt to real local life"
      ],
      "appMenu.connect.global.tip": "For urgent issues, help from local neighbors is the fastest and most reliable.",

      "appMenu.talk.local.title": "talk",
      "appMenu.talk.local.subtitle": "Chat with Foreign Neighbors in Real Time",
      "appMenu.talk.local.description": "Use AI translation for stress-free 1:1 chats and become true global friends.",
      "appMenu.talk.local.points": [
        "Have natural conversations regardless of language level with real-time AI translation",
        "Turn connections from connect requests into lasting friendships",
        "Directly counsel and advise on Korea-life concerns"
      ],
      "appMenu.talk.local.tip": "A small helpful chat can become a lifelong global connection.",

      "appMenu.talk.global.title": "talk",
      "appMenu.talk.global.subtitle": "Chat Comfortably with Koreans",
      "appMenu.talk.global.description": "Message local Koreans in real time without language barriers and get instant answers.",
      "appMenu.talk.global.points": [
        "Ask Koreans directly and get immediate answers about life in Korea",
        "Enjoy natural, comfortable chats even without Korean using AI translation",
        "Keep in touch with helpful neighbors you met through connect and become real friends"
      ],
      "appMenu.talk.global.tip": "Start with small questions and find a reliable partner for life in Korea.",

      "appMenu.passport.local.title": "passport",
      "appMenu.passport.local.subtitle": "Build Your Own Global Story",
      "appMenu.passport.local.description": "Record activities and experiences with foreign friends and shape a global identity—no physical passport needed.",
      "appMenu.passport.local.points": [
        "Visualize your neighborhood’s global activities on a timeline",
        "Build a Global Ambassador portfolio with your help records",
        "Systematically manage language skills and cultural-exchange experiences"
      ],
      "appMenu.passport.local.tip": "Record even small acts of help—complete your global journey story.",

      "appMenu.passport.global.title": "passport",
      "appMenu.passport.global.subtitle": "Global Identity — Your Digital Card",
      "appMenu.passport.global.description": "Showcase your multinational experiences visually and build a trustworthy profile.",
      "appMenu.passport.global.points": [
        "Visualize residence history and global experiences at a glance",
        "Build credibility with language skills and cultural background",
        "Connect naturally with people who share similar experiences"
      ],
      "appMenu.passport.global.tip": "The more detailed your profile, the better local support and truer friends you’ll find.",

      // Demo Section
      "common.viewAll": "View All",
      "common.minutesAgo": "minutes ago",
    
      "home.tag": "Flea Market",
      "home.greeting_01": "Carlos",
      "home.greeting_02": "What's up?",
    
      "home.weather.maxTemp": "High 15°",
      "home.weather.minTemp": "Low 10°",
      "home.weather.morning": "☀️",
      "home.weather.morningWeather": "Clear",
      "home.weather.afternoon": "🌘",
      "home.weather.afternoonWeather": "Cloudy",
      "home.weather.fineDust": "💨",
      "home.weather.fineDustLevel": "Normal",
    
      "home.mytown.title": "Real-time in My town",
      "home.mytown.places.0.name": "Ginkgo Market",
      "home.mytown.places.0.address": "Siheung-dong, Geumcheon-gu",
      "home.mytown.places.1.name": "Gwanak Mountain",
      "home.mytown.places.1.address": "Sillim-dong, Gwanak-gu",
      "home.mytown.places.2.name": "Anyangcheon Multipurpose Plaza",
      "home.mytown.places.2.address": "Dokseon-dong, Geumcheon-gu",
    
      "home.events.title": "Local Events",
      "home.events.post_title": "Flea Market in Doksan-dong",
      "home.events.address": "Doksan-dong, Geumcheon-gu",
    
      "mingl.posts.0.category": "Local Tips",
      "mingl.posts.0.title": "Where did the sundae cart man near Geumcheon District Office Station go?",
      "mingl.posts.0.content": "It was seriously the best sundae... haven't seen him lately. Does anyone know where he is?",
    
      "mingl.posts.1.category": "Local Tips",
      "mingl.posts.1.title": "Doksan Traditional Market grocery shopping tips",
      "mingl.posts.1.content": "I shop often at the market, and prices vary by day. Any strategies to shop better?",
    
      "mingl.posts.2.category": "Daily Life",
      "mingl.posts.2.title": "Lunch near Gasan Digital Complex?",
      "mingl.posts.2.content": "Having a hard time choosing today. What do people around Gasan usually eat?",
    
      "mingl.posts.3.category": "Hobby / Meetup",
      "mingl.posts.3.title": "Board game meetup near Gasan Station",
      "mingl.posts.3.content": "We meet every Friday evening near Gasan Station. Looking for participants!",
    
      "mingl.posts.4.category": "Travel / Outing",
      "mingl.posts.4.title": "Hoamsan walking trail weekend course",
      "mingl.posts.4.content": "Found a relaxing trail around Hoamsan. Sharing my recommended weekend course!",
    
      "mingl.posts.5.category": "Daily Life",
      "mingl.posts.5.title": "Quiet café near Doksan-dong?",
      "mingl.posts.5.content": "Looking for a café with good Wi-Fi and outlets for work. Any recommendations?",
    
      "mingl.posts.6.category": "Local Tips",
      "mingl.posts.6.title": "Gym recommendations near Gasan-dong",
      "mingl.posts.6.content": "Anyone attending gyms around Gasan Digital Complex? Looking for good facilities or reasonable fees.",
    
      "mingl.posts.7.category": "Hobby / Meetup",
      "mingl.posts.7.title": "Gwanaksan hiking group",
      "mingl.posts.7.content": "Going hiking this weekend. Beginners welcome! Looking for companions.",
    
      "connect.titles.0": "Language",
      "connect.titles.1": "Local Support",
      "connect.titles.2": "Deals",
      "connect.titles.3": "Jobs",
      "connect.titles.3.category": "Part-time",
    
      "connect.posts.0.title": "Korean-Japanese business conversation exchange partner wanted",
      "connect.posts.0.reward": "Language Exchange",
      "connect.posts.0.reward_detail": "Time negotiable",
      "connect.posts.0.location": "Cafe in Seongbuk-dong",
    
      "connect.posts.1.title": "Looking for a Spanish native speaker for conversation practice",
      "connect.posts.1.reward": "Gift Card",
      "connect.posts.1.reward_detail": "50,000 KRW / session",
      "connect.posts.1.location": "Geumcheon District Office Station",
    
      "connect.posts.2.title": "Need help navigating from Incheon Airport to Mapo",
      "connect.posts.2.reward": "Item",
      "connect.posts.2.reward_detail": "Spanish Wine",
      "connect.posts.2.location": "Incheon Airport",
    
      "connect.posts.3.title": "Need someone to assist with a one-room rental contract",
      "connect.posts.3.reward": "Cash",
      "connect.posts.3.reward_detail": "10,000 KRW / hour",
      "connect.posts.3.location": "Yangcheon Station, Yeongdeungpo, Seoul",
    
      "connect.posts.4.title": "Looking to borrow a Monkey Driver for one day — offering homemade radish kimchi",
      "connect.posts.4.reward": "Item",
      "connect.posts.4.reward_detail": "Homemade kimchi",
      "connect.posts.4.location": "Seogyo-dong, Mapo-gu",
    
      "connect.posts.5.title": "Selling a bicycle — lightly used",
      "connect.posts.5.reward": "Price",
      "connect.posts.5.reward_detail": "50,000 KRW",
      "connect.posts.5.location": "Near Sinchon Station",
    
      "connect.posts.6.title": "Short-term expo part-time job — English speakers preferred",
      "connect.posts.6.reward": "Work",
      "connect.posts.6.reward_detail": "On-site support and English guidance",
      "connect.posts.6.location": "COEX",
    
      "connect.posts.7.title": "Barista with Spanish preferred (Spanish-native foreigners welcome!)",
      "connect.posts.7.reward": "Hourly Wage",
      "connect.posts.7.reward_detail": "From 10,000 KRW",
      "connect.posts.7.location": "Itaewon Café",
    
      "passport.introduction": "I started learning Korean after watching Korean variety shows, and after winning first place in a Korean speech contest in Mexico, I decided to move to Korea!",
      "passport.gender": "Gender",
      "passport.gender_detail": "Male",
      "passport.birth": "Date of Birth",
      "passport.birth_detail": "1994.04.24",
      "passport.nationality": "Nationality",
      "passport.nationality_detail": "Mexico",
      "passport.mother_tongue": "Native Language",
      "passport.mother_tongue_detail": "Spanish",
      "passport.language": "Foreign Language",
      "passport.language_detail.0": "Korean",
      "passport.language_detail.1": "English",
      "passport.edit": "Edit",
      "passport.share": "Share",

      // Positioned Mobile Demo Section
      "positionedMobileDemo.home.description": "Check what's happening in your neighborhood at a glance",
      "positionedMobileDemo.home.features.0.description": "Stay updated on local news and events",
      "positionedMobileDemo.home.features.1.description": "Discover everyday stories shared around familiar places",
      "positionedMobileDemo.home.features.2.description": "Join local activities like festivals, meetups, and events",

      "positionedMobileDemo.mingl.description": "Explore and share real local moments by place",
      "positionedMobileDemo.mingl.features.0.description": "Share questions, tips, news, and recommendations freely",
      "positionedMobileDemo.mingl.features.1.description": "Talk globally with real-time translation",
      "positionedMobileDemo.mingl.features.2.description": "See your neighborhood from both local and global perspectives",

      "positionedMobileDemo.connect.description": "Connect when you need or give help",
      "positionedMobileDemo.connect.features.0.description": "Find or offer help in your area instantly",
      "positionedMobileDemo.connect.features.1.description": "Choose someone trustworthy for your situation",
      "positionedMobileDemo.connect.features.2.description": "Grow connections from chat → exchange → lasting relationships",

      "positionedMobileDemo.talk.description": "Make global friends without language barriers",
      "positionedMobileDemo.talk.features.0.description": "Have natural conversations with real-time AI translation",
      "positionedMobileDemo.talk.features.1.description": "Ask locals about life here and get answers instantly",
      "positionedMobileDemo.talk.features.2.description": "Turn a Connect conversation into a lasting friendship",

      "positionedMobileDemo.passport.description": "Create your digital profile that shows your global journey",
      "positionedMobileDemo.passport.features.0.description": "Record where you've lived and what you've done on a timeline",
      "positionedMobileDemo.passport.features.1.description": "Show your language ability and communication style clearly",
      "positionedMobileDemo.passport.features.2.description": "Connect naturally with people who share similar experiences",
      

      // Logl Video Section
      "loglVideo.title": "logl introduction video",
      "loglVideo.description": "If you are curious about logl, watch the video first!",
      "loglVideo.watch": "Watch the video",
    }
  },
  ja: {
    translation: {
      // Header Section
      "header.intro": "はじめに",
      "header.demo": "デモ",
      "header.video": "紹介動画",
      
      // Hero Section
      "hero.title": "バブルを壊す,",
      "hero.description": "find your",
      "hero.demo": "インタラクティブデモを体験",  
      "hero.prop1": "検証済みのローカルサービス",
      "hero.prop2": "リアルタイムAI翻訳",
      "hero.prop3": "多様なローカルコミュニティ",

      // Introduction Section
      "introduction.title": "こんな悩み、ありませんか？",
      "introduction.fst.local": "ローカル",
      "introduction.snd.global": "グローバル",

      "introduction.fst.name": "ジミン",
      "introduction.fst.location": "韓国・ソウル",
      "introduction.fst.tag": "#外国語学習",
      "introduction.fst.story": "「英語の勉強も頑張って、留学までしたのに……使う機会がなくてどんどん忘れていきます。日常で使える場があればいいのに😢」",

      "introduction.snd.name": "Sophie",
      "introduction.snd.location": "韓国・水原",
      "introduction.snd.tag": "#現地の友だち作り",
      "introduction.snd.story": "「韓国に来て6か月になりますが、いまだに同じ国の友だちとばかり過ごしています。韓国の友だちと本当に仲良くなりたいのに、どう近づけいけばいいのかわかりません。」",

      "introduction.trd.name": "Carlos",
      "introduction.trd.location": "韓国・全南",
      "introduction.trd.tag": "#ローカル生活情報",
      "introduction.trd.story": "「YouTubeを見てもコミュニティに入っても、自分の町の情報は見つかりません。銀行口座の開設、通信キャリア、病院……最初に定着するとき、正確で最新の情報はどこで手に入りますか？」",

      // App Menu Section
      "appMenu.home.local.title": "home",
      "appMenu.home.local.subtitle": "私たちの街をグローバルハブへ",
      "appMenu.home.local.description": "あなたの街の情報で外国人のご近所さんを助け、地域を本当のグローバルコミュニティにしてみましょう。",
      "appMenu.home.local.points": [
        "隠れた名店・病院・生活施設を外国人に紹介する",
        "リアルタイムな街のニュースやイベント情報を共有する",
        "グローバル指数を高め、地域の国際化をリードする"
      ],
      "appMenu.home.local.tip": "あなたが知っている小さな情報が、誰かの大切な生活ガイドになります。",

      "appMenu.home.global.title": "ホーム",
      "appMenu.home.global.subtitle": "韓国生活に特化したダッシュボード",
      "appMenu.home.global.description": "今日の天気から近所の人気投稿まで、韓国生活に欠かせない情報を1画面で確認できます。",
      "appMenu.home.global.points": [
        "現地の天気と外出ヒントで一日の計画を立てる",
        "地域のリアルタイム情報やヘルプ依頼をいち早くチェック",
        "韓国の人々の間で話題のグローバル投稿を見逃さない"
      ],
      "appMenu.home.global.tip": "毎日5分のチェックで、韓国生活がぐっと楽になります。",

      "appMenu.mingl.local.title": "mingl",
      "appMenu.mingl.local.subtitle": "グローバルな友だちと会話しよう",
      "appMenu.mingl.local.description": "外国人の質問に答え、言語を学びながら一緒に文化を分かち合いましょう。",
      "appMenu.mingl.local.points": [
        "韓国生活のコツを共有してやりがいを感じる",
        "自然に外国語力を伸ばす",
        "多様な文化圏の友だちをつくる"
      ],
      "appMenu.mingl.local.tip": "外国人の質問に答え、言語を学びながら文化を分かち合いましょう。",

      "appMenu.mingl.global.title": "mingl",
      "appMenu.mingl.global.subtitle": "韓国人と自然にコミュニケーション",
      "appMenu.mingl.global.description": "リアルタイム翻訳で言語の心配なく質問でき、現地の友だちをつくれます。",
      "appMenu.mingl.global.points": [
        "韓国生活の疑問をその場で解決",
        "AI翻訳で言語負担のない自然な会話",
        "同郷だけのコミュニティに閉じこもらず本当の韓国人の友だちづくり"
      ],
      "appMenu.mingl.global.tip": "韓国文化を学びながら、現地コミュニティに自然に溶け込もう。",

      "appMenu.connect.local.title": "connect",
      "appMenu.connect.local.subtitle": "外国人のご近所さんを助けて友だちづくり",
      "appMenu.connect.local.description": "地域の外国人の実生活の課題を解決し、グローバルなネットワークを築きましょう。",
      "appMenu.connect.local.points": [
        "銀行・住まい・書類など実務的な生活支援",
        "助け合いを通じて自然にグローバルな人脈形成",
        "地域のグローバル・アンバサダーとして意味ある役割"
      ],
      "appMenu.connect.local.tip": "小さな支援から、本物のグローバルな友人関係へ。",

      "appMenu.connect.global.title": "connect",
      "appMenu.connect.global.subtitle": "韓国人のご近所さんと課題を解決",
      "appMenu.connect.global.description": "銀行・住まい・ビザなど差し迫った生活課題を、信頼できる現地の人と一緒に解決しましょう。",
      "appMenu.connect.global.points": [
        "銀行口座開設・住居探しなど具体的な課題を解決",
        "エージェントなしで近所の人に気軽にヘルプ依頼",
        "同郷コミュニティだけに偏らず本当の現地適応へ"
      ],
      "appMenu.connect.global.tip": "急ぎの用事ほど、現地のご近所さんの助けが早くて確実。",

      "appMenu.talk.local.title": "talk",
      "appMenu.talk.local.subtitle": "外国人のご近所さんとリアルタイムに会話",
      "appMenu.talk.local.description": "AI翻訳で言語の不安なく1対1チャット。本当のグローバルフレンドになりましょう。",
      "appMenu.talk.local.points": [
        "AIリアルタイム翻訳で語学力に関係なく自然な会話",
        "connectのヘルプから始まった縁を継続的な友情へ発展",
        "外国人の韓国生活の悩みを直接相談・アドバイス"
      ],
      "appMenu.talk.local.tip": "小さな助けの会話が、一生もののグローバル人脈につながります。",

      "appMenu.talk.global.title": "talk",
      "appMenu.talk.global.subtitle": "韓国人と気楽にコミュニケーション",
      "appMenu.talk.global.description": "言語の壁なく韓国人のご近所さんとリアルタイムでチャットし、疑問をすぐ解決できます。",
      "appMenu.talk.global.points": [
        "韓国生活の疑問を韓国人に直接聞いて即回答をもらう",
        "AI翻訳で韓国語ができなくても自然で快適な会話が可能",
        "connectで出会った助けてくれるご近所さんと継続的に交流し本当の友だちに"
      ],
      "appMenu.talk.global.tip": "小さな質問から始めて、韓国生活の心強いパートナーを見つけよう。",

      "appMenu.passport.local.title": "passport",
      "appMenu.passport.local.subtitle": "自分だけのグローバルストーリーをつくる",
      "appMenu.passport.local.description": "外国人の友だちとの活動・経験を記録し、パスポートなしでもグローバルなアイデンティティを築きましょう。",
      "appMenu.passport.local.points": [
        "地域でのグローバル活動をタイムラインで可視化",
        "支援の記録でグローバル・アンバサダーのポートフォリオを構築",
        "語学力と文化交流の経験を体系的に管理"
      ],
      "appMenu.passport.local.tip": "小さな支援も記録して、あなたのグローバルな旅の物語を完成させよう。",

      "appMenu.passport.global.title": "passport",
      "appMenu.passport.global.subtitle": "グローバル・アイデンティティ ― デジタル名刺",
      "appMenu.passport.global.description": "多国籍な経験と歩みを視覚的に示し、信頼できるプロフィールを作りましょう。",
      "appMenu.passport.global.points": [
        "居住履歴とグローバル経験をひと目で可視化",
        "語学力と文化的バックグラウンドで信頼性を構築",
        "似た経験を持つ人と自然につながる"
      ],
      "appMenu.passport.global.tip": "詳しいプロフィールほど、より良い現地サポートと本物の友人に出会えます。",

      // Demo Section
      "common.viewAll": "すべて見る",
      "common.minutesAgo": "分前",
    
      "home.tag": "フリーマーケット",
      "home.greeting_01": "Carlos さん",
      "home.greeting_02": "今日も良い一日を",
    
      "home.weather.morningWeather": "Clear",
      "home.weather.afternoonWeather": "Cloudy",
      
      
      "home.weather.maxTemp": "最高 15°",
      "home.weather.minTemp": "最低 10°",
      "home.weather.morning": "☀️",
      "home.weather.morningWeather": "晴れ",
      "home.weather.afternoon": "🌘",
      "home.weather.afternoonWeather": "くもり",
      "home.weather.fineDust": "💨",
      "home.weather.fineDustLevel": "普通",
    
      "home.mytown.title": "リアルタイム まちの様子",
      "home.mytown.places.0.name": "イチョウ市場",
      "home.mytown.places.0.address": "ソウル 金泉区 時興洞",
      "home.mytown.places.1.name": "冠岳山",
      "home.mytown.places.1.address": "ソウル 冠岳区 新林洞",
      "home.mytown.places.2.name": "安養川 多目的広場",
      "home.mytown.places.2.address": "ソウル 金泉区 独善洞",
    
      "home.events.title": "まちのイベント",
      "home.events.post_title": "独山洞でフリーマーケットを開催します",
      "home.events.address": "ソウル 金泉区 独山洞",
    
      "mingl.posts.0.category": "生活情報",
      "mingl.posts.0.title": "金泉区庁駅のスンデ屋台のおじさん、どこにいますか？",
      "mingl.posts.0.content": "本当に最高のスンデでした…最近見かけません。ご存じの方いますか？",
    
      "mingl.posts.1.category": "生活情報",
      "mingl.posts.1.title": "独山伝統市場での買い物コツ",
      "mingl.posts.1.content": "曜日によって値段が結構変わります。上手に買うコツを知りたいです。",
    
      "mingl.posts.2.category": "日常",
      "mingl.posts.2.title": "加山デジタル団地周辺のランチおすすめは？",
      "mingl.posts.2.content": "今日は特に迷っています。周辺の会社員は何を食べていますか？",
    
      "mingl.posts.3.category": "趣味・集まり",
      "mingl.posts.3.title": "加山駅でボードゲーム会　一緒にどうですか？",
      "mingl.posts.3.content": "毎週金曜日の夜に集まっています。参加者募集中！",
    
      "mingl.posts.4.category": "旅行・お出かけ",
      "mingl.posts.4.title": "虎岩山の散策コースおすすめ",
      "mingl.posts.4.content": "週末に気軽に歩けるコースを見つけました。おすすめルートを共有します！",
    
      "mingl.posts.5.category": "日常",
      "mingl.posts.5.title": "独山洞付近で静かなカフェありませんか？",
      "mingl.posts.5.content": "Wi-Fiがよくてコンセントがある作業向きのカフェを探しています。おすすめお願いします。",
    
      "mingl.posts.6.category": "生活情報",
      "mingl.posts.6.title": "加山洞近くのジム おすすめありますか？",
      "mingl.posts.6.content": "施設が良いか、月会費がよいところをご存じなら教えてください。",
    
      "mingl.posts.7.category": "趣味・集まり",
      "mingl.posts.7.title": "冠岳山 ハイキング 一緒に行きましょう",
      "mingl.posts.7.content": "今週末に行きます。初心者歓迎！一緒にゆっくり歩きましょう。",
    
      "connect.titles.0": "言語交換",
      "connect.titles.1": "生活サポート",
      "connect.titles.2": "中古取引",
      "connect.titles.3": "求人・求職",
      "connect.titles.3.category": "アルバイト",
    
      "connect.posts.0.title": "韓国語・日本語 ビジネス会話 言語交換パートナー募集",
      "connect.posts.0.reward": "言語交換",
      "connect.posts.0.reward_detail": "時間相談可",
      "connect.posts.0.location": "城北洞 カフェ",
    
      "connect.posts.1.title": "スペイン語ネイティブの方、会話練習を手伝ってください！",
      "connect.posts.1.reward": "ギフトカード",
      "connect.posts.1.reward_detail": "1回 50,000ウォン",
      "connect.posts.1.location": "金泉区庁駅",
    
      "connect.posts.2.title": "仁川空港から麻浦駅まで道案内してほしいです",
      "connect.posts.2.reward": "物品",
      "connect.posts.2.reward_detail": "スペイン産ワイン",
      "connect.posts.2.location": "仁川空港",
    
      "connect.posts.3.title": "ワンルーム契約の同行サポートお願いできませんか？",
      "connect.posts.3.reward": "現金",
      "connect.posts.3.reward_detail": "時給 10,000ウォン",
      "connect.posts.3.location": "ソウル 永登浦・陽川駅",
    
      "connect.posts.4.title": "モンキードライバー1日だけ貸してください！代わりに自家製カクテキ差し上げます",
      "connect.posts.4.reward": "物品",
      "connect.posts.4.reward_detail": "手作りカクテキ",
      "connect.posts.4.location": "麻浦区 西橋洞",
    
      "connect.posts.5.title": "自転車売ります！使用感少なめ",
      "connect.posts.5.reward": "価格",
      "connect.posts.5.reward_detail": "50,000ウォン",
      "connect.posts.5.location": "新村駅付近",
    
      "connect.posts.6.title": "展示会の短期アルバイト募集　英語できる方優先",
      "connect.posts.6.reward": "業務",
      "connect.posts.6.reward_detail": "現場サポート・英語案内",
      "connect.posts.6.location": "COEX",
    
      "connect.posts.7.title": "スペイン語ができるバリスタ募集（ネイティブ外国人歓迎）",
      "connect.posts.7.reward": "時給",
      "connect.posts.7.reward_detail": "10,000ウォン〜",
      "connect.posts.7.location": "梨泰院 カフェ",
    
      "passport.introduction": "韓国のバラエティ番組を見て独学で韓国語を学び、メキシコで行われた韓国語スピーチ大会で1位を取ったことがきっかけで韓国へ来ました！",
      "passport.gender": "性別",
      "passport.gender_detail": "男性",
      "passport.birth": "生年月日",
      "passport.birth_detail": "1994.04.24",
      "passport.nationality": "国籍",
      "passport.nationality_detail": "メキシコ",
      "passport.mother_tongue": "母語",
      "passport.mother_tongue_detail": "スペイン語",
      "passport.language": "外国語",
      "passport.language_detail.0": "韓国語",
      "passport.language_detail.1": "英語",
      "passport.edit": "編集する",
      "passport.share": "共有する",

      // Positioned Mobile Demo Section
      "positionedMobileDemo.home.description": "Découvrez votre quartier en un coup d'œil",
      "positionedMobileDemo.home.features.0.description": "Ne manquez aucune actualité ou événement local",
      "positionedMobileDemo.home.features.1.description": "Découvrez les histoires du quotidien autour de vous",
      "positionedMobileDemo.home.features.2.description": "Rejoignez facilement fêtes, rencontres et événements",

      "positionedMobileDemo.mingl.description": "Explorez et partagez la vie locale par lieu",
      "positionedMobileDemo.mingl.features.0.description": "Partagez librement questions, infos et recommandations",
      "positionedMobileDemo.mingl.features.1.description": "Discussion globale avec traduction en temps réel",
      "positionedMobileDemo.mingl.features.2.description": "Regards croisés: local sur le monde, global sur le local",

      "positionedMobileDemo.connect.description": "Demandez ou offrez de l'aide—connectez-vous",
      "positionedMobileDemo.connect.features.0.description": "Mise en relation locale pour aide immédiate",
      "positionedMobileDemo.connect.features.1.description": "Choisissez des personnes fiables selon vos besoins",
      "positionedMobileDemo.connect.features.2.description": "Discussion → échange → liens durables",

      "positionedMobileDemo.talk.description": "Faites des amis dans le monde avec chat 1:1 traduit par IA",
      "positionedMobileDemo.talk.features.0.description": "Conversations naturelles avec traduction instantanée",
      "positionedMobileDemo.talk.features.1.description": "Demandez aux locaux et obtenez des réponses immédiates",
      "positionedMobileDemo.talk.features.2.description": "Transformez les premiers échanges en amitiés durables",

      "positionedMobileDemo.passport.description": "Créez une carte numérique de votre parcours global",
      "positionedMobileDemo.passport.features.0.description": "Enregistrez séjours et activités par région",
      "positionedMobileDemo.passport.features.1.description": "Affichez vos compétences linguistiques et votre style de communication",
      "positionedMobileDemo.passport.features.2.description": "Connectez-vous avec ceux qui partagent des parcours similaires",

      // Positioned Mobile Demo Section
      "positionedMobileDemo.home.description": "“近所のニュース”みたいに、今の街の様子を一目でチェック",
      "positionedMobileDemo.home.features.0.description": "地域の最新情報やイベントを逃さずチェック",
      "positionedMobileDemo.home.features.1.description": "場所を軸に、住民の日常やささやかな話題を探す",
      "positionedMobileDemo.home.features.2.description": "祭りや集まりなど、身近な活動に気軽に参加",

      "positionedMobileDemo.mingl.description": "街のリアルな日常を場所ベースで見つけて共有",
      "positionedMobileDemo.mingl.features.0.description": "質問・情報・ニュース・おすすめを自由に共有し、自然に交流",
      "positionedMobileDemo.mingl.features.1.description": "リアルタイム翻訳で言語の壁なしの本当のグローバル交流",
      "positionedMobileDemo.mingl.features.2.description": "ローカルから見た世界、グローバルから見たローカル",

      "positionedMobileDemo.connect.description": "助け合う瞬間から、つながりが生まれる",
      "positionedMobileDemo.connect.features.0.description": "必要な助けをすぐに見つけられる街ベースのマッチング",
      "positionedMobileDemo.connect.features.1.description": "自分に合う“安心して信頼できる”相手を自分で選べる",
      "positionedMobileDemo.connect.features.2.description": "会話 → 交流 → 続くローカル・グローバルな関係へ",

      "positionedMobileDemo.talk.description": "AI翻訳で言葉の不安なくグローバルな友達と出会える",
      "positionedMobileDemo.talk.features.0.description": "AIリアルタイム翻訳で語学力に関係なく自然な会話",
      "positionedMobileDemo.talk.features.1.description": "韓国での疑問を現地の人に直接聞いて即回答",
      "positionedMobileDemo.talk.features.2.description": "Connectで始まった縁を、長く続く友情へ",

      "positionedMobileDemo.passport.description": "自分のグローバル歴をまとめたデジタル名刺を作ろう",
      "positionedMobileDemo.passport.features.0.description": "地域ごとの居住歴や活動をタイムラインで記録",
      "positionedMobileDemo.passport.features.1.description": "言語スキルと交流スタイルをわかりやすく表現",
      "positionedMobileDemo.passport.features.2.description": "似た経験を持つ人と自然につながる",


      // Logl Video Section
      "loglVideo.title": "logl 紹介動画",
      "loglVideo.description": "loglって何？ まずは動画をご覧ください！",
      "loglVideo.watch": "動画を見に行く"

    }
  },
  es: {
    "translation": {
      // Header Section
      "header.intro": "Intro",
      "header.demo": "Demo",
      "header.video": "logl movie",

      // Hero Section
      "hero.title": "Romper Burbujas,",
      "hero.description": "find your",
      "hero.demo": "Probar la demo",
      "hero.prop1": "Servicios locales verificados",
      "hero.prop2": "Traducción con IA en tiempo real",
      "hero.prop3": "Comunidades locales diversas",

      // Introduction Section
      "introduction.title": "¿Has tenido estas preocupaciones?",
      "introduction.fst.role": "local",
      "introduction.snd.role": "global",

      "introduction.fst.name": "Jimin",
      "introduction.fst.location": "Seúl, Corea del Sur",
      "introduction.fst.tag": "#AprendizajeDeIdiomas",
      "introduction.fst.story": "«Estudié mucho inglés e incluso fui de intercambio… pero sin usarlo lo olvido todo. Me encantaría poder usarlo en el día a día 😢»",

      "introduction.snd.name": "Sophie",
      "introduction.snd.location": "Suwon, Corea del Sur",
      "introduction.snd.tag": "#HacerAmigosLocales",
      "introduction.snd.story": "«Llevo seis meses en Corea y aún salgo solo con gente de mi país. Quiero tener amigos coreanos de verdad, pero no sé cómo empezar.»",

      "introduction.trd.name": "Carlos",
      "introduction.trd.location": "Jeonju, Corea del Sur",
      "introduction.trd.tag": "#InfoDeVidaLocal",
      "introduction.trd.story": "«Ni en YouTube ni en las comunidades encuentro info de mi barrio. Bancos, operadoras móviles, hospitales… Al llegar, ¿dónde consigo información precisa y actualizada?»",
      
      // App Menu Section
      "appMenu.home.local.title": "Inicio",
      "appMenu.home.local.subtitle": "Convierte nuestro barrio en un hub global",
      "appMenu.home.local.description": "Comparte lo que sabes de tu zona para ayudar a los vecinos extranjeros y crear una comunidad realmente global.",
      "appMenu.home.local.points": [
        "Recomienda joyas ocultas, clínicas y servicios cotidianos a extranjeros",
        "Comparte noticias del barrio y eventos en tiempo real",
        "Lidera la internacionalización elevando el índice global de tu zona"
      ],
      "appMenu.home.local.tip": "Tu pequeño conocimiento local puede ser la guía de vida esencial de alguien.",

      "appMenu.home.global.title": "Inicio",
      "appMenu.home.global.subtitle": "Tablero a medida para vivir en Corea",
      "appMenu.home.global.description": "Del clima de hoy a los posts populares del barrio: todo lo que necesitas en una sola pantalla.",
      "appMenu.home.global.points": [
        "Planifica tu día con el clima local y consejos para salir",
        "Revisa primero noticias del vecindario y solicitudes de ayuda en tiempo real",
        "No te pierdas historias globales populares entre los coreanos"
      ],
      "appMenu.home.global.tip": "Con solo 5 minutos al día, la vida en Corea se vuelve mucho más fácil.",

      "appMenu.mingl.local.title": "mingl",
      "appMenu.mingl.local.subtitle": "Habla con amigos globales",
      "appMenu.mingl.local.description": "Responde preguntas de extranjeros, aprende idiomas y comparte culturas juntos.",
      "appMenu.mingl.local.points": [
        "Comparte consejos sobre la vida en Corea y siente el impacto",
        "Mejora tu idioma de forma natural",
        "Haz amistades de diversas culturas"
      ],
      "appMenu.mingl.local.tip": "Responde preguntas, aprende idiomas y comparte cultura juntos.",

      "appMenu.mingl.global.title": "mingl",
      "appMenu.mingl.global.subtitle": "Comunícate naturalmente con coreanos",
      "appMenu.mingl.global.description": "Pregunta sobre la vida en Corea sin barreras idiomáticas con traducción en tiempo real y haz amigos locales.",
      "appMenu.mingl.global.points": [
        "Resuelve al instante tus dudas sobre vivir en Corea",
        "Conversaciones naturales gracias a la traducción con IA, sin estrés lingüístico",
        "Sal del “gueto de expats” y haz amigos coreanos de verdad"
      ],
      "appMenu.mingl.global.tip": "Aprende la cultura coreana e intégrate naturalmente en la comunidad local.",

      "appMenu.connect.local.title": "connect",
      "appMenu.connect.local.subtitle": "Ayuda a vecinos extranjeros y haz amigos",
      "appMenu.connect.local.description": "Resuelve problemas reales de los extranjeros de tu zona y crea una red global.",
      "appMenu.connect.local.points": [
        "Apoyo práctico con bancos, vivienda y trámites",
        "Crea una red global de manera natural ayudando",
        "Sé un embajador global con un rol significativo en el barrio"
      ],
      "appMenu.connect.local.tip": "Empieza con pequeñas ayudas y crea amistades globales reales.",

      "appMenu.connect.global.title": "connect",
      "appMenu.connect.global.subtitle": "Resuelve problemas con vecinos coreanos",
      "appMenu.connect.global.description": "Gestiona temas urgentes —banco, vivienda, visado— junto a locales de confianza.",
      "appMenu.connect.global.points": [
        "Resuelve tareas concretas como abrir una cuenta o buscar piso",
        "Pide ayuda de forma informal a los vecinos, sin agencias",
        "Supera el círculo de extranjeros y adáptate a la vida local real"
      ],
      "appMenu.connect.global.tip": "Cuanto más urgente, más rápido y fiable es el apoyo de los vecinos locales.",

      "appMenu.talk.local.title": "talk",
      "appMenu.talk.local.subtitle": "Chatea en tiempo real con vecinos extranjeros",
      "appMenu.talk.local.description": "Usa traducción con IA para chatear 1:1 sin barreras y haz amigos globales de verdad.",
      "appMenu.talk.local.points": [
        "Conversaciones naturales sin importar tu nivel gracias a la traducción en tiempo real",
        "Convierte el vínculo iniciado en connect en una amistad duradera",
        "Escucha y asesora directamente sobre la vida en Corea"
      ],
      "appMenu.talk.local.tip": "Una charla de ayuda puede convertirse en una conexión global para toda la vida.",

      "appMenu.talk.global.title": "talk",
      "appMenu.talk.global.subtitle": "Habla con coreanos con total comodidad",
      "appMenu.talk.global.description": "Chatea en tiempo real con vecinos coreanos sin barreras de idioma y resuelve dudas al instante.",
      "appMenu.talk.global.points": [
        "Pregunta directamente a coreanos y recibe respuestas inmediatas",
        "Conversaciones naturales y cómodas incluso sin saber coreano gracias a la IA",
        "Sigue en contacto con los vecinos que te ayudaron en connect y haz amigos reales"
      ],
      "appMenu.talk.global.tip": "Empieza con preguntas sencillas y encuentra un aliado confiable para tu vida en Corea.",

      "appMenu.passport.local.title": "passport",
      "appMenu.passport.local.subtitle": "Crea tu propia historia global",
      "appMenu.passport.local.description": "Registra actividades y experiencias con amigos extranjeros y construye tu identidad global —sin pasaporte físico—.",
      "appMenu.passport.local.points": [
        "Visualiza en una línea de tiempo tus actividades globales en el barrio",
        "Construye un portafolio de Embajador Global con tus apoyos",
        "Gestiona de forma sistemática idiomas y experiencias de intercambio cultural"
      ],
      "appMenu.passport.local.tip": "Registra incluso las pequeñas ayudas: así completas tu viaje global personal.",

      "appMenu.passport.global.title": "passport",
      "appMenu.passport.global.subtitle": "Identidad global — tarjeta digital",
      "appMenu.passport.global.description": "Muestra visualmente tus experiencias multinacionales y crea un perfil confiable.",
      "appMenu.passport.global.points": [
        "Visualiza de un vistazo tu historial de residencia y experiencias globales",
        "Gana credibilidad con tus idiomas y bagaje cultural",
        "Conéctate naturalmente con personas de experiencias similares"
      ],
      "appMenu.passport.global.tip": "Cuanto más detallado tu perfil, mejor apoyo local y amistades auténticas encontrarás.",

      // Demo Section
      "common.viewAll": "Ver todo",
      "common.minutesAgo": "minutos atrás",

      "home.tag": "Mercado de pulgas",
      "home.greeting_01": "Carlos",
      "home.greeting_02": "¿Que tal?",

      "home.weather.maxTemp": "Máx 15°",
      "home.weather.minTemp": "Mín 10°",

      "home.weather.morning": "☀️",
      "home.weather.morningWeather": "Despejado",
      "home.weather.afternoon": "🌘",
      "home.weather.afternoonWeather": "Nublado",
      "home.weather.fineDust": "💨",
      "home.weather.fineDustLevel": "Normal",

      "home.mytown.title": "En tiempo real en mi barrio",
      "home.mytown.places.0.name": "Mercado del Árbol Ginkgo",
      "home.mytown.places.0.address": "Siheung-dong, Geumcheon-gu",
      "home.mytown.places.1.name": "Monte Gwanak",
      "home.mytown.places.1.address": "Sillim-dong, Gwanak-gu",
      "home.mytown.places.2.name": "Plaza Multipropósito del Río Anyang",
      "home.mytown.places.2.address": "Dokseon-dong, Geumcheon-gu",

      "home.events.title": "Eventos en el barrio",
      "home.events.post_title": "Se realizará mercado de pulgas en Doksan-dong",
      "home.events.address": "Doksan-dong, Geumcheon-gu",

      "mingl.posts.0.category": "Información local",
      "mingl.posts.0.title": "¿Dónde está el carrito de sundae en la estación del Ayuntamiento de Geumcheon?",
      "mingl.posts.0.content": "Era el mejor sundae… pero últimamente no lo veo. ¿Alguien sabe dónde está?",

      "mingl.posts.1.category": "Información local",
      "mingl.posts.1.title": "Consejos para comprar en el mercado tradicional de Doksan",
      "mingl.posts.1.content": "Los precios cambian según el día. ¿Alguna recomendación para comprar mejor?",

      "mingl.posts.2.category": "Vida diaria",
      "mingl.posts.2.title": "¿Qué almorzar cerca del complejo digital de Gasan?",
      "mingl.posts.2.content": "Hoy es difícil decidir. ¿Qué suelen comer los trabajadores por aquí?",

      "mingl.posts.3.category": "Hobbies / Encuentros",
      "mingl.posts.3.title": "Buscamos personas para un grupo de juegos de mesa cerca de Gasan",
      "mingl.posts.3.content": "Nos reunimos todos los viernes por la tarde. ¡Únete si te interesa!",

      "mingl.posts.4.category": "Viajes / Paseos",
      "mingl.posts.4.title": "Ruta recomendada para caminar en el sendero de Hoamsan",
      "mingl.posts.4.content": "Encontré una ruta tranquila para caminar el fin de semana. ¡La recomiendo!",

      "mingl.posts.5.category": "Vida diaria",
      "mingl.posts.5.title": "Busco un café tranquilo cerca de Doksan-dong",
      "mingl.posts.5.content": "Necesito un lugar con buen Wi-Fi y enchufes. ¿Alguna sugerencia?",

      "mingl.posts.6.category": "Información local",
      "mingl.posts.6.title": "Recomendación de gimnasio cerca de Gasan-dong",
      "mingl.posts.6.content": "¿Alguien conoce un gimnasio con buenas instalaciones o buena tarifa mensual por aquí?",

      "mingl.posts.7.category": "Hobbies / Encuentros",
      "mingl.posts.7.title": "¿Quién quiere hacer senderismo en el Monte Gwanak?",
      "mingl.posts.7.content": "Iré este fin de semana. Principiantes bienvenidos, ritmo tranquilo 😊",

      "connect.titles.0": "idiomas",
      "connect.titles.1": "Adaptación",
      "connect.titles.2": "Segunda mano",
      "connect.titles.3": "Empleo",
      "connect.titles.3.category": "Trabajo temporal",

      "connect.posts.0.title": "Busco intercambio de conversación de negocios coreano-japonés",
      "connect.posts.0.reward": "Japonés",
      "connect.posts.0.reward_detail": "Horario a convenir",
      "connect.posts.0.location": "Café en Seongbuk-dong",

      "connect.posts.1.title": "¡Busco hablante nativo de español para practicar conversación!",
      "connect.posts.1.reward": "Vale de regalo",
      "connect.posts.1.reward_detail": "50,000 KRW por sesión",
      "connect.posts.1.location": "Estación del Ayuntamiento de Geumcheon",

      "connect.posts.2.title": "Busco ayuda para ir desde el aeropuerto de Incheon a Mapo en metro",
      "connect.posts.2.reward": "Objeto",
      "connect.posts.2.reward_detail": "Vino español",
      "connect.posts.2.location": "Aeropuerto de Incheon",

      "connect.posts.3.title": "¿Alguien puede acompañarme para revisar un contrato de alquiler de una habitación?",
      "connect.posts.3.reward": "Efectivo",
      "connect.posts.3.reward_detail": "10,000 KRW / hora",
      "connect.posts.3.location": "Yeongdeungpo / Yangcheon, Seúl",

      "connect.posts.4.title": "¡Préstame un Monkey Driver por un día! Te doy kimchi de rábano hecho en casa 🍽️",
      "connect.posts.4.reward": "Objeto",
      "connect.posts.4.reward_detail": "Kimchi casero",
      "connect.posts.4.location": "Seogyo-dong, Mapo-gu",

      "connect.posts.5.title": "Vendo bicicleta, poco uso",
      "connect.posts.5.reward": "Precio",
      "connect.posts.5.reward_detail": "50,000 KRW",
      "connect.posts.5.location": "Cerca de la estación Sinchon",

      "connect.posts.6.title": "Se busca personal temporal para exposición — inglés preferido",
      "connect.posts.6.reward": "Trabajo",
      "connect.posts.6.reward_detail": "Apoyo en el lugar y guía en inglés",
      "connect.posts.6.location": "COEX",

      "connect.posts.7.title": "Se busca barista que hable español (preferencia extranjeros nativos)",
      "connect.posts.7.reward": "Salario por hora",
      "connect.posts.7.reward_detail": "Desde 10,000 KRW",
      "connect.posts.7.location": "Café en Itaewon",

      "passport.introduction": "Comencé a estudiar coreano viendo programas de entretenimiento y, después de ganar el primer lugar en un concurso de discurso en México, decidí venir a Corea.",
      "passport.gender": "Género",
      "passport.gender_detail": "Masculino",
      "passport.birth": "Fecha de nacimiento",
      "passport.birth_detail": "1994.04.24",
      "passport.nationality": "Nacionalidad",
      "passport.nationality_detail": "México",
      "passport.mother_tongue": "Lengua materna",
      "passport.mother_tongue_detail": "Español",
      "passport.language": "Idiomas",
      "passport.language_detail.0": "Coreano",
      "passport.language_detail.1": "Inglés",
      "passport.edit": "Editar",
      "passport.share": "Compartir",

      // Positioned Mobile Demo Section
      "positionedMobileDemo.home.description": "Consulta tu barrio al instante—como noticias locales",
      "positionedMobileDemo.home.features.0.description": "No te pierdas avisos y eventos del barrio",
      "positionedMobileDemo.home.features.1.description": "Explora momentos cotidianos por lugar",
      "positionedMobileDemo.home.features.2.description": "Únete fácil a festivales, quedadas y eventos",

      "positionedMobileDemo.mingl.description": "Explora y comparte la vida real por lugares",
      "positionedMobileDemo.mingl.features.0.description": "Comparte preguntas, info, noticias y tips",
      "positionedMobileDemo.mingl.features.1.description": "Traducción en tiempo real para charlas sin barreras",
      "positionedMobileDemo.mingl.features.2.description": "Mirada local del mundo, global de lo local",

      "positionedMobileDemo.connect.description": "Da o recibe ayuda—conéctate ya",
      "positionedMobileDemo.connect.features.0.description": "Matching del barrio para ayuda inmediata",
      "positionedMobileDemo.connect.features.1.description": "Elige personas seguras y de confianza",
      "positionedMobileDemo.connect.features.2.description": "Chat → intercambio → relaciones duraderas",

      "positionedMobileDemo.talk.description": "Haz amigos globales con chat 1:1 traducido por IA",
      "positionedMobileDemo.talk.features.0.description": "Conversaciones naturales con traducción en vivo",
      "positionedMobileDemo.talk.features.1.description": "Pregunta a locales sobre Corea y recibe al instante",
      "positionedMobileDemo.talk.features.2.description": "Convierte Connect en amistades duraderas",

      "positionedMobileDemo.passport.description": "Crea una tarjeta digital con tu historia global",
      "positionedMobileDemo.passport.features.0.description": "Cronología de estancias y actividades por región",
      "positionedMobileDemo.passport.features.1.description": "Muestra nivel de idiomas y estilo de comunicación",
      "positionedMobileDemo.passport.features.2.description": "Conéctate con quienes comparten experiencias",

      // Logl Video Section
      "loglVideo.title": "Video de presentación de logl",
      "loglVideo.description": "¿Te preguntas qué es logl? ¡Empieza por el video!",
      "loglVideo.watch": "Ver el video"
    }
  },
  vi: {
    "translation": {
      // Header Section
      "header.intro": "Giới thiệu",
      "header.demo": "Demo",
      "header.video": "Video logl",

      // Hero Section
      "hero.title": "Phá vỡ Bong bóng,",
      "hero.description": "find your",
      "hero.demo": "Dùng thử demo",
      "hero.prop1": "Dịch vụ địa phương đã xác minh",
      "hero.prop2": "Dịch thuật AI theo thời gian thực",
      "hero.prop3": "Cộng đồng địa phương đa dạng",

      // Introduction Section
      "introduction.title": "Bạn từng có những băn khoăn này chứ?",
      "introduction.fst.role": "local",
      "introduction.snd.role": "global",

      "introduction.fst.name": "Jimin",
      "introduction.fst.location": "Seoul, Hàn Quốc",
      "introduction.fst.tag": "#HọcNgoạiNgữ",
      "introduction.fst.story": "“Mình đã học tiếng Anh rất chăm và còn đi du học… nhưng không có cơ hội dùng nên dần quên hết. Ước gì có nơi để dùng trong đời sống hằng ngày 😢”",

      "introduction.snd.name": "Sophie",
      "introduction.snd.location": "Suwon, Hàn Quốc",
      "introduction.snd.tag": "#KếtBạnVớiNgườiĐịaPhương",
      "introduction.snd.story": "“Mình sang Hàn được 6 tháng rồi mà vẫn chỉ chơi với bạn bè cùng quốc tịch. Mình thật sự muốn thân với người Hàn nhưng không biết bắt đầu từ đâu.”",

      "introduction.trd.name": "Carlos",
      "introduction.trd.location": "Jeonju, Hàn Quốc",
      "introduction.trd.tag": "#ThôngTinCuộcSốngĐịaPhương",
      "introduction.trd.story": "“Xem YouTube hay vào các cộng đồng cũng không có thông tin về khu mình ở. Mở tài khoản ngân hàng, nhà mạng, bệnh viện… Lúc mới định cư thì tìm thông tin chính xác, cập nhật ở đâu?”",
      
      // App Menu Section
      "appMenu.home.local.title": "Trang chủ",
      "appMenu.home.local.subtitle": "Biến khu phố của chúng ta thành một hub toàn cầu",
      "appMenu.home.local.description": "Chia sẻ hiểu biết về khu vực để giúp hàng xóm người nước ngoài và xây dựng một cộng đồng thật sự toàn cầu.",
      "appMenu.home.local.points": [
        "Giới thiệu quán ngon, bệnh viện và tiện ích cho người nước ngoài",
        "Chia sẻ tin tức khu vực và sự kiện theo thời gian thực",
        "Dẫn dắt quốc tế hóa bằng cách nâng cao chỉ số toàn cầu của khu phố"
      ],
      "appMenu.home.local.tip": "Những thông tin nhỏ bạn biết có thể là cẩm nang sống quý giá với ai đó.",

      "appMenu.home.global.title": "Trang chủ",
      "appMenu.home.global.subtitle": "Bảng điều khiển dành riêng cho cuộc sống tại Hàn Quốc",
      "appMenu.home.global.description": "Từ thời tiết hôm nay đến bài viết đang thịnh hành trong khu—mọi thứ cần thiết trên một màn hình.",
      "appMenu.home.global.points": [
        "Lên kế hoạch ngày mới với thời tiết địa phương và mẹo ra ngoài",
        "Xem trước tin tức khu phố và yêu cầu giúp đỡ theo thời gian thực",
        "Đừng bỏ lỡ những câu chuyện toàn cầu được người Hàn yêu thích"
      ],
      "appMenu.home.global.tip": "Chỉ 5 phút mỗi ngày là cuộc sống ở Hàn dễ dàng hơn rất nhiều.",

      "appMenu.mingl.local.title": "mingl",
      "appMenu.mingl.local.subtitle": "Trò chuyện với bạn bè quốc tế",
      "appMenu.mingl.local.description": "Trả lời câu hỏi của người nước ngoài, học ngôn ngữ và chia sẻ văn hóa cùng nhau.",
      "appMenu.mingl.local.points": [
        "Chia sẻ mẹo sống ở Hàn và cảm nhận giá trị bạn mang lại",
        "Cải thiện ngoại ngữ một cách tự nhiên",
        "Kết bạn từ nhiều nền văn hóa khác nhau"
      ],
      "appMenu.mingl.local.tip": "Hãy trả lời, học ngôn ngữ và cùng nhau sẻ chia văn hóa.",

      "appMenu.mingl.global.title": "mingl",
      "appMenu.mingl.global.subtitle": "Giao tiếp tự nhiên với người Hàn",
      "appMenu.mingl.global.description": "Hỏi về cuộc sống ở Hàn không còn lo ngôn ngữ nhờ dịch theo thời gian thực và kết bạn địa phương.",
      "appMenu.mingl.global.points": [
        "Giải đáp ngay mọi thắc mắc về cuộc sống ở Hàn",
        "Trò chuyện tự nhiên với dịch thuật AI—không còn áp lực ngôn ngữ",
        "Thoát khỏi “bong bóng expat” và kết bạn người Hàn thực sự"
      ],
      "appMenu.mingl.global.tip": "Học văn hóa Hàn và hòa nhập tự nhiên vào cộng đồng địa phương.",

      "appMenu.connect.local.title": "connect",
      "appMenu.connect.local.subtitle": "Giúp hàng xóm người nước ngoài & kết bạn",
      "appMenu.connect.local.description": "Giải quyết vấn đề thực tế của người nước ngoài quanh bạn và xây dựng mạng lưới toàn cầu.",
      "appMenu.connect.local.points": [
        "Hỗ trợ thiết thực về ngân hàng, nhà ở, giấy tờ",
        "Hình thành mạng lưới toàn cầu một cách tự nhiên qua việc giúp đỡ",
        "Đảm nhận vai trò ý nghĩa như một “đại sứ toàn cầu” của khu phố"
      ],
      "appMenu.connect.local.tip": "Bắt đầu từ những giúp đỡ nhỏ—xây nên tình bạn quốc tế bền lâu.",

      "appMenu.connect.global.title": "connect",
      "appMenu.connect.global.subtitle": "Giải quyết vấn đề cùng hàng xóm người Hàn",
      "appMenu.connect.global.description": "Xử lý các nhu cầu cấp bách—ngân hàng, nhà ở, visa—cùng người địa phương đáng tin cậy.",
      "appMenu.connect.global.points": [
        "Giải quyết việc cụ thể như mở tài khoản hoặc tìm nhà",
        "Nhờ giúp đỡ hàng xóm một cách thân mật—không cần đại lý",
        "Vượt ra khỏi cộng đồng người nước ngoài và thích nghi thật sự với đời sống địa phương"
      ],
      "appMenu.connect.global.tip": "Càng gấp, sự hỗ trợ từ hàng xóm địa phương càng nhanh và đáng tin.",

      "appMenu.talk.local.title": "talk",
      "appMenu.talk.local.subtitle": "Trò chuyện thời gian thực với hàng xóm người nước ngoài",
      "appMenu.talk.local.description": "Dùng dịch thuật AI để chat 1:1 không rào cản và trở thành những người bạn quốc tế đích thực.",
      "appMenu.talk.local.points": [
        "Trò chuyện tự nhiên bất kể trình độ nhờ dịch theo thời gian thực",
        "Biến kết nối từ connect thành tình bạn lâu dài",
        "Tư vấn trực tiếp về những trăn trở trong cuộc sống ở Hàn"
      ],
      "appMenu.talk.local.tip": "Một cuộc trò chuyện giúp đỡ nhỏ có thể trở thành kết nối toàn cầu suốt đời.",

      "appMenu.talk.global.title": "talk",
      "appMenu.talk.global.subtitle": "Trò chuyện thoải mái với người Hàn",
      "appMenu.talk.global.description": "Chat thời gian thực với hàng xóm người Hàn không rào cản ngôn ngữ và nhận câu trả lời tức thì.",
      "appMenu.talk.global.points": [
        "Hỏi trực tiếp người Hàn và nhận phản hồi ngay",
        "Trò chuyện tự nhiên, thoải mái dù chưa biết tiếng Hàn nhờ AI",
        "Giữ liên lạc với những người đã giúp bạn qua connect để trở thành bạn bè thật sự"
      ],
      "appMenu.talk.global.tip": "Bắt đầu bằng những câu hỏi nhỏ để tìm một người bạn đồng hành tin cậy cho cuộc sống ở Hàn.",

      "appMenu.passport.local.title": "passport",
      "appMenu.passport.local.subtitle": "Tạo nên câu chuyện toàn cầu của riêng bạn",
      "appMenu.passport.local.description": "Ghi lại hoạt động và trải nghiệm với bạn bè quốc tế và xây dựng bản sắc toàn cầu—không cần hộ chiếu vật lý.",
      "appMenu.passport.local.points": [
        "Trực quan hóa hoạt động toàn cầu tại khu phố theo dòng thời gian",
        "Xây dựng hồ sơ Đại sứ Toàn cầu từ những lần bạn giúp đỡ",
        "Quản lý có hệ thống kỹ năng ngôn ngữ và trải nghiệm giao lưu văn hóa"
      ],
      "appMenu.passport.local.tip": "Ghi lại cả những giúp đỡ nhỏ—hoàn thiện hành trình toàn cầu của riêng bạn.",

      "appMenu.passport.global.title": "passport",
      "appMenu.passport.global.subtitle": "Bản sắc toàn cầu — danh thiếp số",
      "appMenu.passport.global.description": "Trình bày trực quan trải nghiệm đa quốc gia và xây dựng hồ sơ đáng tin cậy.",
      "appMenu.passport.global.points": [
        "Nhìn tổng quan lịch sử cư trú và trải nghiệm toàn cầu chỉ trong một lần xem",
        "Tăng độ tin cậy bằng kỹ năng ngôn ngữ và nền tảng văn hóa",
        "Kết nối tự nhiên với những người có trải nghiệm tương đồng"
      ],
      "appMenu.passport.global.tip": "Hồ sơ càng chi tiết, bạn càng dễ nhận được hỗ trợ địa phương tốt hơn và gặp gỡ những người bạn chân thành.",

      // Demo Section
      "common.viewAll": "Xem tất cả",
      "common.minutesAgo": "phút trước",

      "home.tag": "Chợ đồ cũ",
      "home.greeting_01": "Carlos",
      "home.greeting_02": "Chúc bạn một ngày tốt lành",

      "home.weather.maxTemp": "Cao nhất 15°",
      "home.weather.minTemp": "Thấp nhất 10°",

      "home.weather.morning": "☀️",
      "home.weather.morningWeather": "Trời quang",
      "home.weather.afternoon": "🌘",
      "home.weather.afternoonWeather": "Nhiều mây",
      "home.weather.fineDust": "💨",
      "home.weather.fineDustLevel": "Bình thường",

      "home.mytown.title": "Trực tiếp quanh khu vực",
      "home.mytown.places.0.name": "Chợ Cây Bạch Quả",
      "home.mytown.places.0.address": "Siheung-dong, Geumcheon-gu",
      "home.mytown.places.1.name": "Núi Gwanak",
      "home.mytown.places.1.address": "Sillim-dong, Gwanak-gu",
      "home.mytown.places.2.name": "Quảng trường ven sông Anyang",
      "home.mytown.places.2.address": "Dokseon-dong, Geumcheon-gu",

      "home.events.title": "Sự kiện trong khu vực",
      "home.events.post_title": "Có chợ đồ cũ tại Doksan-dong",
      "home.events.address": "Doksan-dong, Geumcheon-gu",

      "mingl.posts.0.category": "Thông tin sinh hoạt",
      "mingl.posts.0.title": "Chú bán xe Sundae ở ga Geumcheon-gu đang ở đâu?",
      "mingl.posts.0.content": "Đó là món sundae ngon nhất… nhưng dạo này không thấy nữa. Có ai biết không?",

      "mingl.posts.1.category": "Thông tin sinh hoạt",
      "mingl.posts.1.title": "Mẹo mua đồ ở chợ truyền thống Doksan",
      "mingl.posts.1.content": "Giá thay đổi theo ngày. Có mẹo nào để mua với giá tốt hơn không?",

      "mingl.posts.2.category": "Đời sống",
      "mingl.posts.2.title": "Ăn trưa gì gần khu Gasan Digital?",
      "mingl.posts.2.content": "Hôm nay chọn món thật khó. Mọi người ở khu này hay ăn gì vậy?",

      "mingl.posts.3.category": "Sở thích / Gặp gỡ",
      "mingl.posts.3.title": "Tìm người tham gia nhóm board game gần ga Gasan",
      "mingl.posts.3.content": "Chúng mình chơi vào tối thứ Sáu hàng tuần. Ai muốn tham gia không?",

      "mingl.posts.4.category": "Du lịch / Dã ngoại",
      "mingl.posts.4.title": "Gợi ý đường đi dạo cuối tuần ở núi Hoamsan",
      "mingl.posts.4.content": "Mình tìm được một đường đi dạo nhẹ nhàng cuối tuần. Muốn chia sẻ để mọi người cùng thử!",

      "mingl.posts.5.category": "Đời sống",
      "mingl.posts.5.title": "Tìm quán cà phê yên tĩnh gần Doksan-dong",
      "mingl.posts.5.content": "Cần quán có Wi-Fi mạnh và ổ cắm điện để làm việc. Ai biết chỉ giúp mình nhé!",

      "mingl.posts.6.category": "Thông tin sinh hoạt",
      "mingl.posts.6.title": "Gợi ý phòng gym gần Gasan-dong",
      "mingl.posts.6.content": "Ai đang tập gym gần đây không? Có phòng nào giá tốt hoặc cơ sở vật chất ổn không?",

      "mingl.posts.7.category": "Sở thích / Gặp gỡ",
      "mingl.posts.7.title": "Đi leo núi Gwanak cuối tuần, ai đi cùng không?",
      "mingl.posts.7.content": "Cuối tuần này mình đi. Người mới cũng được, đi nhẹ nhàng thôi nha 😊",

      "connect.titles.0": "ngôn ngữ",
      "connect.titles.1": "Hỗ trợ sinh hoạt",
      "connect.titles.2": "Mua bán đồ cũ",
      "connect.titles.3": "Tuyển dụng",
      "connect.titles.3.category": "Làm thêm",

      "connect.posts.0.title": "Tìm người trao đổi tiếng Hàn - Nhật cho hội thoại công việc",
      "connect.posts.0.reward": "Tiếng Nhật",
      "connect.posts.0.reward_detail": "Thời gian thỏa thuận",
      "connect.posts.0.location": "Quán cà phê ở Seongbuk-dong",

      "connect.posts.1.title": "Cần người bản ngữ tiếng Tây Ban Nha để luyện hội thoại!",
      "connect.posts.1.reward": "Phiếu quà tặng",
      "connect.posts.1.reward_detail": "50,000 KRW / buổi",
      "connect.posts.1.location": "Ga Geumcheon-gu Office",

      "connect.posts.2.title": "Cần người hướng dẫn đi tàu từ sân bay Incheon đến ga Mapo",
      "connect.posts.2.reward": "Quà tặng",
      "connect.posts.2.reward_detail": "Rượu vang Tây Ban Nha",
      "connect.posts.2.location": "Sân bay Incheon",

      "connect.posts.3.title": "Có ai đi cùng để hỗ trợ xem hợp đồng thuê phòng không?",
      "connect.posts.3.reward": "Tiền mặt",
      "connect.posts.3.reward_detail": "10,000 KRW / giờ",
      "connect.posts.3.location": "Ga Yeongdeungpo / Yangcheon, Seoul",

      "connect.posts.4.title": "Cho mình mượn Monkey Driver một ngày! Mình tặng kim chi củ cải tự làm",
      "connect.posts.4.reward": "Quà tặng",
      "connect.posts.4.reward_detail": "Kim chi củ cải tự làm",
      "connect.posts.4.location": "Seogyo-dong, Mapo-gu",

      "connect.posts.5.title": "Bán xe đạp — còn mới",
      "connect.posts.5.reward": "Giá",
      "connect.posts.5.reward_detail": "50,000 KRW",
      "connect.posts.5.location": "Gần ga Sinchon",

      "connect.posts.6.title": "Tuyển làm thêm ngắn hạn tại hội chợ — biết tiếng Anh là lợi thế",
      "connect.posts.6.reward": "Công việc",
      "connect.posts.6.reward_detail": "Hỗ trợ tại chỗ & hướng dẫn tiếng Anh",
      "connect.posts.6.location": "COEX",

      "connect.posts.7.title": "Tuyển barista biết tiếng Tây Ban Nha (ưu tiên người nước ngoài bản ngữ)",
      "connect.posts.7.reward": "Lương theo giờ",
      "connect.posts.7.reward_detail": "Từ 10,000 KRW",
      "connect.posts.7.location": "Quán cà phê ở Itaewon",

      "passport.introduction": "Mình bắt đầu tự học tiếng Hàn qua các chương trình giải trí, và sau khi đạt giải nhất cuộc thi diễn thuyết tiếng Hàn tại Mexico, mình đã quyết định đến Hàn Quốc.",
      "passport.gender": "Giới tính",
      "passport.gender_detail": "Nam",
      "passport.birth": "Ngày sinh",
      "passport.birth_detail": "1994.04.24",
      "passport.nationality": "Quốc tịch",
      "passport.nationality_detail": "Mexico",
      "passport.mother_tongue": "Tiếng mẹ đẻ",
      "passport.mother_tongue_detail": "Tiếng Tây Ban Nha",
      "passport.language": "Ngôn ngữ khác",
      "passport.language_detail.0": "Tiếng Hàn",
      "passport.language_detail.1": "Tiếng Anh",
      "passport.edit": "Chỉnh sửa",
      "passport.share": "Chia sẻ",

      // Positioned Mobile Demo Section
      "positionedMobileDemo.home.description": "Xem nhanh tình hình khu vực của bạn",
      "positionedMobileDemo.home.features.0.description": "Không bỏ lỡ tin tức và sự kiện địa phương",
      "positionedMobileDemo.home.features.1.description": "Khám phá những câu chuyện đời thường quanh bạn",
      "positionedMobileDemo.home.features.2.description": "Tham gia lễ hội và gặp gỡ gần bạn dễ dàng",

      "positionedMobileDemo.mingl.description": "Khám phá và chia sẻ đời sống theo địa điểm",
      "positionedMobileDemo.mingl.features.0.description": "Chia sẻ câu hỏi, mẹo và tin tức thoải mái",
      "positionedMobileDemo.mingl.features.1.description": "Trò chuyện toàn cầu với dịch thời gian thực",
      "positionedMobileDemo.mingl.features.2.description": "Góc nhìn địa phương và toàn cầu hòa nhau",

      "positionedMobileDemo.connect.description": "Cần giúp hoặc muốn giúp—kết nối ngay",
      "positionedMobileDemo.connect.features.0.description": "Kết nối nhanh với người hỗ trợ gần bạn",
      "positionedMobileDemo.connect.features.1.description": "Tự chọn người đáng tin phù hợp nhu cầu",
      "positionedMobileDemo.connect.features.2.description": "Trò chuyện → trao đổi → gắn kết bền lâu",

      "positionedMobileDemo.talk.description": "Kết bạn toàn cầu với chat 1:1 có AI dịch",
      "positionedMobileDemo.talk.features.0.description": "Trò chuyện tự nhiên với dịch thời gian thực",
      "positionedMobileDemo.talk.features.1.description": "Hỏi người bản địa và nhận trả lời ngay",
      "positionedMobileDemo.talk.features.2.description": "Biến kết nối ban đầu thành tình bạn lâu dài",

      "positionedMobileDemo.passport.description": "Tạo thẻ số thể hiện hành trình toàn cầu của bạn",
      "positionedMobileDemo.passport.features.0.description": "Ghi lại nơi từng sống và hoạt động theo thời gian",
      "positionedMobileDemo.passport.features.1.description": "Thể hiện khả năng ngôn ngữ và cách giao tiếp",
      "positionedMobileDemo.passport.features.2.description": "Kết nối với người có trải nghiệm tương tự",

      // Logl Video Section
      "loglVideo.title": "Video giới thiệu logl",
      "loglVideo.description": "Muốn biết logl là gì? Hãy xem video trước nhé!",
      "loglVideo.watch": "Xem video"
    }
  },
  fr: {
    translation: {
      // Header Section
      "header.intro": "Intro",
    "header.demo": "Démo",
    "header.video": "film logl",
      
      // Hero Section
    "hero.title": "Briser les barrières linguistiques",
    "hero.description": "trouve ton",
      "hero.demo": "Essayer la démo",
      "hero.prop1": "Services locaux vérifiés",
      "hero.prop2": "Traduction IA en temps réel",
    "hero.prop3": "Communautés locales variées",

    // Introduction Section
    "introduction.title": "Vous avez déjà eu ces préoccupations ?",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",

    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Séoul, Corée",
    "introduction.fst.tag": "#apprentissageLangue",
    "introduction.fst.story": "\"J’ai étudié l’anglais et même vécu à l'étranger... mais sans l’utiliser au quotidien, j'oublie tout. J’aimerais juste avoir l’occasion de l’utiliser 😢\"",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Corée",
    "introduction.snd.tag": "#seFaireDesAmisLocaux",
    "introduction.snd.story": "\"Cela fait 6 mois que je suis en Corée, mais je traîne encore seulement avec des gens de mon pays. Je veux vraiment avoir des amis coréens, mais je ne sais pas comment commencer.\"",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Corée",
    "introduction.trd.tag": "#infosVieLocale",
    "introduction.trd.story": "\"Même en regardant YouTube ou les forums, je ne trouve pas d’infos sur mon quartier. Banque, téléphone, hôpitaux... Où trouver des infos locales fiables quand on s’installe ?\"",

    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "Faire de mon quartier un hub global",
    "appMenu.home.local.description": "Partagez vos connaissances locales avec les voisins étrangers et transformez votre ville en vraie communauté internationale.",
    "appMenu.home.local.points": [
      "Partager vos bonnes adresses, services et lieux utiles",
      "Publier des nouvelles et événements du quartier",
      "Contribuer à l'ouverture internationale de votre ville"
    ],
    "appMenu.home.local.tip": "Votre petite connaissance peut devenir une grande aide pour quelqu’un.",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "Tableau de bord pour la vie en Corée",
    "appMenu.home.global.description": "Vérifiez en un coup d’œil la météo, les posts populaires et les infos locales essentielles.",
    "appMenu.home.global.points": [
      "Planifier la journée avec météo et conseils pratiques",
      "Voir les demandes d’aide et actualités du quartier",
      "Ne pas manquer les sujets populaires parmi les locaux"
    ],
    "appMenu.home.global.tip": "5 minutes par jour rendent la vie en Corée plus facile.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Parler avec des voisins étrangers",
    "appMenu.mingl.local.description": "Répondez aux questions, échangez la langue et partagez votre culture.",
    "appMenu.mingl.local.points": [
      "Partager des conseils utiles sur la vie en Corée",
      "Améliorer une langue naturellement",
      "Se faire des amis de différentes cultures"
    ],
    "appMenu.mingl.local.tip": "Petit échange, grande rencontre.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Communiquer naturellement avec les coréens",
    "appMenu.mingl.global.description": "Posez vos questions en toute simplicité avec traduction automatique.",
    "appMenu.mingl.global.points": [
      "Résoudre vos questions sur la vie locale",
      "Dialoguer naturellement grâce à l’IA",
      "Sortir du cercle d’étrangers et faire de vrais amis locaux"
    ],
    "appMenu.mingl.global.tip": "S’intégrer petit à petit, naturellement.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Aider les voisins étrangers & créer des liens",
    "appMenu.connect.local.description": "Aidez les étrangers dans leur installation et construisez un réseau global.",
    "appMenu.connect.local.points": [
      "Aide pratique : banque, logement, documents",
      "Créer une relation en donnant un coup de main",
      "Devenir ambassadeur global du quartier"
    ],
    "appMenu.connect.local.tip": "Une petite aide → une grande amitié.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Résoudre les soucis du quotidien avec des locaux",
    "appMenu.connect.global.description": "Obtenez de l’aide fiable pour banque, logement, visa et plus encore.",
    "appMenu.connect.global.points": [
      "Résoudre des tâches concrètes avec un local",
      "Demander de l’aide simplement, sans formalisme",
      "S’adapter réellement à la vie locale"
    ],
    "appMenu.connect.global.tip": "Pour les problèmes urgents, l’aide locale est la plus efficace.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Discuter en direct avec les voisins étrangers",
    "appMenu.talk.local.description": "Traduction IA → discuter librement et créer une vraie relation.",
    "appMenu.talk.local.points": [
      "Conversation fluide peu importe le niveau de langue",
      "Faire grandir une relation née sur Connect",
      "Écouter et conseiller les nouveaux arrivants"
    ],
    "appMenu.talk.local.tip": "Une conversation peut devenir une amitié durable.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Parler facilement avec des coréens",
    "appMenu.talk.global.description": "Posez vos questions et obtenez des réponses immédiates, sans barrière linguistique.",
    "appMenu.talk.global.points": [
      "Obtenir des réponses directes de locaux",
      "Conversation confortable avec traduction IA",
      "Développer une relation continue avec les voisins"
    ],
    "appMenu.talk.global.tip": "Commencez par une petite question.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Créer votre histoire globale",
    "appMenu.passport.local.description": "Gardez trace de vos échanges et activités globales.",
    "appMenu.passport.local.points": [
      "Visualiser l’historique de vos activités globales",
      "Construire un portfolio d’ambassadeur local",
      "Gérer vos compétences linguistiques et culturelles"
    ],
    "appMenu.passport.local.tip": "Chaque petite aide fait partie de votre histoire globale.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Identité globale - Carte de visite numérique",
    "appMenu.passport.global.description": "Montrez votre parcours multiculturel et établissez la confiance.",
    "appMenu.passport.global.points": [
      "Visualiser votre parcours international",
      "Construire la confiance par votre profil",
      "Se connecter avec des personnes ayant des expériences similaires"
    ],
    "appMenu.passport.global.tip": "Plus votre profil est détaillé, plus les connexions sont authentiques.",

    // Demo Section
    "common.viewAll": "Tout voir",
    "common.minutesAgo": "il y a min",

    "home.tag": "Marché local",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Bonne journée",

    "home.weather.maxTemp": "Max 15°",
    "home.weather.minTemp": "Min 10°",
    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Clair",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Nuageux",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Moyen",

    "home.mytown.title": "Quartier en direct",
    "home.mytown.places.0.name": "Marché Ginkgo",
    "home.mytown.places.0.address": "Siheung-dong, Geumcheon",
    "home.mytown.places.1.name": "Mont Gwanak",
    "home.mytown.places.1.address": "Sillim-dong, Gwanak",
    "home.mytown.places.2.name": "Parc polyvalent Anyangcheon",
    "home.mytown.places.2.address": "Dokseon-dong, Geumcheon",

    "home.events.title": "Événements du quartier",
    "home.events.post_title": "Marché de Doksa-dong ce week-end",
    "home.events.address": "Doksa-dong, Geumcheon",

    "mingl.posts.0.category": "Infos vie",
    "mingl.posts.0.title": "Le vendeur de soondae à Geumcheon-gu est où ?",
    "mingl.posts.0.content": "C’était le meilleur soondae… on ne le voit plus. Quelqu’un sait où il est ?",

    "mingl.posts.1.category": "Infos vie",
    "mingl.posts.1.title": "Astuces marché traditionnel de Doksa-dong",
    "mingl.posts.1.content": "Les prix changent selon les jours. Des conseils ?",

    "mingl.posts.2.category": "Quotidien",
    "mingl.posts.2.title": "Déjeuner près de Gasan Digital ?",
    "mingl.posts.2.content": "Difficile de choisir aujourd’hui… que mangent les salariés du coin ?",

    "mingl.posts.3.category": "Loisir",
    "mingl.posts.3.title": "Soirée jeux de société à Gasan — participants recherchés",
    "mingl.posts.3.content": "Tous les vendredis soir. Rejoignez-nous !",

    "mingl.posts.4.category": "Sortie",
    "mingl.posts.4.title": "Randonnée légère au Mont Hoam ce week-end",
    "mingl.posts.4.content": "J’ai trouvé un parcours agréable, je partage !",

    "mingl.posts.5.category": "Quotidien",
    "mingl.posts.5.title": "Recherche café calme à Doksa-dong",
    "mingl.posts.5.content": "Wi-Fi stable + prises → recommandations bienvenues",

    "mingl.posts.6.category": "Infos vie",
    "mingl.posts.6.title": "Bonne salle de sport à Gasan ?",
    "mingl.posts.6.content": "Des recommandations selon prix / équipement ?",

    "mingl.posts.7.category": "Loisir",
    "mingl.posts.7.title": "Randonnée Gwanak — Qui vient ?",
    "mingl.posts.7.content": "Débutants bienvenus, marche tranquille 😊",

    "connect.titles.0": "Langue",
    "connect.titles.1": "Vie",
    "connect.titles.2": "Occas",
    "connect.titles.3": "Emploi",
    "connect.titles.3.category": "Extra",

    "connect.posts.0.title": "Échange coréen-japonais (conversation business)",
    "connect.posts.0.reward": "Japonais",
    "connect.posts.0.reward_detail": "Horaire flexible",
    "connect.posts.0.location": "Café à Seongbuk-dong",

    "connect.posts.1.title": "Cherche natif hispanophone pour pratique",
    "connect.posts.1.reward": "Carte cadeau",
    "connect.posts.1.reward_detail": "50 000₩ / session",
    "connect.posts.1.location": "Station Geumcheon-gu Office",

    "connect.posts.2.title": "Besoin d’aide : itinéraire Incheon → Mapo",
    "connect.posts.2.reward": "Cadeau",
    "connect.posts.2.reward_detail": "Vin espagnol",
    "connect.posts.2.location": "Aéroport Incheon",

    "connect.posts.3.title": "Besoin d’accompagnement pour contrat de studio",
    "connect.posts.3.reward": "Cash",
    "connect.posts.3.reward_detail": "10 000₩ / heure",
    "connect.posts.3.location": "Yeongdeungpo / Yangcheon",

    "connect.posts.4.title": "Prêter un *monkey driver* 1 jour — J’offre du kimchi",
    "connect.posts.4.reward": "Cadeau",
    "connect.posts.4.reward_detail": "Kimchi maison",
    "connect.posts.4.location": "Seogyo-dong, Mapo",

    "connect.posts.5.title": "Vélo à vendre — très bon état",
    "connect.posts.5.reward": "Prix",
    "connect.posts.5.reward_detail": "50 000₩",
    "connect.posts.5.location": "Près de Sinchon",

    "connect.posts.6.title": "Job court événement — anglais apprécié",
    "connect.posts.6.reward": "Tâche",
    "connect.posts.6.reward_detail": "Support sur site + accueil anglophone",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "Recherche barista parlant espagnol (priorité natifs étrangers)",
    "connect.posts.7.reward": "Salaire",
    "connect.posts.7.reward_detail": "Dès 10 000₩",
    "connect.posts.7.location": "Café à Itaewon",

    "passport.introduction": "J’ai appris le coréen en regardant des émissions, puis gagné un concours de discours en Corée. Cela m’a décidé à venir !",
    "passport.gender": "Sexe",
    "passport.gender_detail": "Homme",
    "passport.birth": "Date de naissance",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Nationalité",
    "passport.nationality_detail": "Mexique",
    "passport.mother_tongue": "Langue maternelle",
    "passport.mother_tongue_detail": "Espagnol",
    "passport.language": "Langues",
    "passport.language_detail.0": "Coréen",
    "passport.language_detail.1": "Anglais",
    "passport.edit": "Modifier",
    "passport.share": "Partager",

    // Logl Video Section
    "loglVideo.title": "Vidéo de présentation logl",
    "loglVideo.description": "Curieux de savoir ce qu’est logl ? Regardez la vidéo !",
    "loglVideo.watch": "Voir la vidéo"
    }
  },
  th: {
    translation: {
      // Header Section
    "header.intro": "แนะนำ",
    "header.demo": "เดโม่",
    "header.video": "วิดีโอ logl",
      
      // Hero Section
    "hero.title": "ทำลายกำแพงภาษา",
    "hero.description": "ค้นหา",
    "hero.demo": "ลองเดโม่",
    "hero.prop1": "บริการท้องถิ่นที่น่าเชื่อถือ",
    "hero.prop2": "แปลภาษา AI แบบเรียลไทม์",
    "hero.prop3": "ชุมชนท้องถิ่นหลากหลาย",

    // Introduction Section
    "introduction.title": "คุณเคยรู้สึกแบบนี้ไหม?",
    "introduction.fst.role": "โลคอล",
    "introduction.snd.role": "โกลบอล",

    "introduction.fst.name": "จิมิน",
    "introduction.fst.location": "โซล เกาหลีใต้",
    "introduction.fst.tag": "#เรียนภาษา",
    "introduction.fst.story": "\"ฉันพยายามเรียนภาษาอังกฤษและเคยไปเรียนต่อต่างประเทศ... แต่พอไม่ได้ใช้ก็ลืมหมดเลย อยากมีโอกาสใช้ในชีวิตประจำวัน 😢\"",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "ซูวอน เกาหลีใต้",
    "introduction.snd.tag": "#หาเพื่อนคนท้องถิ่น",
    "introduction.snd.story": "\"มาเกาหลีมา 6 เดือนแล้ว แต่ก็ยังอยู่กับเพื่อนประเทศเดียวกันตลอด อยากสนิทกับเพื่อนเกาหลีจริงๆ แต่ไม่รู้จะเริ่มยังไง.\"",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "ช็อนจู เกาหลีใต้",
    "introduction.trd.tag": "#ข้อมูลชีวิตประจำวัน",
    "introduction.trd.story": "\"ดูยูทูบก็แล้ว เข้ากลุ่มก็แล้ว แต่ข้อมูลในย่านที่ฉันอยู่ไม่มีเลย เปิดบัญชีธนาคาร อินเทอร์เน็ต โรงพยาบาล... จะหาข้อมูลล่าสุดที่เชื่อถือได้ที่ไหน?\"",

    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "ทำให้ย่านของคุณเป็นศูนย์กลางนานาชาติ",
    "appMenu.home.local.description": "แชร์ข้อมูลท้องถิ่นให้เพื่อนต่างชาติ และสร้างชุมชนที่เป็นมิตรและเชื่อมต่อกัน",
    "appMenu.home.local.points": [
      "แนะนำร้านอาหาร สถานที่ และสิ่งอำนวยความสะดวก",
      "แชร์ข่าวสารและกิจกรรมในย่านแบบเรียลไทม์",
      "ช่วยสร้างภาพลักษณ์ย่านนานาชาติ"
    ],
    "appMenu.home.local.tip": "ข้อมูลเล็กๆ ของคุณ อาจเป็นคู่มือชีวิตของใครบางคน",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "แดชบอร์ดชีวิตในเกาหลี",
    "appMenu.home.global.description": "ดูข้อมูลสำคัญในชีวิตประจำวันได้ในที่เดียว เช่น สภาพอากาศและกระทู้ยอดฮิตในย่าน",
    "appMenu.home.global.points": [
      "วางแผนวันของคุณด้วยข้อมูลสภาพอากาศ",
      "เช็คข่าวสารและคำขอความช่วยเหลือในย่าน",
      "ไม่พลาดหัวข้อยอดนิยมในหมู่คนเกาหลี"
    ],
    "appMenu.home.global.tip": "ดูแค่วันละ 5 นาที ชีวิตในเกาหลีง่ายขึ้นมาก",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "สนทนากับเพื่อนต่างชาติ",
    "appMenu.mingl.local.description": "ตอบคำถาม แบ่งปันวัฒนธรรม และแลกเปลี่ยนภาษา",
    "appMenu.mingl.local.points": [
      "แชร์เคล็ดลับชีวิตในเกาหลี",
      "ฝึกภาษาต่างประเทศแบบเป็นธรรมชาติ",
      "พบเพื่อนใหม่จากหลากหลายประเทศ"
    ],
    "appMenu.mingl.local.tip": "บทสนทนาเล็กๆ นำไปสู่ความสัมพันธ์ที่มีความหมาย",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "คุยกับคนเกาหลีได้อย่างเป็นธรรมชาติ",
    "appMenu.mingl.global.description": "ถามสิ่งที่สงสัยเกี่ยวกับชีวิตในเกาหลีได้ทันที ด้วยการแปลอัตโนมัติ",
    "appMenu.mingl.global.points": [
      "แก้ไขข้อสงสัยในชีวิตประจำวัน",
      "สนทนาได้อย่างราบรื่นแม้ไม่เก่งภาษา",
      "ออกจากกลุ่มต่างชาติ และพบเพื่อนคนเกาหลีจริงๆ"
    ],
    "appMenu.mingl.global.tip": "ค่อยๆ เข้าสู่สังคมท้องถิ่นอย่างเป็นธรรมชาติ",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "ช่วยเหลือเพื่อนต่างชาติ & สร้างมิตรภาพ",
    "appMenu.connect.local.description": "ช่วยจัดการเรื่องสำคัญ เช่น ธนาคาร ห้องพัก เอกสาร",
    "appMenu.connect.local.points": [
      "ให้ความช่วยเหลือด้านชีวิตจริง",
      "สร้างความสัมพันธ์ผ่านการช่วยเหลือ",
      "เป็นตัวแทนประสานเพื่อนต่างชาติกับชุมชน"
    ],
    "appMenu.connect.local.tip": "ความช่วยเหลือเล็กๆ นำไปสู่มิตรภาพยาวนาน",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "แก้ปัญหาชีวิตประจำวันกับคนท้องถิ่น",
    "appMenu.connect.global.description": "รับความช่วยเหลือที่ไว้ใจได้จากคนในย่าน",
    "appMenu.connect.global.points": [
      "จัดการเรื่องธนาคาร ที่พัก เอกสารได้ง่าย",
      "ขอความช่วยเหลือแบบเป็นกันเอง",
      "ปรับตัวเข้ากับวิถีชีวิตท้องถิ่นจริงๆ"
    ],
    "appMenu.connect.global.tip": "เรื่องด่วน คนท้องถิ่นช่วยได้เร็วที่สุด",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "คุยกับเพื่อนต่างชาติแบบเรียลไทม์",
    "appMenu.talk.local.description": "พูดคุยโดยไม่ต้องกังวลเรื่องภาษา",
    "appMenu.talk.local.points": [
      "คุยได้ลื่นไหลโดยไม่ต้องเก่งภาษา",
      "สานสัมพันธ์ต่อจาก Connect",
      "ให้คำแนะนำและพูดคุยอย่างจริงใจ"
    ],
    "appMenu.talk.local.tip": "บทสนทนาวันนี้ อาจกลายเป็นมิตรภาพตลอดไป",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "คุยกับคนเกาหลีได้อย่างสบายใจ",
    "appMenu.talk.global.description": "ถามสิ่งที่สงสัย และได้คำตอบทันที",
    "appMenu.talk.global.points": [
      "ถามคนเกาหลีได้โดยตรง",
      "คุยได้อย่างเป็นธรรมชาติด้วยการแปล AI",
      "สานต่อความสัมพันธ์จาก Connect"
    ],
    "appMenu.talk.global.tip": "เริ่มจากคำถามเล็กๆ ก็เพียงพอ",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "สร้างเส้นทางสู่การเป็นพลเมืองโลก",
    "appMenu.passport.local.description": "บันทึกประสบการณ์กับเพื่อนต่างชาติ",
    "appMenu.passport.local.points": [
      "แสดงไทม์ไลน์กิจกรรมระหว่างวัฒนธรรม",
      "สร้างโปรไฟล์ผู้ช่วยเหลือเพื่อนต่างชาติ",
      "จัดการทักษะภาษาและวัฒนธรรม"
    ],
    "appMenu.passport.local.tip": "ทุกการช่วยเหลือคือส่วนหนึ่งของเรื่องราวระดับโลกของคุณ",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "อัตลักษณ์ระดับโลก - โปรไฟล์ที่เชื่อถือได้",
    "appMenu.passport.global.description": "แสดงประสบการณ์และเส้นทางของคุณอย่างชัดเจน",
    "appMenu.passport.global.points": [
      "เห็นประสบการณ์ต่างประเทศของคุณชัดเจน",
      "สร้างความน่าเชื่อถือผ่านโปรไฟล์",
      "เชื่อมต่อกับคนที่มีประสบการณ์คล้ายกัน"
    ],
    "appMenu.passport.global.tip": "โปรไฟล์ละเอียด → มิตรภาพที่จริงใจ",

    // Demo Section
    "common.viewAll": "ดูทั้งหมด",
    "common.minutesAgo": "นาทีที่แล้ว",

    "home.tag": "ตลาดนัด",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "ขอให้เป็นวันที่ดี",

    "home.weather.maxTemp": "สูงสุด 15°",
    "home.weather.minTemp": "ต่ำสุด 10°",
    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "แจ่มใส",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "มีเมฆ",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "ปานกลาง",

    "home.mytown.title": "ย่านของฉันตอนนี้",
    "home.mytown.places.0.name": "ตลาดแปะก๊วย",
    "home.mytown.places.0.address": "Siheung-dong, Geumcheon",
    "home.mytown.places.1.name": "ภูเขา Gwanak",
    "home.mytown.places.1.address": "Sillim-dong, Gwanak",
    "home.mytown.places.2.name": "ลานเอนกประสงค์ Anyangcheon",
    "home.mytown.places.2.address": "Dokseon-dong, Geumcheon",

    "home.events.title": "กิจกรรมในย่าน",
    "home.events.post_title": "ตลาดนัด Doksa-dong สุดสัปดาห์นี้",
    "home.events.address": "Doksa-dong, Geumcheon",

    "mingl.posts.0.category": "ข้อมูลชีวิตประจำวัน",
    "mingl.posts.0.title": "รถขายซุนแดที่ Geumcheon หายไปไหน?",
    "mingl.posts.0.content": "อร่อยที่สุดที่เคยกิน! ช่วงนี้ไม่เห็นเลย ใครรู้บ้าง?",

    "mingl.posts.1.category": "ข้อมูลชีวิตประจำวัน",
    "mingl.posts.1.title": "เคล็ดลับซื้อของที่ตลาด Doksa-dong",
    "mingl.posts.1.content": "ราคาต่างกันตามวัน มีใครมีทริคดีๆ ไหม?",

    "mingl.posts.2.category": "ชีวิตประจำวัน",
    "mingl.posts.2.title": "เที่ยงนี้กินอะไรดีแถว Gasan?",
    "mingl.posts.2.content": "เลือกไม่ถูกเลย… คนที่ทำงานแถวนั้นกินอะไรกัน?",

    "mingl.posts.3.category": "งานอดิเรก",
    "mingl.posts.3.title": "ชวนเล่นบอร์ดเกมที่ Gasan — ต้องการสมาชิกเพิ่ม",
    "mingl.posts.3.content": "ทุกคืนวันศุกร์ อยากให้มาร่วมด้วย!",

    "mingl.posts.4.category": "เที่ยว/เดินเล่น",
    "mingl.posts.4.title": "เส้นทางเดินเล่นสบายๆ ที่เขา Hoam",
    "mingl.posts.4.content": "พบเส้นทางดีๆ มา แบ่งปันนะ!",

    "mingl.posts.5.category": "ชีวิตประจำวัน",
    "mingl.posts.5.title": "มองหาคาเฟ่เงียบๆ แถว Doksa-dong",
    "mingl.posts.5.content": "ต้องมีไวไฟดี + ปลั๊ก ถ้ามีแนะนำที",

    "mingl.posts.6.category": "ข้อมูลชีวิตประจำวัน",
    "mingl.posts.6.title": "มีฟิตเนสดีๆ แถว Gasan ไหม?",
    "mingl.posts.6.content": "แนะนำตามราคา/อุปกรณ์ได้เลย!",

    "mingl.posts.7.category": "งานอดิเรก",
    "mingl.posts.7.title": "ใครสนใจไปเดินเขา Gwanak ด้วยกัน?",
    "mingl.posts.7.content": "มือใหม่ยินดีมาก เดินชิลๆ 😊",

    "connect.titles.0": "ภาษา",
    "connect.titles.1": "ชีวิต",
    "connect.titles.2": "มือสอง",
    "connect.titles.3": "งาน",
    "connect.titles.3.category": "พาร์ท",

    "connect.posts.0.title": "แลกเปลี่ยนภาษาเกาหลี-ญี่ปุ่น (แนวธุรกิจ)",
    "connect.posts.0.reward": "ภาษาญี่ปุ่น",
    "connect.posts.0.reward_detail": "เวลาเจรจาได้",
    "connect.posts.0.location": "คาเฟ่ Seongbuk-dong",

    "connect.posts.1.title": "หาคนสเปนเจ้าของภาษา ช่วยฝึกสนทนา",
    "connect.posts.1.reward": "บัตรของขวัญ",
    "connect.posts.1.reward_detail": "50,000₩ / ครั้ง",
    "connect.posts.1.location": "สถานี Geumcheon-gu Office",

    "connect.posts.2.title": "ขอความช่วยเหลือ: เส้นทางสนามบินอินชอน → Mapo",
    "connect.posts.2.reward": "ของฝาก",
    "connect.posts.2.reward_detail": "ไวน์สเปน",
    "connect.posts.2.location": "สนามบินอินชอน",

    "connect.posts.3.title": "ช่วยไปเซ็นสัญญาห้องพักด้วยกันได้ไหม?",
    "connect.posts.3.reward": "เงินสด",
    "connect.posts.3.reward_detail": "10,000₩ / ชม.",
    "connect.posts.3.location": "Yeongdeungpo / Yangcheon",

    "connect.posts.4.title": "ขอยืม Monkey Driver หนึ่งวัน — มีแจกกักดูจิ",
    "connect.posts.4.reward": "ของฝาก",
    "connect.posts.4.reward_detail": "กักดูจิทำเอง",
    "connect.posts.4.location": "Seogyo-dong, Mapo",

    "connect.posts.5.title": "ขายจักรยาน สภาพดีมาก",
    "connect.posts.5.reward": "ราคา",
    "connect.posts.5.reward_detail": "50,000₩",
    "connect.posts.5.location": "ใกล้สถานี Sinchon",

    "connect.posts.6.title": "รับสมัครงานอีเวนต์ ระยะสั้น — เก่งอังกฤษได้เปรียบ",
    "connect.posts.6.reward": "งาน",
    "connect.posts.6.reward_detail": "ช่วยงานในงาน + ต้อนรับภาษาอังกฤษ",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "รับสมัครบาริสต้าพูดสเปน (ชาวต่างชาติมีสิทธิ์ก่อน)",
    "connect.posts.7.reward": "รายชั่วโมง",
    "connect.posts.7.reward_detail": "เริ่มที่ 10,000₩",
    "connect.posts.7.location": "คาเฟ่ Itaewon",

    "passport.introduction": "ฉันเริ่มเรียนภาษาเกาหลีจากรายการทีวี และได้รางวัลที่ 1 ในการแข่งขันสุนทรพจน์ จึงตัดสินใจมาเกาหลี!",
    "passport.gender": "เพศ",
    "passport.gender_detail": "ชาย",
    "passport.birth": "วันเกิด",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "สัญชาติ",
    "passport.nationality_detail": "เม็กซิโก",
    "passport.mother_tongue": "ภาษาแม่",
    "passport.mother_tongue_detail": "สเปน",
    "passport.language": "ภาษา",
    "passport.language_detail.0": "เกาหลี",
    "passport.language_detail.1": "อังกฤษ",
    "passport.edit": "แก้ไข",
    "passport.share": "แชร์",

    // Positioned Mobile Demo Section (th)
    "positionedMobileDemo.home.description": "เหมือน ‘ข่าวย่านนี้’ ดูสถานการณ์รอบตัวได้ในครั้งเดียว",
    "positionedMobileDemo.home.features.0.description": "ไม่พลาดข่าวและกิจกรรมในพื้นที่แบบเรียลไทม์",
    "positionedMobileDemo.home.features.1.description": "สำรวจเรื่องราวในชีวิตประจำวันของผู้คนรอบสถานที่ต่างๆ",
    "positionedMobileDemo.home.features.2.description": "เข้าร่วมงานเทศกาล กิจกรรม และกิจกรรมเล็กใหญ่ในชุมชนได้ง่าย",

    "positionedMobileDemo.mingl.description": "ค้นหาและแชร์ชีวิตจริงในย่านของคุณด้วยแผนที่เป็นศูนย์กลาง",
    "positionedMobileDemo.mingl.features.0.description": "แบ่งปันคำถาม ข้อมูล ข่าว และคำแนะนำได้อย่างอิสระ เข้าสู่การสื่อสารอย่างเป็นธรรมชาติ",
    "positionedMobileDemo.mingl.features.1.description": "แปลเรียลไทม์ ไม่มีอุปสรรคด้านภาษาในการพูดคุยระดับสากล",
    "positionedMobileDemo.mingl.features.2.description": "โลกในสายตาของคนท้องถิ่น และท้องถิ่นในสายตาของคนต่างชาติ",

    "positionedMobileDemo.connect.description": "ความช่วยเหลือที่ให้และได้รับ ทำให้เกิดการเชื่อมต่อ",
    "positionedMobileDemo.connect.features.0.description": "จับคู่ความช่วยเหลือตามพื้นที่ได้ทันทีเมื่อคุณต้องการ",
    "positionedMobileDemo.connect.features.1.description": "เลือกคนที่ ‘ไว้ใจได้และปลอดภัย’ ด้วยตัวเอง",
    "positionedMobileDemo.connect.features.2.description": "จากการสนทนา → การแลกเปลี่ยน → ความสัมพันธ์ยาวนานในพื้นที่และระดับโลก",

    "positionedMobileDemo.talk.description": "พบเพื่อนต่างชาติได้ง่ายโดยไม่ต้องกังวลเรื่องภาษา ด้วย AI แปลทันที",
    "positionedMobileDemo.talk.features.0.description": "การสนทนาเป็นธรรมชาติ แม้ไม่เก่งภาษา ด้วยการแปลเรียลไทม์จาก AI",
    "positionedMobileDemo.talk.features.1.description": "ถามเรื่องชีวิตในเกาหลีโดยตรงจากคนท้องถิ่นและรับคำตอบทันที",
    "positionedMobileDemo.talk.features.2.description": "พัฒนาความสัมพันธ์ที่เริ่มจาก Connect ให้กลายเป็นมิตรภาพที่ยาวนาน",

    "positionedMobileDemo.passport.description": "สร้างนามบัตรดิจิทัลที่รวมประสบการณ์ระดับสากลของคุณ",
    "positionedMobileDemo.passport.features.0.description": "บันทึกประวัติการอยู่อาศัยและกิจกรรมตามแต่ละพื้นที่ในไทม์ไลน์",
    "positionedMobileDemo.passport.features.1.description": "แสดงความสามารถด้านภาษาและสไตล์การสื่อสารอย่างชัดเจน",
    "positionedMobileDemo.passport.features.2.description": "เชื่อมต่อกับคนที่มีประสบการณ์คล้ายกันได้อย่างเป็นธรรมชาติ",

    // Logl Video Section
    "loglVideo.title": "วิดีโอแนะนำ logl",
    "loglVideo.description": "อยากรู้ว่า logl คืออะไร? ดูวิดีโอนี้เลย!",
    "loglVideo.watch": "ดูวิดีโอ"
    }
  },
  ar: {
    translation: {
      // Header Section
    "header.intro": "مقدمة",
    "header.demo": "تجربة",
    "header.video": "فيديو logl",
      
      // Hero Section
    "hero.title": "إزالة حاجز اللغة",
    "hero.description": "ابحث عن",
    "hero.demo": "جرّب الديمو",
      "hero.prop1": "خدمات محلية موثوقة",
    "hero.prop2": "ترجمة فورية بالذكاء الاصطناعي",
      "hero.prop3": "مجتمعات محلية متنوعة",

    // Introduction Section
    "introduction.title": "هل شعرت بهذا من قبل؟",
    "introduction.fst.role": "محلي",
    "introduction.snd.role": "عالمي",

    "introduction.fst.name": "جيمين",
    "introduction.fst.location": "سيول، كوريا الجنوبية",
    "introduction.fst.tag": "#تعلم_لغة",
    "introduction.fst.story": "«درست الإنجليزية وسافرت للخارج... لكن بدون استخدام يومي أنسى كل شيء. أتمنى لو أستطيع استخدامها في حياتي اليومية 😢»",

    "introduction.snd.name": "صوفيا",
    "introduction.snd.location": "سوون، كوريا الجنوبية",
    "introduction.snd.tag": "#صداقة_محلية",
    "introduction.snd.story": "«لي 6 أشهر في كوريا وما زلت ألتقي فقط بأصدقائي الأجانب. أريد أصدقاء كوريين حقيقيين لكن لا أعرف كيف أبدأ.»",

    "introduction.trd.name": "كارلوس",
    "introduction.trd.location": "جونجو، كوريا الجنوبية",
    "introduction.trd.tag": "#معلومات_محلية",
    "introduction.trd.story": "«حتى مع YouTube والمجموعات، لا توجد معلومات تخص الحي الذي أعيش فيه. حساب بنكي، شركات الاتصالات، المستشفى... من أين أحصل على معلومات حديثة وموثوقة؟»",

    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "اجعل حيّك مجتمعًا عالميًا",
    "appMenu.home.local.description": "شارك معرفتك بالحي وساعد الجيران الأجانب لبناء مجتمع متواصل وداعم.",
    "appMenu.home.local.points": [
      "اقتراح مطاعم وأماكن وخدمات محلية",
      "مشاركة أخبار وأنشطة الحي",
      "دعم جعل الحي أكثر انفتاحًا وثقافيًا"
    ],
    "appMenu.home.local.tip": "معلومة صغيرة منك قد تكون دليل حياة لشخص آخر",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "لوحة تحكم لحياتك في كوريا",
    "appMenu.home.global.description": "كل ما تحتاجه في حياتك اليومية — الطقس، الأخبار، وأكثر — في شاشة واحدة.",
    "appMenu.home.global.points": [
      "تنظيم يومك حسب الطقس",
      "متابعة أخبار الحي وطلبات المساعدة",
      "عدم تفويت القصص الشائعة بين الكوريين"
    ],
    "appMenu.home.global.tip": "متابعة قصيرة يوميًا تجعل حياتك في كوريا أسهل بكثير",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "تحدث مع أصدقاء عالميين",
    "appMenu.mingl.local.description": "شارك ثقافتك وساعد الآخرين وتعلم لغات جديدة بشكل طبيعي.",
    "appMenu.mingl.local.points": [
      "مشاركة نصائح الحياة في كوريا",
      "تطوير اللغة بشكل طبيعي",
      "التعرف على أصدقاء من دول مختلفة"
    ],
    "appMenu.mingl.local.tip": "الحوار الصغير اليوم يمكن أن يصبح صداقة كبيرة غدًا",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "تواصل بشكل طبيعي مع الكوريين",
    "appMenu.mingl.global.description": "استخدم الترجمة الفورية لطرح الأسئلة وتكوين علاقات حقيقية.",
    "appMenu.mingl.global.points": [
      "حل تساؤلات الحياة اليومية",
      "حديث طبيعي بلا خوف من اللغة",
      "الخروج من فقاعات الأجانب وصنع صداقات محلية حقيقية"
    ],
    "appMenu.mingl.global.tip": "التعايش الثقافي يبدأ من محادثة بسيطة",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "ساعد الجيران الأجانب وكون صداقات",
    "appMenu.connect.local.description": "ساعد في أمور الحياة اليومية واصنع علاقات ذات معنى.",
    "appMenu.connect.local.points": [
      "مساعدة حقيقية في الأمور العملية",
      "العلاقات تتكون من المساعدة المتبادلة",
      "كن سفيرًا عالميًا في حيّك"
    ],
    "appMenu.connect.local.tip": "المساعدة الصغيرة تصنع روابط قوية",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "حل مشاكلك مع جيران محليين",
    "appMenu.connect.global.description": "احصل على دعم موثوق من أشخاص يعرفون المكان جيدًا.",
    "appMenu.connect.global.points": [
      "فتح حساب، إيجاد منزل، وإجراءات أخرى بسهولة",
      "طلب المساعدة دون وسطاء",
      "الاندماج في المجتمع الحقيقي"
    ],
    "appMenu.connect.global.tip": "عندما تكون الأمور طارئة، الجار هو الأسرع والأوثق.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "تحدث مع الجيران الأجانب في الوقت الحقيقي",
    "appMenu.talk.local.description": "ترجمة فورية بدون خوف من اللغة.",
    "appMenu.talk.local.points": [
      "حديث سلس دون الحاجة لإتقان اللغة",
      "بناء علاقة بعد Connect",
      "دعم ومشورة صادقة"
    ],
    "appMenu.talk.local.tip": "حديث اليوم قد يصبح صداقة العمر.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "تحدث براحة مع الكوريين",
    "appMenu.talk.global.description": "اسأل واحصل على إجابة مباشرة.",
    "appMenu.talk.global.points": [
      "اسأل الكوريين مباشرة",
      "حديث طبيعي بفضل الترجمة بالذكاء الاصطناعي",
      "تابع علاقتك مع من ساعدك عبر Connect"
    ],
    "appMenu.talk.global.tip": "ابدأ بسؤال صغير.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "اصنع هويتك العالمية",
    "appMenu.passport.local.description": "وثّق تجاربك وتفاعلك مع الجيران الأجانب.",
    "appMenu.passport.local.points": [
      "عرض خط زمني لتجاربك الثقافية",
      "بناء ملف سفير المجتمع العالمي",
      "إدارة مهاراتك اللغوية والثقافية"
    ],
    "appMenu.passport.local.tip": "كل لحظة مساعدة هي جزء من قصتك العالمية.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "هوية عالمية — بطاقة تعريف موثوقة",
    "appMenu.passport.global.description": "اعرض تجربتك بثقة واجذب أصدقاء ومرشدين موثوقين.",
    "appMenu.passport.global.points": [
      "خبراتك واضحة في مكان واحد",
      "بناء الثقة عبر ملفك الشخصي",
      "الاتصال مع أشخاص يشاركونك نفس التجارب"
    ],
    "appMenu.passport.global.tip": "كلما كان ملفك أوضح، أصبحت علاقاتك أعمق.",

    // Demo Section
    "common.viewAll": "عرض الكل",
    "common.minutesAgo": "قبل دقائق",

    "home.tag": "سوق محلي",
    "home.greeting_01": "كارلوس",
    "home.greeting_02": "أتمنى لك يومًا جميلًا",

    "home.weather.maxTemp": "أعلى 15°",
    "home.weather.minTemp": "أدنى 10°",
    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "صحو",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "غائم",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "متوسط",

    "home.mytown.title": "حيّي الآن",
    "home.mytown.places.0.name": "سوق الجينكو",
    "home.mytown.places.0.address": "سيهونغ-دونغ، غومتشون",
    "home.mytown.places.1.name": "جبل غواناك",
    "home.mytown.places.1.address": "سيلّيم-دونغ، غواناك",
    "home.mytown.places.2.name": "ساحة أنيانغ المفتوحة",
    "home.mytown.places.2.address": "دوكسيون-دونغ، غومتشون",

    "home.events.title": "فعاليات الحي",
    "home.events.post_title": "سوق محلي في دوكسان-دونغ",
    "home.events.address": "دوكسان-دونغ، غومتشون",

    "mingl.posts.0.category": "معلومات الحياة اليومية",
    "mingl.posts.0.title": "أين ذهب بائع السونداي قرب محطة غومتشون؟",
    "mingl.posts.0.content": "كان ألذ ما أكلت! لم أره مؤخرًا. هل يعرف أحد؟",

    "mingl.posts.1.category": "معلومات الحياة اليومية",
    "mingl.posts.1.title": "نصائح التسوق في سوق دوكسان التقليدي",
    "mingl.posts.1.content": "الأسعار تختلف حسب الأيام. أي نصائح؟",

    "mingl.posts.2.category": "يوميات",
    "mingl.posts.2.title": "ماذا نأكل للغداء قرب غاسان؟",
    "mingl.posts.2.content": "صعب أقرر اليوم… ماذا يأكل الموظفون هناك؟",

    "mingl.posts.3.category": "هوايات / تجمعات",
    "mingl.posts.3.title": "مجموعة ألعاب لوحية قرب غاسان — انضموا!",
    "mingl.posts.3.content": "نجتمع كل جمعة مساءً. أهلًا بالجميع!",

    "mingl.posts.4.category": "تنزه / خروج",
    "mingl.posts.4.title": "مسار سهل للمشي في جبل هوام",
    "mingl.posts.4.content": "وجدت مسارًا لطيفًا للويكند. سأشاركه!",

    "mingl.posts.5.category": "يوميات",
    "mingl.posts.5.title": "أبحث عن مقهى هادئ قرب دوكسان-دونغ",
    "mingl.posts.5.content": "يفضل Wi-Fi جيد + مقابس. أي اقتراحات؟",

    "mingl.posts.6.category": "معلومات الحياة اليومية",
    "mingl.posts.6.title": "هل يوجد نادي رياضي جيد قرب غاسان؟",
    "mingl.posts.6.content": "أرغب بترشيحات حسب السعر/المعدات!",

    "mingl.posts.7.category": "هوايات / تجمعات",
    "mingl.posts.7.title": "من يرغب بالمشي في جبل غواناك معي؟",
    "mingl.posts.7.content": "نمشِي بهدوء. المبتدئون مرحب بهم 😊",

    "connect.titles.0": "لغة",
    "connect.titles.1": "حياة",
    "connect.titles.2": "مستعمل",
    "connect.titles.3": "وظائف",
    "connect.titles.3.category": "جزئي",

    "connect.posts.0.title": "تبادل لغوي كوري-ياباني (عمل/محادثة)",
    "connect.posts.0.reward": "اليابانية",
    "connect.posts.0.reward_detail": "تنسيق حسب الوقت",
    "connect.posts.0.location": "مقهى في Seongbuk-dong",

    "connect.posts.1.title": "أبحث عن متحدث أصلي بالإسبانية للتدريب",
    "connect.posts.1.reward": "بطاقة هدية",
    "connect.posts.1.reward_detail": "50,000₩ للمرّة",
    "connect.posts.1.location": "محطة مكتب غومتشون",

    "connect.posts.2.title": "مساعدة: الطريق من مطار إنشون إلى Mapo",
    "connect.posts.2.reward": "هدية",
    "connect.posts.2.reward_detail": "نبيذ إسباني",
    "connect.posts.2.location": "مطار إنشون",

    "connect.posts.3.title": "هل يمكنك مرافقتي لتوقيع عقد الغرفة؟",
    "connect.posts.3.reward": "نقد",
    "connect.posts.3.reward_detail": "10,000₩ / الساعة",
    "connect.posts.3.location": "يونغدونغبو / يانغتشون",

    "connect.posts.4.title": "أقرضني Monkey Driver ليوم واحد — أعطيك كيمتشي منزلي!",
    "connect.posts.4.reward": "هدية",
    "connect.posts.4.reward_detail": "كيمتشي منزلي",
    "connect.posts.4.location": "Seogyo-dong، Mapo",

    "connect.posts.5.title": "أبيع دراجة — بحالة ممتازة",
    "connect.posts.5.reward": "السعر",
    "connect.posts.5.reward_detail": "50,000₩",
    "connect.posts.5.location": "قرب محطة Sinchon",

    "connect.posts.6.title": "وظيفة مؤقتة في معرض — الأفضلية لمن يجيد الإنجليزية",
    "connect.posts.6.reward": "عمل",
    "connect.posts.6.reward_detail": "مساعدة ميدانية + استقبال",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "مطلوب باريستا يتحدث الإسبانية (الأجانب مرحب بهم أولًا)",
    "connect.posts.7.reward": "أجر الساعة",
    "connect.posts.7.reward_detail": "ابتداءً من 10,000₩",
    "connect.posts.7.location": "مقهى في Itaewon",

    "passport.introduction": "بدأت تعلم الكورية من البرامج التلفزيونية، وفزت بمسابقة خطاب بالكورية في المكسيك، ثم قررت المجيء إلى كوريا!",
    "passport.gender": "الجنس",
    "passport.gender_detail": "ذكر",
    "passport.birth": "تاريخ الميلاد",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "الجنسية",
    "passport.nationality_detail": "المكسيك",
    "passport.mother_tongue": "اللغة الأم",
    "passport.mother_tongue_detail": "الإسبانية",
    "passport.language": "اللغات",
    "passport.language_detail.0": "الكورية",
    "passport.language_detail.1": "الإنجليزية",
    "passport.edit": "تعديل",
    "passport.share": "مشاركة",

    // Positioned Mobile Demo Section (ar)
    "positionedMobileDemo.home.description": "تابع ما يحدث في منطقتك الآن كما لو كان «أخبار الحي»",
    "positionedMobileDemo.home.features.0.description": "لا تفوّت الأخبار والفعاليات المحلية في الوقت الفعلي",
    "positionedMobileDemo.home.features.1.description": "استكشف يوميات وأحاديث السكان حول الأماكن المختلفة",
    "positionedMobileDemo.home.features.2.description": "انضم بسهولة للمهرجانات واللقاءات والأنشطة الكبيرة والصغيرة في منطقتك",

    "positionedMobileDemo.mingl.description": "اكتشف وشارك الحياة الواقعية في الحي اعتمادًا على الموقع",
    "positionedMobileDemo.mingl.features.0.description": "شارك الأسئلة والمعلومات والأخبار والتوصيات بحرية لخلق تواصل طبيعي",
    "positionedMobileDemo.mingl.features.1.description": "ترجمة فورية لكسر حاجز اللغة وتحقيق تواصل عالمي حقيقي",
    "positionedMobileDemo.mingl.features.2.description": "رؤية العالم بعين المحلي، ورؤية المحلي بعين القادم من الخارج",

    "positionedMobileDemo.connect.description": "من لحظات المساعدة تنشأ الروابط",
    "positionedMobileDemo.connect.features.0.description": "ابحث واحصل على المساعدة التي تحتاجها عبر مطابقة محلية مباشرة",
    "positionedMobileDemo.connect.features.1.description": "اختر بنفسك الشخص «الآمن والموثوق» الذي يناسب وضعك",
    "positionedMobileDemo.connect.features.2.description": "من الحوار → إلى التبادل → إلى علاقات محلية وعالمية مستمرة",

    "positionedMobileDemo.talk.description": "التقِ بأصدقاء من مختلف الدول دون قلق من اللغة بفضل الترجمة الفورية بالذكاء الاصطناعي",
    "positionedMobileDemo.talk.features.0.description": "محادثات طبيعية بغض النظر عن مستواك اللغوي عبر الترجمة الفورية",
    "positionedMobileDemo.talk.features.1.description": "اسأل السكان المحليين مباشرة عن الحياة في كوريا واحصل على إجابة فورية",
    "positionedMobileDemo.talk.features.2.description": "حوّل العلاقة التي بدأت في Connect إلى صداقة طويلة الأمد",

    "positionedMobileDemo.passport.description": "أنشئ بطاقة تعريف رقمية تلخص تاريخك العالمي",
    "positionedMobileDemo.passport.features.0.description": "سجّل تاريخ إقامتك وأنشطتك حسب المناطق في خط زمني واضح",
    "positionedMobileDemo.passport.features.1.description": "اعرض مهاراتك اللغوية وأسلوبك في التواصل بوضوح",
    "positionedMobileDemo.passport.features.2.description": "تواصل بشكل طبيعي مع أشخاص يمتلكون تجارب مشابهة",


    // Logl Video Section
    "loglVideo.title": "فيديو تعريفي عن logl",
    "loglVideo.description": "هل تريد معرفة ما هو logl؟ شاهد الفيديو!",
    "loglVideo.watch": "مشاهدة الفيديو"
      
    }
  },
  ru: {
    translation: {
      // Header Section
    "header.intro": "مقدمة",
    "header.demo": "تجربة",
    "header.video": "فيديو logl",
      
      // Hero Section
    "hero.title": "إزالة حاجز اللغة",
    "hero.description": "ابحث عن",
    "hero.demo": "جرّب الديمو",
    "hero.prop1": "خدمات محلية موثوقة",
    "hero.prop2": "ترجمة فورية بالذكاء الاصطناعي",
    "hero.prop3": "مجتمعات محلية متنوعة",

    // Introduction Section
    "introduction.title": "هل شعرت بهذا من قبل؟",
    "introduction.fst.role": "محلي",
    "introduction.snd.role": "عالمي",

    "introduction.fst.name": "جيمين",
    "introduction.fst.location": "سيول، كوريا الجنوبية",
    "introduction.fst.tag": "#تعلم_لغة",
    "introduction.fst.story": "«درست الإنجليزية وسافرت للخارج... لكن بدون استخدام يومي أنسى كل شيء. أتمنى لو أستطيع استخدامها في حياتي اليومية 😢»",

    "introduction.snd.name": "صوفيا",
    "introduction.snd.location": "سوون، كوريا الجنوبية",
    "introduction.snd.tag": "#صداقة_محلية",
    "introduction.snd.story": "«لي 6 أشهر في كوريا وما زلت ألتقي فقط بأصدقائي الأجانب. أريد أصدقاء كوريين حقيقيين لكن لا أعرف كيف أبدأ.»",

    "introduction.trd.name": "كارلوس",
    "introduction.trd.location": "جونجو، كوريا الجنوبية",
    "introduction.trd.tag": "#معلومات_محلية",
    "introduction.trd.story": "«حتى مع YouTube والمجموعات، لا توجد معلومات تخص الحي الذي أعيش فيه. حساب بنكي، شركات الاتصالات، المستشفى... من أين أحصل على معلومات حديثة وموثوقة؟»",

    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "اجعل حيّك مجتمعًا عالميًا",
    "appMenu.home.local.description": "شارك معرفتك بالحي وساعد الجيران الأجانب لبناء مجتمع متواصل وداعم.",
    "appMenu.home.local.points": [
      "اقتراح مطاعم وأماكن وخدمات محلية",
      "مشاركة أخبار وأنشطة الحي",
      "دعم جعل الحي أكثر انفتاحًا وثقافيًا"
    ],
    "appMenu.home.local.tip": "معلومة صغيرة منك قد تكون دليل حياة لشخص آخر",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "لوحة تحكم لحياتك في كوريا",
    "appMenu.home.global.description": "كل ما تحتاجه في حياتك اليومية — الطقس، الأخبار، وأكثر — في شاشة واحدة.",
    "appMenu.home.global.points": [
      "تنظيم يومك حسب الطقس",
      "متابعة أخبار الحي وطلبات المساعدة",
      "عدم تفويت القصص الشائعة بين الكوريين"
    ],
    "appMenu.home.global.tip": "متابعة قصيرة يوميًا تجعل حياتك في كوريا أسهل بكثير",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "تحدث مع أصدقاء عالميين",
    "appMenu.mingl.local.description": "شارك ثقافتك وساعد الآخرين وتعلم لغات جديدة بشكل طبيعي.",
    "appMenu.mingl.local.points": [
      "مشاركة نصائح الحياة في كوريا",
      "تطوير اللغة بشكل طبيعي",
      "التعرف على أصدقاء من دول مختلفة"
    ],
    "appMenu.mingl.local.tip": "الحوار الصغير اليوم يمكن أن يصبح صداقة كبيرة غدًا",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "تواصل بشكل طبيعي مع الكوريين",
    "appMenu.mingl.global.description": "استخدم الترجمة الفورية لطرح الأسئلة وتكوين علاقات حقيقية.",
    "appMenu.mingl.global.points": [
      "حل تساؤلات الحياة اليومية",
      "حديث طبيعي بلا خوف من اللغة",
      "الخروج من فقاعات الأجانب وصنع صداقات محلية حقيقية"
    ],
    "appMenu.mingl.global.tip": "التعايش الثقافي يبدأ من محادثة بسيطة",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "ساعد الجيران الأجانب وكون صداقات",
    "appMenu.connect.local.description": "ساعد في أمور الحياة اليومية واصنع علاقات ذات معنى.",
    "appMenu.connect.local.points": [
      "مساعدة حقيقية في الأمور العملية",
      "العلاقات تتكون من المساعدة المتبادلة",
      "كن سفيرًا عالميًا في حيّك"
    ],
    "appMenu.connect.local.tip": "المساعدة الصغيرة تصنع روابط قوية",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "حل مشاكلك مع جيران محليين",
    "appMenu.connect.global.description": "احصل على دعم موثوق من أشخاص يعرفون المكان جيدًا.",
    "appMenu.connect.global.points": [
      "فتح حساب، إيجاد منزل، وإجراءات أخرى بسهولة",
      "طلب المساعدة دون وسطاء",
      "الاندماج في المجتمع الحقيقي"
    ],
    "appMenu.connect.global.tip": "عندما تكون الأمور طارئة، الجار هو الأسرع والأوثق.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "تحدث مع الجيران الأجانب في الوقت الحقيقي",
    "appMenu.talk.local.description": "ترجمة فورية بدون خوف من اللغة.",
    "appMenu.talk.local.points": [
      "حديث سلس دون الحاجة لإتقان اللغة",
      "بناء علاقة بعد Connect",
      "دعم ومشورة صادقة"
    ],
    "appMenu.talk.local.tip": "حديث اليوم قد يصبح صداقة العمر.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "تحدث براحة مع الكوريين",
    "appMenu.talk.global.description": "اسأل واحصل على إجابة مباشرة.",
    "appMenu.talk.global.points": [
      "اسأل الكوريين مباشرة",
      "حديث طبيعي بفضل الترجمة بالذكاء الاصطناعي",
      "تابع علاقتك مع من ساعدك عبر Connect"
    ],
    "appMenu.talk.global.tip": "ابدأ بسؤال صغير.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "اصنع هويتك العالمية",
    "appMenu.passport.local.description": "وثّق تجاربك وتفاعلك مع الجيران الأجانب.",
    "appMenu.passport.local.points": [
      "عرض خط زمني لتجاربك الثقافية",
      "بناء ملف سفير المجتمع العالمي",
      "إدارة مهاراتك اللغوية والثقافية"
    ],
    "appMenu.passport.local.tip": "كل لحظة مساعدة هي جزء من قصتك العالمية.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "هوية عالمية — بطاقة تعريف موثوقة",
    "appMenu.passport.global.description": "اعرض تجربتك بثقة واجذب أصدقاء ومرشدين موثوقين.",
    "appMenu.passport.global.points": [
      "خبراتك واضحة في مكان واحد",
      "بناء الثقة عبر ملفك الشخصي",
      "الاتصال مع أشخاص يشاركونك نفس التجارب"
    ],
    "appMenu.passport.global.tip": "كلما كان ملفك أوضح، أصبحت علاقاتك أعمق.",

    // Demo Section
    "common.viewAll": "عرض الكل",
    "common.minutesAgo": "قبل دقائق",

    "home.tag": "سوق محلي",
    "home.greeting_01": "كارلوس",
    "home.greeting_02": "أتمنى لك يومًا جميلًا",

    "home.weather.maxTemp": "أعلى 15°",
    "home.weather.minTemp": "أدنى 10°",
    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "صحو",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "غائم",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "متوسط",

    "home.mytown.title": "حيّي الآن",
    "home.mytown.places.0.name": "سوق الجينكو",
    "home.mytown.places.0.address": "سيهونغ-دونغ، غومتشون",
    "home.mytown.places.1.name": "جبل غواناك",
    "home.mytown.places.1.address": "سيلّيم-دونغ، غواناك",
    "home.mytown.places.2.name": "ساحة أنيانغ المفتوحة",
    "home.mytown.places.2.address": "دوكسيون-دونغ، غومتشون",

    "home.events.title": "فعاليات الحي",
    "home.events.post_title": "سوق محلي في دوكسان-دونغ",
    "home.events.address": "دوكسان-دونغ، غومتشون",

    "mingl.posts.0.category": "معلومات الحياة اليومية",
    "mingl.posts.0.title": "أين ذهب بائع السونداي قرب محطة غومتشون؟",
    "mingl.posts.0.content": "كان ألذ ما أكلت! لم أره مؤخرًا. هل يعرف أحد؟",

    "mingl.posts.1.category": "معلومات الحياة اليومية",
    "mingl.posts.1.title": "نصائح التسوق في سوق دوكسان التقليدي",
    "mingl.posts.1.content": "الأسعار تختلف حسب الأيام. أي نصائح؟",

    "mingl.posts.2.category": "يوميات",
    "mingl.posts.2.title": "ماذا نأكل للغداء قرب غاسان؟",
    "mingl.posts.2.content": "صعب أقرر اليوم… ماذا يأكل الموظفون هناك؟",

    "mingl.posts.3.category": "هوايات / تجمعات",
    "mingl.posts.3.title": "مجموعة ألعاب لوحية قرب غاسان — انضموا!",
    "mingl.posts.3.content": "نجتمع كل جمعة مساءً. أهلًا بالجميع!",

    "mingl.posts.4.category": "تنزه / خروج",
    "mingl.posts.4.title": "مسار سهل للمشي في جبل هوام",
    "mingl.posts.4.content": "وجدت مسارًا لطيفًا للويكند. سأشاركه!",

    "mingl.posts.5.category": "يوميات",
    "mingl.posts.5.title": "أبحث عن مقهى هادئ قرب دوكسان-دونغ",
    "mingl.posts.5.content": "يفضل Wi-Fi جيد + مقابس. أي اقتراحات؟",

    "mingl.posts.6.category": "معلومات الحياة اليومية",
    "mingl.posts.6.title": "هل يوجد نادي رياضي جيد قرب غاسان؟",
    "mingl.posts.6.content": "أرغب بترشيحات حسب السعر/المعدات!",

    "mingl.posts.7.category": "هوايات / تجمعات",
    "mingl.posts.7.title": "من يرغب بالمشي في جبل غواناك معي؟",
    "mingl.posts.7.content": "نمشِي بهدوء. المبتدئون مرحب بهم 😊",

    "connect.titles.0": "لغة",
    "connect.titles.1": "حياة",
    "connect.titles.2": "مستعمل",
    "connect.titles.3": "وظائف",
    "connect.titles.3.category": "جزئي",

    "connect.posts.0.title": "تبادل لغوي كوري-ياباني (عمل/محادثة)",
    "connect.posts.0.reward": "اليابانية",
    "connect.posts.0.reward_detail": "تنسيق حسب الوقت",
    "connect.posts.0.location": "مقهى في Seongbuk-dong",

    "connect.posts.1.title": "أبحث عن متحدث أصلي بالإسبانية للتدريب",
    "connect.posts.1.reward": "بطاقة هدية",
    "connect.posts.1.reward_detail": "50,000₩ للمرّة",
    "connect.posts.1.location": "محطة مكتب غومتشون",

    "connect.posts.2.title": "مساعدة: الطريق من مطار إنشون إلى Mapo",
    "connect.posts.2.reward": "هدية",
    "connect.posts.2.reward_detail": "نبيذ إسباني",
    "connect.posts.2.location": "مطار إنشون",

    "connect.posts.3.title": "هل يمكنك مرافقتي لتوقيع عقد الغرفة؟",
    "connect.posts.3.reward": "نقد",
    "connect.posts.3.reward_detail": "10,000₩ / الساعة",
    "connect.posts.3.location": "يونغدونغبو / يانغتشون",

    "connect.posts.4.title": "أقرضني Monkey Driver ليوم واحد — أعطيك كيمتشي منزلي!",
    "connect.posts.4.reward": "هدية",
    "connect.posts.4.reward_detail": "كيمتشي منزلي",
    "connect.posts.4.location": "Seogyo-dong، Mapo",

    "connect.posts.5.title": "أبيع دراجة — بحالة ممتازة",
    "connect.posts.5.reward": "السعر",
    "connect.posts.5.reward_detail": "50,000₩",
    "connect.posts.5.location": "قرب محطة Sinchon",

    "connect.posts.6.title": "وظيفة مؤقتة في معرض — الأفضلية لمن يجيد الإنجليزية",
    "connect.posts.6.reward": "عمل",
    "connect.posts.6.reward_detail": "مساعدة ميدانية + استقبال",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "مطلوب باريستا يتحدث الإسبانية (الأجانب مرحب بهم أولًا)",
    "connect.posts.7.reward": "أجر الساعة",
    "connect.posts.7.reward_detail": "ابتداءً من 10,000₩",
    "connect.posts.7.location": "مقهى في Itaewon",

    "passport.introduction": "بدأت تعلم الكورية من البرامج التلفزيونية، وفزت بمسابقة خطاب بالكورية في المكسيك، ثم قررت المجيء إلى كوريا!",
    "passport.gender": "الجنس",
    "passport.gender_detail": "ذكر",
    "passport.birth": "تاريخ الميلاد",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "الجنسية",
    "passport.nationality_detail": "المكسيك",
    "passport.mother_tongue": "اللغة الأم",
    "passport.mother_tongue_detail": "الإسبانية",
    "passport.language": "اللغات",
    "passport.language_detail.0": "الكورية",
    "passport.language_detail.1": "الإنجليزية",
    "passport.edit": "تعديل",
    "passport.share": "مشاركة",

    // Positioned Mobile Demo Section (ru)
    "positionedMobileDemo.home.description": "Как «новости района» — быстро проверяйте, что происходит рядом",
    "positionedMobileDemo.home.features.0.description": "Не пропускайте локальные новости и события в реальном времени",
    "positionedMobileDemo.home.features.1.description": "Исследуйте повседневные истории жителей вокруг конкретных мест",
    "positionedMobileDemo.home.features.2.description": "Легко присоединяйтесь к фестивалям, встречам и мероприятиям в округе",

    "positionedMobileDemo.mingl.description": "Откройте и поделитесь реальной жизнью района через карту",
    "positionedMobileDemo.mingl.features.0.description": "Свободно делитесь вопросами, советами и новостями — естественное общение",
    "positionedMobileDemo.mingl.features.1.description": "Мгновенный перевод без языковых барьеров для настоящего глобального общения",
    "positionedMobileDemo.mingl.features.2.description": "Мир глазами локала, локал глазами иностранца",

    "positionedMobileDemo.connect.description": "Моменты взаимопомощи создают связи",
    "positionedMobileDemo.connect.features.0.description": "Находите и получайте помощь быстро через локальный матчинг",
    "positionedMobileDemo.connect.features.1.description": "Самостоятельно выбирайте «надежного и безопасного» человека",
    "positionedMobileDemo.connect.features.2.description": "Разговор → обмен → долгосрочные локальные и глобальные отношения",

    "positionedMobileDemo.talk.description": "Знакомьтесь с друзьями из разных стран без страха перед языком",
    "positionedMobileDemo.talk.features.0.description": "Естественное общение благодаря мгновенному ИИ-переводу",
    "positionedMobileDemo.talk.features.1.description": "Спрашивайте о жизни в Корее напрямую у местных и получайте ответ сразу",
    "positionedMobileDemo.talk.features.2.description": "Переведите знакомство из Connect в настоящую дружбу",

    "positionedMobileDemo.passport.description": "Создайте цифровую визитку с вашим глобальным опытом",
    "positionedMobileDemo.passport.features.0.description": "Записывайте историю проживания и активности по регионам в таймлайне",
    "positionedMobileDemo.passport.features.1.description": "Четко показывайте языковые навыки и стиль общения",
    "positionedMobileDemo.passport.features.2.description": "Естественно соединяйтесь с людьми с похожим опытом",


    // Logl Video Section
    "loglVideo.title": "فيديو تعريفي عن logl",
    "loglVideo.description": "هل تريد معرفة ما هو logl؟ شاهد الفيديو!",
    "loglVideo.watch": "مشاهدة الفيديو"
      
    }
  },
  zh: {
    translation: {
      // Header Section
      "header.intro": "Intro",
      "header.demo": "Demo",
    "header.video": "logl 影片",
      
      // Hero Section
    "hero.title": "消除语言障碍",
      "hero.description": "find your",
    "hero.demo": "体验 Demo",
    "hero.prop1": "可信本地服务",
    "hero.prop2": "实时 AI 翻译",
      "hero.prop3": "多元本地社区",
  
    // Introduction Section
    "introduction.title": "你也有过这样的困扰吗？",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",
  
    "introduction.fst.name": "智敏",
    "introduction.fst.location": "韩国 首尔",
    "introduction.fst.tag": "#语言学习",
    "introduction.fst.story": "\"英语也认真学了，还去过语言研修……但没有机会用就全忘了。如果能在日常中用到就好了😢\"",
  
    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "韩国 水原",
    "introduction.snd.tag": "#结交本地朋友",
    "introduction.snd.story": "\"来韩国 6 个月了，还只是和同国家的朋友一起。我真的很想和韩国朋友变熟，但不知道怎么开始。\"",
  
    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "韩国 全州",
    "introduction.trd.tag": "#本地生活信息",
    "introduction.trd.story": "\"看 YouTube 和社区也找不到我住的区域信息。银行开户、手机、医院……刚定居时哪里能找到正确且最新的信息？\"",
    
    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "让你的社区成为全球友好枢纽",
    "appMenu.home.local.description": "用你熟悉的本地信息帮助外国邻居，让社区成为真正的国际社区",
    "appMenu.home.local.points": [
      "向外国人介绍隐秘美食、医院、便利设施",
      "分享实时社区新闻和活动信息",
      "提升全球友好指数，带动社区国际化"
    ],
    "appMenu.home.local.tip": "你知道的小事，可能是别人重要的生活指南",
  
    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "为你的韩国生活定制的主页",
    "appMenu.home.global.description": "从天气到本地热门帖子，一页就能查看韩国生活必需信息",
    "appMenu.home.global.points": [
      "根据当地天气与外出提示安排一天",
      "优先查看社区实时信息与求助内容",
      "不遗漏韩国人之间热门的全球话题"
    ],
    "appMenu.home.global.tip": "每天 5 分钟，韩国生活更轻松",
  
    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "与世界朋友交流",
    "appMenu.mingl.local.description": "回答外国人的生活问题，一起交流语言与文化",
    "appMenu.mingl.local.points": [
      "分享韩国生活技巧并获得成就感",
      "自然提升外语能力",
      "结识多元文化的朋友"
    ],
    "appMenu.mingl.local.tip": "回答问题、学习语言、分享文化",
  
    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "与韩国人自然交流",
    "appMenu.mingl.global.description": "通过实时翻译，无语言压力地提问、交流并交朋友",
    "appMenu.mingl.global.points": [
      "实时解决韩国生活中的疑问",
      "AI 翻译让交流自然轻松",
      "跳出外国人圈，交真正的韩国朋友"
    ],
    "appMenu.mingl.global.tip": "学习韩国文化，自然融入本地社区",
  
    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "帮助外国邻居并交朋友",
    "appMenu.connect.local.description": "帮助在社区生活的外国人解决真实问题，建立全球人脉网络",
    "appMenu.connect.local.points": [
      "提供银行、住房、文件等生活协助",
      "通过帮助自然建立国际友谊",
      "成为社区的全球友好大使"
    ],
    "appMenu.connect.local.tip": "从小小的帮助开始，发展真正的全球友谊",
  
    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "与韩国邻居一起解决问题",
    "appMenu.connect.global.description": "银行、住房、签证等急事，与可信赖的本地人一起处理",
    "appMenu.connect.global.points": [
      "具体解决开户、租房等生活难题",
      "不需要中介，随时与邻居轻松求助",
      "走出外国人孤岛，真正适应韩国生活"
    ],
    "appMenu.connect.global.tip": "越着急的事，越需要邻居帮忙——又快又稳",
  
    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "与外国邻居实时聊天",
    "appMenu.talk.local.description": "通过 AI 翻译，无语言焦虑地交流，成为真正的全球朋友",
    "appMenu.talk.local.points": [
      "AI 实时翻译，无论语言能力都能自然交流",
      "将一次帮助延续为长期友谊",
      "倾听外国邻居的韩国生活烦恼并提供建议"
    ],
    "appMenu.talk.local.tip": "一次聊天可以成为一生的友谊",
  
    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "与韩国人无障碍交流",
    "appMenu.talk.global.description": "无语言障碍，与本地邻居实时聊天、提问和解答",
    "appMenu.talk.global.points": [
      "直接向韩国人提问并即时获得回答",
      "AI 翻译让不会韩语也能自然交流",
      "与在 connect 中认识的本地人持续沟通关系更深"
    ],
    "appMenu.talk.global.tip": "从小问题开始，找到你在韩国的真正伙伴",
  
    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "记录你的全球旅程",
    "appMenu.passport.local.description": "记录与你的外国朋友的互动与经验，构建无需护照的全球身份",
    "appMenu.passport.local.points": [
      "将社区国际活动以时间线可视化",
      "以帮助记录建立全球友好履历",
      "系统管理语言能力与文化交流经验"
    ],
    "appMenu.passport.local.tip": "每一次小小的帮助都构成你的全球故事",
  
    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "全球身份——你的数字名片",
    "appMenu.passport.global.description": "展示你的跨国经历与旅程，建立可信的社交档案",
    "appMenu.passport.global.points": [
      "以视觉化方式呈现居住与全球经验",
      "用语言与文化背景建立信任",
      "自然连接拥有类似经验的人"
    ],
    "appMenu.passport.global.tip": "越详细的档案，越容易遇到正确的人",
  
    // Demo Section
    "common.viewAll": "全部查看",
    "common.minutesAgo": "分钟前",
  
    "home.tag": "跳蚤市场",
    "home.greeting_01": "Carlos 你好",
    "home.greeting_02": "祝你今天顺心",
  
    "home.weather.maxTemp": "最高 15°",
    "home.weather.minTemp": "最低 10°",
  
    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "晴朗",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "多云",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "一般",
  
    "home.mytown.title": "实时 我们的社区",
    "home.mytown.places.0.name": "银杏市场",
    "home.mytown.places.0.address": "衿川区 时兴洞",
    "home.mytown.places.1.name": "冠岳山",
    "home.mytown.places.1.address": "冠岳区 新林洞",
    "home.mytown.places.2.name": "安养川多功能广场",
    "home.mytown.places.2.address": "衿川区 独善洞",
  
    "home.events.title": "我们社区活动",
    "home.events.post_title": "独山洞跳蚤市场进行中",
    "home.events.address": "衿川区 独山洞",
  
    "mingl.posts.0.category": "生活信息",
    "mingl.posts.0.title": "衿川区厅站的血肠车大叔去哪了？",
    "mingl.posts.0.content": "真的是人生血肠，但最近完全看不到了，不知道在哪里",
  
    "mingl.posts.1.category": "生活信息",
    "mingl.posts.1.title": "独山洞传统市场购物小技巧",
    "mingl.posts.1.content": "经常在独山传统市场买东西，发现不同日子价格不同，怎么买更划算？",
  
    "mingl.posts.2.category": "日常",
    "mingl.posts.2.title": "加山数码园区附近中午吃什么？",
    "mingl.posts.2.content": "今天特别难决定，加山站附近的上班族都怎么吃？",
  
    "mingl.posts.3.category": "兴趣/聚会",
    "mingl.posts.3.title": "加山站桌游聚会招人",
    "mingl.posts.3.content": "每周五晚上在加山站附近玩桌游，欢迎一起加入",
  
    "mingl.posts.4.category": "旅行/郊游",
    "mingl.posts.4.title": "虎岩山环山步道周末散步路线推荐",
    "mingl.posts.4.content": "最近想找轻松散步的地方，发现虎岩山步道，分享轻松路线",
  
    "mingl.posts.5.category": "日常",
    "mingl.posts.5.title": "请推荐独山洞附近安静的咖啡厅",
    "mingl.posts.5.content": "想找有稳定 Wi-Fi 和插座、适合工作学习的咖啡厅",
  
    "mingl.posts.6.category": "生活信息",
    "mingl.posts.6.title": "请推荐加山洞附近的健身房",
    "mingl.posts.6.content": "有人在加山数码园区附近锻炼吗？有月费或设施好的健身房吗？",
  
    "mingl.posts.7.category": "兴趣/聚会",
    "mingl.posts.7.title": "一起去爬冠岳山吧",
    "mingl.posts.7.content": "这周末打算去冠岳山，招同行，初学者也欢迎",
  
    "connect.titles.0": "语言",
    "connect.titles.1": "生活",
    "connect.titles.2": "二手",
    "connect.titles.3": "工作",
    "connect.titles.3.category": "兼职",
  
    "connect.posts.0.title": "招韩语×日语商务会话语言交换",
    "connect.posts.0.reward": "日语",
    "connect.posts.0.reward_detail": "时长协商",
    "connect.posts.0.location": "城北洞 咖啡厅",
  
    "connect.posts.1.title": "找西语母语者！一起练口语～",
    "connect.posts.1.reward": "礼品卡",
    "connect.posts.1.reward_detail": "50,000 韩元 / 次",
    "connect.posts.1.location": "衿川区厅站",
  
    "connect.posts.2.title": "找人引导仁川机场到麻浦的地铁路线",
    "connect.posts.2.reward": "物品",
    "connect.posts.2.reward_detail": "西班牙红酒",
    "connect.posts.2.location": "仁川机场",
  
    "connect.posts.3.title": "有人能陪我去签单间合同吗？",
    "connect.posts.3.reward": "现金",
    "connect.posts.3.reward_detail": "10,000 韩元 / 小时",
    "connect.posts.3.location": "首尔 永登浦 阳川站",
  
    "connect.posts.4.title": "Monkey Driver 借我一天！送自制萝卜泡菜",
    "connect.posts.4.reward": "物品",
    "connect.posts.4.reward_detail": "自制萝卜泡菜",
    "connect.posts.4.location": "麻浦区 西桥洞",
  
    "connect.posts.5.title": "出售自行车！使用痕迹少",
    "connect.posts.5.reward": "价格",
    "connect.posts.5.reward_detail": "50,000 韩元",
    "connect.posts.5.location": "新村站附近",
  
    "connect.posts.6.title": "展会短期兼职招聘，会英文者优先",
    "connect.posts.6.reward": "工作",
    "connect.posts.6.reward_detail": "展会现场支援与英文引导",
    "connect.posts.6.location": "COEX",
  
    "connect.posts.7.title": "招聘会西语的咖啡师（西语母语者优先）",
    "connect.posts.7.reward": "时薪",
    "connect.posts.7.reward_detail": "10,000 韩元起",
    "connect.posts.7.location": "梨泰院 咖啡厅",
  
    "passport.introduction": "看了韩国综艺后开始自学韩语，并在墨西哥举办的韩语演讲比赛中获得第一名，于是决定来韩国！",
    "passport.gender": "性别",
    "passport.gender_detail": "男性",
    "passport.birth": "出生日期",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "国籍",
    "passport.nationality_detail": "Mexico",
    "passport.mother_tongue": "母语",
    "passport.mother_tongue_detail": "Spanish",
    "passport.language": "外语",
    "passport.language_detail.0": "Korean",
    "passport.language_detail.1": "English",
    "passport.edit": "编辑",
    "passport.share": "分享",

    // Positioned Mobile Demo Section (zh)
    "positionedMobileDemo.home.description": "像“本地新闻”一样，一眼掌握你所在社区的最新动态",
    "positionedMobileDemo.home.features.0.description": "不错过社区实时资讯和活动",
    "positionedMobileDemo.home.features.1.description": "以地点为中心探索居民的日常与故事",
    "positionedMobileDemo.home.features.2.description": "轻松参与周边的节日、聚会与大小活动",

    "positionedMobileDemo.mingl.description": "基于地点发现并分享真实的社区生活",
    "positionedMobileDemo.mingl.features.0.description": "自由分享提问、信息、新闻和推荐，形成自然交流",
    "positionedMobileDemo.mingl.features.1.description": "实时翻译，真正打破语言壁垒的全球沟通",
    "positionedMobileDemo.mingl.features.2.description": "本地视角看世界，全球视角看本地",

    "positionedMobileDemo.connect.description": "在互相帮助的瞬间，建立连接",
    "positionedMobileDemo.connect.features.0.description": "基于位置快速找到需要的帮助和提供帮助的人",
    "positionedMobileDemo.connect.features.1.description": "自行选择“可信、安心”的对象",
    "positionedMobileDemo.connect.features.2.description": "从对话 → 互动 → 延伸为持续的本地与全球关系",

    "positionedMobileDemo.talk.description": "AI 翻译，让你无语言压力地结识全球朋友",
    "positionedMobileDemo.talk.features.0.description": "AI 实时翻译，让对话自然顺畅，无需语言水平",
    "positionedMobileDemo.talk.features.1.description": "直接向当地人提问韩国生活并即时获得回答",
    "positionedMobileDemo.talk.features.2.description": "将 Connect 中的初次相遇发展为长期友谊",

    "positionedMobileDemo.passport.description": "制作记录你全球经历的数字名片",
    "positionedMobileDemo.passport.features.0.description": "按地区记录居住与活动经历的时间线",
    "positionedMobileDemo.passport.features.1.description": "清晰展示语言能力与沟通风格",
    "positionedMobileDemo.passport.features.2.description": "自然连接拥有相似经历的人",

  
    // Logl Video Section
    "loglVideo.title": "logl 介绍视频",
    "loglVideo.description": "想了解 logl 是什么？先看看这段视频吧！",
    "loglVideo.watch": "前往观看"
    }
  },
  "zh-TW": {
    translation: {
      // Header Section
      "header.intro": "Intro",
      "header.demo": "Demo",
    "header.video": "logl 影片",
      
      // Hero Section
    "hero.title": "消除語言障礙",
      "hero.description": "find your",
    "hero.demo": "體驗示範",
    "hero.prop1": "嚴選在地服務",
    "hero.prop2": "即時 AI 翻譯",
      "hero.prop3": "多元在地社群",

    // Introduction Section
    "introduction.title": "這些困擾你也有過嗎？",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",

    "introduction.fst.name": "智民",
    "introduction.fst.location": "首爾 韓國",
    "introduction.fst.tag": "#語言學習",
    "introduction.fst.story": "\"英文也很努力學了，還去過遊學……但沒有地方用就全忘了。要是日常生活有機會能用就好了😢\"",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "水原 韓國",
    "introduction.snd.tag": "#結交在地朋友",
    "introduction.snd.story": "\"來韓國六個月了，還是只跟同國朋友一起。我很想跟韓國朋友真正熟起來，但不知道該怎麼開始。\"",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "全州 韓國",
    "introduction.trd.tag": "#在地生活資訊",
    "introduction.trd.story": "\"看 YouTube、逛社群都找不到我家附近的資訊。開戶、電信、醫院……剛落腳時，哪裡能拿到正確又最新的資訊？\"",
    
    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "讓你的社區成為全球友善樞紐",
    "appMenu.home.local.description": "把你熟悉的在地資訊分享給外國鄰居，讓我們的地區成為真正的全球社群",
    "appMenu.home.local.points": [
      "把隱藏版美食、醫院、便利設施介紹給外國人",
      "即時分享街坊新聞與活動資訊",
      "提升全球化指數，帶頭推動社區國際化"
    ],
    "appMenu.home.local.tip": "你知道的小事，可能是別人珍貴的生活指南",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "量身打造的韓國生活儀表板",
    "appMenu.home.global.description": "從今天天氣到社區熱門貼文，韓國生活必備資訊一頁掌握",
    "appMenu.home.global.points": [
      "依在地天氣與外出提示規劃你的每一天",
      "先看社區即時訊息與求助內容",
      "不錯過在韓國人之間最夯的全球話題"
    ],
    "appMenu.home.global.tip": "每天 5 分鐘，韓國生活更順手",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "與全球朋友交流",
    "appMenu.mingl.local.description": "回答外國人的提問、學語言、共享文化",
    "appMenu.mingl.local.points": [
      "分享韓國生活小撇步、成就感滿滿",
      "自然提升外語能力",
      "結交多元文化圈的朋友"
    ],
    "appMenu.mingl.local.tip": "回答問題、學語言、一起分享文化",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "自然與韓國人溝通",
    "appMenu.mingl.global.description": "即時翻譯免去語言負擔，提出你的疑問並結交在地朋友",
    "appMenu.mingl.global.points": [
      "即時解答韓國生活的各種疑惑",
      "AI 翻譯助攻，對話自然不費力",
      "跳出外國人小圈圈，交到真正的韓國朋友"
    ],
    "appMenu.mingl.global.tip": "學韓文、懂文化，自然融入在地社群",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "幫助外國鄰居、結交朋友",
    "appMenu.connect.local.description": "協助解決外國人的日常實務問題，建立你的全球人脈網",
    "appMenu.connect.local.points": [
      "銀行、租屋、文件等實際生活協助",
      "在幫助中自然形成國際人脈",
      "成為社區的全球大使，發揮影響力"
    ],
    "appMenu.connect.local.tip": "從小幫忙開始，累積成真正的全球友誼",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "與韓國鄰居一同解決問題",
    "appMenu.connect.global.description": "銀行、租屋、簽證等急事，和可信的在地人一起處理",
    "appMenu.connect.global.points": [
      "新戶開立、找房等具體生活難題迎刃而解",
      "不靠仲介，直接向鄰居輕鬆求助",
      "跳脫外國人孤島，真正適應在地生活"
    ],
    "appMenu.connect.global.tip": "越急的事越需要鄰居出手，最快最穩",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "與外國鄰居即時聊天",
    "appMenu.talk.local.description": "AI 翻譯，無語言焦慮，1:1 私訊成為真正的全球朋友",
    "appMenu.talk.local.points": [
      "AI 即時翻譯，無論語感程度都能自然對話",
      "把 Connect 的一次協助延伸為長久友誼",
      "傾聽外國鄰居的韓國生活煩惱並給予建議"
    ],
    "appMenu.talk.local.tip": "今天的小對話，會成為一生的人脈",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "與韓國人自在溝通",
    "appMenu.talk.global.description": "沒有語言隔閡，與在地鄰居即時聊天、即問即答",
    "appMenu.talk.global.points": [
      "向韓國人直接發問、即刻獲得回覆",
      "AI 翻譯讓不懂韓文也能自然聊天",
      "與 Connect 認識的在地幫手持續溝通，變成真朋友"
    ],
    "appMenu.talk.global.tip": "從小問題開始，找到你的在地夥伴",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "打造你的全球故事",
    "appMenu.passport.local.description": "把與外國朋友的互動與體驗記錄下來，無需護照也能建立全球認同",
    "appMenu.passport.local.points": [
      "將在地國際活動的時間軸視覺化",
      "以協助紀錄形塑全球大使履歷",
      "系統管理你的語言能力與文化交流經驗"
    ],
    "appMenu.passport.local.tip": "把每一次小小的幫助都寫進你的全球旅程",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "全球識別——你的數位名片",
    "appMenu.passport.global.description": "把你的多國經歷與旅程清楚呈現，建立可信賴的個人檔案",
    "appMenu.passport.global.points": [
      "居住與全球經驗一目了然的視覺化",
      "以語言與文化背景建立信任",
      "自然連結擁有相似經歷的人們"
    ],
    "appMenu.passport.global.tip": "越完整的檔案，就越容易遇見合適的在地幫手與真朋友",

    // Demo Section
    "common.viewAll": "全部查看",
    "common.minutesAgo": "分 前",

    "home.tag": "跳蚤市場",
    "home.greeting_01": "Carlos 您好",
    "home.greeting_02": "祝你今天也順心",
    
    "home.weather.maxTemp": "最高 15°",
    "home.weather.minTemp": "最低 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "晴朗",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "多雲",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "普通",

    "home.mytown.title": "即時 我們的社區",
    "home.mytown.places.0.name": "銀杏市場",
    "home.mytown.places.0.address": "金泉區 時興洞",
    "home.mytown.places.1.name": "冠岳山",
    "home.mytown.places.1.address": "冠岳區 新林洞",
    "home.mytown.places.2.name": "安養川多功能廣場",
    "home.mytown.places.2.address": "金泉區 獨善洞",

    "home.events.title": "我們社區活動",
    "home.events.post_title": "獨山洞將舉辦跳蚤市場",
    "home.events.address": "金泉區 獨山洞",

    "mingl.posts.0.category": "生活資訊",
    "mingl.posts.0.title": "金泉區廳站的血腸餐車大叔在哪裡？",
    "mingl.posts.0.content": "真的人生最強的血腸攤，但最近完全沒看見，不知道去哪了",

    "mingl.posts.1.category": "生活資訊",
    "mingl.posts.1.title": "獨山洞傳統市場採買小撇步",
    "mingl.posts.1.content": "常在獨山傳統市場買菜，發現不同日子價格有差；怎麼買最划算？",

    "mingl.posts.2.category": "日常",
    "mingl.posts.2.title": "加山數位園區附近中午吃什麼？",
    "mingl.posts.2.content": "今天特別難決定，加山站附近的上班族都怎麼吃？",

    "mingl.posts.3.category": "興趣/聚會",
    "mingl.posts.3.title": "加山站桌遊團徵人",
    "mingl.posts.3.content": "每週五晚上在加山站附近玩桌遊，歡迎一起加入",

    "mingl.posts.4.category": "旅行/郊遊",
    "mingl.posts.4.title": "虎岩山環山步道 周末散步路線推薦",
    "mingl.posts.4.content": "最近想找輕鬆散步的地方，發現虎岩山步道；分享我找到的輕鬆路線",

    "mingl.posts.5.category": "日常",
    "mingl.posts.5.title": "請推薦獨山洞附近安靜的咖啡廳",
    "mingl.posts.5.content": "想找可以安靜工作、有穩定 Wi-Fi 與插座的咖啡廳，拜託推薦",

    "mingl.posts.6.category": "生活資訊",
    "mingl.posts.6.title": "請推薦加山洞附近的健身房",
    "mingl.posts.6.content": "有人在加山數位園區附近運動嗎？有月費或設備好的健身房嗎？",

    "mingl.posts.7.category": "興趣/聚會",
    "mingl.posts.7.title": "一起去爬冠岳山吧",
    "mingl.posts.7.content": "這週末要去冠岳山，徵同行；初學者也歡迎，輕鬆散步路線",

    "connect.titles.0": "語言",
    "connect.titles.1": "生活",
    "connect.titles.2": "二手",
    "connect.titles.3": "工作",
    "connect.titles.3.category": "打工",


    "connect.posts.0.title": "韓語×日語商務會話 語言交換夥伴募集！",
    "connect.posts.0.reward": "日語",
    "connect.posts.0.reward_detail": "同等時數協議",
    "connect.posts.0.location": "城北洞 咖啡廳",

    "connect.posts.1.title": "徵西語母語者！一起練習會話～",
    "connect.posts.1.reward": "禮券",
    "connect.posts.1.reward_detail": "50,000 韓圓 / 次",
    "connect.posts.1.location": "金泉區廳站",

    "connect.posts.2.title": "徵協助：仁川機場到首爾麻浦站的地鐵路線",
    "connect.posts.2.reward": "物品",
    "connect.posts.2.reward_detail": "西班牙紅酒",
    "connect.posts.2.location": "仁川機場",

    "connect.posts.3.title": "有人能陪我去簽套房租約嗎？",
    "connect.posts.3.reward": "現金",
    "connect.posts.3.reward_detail": "10,000 韓圓 / 時",
    "connect.posts.3.location": "首爾 永登浦 陽川站",

    "connect.posts.4.title": "Monkey Driver 借我一天！送自製蘿蔔泡菜一盤",
    "connect.posts.4.reward": "物品",
    "connect.posts.4.reward_detail": "自家醃蘿蔔泡菜",
    "connect.posts.4.location": "麻浦區 西橋洞",

    "connect.posts.5.title": "出售自行車！使用痕跡少",
    "connect.posts.5.reward": "價格",
    "connect.posts.5.reward_detail": "50,000 韓圓",
    "connect.posts.5.location": "新村站附近",

    "connect.posts.6.title": "展覽短期打工 招募中（會英文優先）",
    "connect.posts.6.reward": "業務",
    "connect.posts.6.reward_detail": "展場支援與英文引導",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "徵會西語的咖啡師（西語母語外國人優先）",
    "connect.posts.7.reward": "時薪",
    "connect.posts.7.reward_detail": "自 10,000 韓圓 起",
    "connect.posts.7.location": "梨泰院 咖啡廳",

    "passport.introduction": "看了韓國綜藝後開始自學韓文，並在墨西哥舉辦的韓語演講比賽拿下第一名，於是決定來韓國！",
    "passport.gender": "性別",
    "passport.gender_detail": "男性",
    "passport.birth": "出生日期",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "國籍",
    "passport.nationality_detail": "Mexico",
    "passport.mother_tongue": "母語",
    "passport.mother_tongue_detail": "Spanish",
    "passport.language": "外語",
    "passport.language_detail.0": "Korean",
    "passport.language_detail.1": "English",
    "passport.edit": "編輯",
    "passport.share": "分享",

    // Positioned Mobile Demo Section (zh-TW)
    "positionedMobileDemo.home.description": "就像「在地新聞」一樣，一眼掌握你所在社區的最新動態",
    "positionedMobileDemo.home.features.0.description": "不錯過社區的即時資訊與活動",
    "positionedMobileDemo.home.features.1.description": "以地點為中心探索居民的日常與小故事",
    "positionedMobileDemo.home.features.2.description": "輕鬆參與附近的節慶、聚會與大小活動",

    "positionedMobileDemo.mingl.description": "以地點為基礎發現並分享真實的社區生活",
    "positionedMobileDemo.mingl.features.0.description": "自由分享提問、資訊、消息與推薦，自然交流",
    "positionedMobileDemo.mingl.features.1.description": "即時翻譯，真正打破語言隔閡的全球互動",
    "positionedMobileDemo.mingl.features.2.description": "從在地看世界，從世界看在地",

    "positionedMobileDemo.connect.description": "在互相幫助的瞬間，連結就此開始",
    "positionedMobileDemo.connect.features.0.description": "根據地點需求迅速找到需要或提供幫助的人",
    "positionedMobileDemo.connect.features.1.description": "由你親自選擇「安心、可信」的對象",
    "positionedMobileDemo.connect.features.2.description": "從對話 → 交流 → 發展為長期的在地與全球關係",

    "positionedMobileDemo.talk.description": "透過 AI 翻譯，無語言壓力地認識全球朋友",
    "positionedMobileDemo.talk.features.0.description": "AI 即時翻譯，讓對話自然流暢，不受語言程度限制",
    "positionedMobileDemo.talk.features.1.description": "直接向在地人詢問韓國生活並立即獲得回應",
    "positionedMobileDemo.talk.features.2.description": "將 Connect 的初次連結延伸為長久友誼",

    "positionedMobileDemo.passport.description": "製作紀錄你全球經歷的數位名片",
    "positionedMobileDemo.passport.features.0.description": "以時間線方式記錄各地的居住與活動經驗",
    "positionedMobileDemo.passport.features.1.description": "清楚呈現語言能力與溝通風格",
    "positionedMobileDemo.passport.features.2.description": "自然連結擁有相似經歷的人",


    // Logl Video Section
    "loglVideo.title": "logl 介紹影片",
    "loglVideo.description": "想先了解 logl 是什麼？先看這支影片！",
    "loglVideo.watch": "前往觀看"
      
    }
  },
  sw: {
    translation: {
      // Header Section
    "header.intro": "Utangulizi",
      "header.demo": "Demo",
    "header.video": "Video ya logl",
      
      // Hero Section
    "hero.title": "Kuondoa vizuizi vya lugha",
      "hero.description": "find your",
      "hero.demo": "Jaribu Demo",
    "hero.prop1": "Huduma za ndani zilizoaminika",
      "hero.prop2": "Tafsiri ya AI papo hapo",
    "hero.prop3": "Jumuiya mbalimbali za wenyeji",
  
    // Introduction Section
    "introduction.title": "Umewahi kuwa na wasiwasi huu?",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",
  
    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Seoul, Korea ya Kusini",
    "introduction.fst.tag": "#KujifunzaLugha",
    "introduction.fst.story": "\"Nilijitahidi kusoma Kiingereza na hata kwenda kusoma nje... lakini bila kutumika, nimesahau yote. Laiti ningekuwa na nafasi ya kuitumia katika maisha ya kila siku 😢\"",
  
    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Korea ya Kusini",
    "introduction.snd.tag": "#KutafutaRafikiWenyeji",
    "introduction.snd.story": "\"Nimekuwa Korea miezi 6, lakini bado ninajumuika na watu kutoka nchi yangu tu. Natamani kuwa rafiki wa kweli na Wakorea, lakini sijui nianzie wapi.\"",
  
    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Korea ya Kusini",
    "introduction.trd.tag": "#MaishaYaMitaa",
    "introduction.trd.story": "\"Hata nikiangalia YouTube au jumuiya mtandaoni, hakuna taarifa sahihi za eneo ninaloishi. Benki, laini ya simu, hospitali... wakati wa kuanza maisha mapya, ni wapi unaweza kupata taarifa sahihi na zilizosasishwa?\"",
    
    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "Kutoa jumuiya yako ufunguo wa dunia",
    "appMenu.home.local.description": "Tumia ujuzi wako wa eneo kuwasaidia majirani wa kigeni na kujenga jumuiya ya kweli ya kimataifa",
    "appMenu.home.local.points": [
      "Washauri wageni kuhusu migahawa, hospitali na huduma muhimu",
      "Shiriki habari na matukio ya papo hapo ya mitaa",
      "Inua hadhi ya jumuiya yako kama rafiki wa wageni"
    ],
    "appMenu.home.local.tip": "Habari ndogo unayojua inaweza kuwa mwongozo muhimu kwa mwingine",
  
    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "Dashibodi ya maisha yako nchini Korea",
    "appMenu.home.global.description": "Angalia hali ya hewa, habari za mitaa, na maandishi maarufu kwa urahisi katika ukurasa mmoja",
    "appMenu.home.global.points": [
      "Panga siku yako kwa hali ya hewa na vidokezo vya kutoka",
      "Angalia kwanza habari na maombi kutoka kwa watu wa eneo",
      "Usikose hadithi maarufu za wageni nchini Korea"
    ],
    "appMenu.home.global.tip": "Dakika 5 kila siku inaweza kufanya maisha Korea kuwa mepesi zaidi",
  
    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Sungumza na marafiki wa kimataifa",
    "appMenu.mingl.local.description": "Jibu maswali ya wageni, shirikiana kujifunza lugha, na kubadilishana tamaduni",
    "appMenu.mingl.local.points": [
      "Shiriki vidokezo vya maisha Korea na ujisikie mwenye thamani",
      "Boresha lugha kwa njia ya asili",
      "Tengeneza urafiki kutoka tamaduni tofauti"
    ],
    "appMenu.mingl.local.tip": "Saidia, jifunze, na shiriki tamaduni pamoja",
  
    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Ongea na Wakorea kwa urahisi",
    "appMenu.mingl.global.description": "Kwa tafsiri ya papo hapo, unaweza kuuliza, kuzungumza, na kuwa rafiki bila wasiwasi wa lugha",
    "appMenu.mingl.global.points": [
      "Pata majibu kuhusu maisha Korea papo hapo",
      "Tafsiri ya AI hufanya mazungumzo kuwa ya asili",
      "Ondoka kwenye 'kikundi cha wageni' na tengeneza urafiki wa kweli"
    ],
    "appMenu.mingl.global.tip": "Jifunze utamaduni wa Korea na jumuika kwenye jamii",
  
    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Saidia majirani wa kigeni",
    "appMenu.connect.local.description": "Saidia wageni kushughulikia changamoto halisi za maisha na jenga mtandao wa kimataifa",
    "appMenu.connect.local.points": [
      "Usaidizi wa benki, makazi, na nyaraka",
      "Urafiki wa kimataifa huanza na msaada mdogo",
      "Kuwa balozi wa jumuiya yako"
    ],
    "appMenu.connect.local.tip": "Urafiki wa kweli huanza na msaada mdogo",
  
    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Tafutia msaada kutoka kwa wenyeji",
    "appMenu.connect.global.description": "Shughulikia masuala kama benki, makazi, au hati kwa msaada wa mtu wa eneo la kuaminika",
    "appMenu.connect.global.points": [
      "Suluhisha changamoto za kuanza maisha Korea",
      "Omba msaada bila wakala au taratibu ngumu",
      "Jumuika kwenye maisha halisi ya mitaa"
    ],
    "appMenu.connect.global.tip": "Wakati wa dharura, msaada wa jirani ndiyo wa haraka zaidi",
  
    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Sungumza papo hapo na wageni",
    "appMenu.talk.local.description": "Kwa tafsiri ya AI, zungumza bila wasiwasi wa lugha na tengeneza urafiki wa kweli",
    "appMenu.talk.local.points": [
      "Tafsiri papo hapo, mazungumzo ya asili bila kujali uwezo wa lugha",
      "Kukuza mawasiliano kutoka connect kuwa urafiki wa muda mrefu",
      "Sikiliza na saidia changamoto za maisha Korea"
    ],
    "appMenu.talk.local.tip": "Mazungumzo madogo yanaweza kuwa urafiki wa maisha",
  
    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Ongea kwa urahisi na Wakorea",
    "appMenu.talk.global.description": "Ongea, uliza, na ujibiwe papo hapo bila vizuizi vya lugha",
    "appMenu.talk.global.points": [
      "Uliza maswali moja kwa moja kwa wenyeji",
      "AI inafanya mazungumzo kuwa ya utulivu hata bila kujua Kihangul",
      "Dumisha urafiki ulioanzia connect"
    ],
    "appMenu.talk.global.tip": "Anza na swali dogo, pata mshirika wa maisha Korea",
  
    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Jenga hadithi yako ya kimataifa",
    "appMenu.passport.local.description": "Rekodi uzoefu na marafiki wa kigeni na jenga utambulisho wa kimataifa bila pasipoti",
    "appMenu.passport.local.points": [
      "Onyesha shughuli zako za kimataifa katika jumuiya",
      "Unda wasifu wa balozi wa kimataifa",
      "Simamia uwezo wa lugha na utamaduni"
    ],
    "appMenu.passport.local.tip": "Kila hatua ndogo ni sehemu ya safari yako ya kimataifa",
  
    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Utambulisho wa kimataifa - Kadi ya dijitali",
    "appMenu.passport.global.description": "Onyesha safari zako za makazi na utamaduni na uunde wasifu wa kuaminika",
    "appMenu.passport.global.points": [
      "Onyesha historia ya makazi na uzoefu kwa njia ya kuona",
      "Uwezo wa lugha na utamaduni huongeza uaminifu",
      "Ungana na wengine wenye safari zinazofanana"
    ],
    "appMenu.passport.global.tip": "Wasifu wako unavyojieleza vizuri, ndivyo utakavyokutana na watu sahihi",
  
    // Demo Section
    "common.viewAll": "Ona yote",
    "common.minutesAgo": "dakika zilizopita",
  
    "home.tag": "Soko la jumla",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Iwe siku njema",
  
    "home.weather.maxTemp": "Juu 15°",
    "home.weather.minTemp": "Chini 10°",
  
    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Angavu",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Mawingu",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Wastani",
  
    "home.mytown.title": "Mtaa wetu - papo hapo",
    "home.mytown.places.0.name": "Soko la Ginkgo",
    "home.mytown.places.0.address": "Siheung-dong, Geumcheon-gu",
    "home.mytown.places.1.name": "Mlima Gwanak",
    "home.mytown.places.1.address": "Sillim-dong, Gwanak-gu",
    "home.mytown.places.2.name": "Uwanja wa Anayangcheon",
    "home.mytown.places.2.address": "Dokseon-dong, Geumcheon-gu",
  
    "home.events.title": "Matukio ya mtaa",
    "home.events.post_title": "Soko la jumla linaendelea Doksan",
    "home.events.address": "Doksan-dong, Geumcheon-gu",
  
    "mingl.posts.0.category": "Taarifa za maisha",
    "mingl.posts.0.title": "Mpakia-sundae wa Geumcheon amepotea?",
    "mingl.posts.0.content": "Hii ilikuwa sundae bora maishani... sasa haonekani tena. Yuko wapi?",
  
    "mingl.posts.1.category": "Taarifa za maisha",
    "mingl.posts.1.title": "Mbinu bora za kununua Doksan Market",
    "mingl.posts.1.content": "Bei hubadilika kulingana na siku ya wiki. Unafanyaje manunuzi kwa busara?",
  
    "mingl.posts.2.category": "Kila siku",
    "mingl.posts.2.title": "Tukule nini karibu na Gasan?",
    "mingl.posts.2.content": "Leo kuamua chakula ni ngumu sana. Wafanyakazi karibu na kituo wanakula nini?",
  
    "mingl.posts.3.category": "Burudani/Mikutano",
    "mingl.posts.3.title": "Tunakutana kucheza bodi Gasan Ijumaa",
    "mingl.posts.3.content": "Kila Ijumaa jioni, tunatafuta wanaojiunga.",
  
    "mingl.posts.4.category": "Safari/Matembezi",
    "mingl.posts.4.title": "Njia rafiki ya kutembea Mlima Hoamsan",
    "mingl.posts.4.content": "Nimegundua njia ya kutembea kirahisi wikendi. Hii ndiyo mapendekezo yangu.",
  
    "mingl.posts.5.category": "Kila siku",
    "mingl.posts.5.title": "Tafadhali pendekeza kahawa tulivu Doksan",
    "mingl.posts.5.content": "Nataka mahali pa kufanya kazi na Wi-Fi thabiti na soketi.",
  
    "mingl.posts.6.category": "Taarifa za maisha",
    "mingl.posts.6.title": "Gym nzuri karibu na Gasan?",
    "mingl.posts.6.content": "Kuna mtu anayejua chaguo nzuri la bei au vifaa?",
  
    "mingl.posts.7.category": "Burudani/Mikutano",
    "mingl.posts.7.title": "Twende kupanda Mlima Gwanak wikendi",
    "mingl.posts.7.content": "Wanafunzi wapya wanakaribishwa!",
  
    "connect.titles.0": "Lugha",
    "connect.titles.1": "Maisha",
    "connect.titles.2": "Mitumba",
    "connect.titles.3": "Kazi",
    "connect.titles.3.category": "Kibarua",
  
    "connect.posts.0.title": "Tunatafuta kubadilishana lugha (Korea × Kijapani)",
    "connect.posts.0.reward": "Kijapani",
    "connect.posts.0.reward_detail": "Muda ni makubaliano",
    "connect.posts.0.location": "Café Seongbuk-dong",
  
    "connect.posts.1.title": "Tunatafuta mzawa wa Kihispania! Tusaidie mazungumzo!",
    "connect.posts.1.reward": "Kadi ya zawadi",
    "connect.posts.1.reward_detail": "₩50,000 / mara",
    "connect.posts.1.location": "Kituo cha Geumcheon-gu Office",
  
    "connect.posts.2.title": "Tafuta mtu wa kuelekeza njia Incheon → Mapo",
    "connect.posts.2.reward": "Bidhaa",
    "connect.posts.2.reward_detail": "Mvinyo wa Uhispania",
    "connect.posts.2.location": "Uwanja wa ndege wa Incheon",
  
    "connect.posts.3.title": "Nahitaji mtu wa kunisaidia kusaini mkataba wa chumba",
    "connect.posts.3.reward": "Fedha taslimu",
    "connect.posts.3.reward_detail": "₩10,000 / saa",
    "connect.posts.3.location": "Yeongdeungpo - Yangcheon",
  
    "connect.posts.4.title": "Niazime Monkey Driver kwa siku moja, nakupa kimchi!",
    "connect.posts.4.reward": "Bidhaa",
    "connect.posts.4.reward_detail": "Kimchi ya nyumbani",
    "connect.posts.4.location": "Seogyo-dong, Mapo-gu",
  
    "connect.posts.5.title": "Nauza baiskeli! Inatumika kidogo",
    "connect.posts.5.reward": "Bei",
    "connect.posts.5.reward_detail": "₩50,000",
    "connect.posts.5.location": "Kituo cha Sinchon",
  
    "connect.posts.6.title": "Kibarua cha muda mfupi kwenye maonyesho (Kiingereza kinapewa kipaumbele)",
    "connect.posts.6.reward": "Kazi",
    "connect.posts.6.reward_detail": "Msaada wa eneo + maelekezo",
    "connect.posts.6.location": "COEX",
  
    "connect.posts.7.title": "Tunatafuta barista anayejua Kihispania (Wageni wenye Kihispania asili wanapewa kipaumbele)",
    "connect.posts.7.reward": "Mshahara",
    "connect.posts.7.reward_detail": "Kuanzia ₩10,000",
    "connect.posts.7.location": "Café Itaewon",
  
    "passport.introduction": "Nilianza kujifunza Kikorea baada ya kutazama vipindi vya burudani vya Kikorea, na nilishinda mashindano ya hotuba ya Kikorea nchini Mexico — ndipo niliamua kuja Korea!",
    "passport.gender": "Jinsia",
    "passport.gender_detail": "Mwanaume",
    "passport.birth": "Tarehe ya kuzaliwa",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Utaifa",
    "passport.nationality_detail": "Mexico",
    "passport.mother_tongue": "Lugha ya mama",
    "passport.mother_tongue_detail": "Kihispania",
    "passport.language": "Lugha",
    "passport.language_detail.0": "Kikorea",
    "passport.language_detail.1": "Kiingereza",
    "passport.edit": "Hariri",
    "passport.share": "Shiriki",

    // Positioned Mobile Demo Section (sw)
    "positionedMobileDemo.home.description": "Kama ‘habari za mtaa’ — angalia kilichopo eneo lako mara moja",
    "positionedMobileDemo.home.features.0.description": "Usikose habari na matukio ya eneo lako kwa wakati halisi",
    "positionedMobileDemo.home.features.1.description": "Gundua maisha ya kila siku ya wakazi kulingana na maeneo tofauti",
    "positionedMobileDemo.home.features.2.description": "Jiunge kwa urahisi na sherehe, mikusanyiko, na shughuli mbalimbali za jamii",

    "positionedMobileDemo.mingl.description": "Gundua na shiriki maisha halisi ya mtaa kulingana na ramani",
    "positionedMobileDemo.mingl.features.0.description": "Shiriki maswali, taarifa, habari na mapendekezo kwa uhuru — mawasiliano ya asili",
    "positionedMobileDemo.mingl.features.1.description": "Tafsiri ya papo hapo bila vizuizi vya lugha kwa mawasiliano ya kimataifa",
    "positionedMobileDemo.mingl.features.2.description": "Ulimwengu kwa macho ya wenyeji, wenyeji kwa macho ya wageni",

    "positionedMobileDemo.connect.description": "Wakati wa kusaidiana ndipo uhusiano huanza",
    "positionedMobileDemo.connect.features.0.description": "Pata msaada unahitaji mara moja kupitia ulinganifu wa eneo",
    "positionedMobileDemo.connect.features.1.description": "Chagua mwenyewe mtu ‘anayestahili kuaminiwa na aliye salama’",
    "positionedMobileDemo.connect.features.2.description": "Mazungumzo → Mabadilishano → Mahusiano ya muda mrefu ya ndani na ya kimataifa",

    "positionedMobileDemo.talk.description": "Kutana na marafiki wa kimataifa bila wasiwasi wa lugha kwa msaada wa AI",
    "positionedMobileDemo.talk.features.0.description": "Mazungumzo ya kawaida bila kujali kiwango cha lugha kupitia tafsiri ya papo hapo",
    "positionedMobileDemo.talk.features.1.description": "Uliza moja kwa moja kuhusu maisha Korea na upate jibu papo hapo",
    "positionedMobileDemo.talk.features.2.description": "Geuza uhusiano ulioanza kupitia Connect kuwa urafiki wa kudumu",

    "positionedMobileDemo.passport.description": "Tengeneza kadi ya kidijitali inayorekodi safari yako ya kimataifa",
    "positionedMobileDemo.passport.features.0.description": "Rekodi historia ya makazi na shughuli zako kwa maeneo kwenye mpangilio wa wakati",
    "positionedMobileDemo.passport.features.1.description": "Onyesha uwezo wako wa lugha na mtindo wa mawasiliano kwa uwazi",
    "positionedMobileDemo.passport.features.2.description": "Ungana kwa urahisi na watu wenye uzoefu unaofanana",

  
    // Logl Video Section
    "loglVideo.title": "Video ya utangulizi wa logl",
    "loglVideo.description": "Unataka kujua logl ni nini? Anza na video hii!",
    "loglVideo.watch": "Tazama sasa"
    }
  },
  pt: {
    translation: {
      // Header Section
    "header.intro": "Introdução",
      "header.demo": "Demo",
    "header.video": "vídeo da logl",
      
      // Hero Section
    "hero.title": "Elimine as barreiras do idioma",
      "hero.description": "find your",
    "hero.demo": "Experimentar a demo",
    "hero.prop1": "Serviço local verificado",
    "hero.prop2": "Tradução de IA em tempo real",
    "hero.prop3": "Várias comunidades locais",

    // Introduction Section
    "introduction.title": "Já teve estas preocupações?",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",

    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Seul, Coreia do Sul",
    "introduction.fst.tag": "#EstudoDeIdiomas",
    "introduction.fst.story": "\"Estudei inglês com empenho e até fiz intercâmbio… mas sem usar no dia a dia acabo esquecendo tudo. Queria só ter a chance de usar na vida real 😢\"",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Coreia do Sul",
    "introduction.snd.tag": "#FazerAmigosLocais",
    "introduction.snd.story": "\"Estou na Coreia há 6 meses e ainda saio só com amigos do meu país. Quero mesmo fazer amigos coreanos, mas não sei por onde começar.\"",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Coreia do Sul",
    "introduction.trd.tag": "#InfoVidaLocal",
    "introduction.trd.story": "\"Mesmo vendo YouTube e entrando em comunidades, não há info do meu bairro. Banco, operadora, hospital… Onde encontro informações corretas e atuais quando vou me estabelecer?\"",

    // App Menu Section
    "appMenu.home.local.title": "Início",
    "appMenu.home.local.subtitle": "Transforme seu bairro em um hub global",
    "appMenu.home.local.description": "Com as informações que você conhece do bairro, ajude vizinhos estrangeiros e torne a sua região uma verdadeira comunidade global.",
    "appMenu.home.local.points": [
      "Apresentar a estrangeiros restaurantes escondidos, hospitais e serviços locais",
      "Compartilhar notícias e eventos do bairro em tempo real",
      "Elevar o índice global e liderar a internacionalização local"
    ],
    "appMenu.home.local.tip": "A sua pequena informação pode ser o guia essencial de alguém.",

    "appMenu.home.global.title": "Home",
    "appMenu.home.global.subtitle": "Painel sob medida para a vida na Coreia",
    "appMenu.home.global.description": "Do clima de hoje aos posts populares do bairro, veja em uma tela o que é essencial para viver na Coreia.",
    "appMenu.home.global.points": [
      "Planeje o dia com clima local e dicas de saída",
      "Confira primeiro notícias do bairro e pedidos de ajuda em tempo real",
      "Não perca histórias de estrangeiros em alta entre coreanos"
    ],
    "appMenu.home.global.tip": "Com 5 minutos por dia, sua vida na Coreia fica muito mais fácil.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Converse com amigos globais",
    "appMenu.mingl.local.description": "Responda perguntas de estrangeiros, aprenda idiomas e compartilhe culturas juntos.",
    "appMenu.mingl.local.points": [
      "Compartilhe dicas de vida na Coreia e sinta-se útil",
      "Melhore seu idioma de forma natural",
      "Faça amigos de diversas culturas"
    ],
    "appMenu.mingl.local.tip": "Responda às perguntas, aprenda idiomas e troque culturas juntos.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Comunique-se naturalmente com coreanos",
    "appMenu.mingl.global.description": "Com tradução em tempo real, pergunte sem barreiras e faça amigos locais.",
    "appMenu.mingl.global.points": [
      "Resolva dúvidas sobre a vida na Coreia em tempo real",
      "Converse naturalmente sem peso de idioma graças à IA",
      "Saia do ‘gueto de estrangeiros’ e faça amigos coreanos de verdade"
    ],
    "appMenu.mingl.global.tip": "Aprenda a cultura coreana e integre-se naturalmente à comunidade local.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Ajude vizinhos estrangeiros e faça amigos",
    "appMenu.connect.local.description": "Resolva problemas práticos de estrangeiros do bairro e construa uma rede global.",
    "appMenu.connect.local.points": [
      "Ajuda prática com banco, moradia e documentos",
      "Crie conexões globais de forma natural ajudando",
      "Atue com significado como embaixador global do bairro"
    ],
    "appMenu.connect.local.tip": "Comece com pequenas ajudas e construa amizade global de verdade.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Resolva problemas com vizinhos coreanos",
    "appMenu.connect.global.description": "Resolva questões urgentes como banco, casa e visto com locais de confiança.",
    "appMenu.connect.global.points": [
      "Solucione questões concretas como abrir conta e achar moradia",
      "Peça ajuda casualmente a vizinhos sem agência",
      "Saia do ‘gueto de estrangeiros’ e adapte-se de verdade"
    ],
    "appMenu.connect.global.tip": "Quanto mais urgente, mais rápido e certo é contar com um vizinho local.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Converse em tempo real com vizinhos estrangeiros",
    "appMenu.talk.local.description": "Com tradução por IA, faça 1:1 sem medo de idioma e torne-se um amigo global de verdade.",
    "appMenu.talk.local.points": [
      "Conversa natural independente do nível de idioma, via tradução em tempo real",
      "Transforme conexões do Connect em amizades duradouras",
      "Acolha e aconselhe sobre desafios da vida na Coreia"
    ],
    "appMenu.talk.local.tip": "Conversas de pequena ajuda viram uma rede global para a vida toda.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Comunique-se à vontade com coreanos",
    "appMenu.talk.global.description": "Converse em tempo real sem barreiras e resolva dúvidas na hora com vizinhos coreanos.",
    "appMenu.talk.global.points": [
      "Pergunte diretamente a coreanos e receba respostas imediatas",
      "Mesmo sem coreano, converse de forma natural com tradução por IA",
      "Mantenha laços com quem ajudou no Connect e torne-se amigo de verdade"
    ],
    "appMenu.talk.global.tip": "Comece com pequenas perguntas e encontre um parceiro confiável para a vida na Coreia.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Crie sua história global",
    "appMenu.passport.local.description": "Registre atividades e experiências com amigos estrangeiros e construa identidade global sem passaporte.",
    "appMenu.passport.local.points": [
      "Visualize sua linha do tempo de atividades globais no bairro",
      "Monte um portfólio de embaixador global com registros de ajuda",
      "Gerencie idioma e experiências de troca cultural de forma organizada"
    ],
    "appMenu.passport.local.tip": "Registre até as pequenas ajudas e complete sua jornada global pessoal.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Identidade global — cartão digital",
    "appMenu.passport.global.description": "Mostre visualmente sua trajetória multicultural e crie um perfil confiável.",
    "appMenu.passport.global.points": [
      "Visualize histórico de moradia e experiências globais de relance",
      "Construa credibilidade com proficiência linguística e bagagem cultural",
      "Conecte-se naturalmente com quem tem vivências parecidas"
    ],
    "appMenu.passport.global.tip": "Quanto mais detalhado o perfil, melhor a ajuda local e mais amizades reais.",

    // Demo Section
    "common.viewAll": "Ver tudo",
    "common.minutesAgo": "min atrás",

    "home.tag": "Feira livre",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Tenha um ótimo dia",

    "home.weather.maxTemp": "Máx 15°",
    "home.weather.minTemp": "Mín 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Céu limpo",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Nublado",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Normal",

    "home.mytown.title": "Nosso bairro em tempo real",
    "home.mytown.places.0.name": "Mercado Ginkgo",
    "home.mytown.places.0.address": "Siheung-dong, Geumcheon-gu",
    "home.mytown.places.1.name": "Monte Gwanak",
    "home.mytown.places.1.address": "Sillim-dong, Gwanak-gu",
    "home.mytown.places.2.name": "Praça Multifuncional Anyangcheon",
    "home.mytown.places.2.address": "Dokseon-dong, Geumcheon-gu",

    "home.events.title": "Eventos do bairro",
    "home.events.post_title": "Feira livre em Doksan-dong",
    "home.events.address": "Doksan-dong, Geumcheon-gu",

    "mingl.posts.0.category": "Informações",
    "mingl.posts.0.title": "Onde está o carrinho de salsicha da estação Geumcheon-gu Office?",
    "mingl.posts.0.content": "Era a melhor salsicha da vida, mas há tempos não vejo. Alguém sabe onde está?",

    "mingl.posts.1.category": "Informações",
    "mingl.posts.1.title": "Dicas para comprar no mercado tradicional de Doksan",
    "mingl.posts.1.content": "Os preços variam por dia da semana. Qual a melhor estratégia de compras?",

    "mingl.posts.2.category": "Cotidiano",
    "mingl.posts.2.title": "O que almoçar perto do Gasan Digital Complex?",
    "mingl.posts.2.content": "Hoje está difícil decidir. O que o pessoal que trabalha na região come?",

    "mingl.posts.3.category": "Hobby/Encontros",
    "mingl.posts.3.title": "Procuro gente para grupo de board game em Gasan",
    "mingl.posts.3.content": "Toda sexta à noite perto da estação Gasan. Participe!",

    "mingl.posts.4.category": "Passeios",
    "mingl.posts.4.title": "Trilha leve no anel do Monte Hoam",
    "mingl.posts.4.content": "Descobri um trajeto leve para o fim de semana. Recomendo a rota que encontrei.",

    "mingl.posts.5.category": "Cotidiano",
    "mingl.posts.5.title": "Café silencioso perto de Doksan, indicações?",
    "mingl.posts.5.content": "Procuro café tranquilo com bom Wi-Fi e tomadas para trabalhar.",

    "mingl.posts.6.category": "Informações",
    "mingl.posts.6.title": "Indicação de academia perto de Gasan",
    "mingl.posts.6.content": "Alguém frequenta por perto? Boa estrutura e mensalidade em conta?",

    "mingl.posts.7.category": "Hobby/Encontros",
    "mingl.posts.7.title": "Trilha no Monte Gwanak — vamos juntos?",
    "mingl.posts.7.content": "Vou neste fim de semana. Iniciantes bem-vindos, passeio em ritmo leve.",

    // connect.titles.* (≤ 6 caracteres, curtos)
    "connect.titles.0": "Idioma",
    "connect.titles.1": "Vida",
    "connect.titles.2": "Usados",
    "connect.titles.3": "Vagas",
    "connect.titles.3.category": "Extra",

    "connect.posts.0.title": "Coreano–Japonês (negócios): troca de conversação",
    "connect.posts.0.reward": "Japonês",
    "connect.posts.0.reward_detail": "Tempo igual a combinar",
    "connect.posts.0.location": "Café em Seongbuk-dong",

    "connect.posts.1.title": "Procuro nativo de espanhol — treino de conversa",
    "connect.posts.1.reward": "Vale-presente",
    "connect.posts.1.reward_detail": "₩50.000 / sessão",
    "connect.posts.1.location": "Estação Geumcheon-gu Office",

    "connect.posts.2.title": "Ajuda no metrô do Aeroporto de Incheon até Mapo",
    "connect.posts.2.reward": "Presente",
    "connect.posts.2.reward_detail": "Vinho espanhol",
    "connect.posts.2.location": "Aeroporto de Incheon",

    "connect.posts.3.title": "Acompanhamento para assinar contrato de quitinete",
    "connect.posts.3.reward": "Dinheiro",
    "connect.posts.3.reward_detail": "₩10.000 / hora",
    "connect.posts.3.location": "Seul Yeongdeungpo / Yangcheon",

    "connect.posts.4.title": "Empreste uma Monkey Driver por 1 dia — dou kimchi cubos",
    "connect.posts.4.reward": "Presente",
    "connect.posts.4.reward_detail": "Kkakdugi caseiro",
    "connect.posts.4.location": "Seogyo-dong, Mapo",

    "connect.posts.5.title": "Vendo bicicleta — pouco uso",
    "connect.posts.5.reward": "Preço",
    "connect.posts.5.reward_detail": "₩50.000",
    "connect.posts.5.location": "Perto da estação Sinchon",

    "connect.posts.6.title": "Bico temporário em feira — inglês desejável",
    "connect.posts.6.reward": "Função",
    "connect.posts.6.reward_detail": "Suporte no local e orientação em inglês",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "Barista que fale espanhol — estrangeiros bem-vindos",
    "connect.posts.7.reward": "Hora",
    "connect.posts.7.reward_detail": "A partir de ₩10.000",
    "connect.posts.7.location": "Café em Itaewon",

    "passport.introduction": "Comecei a estudar coreano vendo programas e, após vencer um concurso de discurso em coreano no México, decidi vir para a Coreia!",
    "passport.gender": "Gênero",
    "passport.gender_detail": "Masculino",
    "passport.birth": "Data de nascimento",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Nacionalidade",
    "passport.nationality_detail": "México",
    "passport.mother_tongue": "Língua materna",
    "passport.mother_tongue_detail": "Espanhol",
    "passport.language": "Idiomas",
    "passport.language_detail.0": "Coreano",
    "passport.language_detail.1": "Inglês",
    "passport.edit": "Editar",
    "passport.share": "Compartilhar",

    // Positioned Mobile Demo Section (sw)
    "positionedMobileDemo.home.description": "Kama ‘habari za mtaa’ — angalia kilichopo eneo lako mara moja",
    "positionedMobileDemo.home.features.0.description": "Usikose habari na matukio ya eneo lako kwa wakati halisi",
    "positionedMobileDemo.home.features.1.description": "Gundua maisha ya kila siku ya wakazi kulingana na maeneo tofauti",
    "positionedMobileDemo.home.features.2.description": "Jiunge kwa urahisi na sherehe, mikusanyiko, na shughuli mbalimbali za jamii",

    "positionedMobileDemo.mingl.description": "Gundua na shiriki maisha halisi ya mtaa kulingana na ramani",
    "positionedMobileDemo.mingl.features.0.description": "Shiriki maswali, taarifa, habari na mapendekezo kwa uhuru — mawasiliano ya asili",
    "positionedMobileDemo.mingl.features.1.description": "Tafsiri ya papo hapo bila vizuizi vya lugha kwa mawasiliano ya kimataifa",
    "positionedMobileDemo.mingl.features.2.description": "Ulimwengu kwa macho ya wenyeji, wenyeji kwa macho ya wageni",

    "positionedMobileDemo.connect.description": "Wakati wa kusaidiana ndipo uhusiano huanza",
    "positionedMobileDemo.connect.features.0.description": "Pata msaada unahitaji mara moja kupitia ulinganifu wa eneo",
    "positionedMobileDemo.connect.features.1.description": "Chagua mwenyewe mtu ‘anayestahili kuaminiwa na aliye salama’",
    "positionedMobileDemo.connect.features.2.description": "Mazungumzo → Mabadilishano → Mahusiano ya muda mrefu ya ndani na ya kimataifa",

    "positionedMobileDemo.talk.description": "Kutana na marafiki wa kimataifa bila wasiwasi wa lugha kwa msaada wa AI",
    "positionedMobileDemo.talk.features.0.description": "Mazungumzo ya kawaida bila kujali kiwango cha lugha kupitia tafsiri ya papo hapo",
    "positionedMobileDemo.talk.features.1.description": "Uliza moja kwa moja kuhusu maisha Korea na upate jibu papo hapo",
    "positionedMobileDemo.talk.features.2.description": "Geuza uhusiano ulioanza kupitia Connect kuwa urafiki wa kudumu",

    "positionedMobileDemo.passport.description": "Tengeneza kadi ya kidijitali inayorekodi safari yako ya kimataifa",
    "positionedMobileDemo.passport.features.0.description": "Rekodi historia ya makazi na shughuli zako kwa maeneo kwenye mpangilio wa wakati",
    "positionedMobileDemo.passport.features.1.description": "Onyesha uwezo wako wa lugha na mtindo wa mawasiliano kwa uwazi",
    "positionedMobileDemo.passport.features.2.description": "Ungana kwa urahisi na watu wenye uzoefu unaofanana",


    // Logl Video Section
    "loglVideo.title": "Vídeo de apresentação da logl",
    "loglVideo.description": "Curioso sobre a logl? Comece pelo vídeo!",
    "loglVideo.watch": "Assistir ao vídeo"

    }
  },
  translation: {
    // Header Section
    "header.intro": "परिचय",
    "header.demo": "डेमो",
    "header.video": "logl मूवी",
  
    // Hero Section
    "hero.title": "भाषा की दीवार हटाएँ",
    "hero.description": "अपना खोजें",
    "hero.demo": "डेमो आज़माएँ",
    "hero.prop1": "विश्वसनीय लोकल 서비스",
    "hero.prop2": "रीयल-टाइम AI अनुवाद",
    "hero.prop3": "विविध स्थानीय समुदाय",
  
    // Introduction Section
    "introduction.title": "क्या ऐसी 고민 है?",
    "introduction.fst.role": "स्थानीय",
    "introduction.snd.role": "वैश्विक",
  
    "introduction.fst.name": "지민",
    "introduction.fst.location": "सियोल, दक्षिण कोरिया",
    "introduction.fst.tag": "#विदेशीभाषा",
    "introduction.fst.story": "\"अंग्रेज़ी पढ़ी और विदेश भी गया, पर इस्तेमाल न होने से भूल गया। रोज़मर्रा में उपयोग का मौका चाहिए 😢\"",
  
    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "सुवोन, दक्षिण कोरिया",
    "introduction.snd.tag": "#स्थानीयदोस्त",
    "introduction.snd.story": "\"6 महीने हुए, अभी भी अपने देश के दोस्तों संग ही घूमती हूँ। कोरियाई दोस्तों से सच में घुलना-मिलना चाहती हूँ, पर शुरुआत कैसे करूँ?\"",
  
    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "जिओन्जू, दक्षिण कोरिया",
    "introduction.trd.tag": "#लोकलजीवनसूचना",
    "introduction.trd.story": "\"यूट्यूब/कम्युनिटी में भी हमारे मुहल्ले की जानकारी नहीं मिलती। बैंक, टेलिकॉम, अस्पताल… पहली बार बसने पर सही और नयी जानकारी कहाँ से लूँ?\"",
    
    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "हमारा मुहल्ला, ग्लोबल हब",
    "appMenu.home.local.description": "अपने लोकल ज्ञान से विदेशी पड़ोसियों की मदद करें और क्षेत्र को सच्चा ग्लोबल कम्युनिटी बनाएँ",
    "appMenu.home.local.points": [
      "छुपे रेस्टोरेंट, अस्पताल, सुविधाएँ सुझाएँ",
      "रीयल-टाइम मुहल्ला समाचार/इवेंट साझा करें",
      "ग्लोबल इंडेक्स बढ़ाएँ, क्षेत्र का अंतरराष्ट्रीयकरण लीड करें",
    ],
    "appMenu.home.local.tip": "आपकी छोटी जानकारी किसी के लिए बड़ा मार्गदर्शक है",
  
    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "कोरिया-जीवन डैशबोर्ड",
    "appMenu.home.global.description": "मौसम से लोकप्रिय पोस्ट तक—ज़रूरी बातें एक स्क्रीन पर",
    "appMenu.home.global.points": [
      "लोकल मौसम/आउटिंग टिप से दिन की योजना",
      "मुहल्ले की खबरें और मदद अनुरोध पहले देखें",
      "कोरियाईयों में चर्चित ग्लोबल 이야기 न चूकें",
    ],
    "appMenu.home.global.tip": "रोज़ 5 मिनट, कोरिया-जीवन कहीं आसान",
  
    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "ग्लोबल दोस्तों से बातें",
    "appMenu.mingl.local.description": "विदेशियों के प्रश्नों का उत्तर दें, भाषा सीखें, संस्कृति बाँटें",
    "appMenu.mingl.local.points": [
      "कोरिया-जीवन टिप बाँटें, संतुष्टि पाएँ",
      "स्वाभाविक रूप से भाषा में सुधार",
      "विभिन्न संस्कृतियों के दोस्त बनाएँ"
    ],
    "appMenu.mingl.local.tip": "जवाब दें, सीखें, 함께 나누세요",
  
    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "कोरियाईयों से सहज संवाद",
    "appMenu.mingl.global.description": "रीयल-टाइम अनुवाद से बेझिझक पूछें, लोकल दोस्त बनाएँ",
    "appMenu.mingl.global.points": [
      "कोरिया-जीवन के सवाल तुरंत हल",
      "AI अनुवाद से बिना बोझ की बातचीत",
      "गेटो से बाहर, असली कोरियाई 친구 사귀기"
    ],
    "appMenu.mingl.global.tip": "संस्कृति सीखें, लोकल कम्युनिटी में घुलें",
  
    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "विदेशी पड़ोसी की मदद, दोस्ती तक",
    "appMenu.connect.local.description": "मुहल्ले के विदेशियों की वास्तविक समस्याएँ सुलझाएँ और ग्लोबल नेटवर्क बनाएँ",
    "appMenu.connect.local.points": [
      "बैंक, घर, कागज़ात—व्यावहारिक मदद",
      "मदद देते-देते ग्लोबल नेटवर्क",
      "ग्लोबल एम्बेसडर की अर्थपूर्ण भूमिका"
    ],
    "appMenu.connect.local.tip": "छोटी मदद से असली ग्लोबल रिश्ते",
  
    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "कोरियाई पड़ोसी संग समाधान",
    "appMenu.connect.global.description": "बैंक, घर, वीज़ा—भरोसेमंद लोकल के साथ मिलकर हल करें",
    "appMenu.connect.global.points": [
      "बैंक अकाउंट, घर ढूँढना—ठोस समाधान",
      "एजेंट नहीं, पड़ोसी से कैज़ुअल हेल्प",
      "गेटो से बाहर, असली लोकल जीवन में ढलें"
    ],
    "appMenu.connect.global.tip": "तत्काल समस्या में लोकल मदद सबसे तेज़ और पक्की",
  
    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "विदेशी पड़ोसी से रीयल-टाइम चैट",
    "appMenu.talk.local.description": "AI अनुवाद के साथ 1:1 चैट—सच में ग्लोबल दोस्त बनें",
    "appMenu.talk.local.points": [
      "रीयल-टाइम AI अनुवाद से सहज वार्तालाप",
      "Connect से शुरू रिश्ता—दोस्ती में विस्तार",
      "विदेशी पड़ोसियों की दुविधा पर सीधे सलाह",
    ],
    "appMenu.talk.local.tip": "छोटी बातचीत, उम्रभर की ग्लोबल नेटवर्किंग",
  
    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "कोरियाईयों संग आराम से बात",
    "appMenu.talk.global.description": "भाषा बाधा बिना रीयल-टाइम चैट, सवाल तुरंत हल",
    "appMenu.talk.global.points": [
      "कोरिया-जीवन के सवाल—कोरियाई से सीधे, तुरंत",
      "AI अनुवाद—कोरियाई न आए तब भी सहज",
      "Connect में मिले पड़ोसी संग निरंतर संवाद",
    ],
    "appMenu.talk.global.tip": "छोटे सवाल से भरोसेमंद लोकल साथी तक",
  
    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "अपनी ग्लोबल स्टोरी",
    "appMenu.passport.local.description": "गतिविधियाँ/अनुभव दर्ज करें—बिना पासपोर्ट भी ग्लोबल पहचान",
    "appMenu.passport.local.points": [
      "मुहल्ले की ग्लोबल गतिविधि—टाइमलाइन",
      "मदद रिकॉर्ड से एम्बेसडर पोर्टफोलियो",
      "भाषा व सांस्कृतिक अनुभव—सिस्टेमेटिक",
    ],
    "appMenu.passport.local.tip": "छोटे कदम, आपकी ग्लोबल यात्रा पूरी",
  
    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "ग्लोबल पहचान—डिजिटल कार्ड",
    "appMenu.passport.global.description": "बहुसांस्कृतिक अनुभव को दृश्य रूप दें, भरोसेमंद प्रोफ़ाइल बनाएँ",
    "appMenu.passport.global.points": [
      "निवास इतिहास/ग्लोबल अनुभव—एक नज़र",
      "भाषा कौशल/पृष्ठभूमि से विश्वसनीयता",
      "मिलती-जुलती 경험 वालों से कनेक्ट"
    ],
    "appMenu.passport.global.tip": "जितनी विस्तार प्रोफ़ाइल, उतनी बेहतर लोकल मदद/दोस्ती",
  
    // Demo Section
    "common.viewAll": "전체보기",
    "common.minutesAgo": "मिनट पहले",
  
    "home.tag": "फ्लीमार्केट",
    "home.greeting_01": "Carlos님",
    "home.greeting_02": "आज भी",
  
    "home.weather.maxTemp": "उच्च 15°",
    "home.weather.minTemp": "न्यून 10°",
  
    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "स्वच्छ",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "बादल",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "मध्यम",
  
    "home.mytown.title": "रीयल-टाइम मुहल्ला",
    "home.mytown.places.0.name": "은행나무시장",
    "home.mytown.places.0.address": "금천구 시흥동",
    "home.mytown.places.1.name": "관악산",
    "home.mytown.places.1.address": "관악구 신림동",
    "home.mytown.places.2.name": "안양천다목적광장",
    "home.mytown.places.2.address": "금천구 독선동",
  
    "home.events.title": "मुहल्ला इवेंट",
    "home.events.post_title": "독산동 फ्लीमार्केट हो रहा है",
    "home.events.address": "금천구 독산동",
  
    "mingl.posts.0.category": "जीवनसूचना",
    "mingl.posts.0.title": "금천구청역 순대차 아저씨 कहाँ हैं?",
    "mingl.posts.0.content": "ज़बरदस्त 순대 था, पर हाल में दिखाई नहीं दे रहे। किसी को पता है?",
  
    "mingl.posts.1.category": "जीवनसूचना",
    "mingl.posts.1.title": "독산 시장 में खरीदारी टिप",
    "mingl.posts.1.content": "दिन के अनुसार दाम बदलते दिखे। समझदारी से कैसे खरीदें?",
  
    "mingl.posts.2.category": "दैनिक",
    "mingl.posts.2.title": "가산디지털단지 लंच क्या खाएँ?",
    "mingl.posts.2.content": "आज मेन्यू तय करना मुश्किल है। पास के दफ़्तरवाले क्या खाते हैं?",
  
    "mingl.posts.3.category": "शौक/모임",
    "mingl.posts.3.title": "가산역 बोर्ड게임 모임—लोग चाहिए",
    "mingl.posts.3.content": "हर शुक्रवार शाम, 가산역 근처। इच्छुक जन जुड़ें।",
  
    "mingl.posts.4.category": "घूमना/आउटिंग",
    "mingl.posts.4.title": "호암산 ट्रेल—वीकेंड वॉक",
    "mingl.posts.4.content": "हल्की सैर के लिए बढ़िया रूट मिला—सिफ़ारिश साझा करता हूँ।",
  
    "mingl.posts.5.category": "दैनिक",
    "mingl.posts.5.title": "독산동 में शांत कैफ़े सुझाएँ",
    "mingl.posts.5.content": "काम के लिए शांत जगह चाहिए—वाई-फाई/पावर सॉकेट हों तो बढ़िया।",
  
    "mingl.posts.6.category": "जीवनसूचना",
    "mingl.posts.6.title": "가산동 जिम सुझाव?",
    "mingl.posts.6.content": "फीस/सुविधा अच्छी जिम हो तो बताइए।",
  
    "mingl.posts.7.category": "शौक/모임",
    "mingl.posts.7.title": "관악산 हाइकिंग साथ चलें?",
    "mingl.posts.7.content": "इस वीकेंड हल्की चढ़ाई—नए लोग स्वागतयोग्य।",
  
    "connect.titles.0": "भाषा-विनिमय",
    "connect.titles.1": "जीवन-अनुकूलन",
    "connect.titles.2": "सेकंड-हैंड",
    "connect.titles.3": "नौकरी/भर्ती",
    "connect.titles.3.category": "पार्ट-टाइम",
  
    "connect.posts.0.title": "कोरियन-जापानी बिज़नेस वार्ता—भाषा विनिमय",
    "connect.posts.0.reward": "जापानी",
    "connect.posts.0.reward_detail": "समय समान, सहमति",
    "connect.posts.0.location": "सोंगबुक-डोंग कैफ़े",
  
    "connect.posts.1.title": "स्पेनिश नेटिव चाहिए—कन्वरसेशन प्रैक्टिस",
    "connect.posts.1.reward": "गिफ्ट कार्ड",
    "connect.posts.1.reward_detail": "₩50,000 / बार",
    "connect.posts.1.location": "गुमचॉन-गुचॉन्ग स्टेशन",
  
    "connect.posts.2.title": "ICN से मापो स्टेशन तक—सबवे गाइड चाहिए",
    "connect.posts.2.reward": "वस्तु",
    "connect.posts.2.reward_detail": "स्पेनिश वाइन",
    "connect.posts.2.location": "इंचियोन एयरपोर्ट",
  
    "connect.posts.3.title": "वन-रूम कॉन्ट्रैक्ट—साथ चलेंगे?",
    "connect.posts.3.reward": "नकद",
    "connect.posts.3.reward_detail": "₩10,000 / घंटा",
    "connect.posts.3.location": "यॉंगदेंगपो/यांगछॉन स्टेशन",
  
    "connect.posts.4.title": "मंकी-ड्राइवर एक दिन चाहिए—किम्ची (깍두기) दूँगा",
    "connect.posts.4.reward": "वस्तु",
    "connect.posts.4.reward_detail": "होममेड 깍두기",
    "connect.posts.4.location": "मापो-गु, सोग्यो-डोंग",
  
    "connect.posts.5.title": "साइकिल बेच रहा हूँ—कम इस्तेमाल",
    "connect.posts.5.reward": "कीमत",
    "connect.posts.5.reward_detail": "₩50,000",
    "connect.posts.5.location": "शिनचॉन स्टेशन पास",
  
    "connect.posts.6.title": "एक्सपो शॉर्ट-टर्म पार्ट-टाइम—अंग्रेज़ी वांछित",
    "connect.posts.6.reward": "कार्य",
    "connect.posts.6.reward_detail": "एक्सपो现场 지원 और अंग्रेज़ी 안내",
    "connect.posts.6.location": "COEX",
  
    "connect.posts.7.title": "स्पेनिश बोलने वाला बारिस्ता चाहिए—नेटिव प्राथमिकता",
    "connect.posts.7.reward": "प्रति घंटा",
    "connect.posts.7.reward_detail": "₩10,000 से",
    "connect.posts.7.location": "इटावन कैफ़े",
  
    "passport.introduction": "कोरियन शो देखकर स्वअध्ययन शुरू किया; मैक्सिको की कोरियन स्पीच कॉन्टेस्ट में 1st आया और कोरिया आने का निश्चय किया!",
    "passport.gender": "लिंग",
    "passport.gender_detail": "पुरुष",
    "passport.birth": "जन्मदिन",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "राष्ट्रीयता",
    "passport.nationality_detail": "Mexico",
    "passport.mother_tongue": "मातृभाषा",
    "passport.mother_tongue_detail": "Spanish",
    "passport.language": "विदेशी भाषाएँ",
    "passport.language_detail.0": "Korean",
    "passport.language_detail.1": "English",
    "passport.edit": "संपादित करें",
    "passport.share": "साझा करें",
  
    // Positioned Mobile Demo Section
    "positionedMobileDemo.home.description": "‘मुहल्ला न्यूज़’ की तरह, अपने इलाक़े का अब-का-अब चेक करें",
    "positionedMobileDemo.home.features.0.description": "रीयल-टाइम खबरें/इवेंट न छूटें",
    "positionedMobileDemo.home.features.1.description": "किसी स्थान केंद्रित—पड़ोसियों की रोज़मर्रा कहानियाँ खोजें",
    "positionedMobileDemo.home.features.2.description": "त्योहार, 모임, इवेंट—अपने क्षेत्र की गतिविधियों में आसानी से शामिल हों",
  
    "positionedMobileDemo.mingl.description": "लोकेशन-आधारित, असली मुहल्ला-जीवन खोजें और साझा करें",
    "positionedMobileDemo.mingl.features.0.description": "प्रश्न/सूचना/खबर/सिफ़ारिश—आज़ादी से साझा, स्वाभाविक交流",
    "positionedMobileDemo.mingl.features.1.description": "रीयल-टाइम अनुवाद—भाषा-बाधा रहित ग्लोबल संवाद",
    "positionedMobileDemo.mingl.features.2.description": "लोकल की नज़र से दुनिया, ग्लोबल की नज़र से लोकल",
  
    "positionedMobileDemo.connect.description": "मदद के पल से—कनेक्शन तक",
    "positionedMobileDemo.connect.features.0.description": "ज़रूरी मदद—मुहल्ला-आधारित तुरंत मै칭",
    "positionedMobileDemo.connect.features.1.description": "स्थिति अनुसार ‘सुरक्षित/भरोसेमंद’ व्यक्ति खुद चुनें",
    "positionedMobileDemo.connect.features.2.description": "बातचीत → 교류 → टिकाऊ लोकल·ग्लोबल 관계",
  
    "positionedMobileDemo.talk.description": "AI अनुवाद के साथ—भाषा चिंता बिना ग्लोबल दोस्त",
    "positionedMobileDemo.talk.features.0.description": "AI रीयल-टाइम अनुवाद—कौशल परे, सहज वार्तालाप",
    "positionedMobileDemo.talk.features.1.description": "कोरिया-जीवन प्रश्न—कोरियाई से सीधे, तुरंत उत्तर",
    "positionedMobileDemo.talk.features.2.description": "Connect से शुरू रिश्ता—लंबी दोस्ती में बदलें",
  
    "positionedMobileDemo.passport.description": "अपनी ग्लोबल यात्रा वाला डिजिटल कार्ड बनाएँ",
    "positionedMobileDemo.passport.features.0.description": "क्षेत्र-वार निवास/गतिविधि—टाइमलाइन में दर्ज",
    "positionedMobileDemo.passport.features.1.description": "भाषा-कौशल और संचार-स्टाइल स्पष्ट दिखाएँ",
    "positionedMobileDemo.passport.features.2.description": "मिलते अनुभव वालों से सहज कनेक्ट",
  
    // Logl Video Section
    "loglVideo.title": "logl परिचय 영상",
    "loglVideo.description": "logl क्या है? पहले वीडियो देखें!",
    "loglVideo.watch": "वीडियो देखें",
  },
  id: {
    translation: {
      // Header Section
      "header.intro": "Intro",
      "header.demo": "Demo",
    "header.video": "video logl",
      
      // Hero Section
    "hero.title": "Hapus hambatan bahasa",
      "hero.description": "find your",
    "hero.demo": "Coba demo",
    "hero.prop1": "Layanan lokal tepercaya",
    "hero.prop2": "Terjemahan AI real-time",
    "hero.prop3": "Komunitas lokal beragam",

    // Introduction Section
    "introduction.title": "Pernah merasa begini?",
    "introduction.fst.role": "lokal",
    "introduction.snd.role": "global",

    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Seoul, Korea Selatan",
    "introduction.fst.tag": "#BelajarBahasa",
    "introduction.fst.story": "\"Aku belajar bahasa Inggris keras dan bahkan studi ke luar negeri… tapi karena jarang dipakai, jadi lupa. Andai ada kesempatan memakainya di keseharian 😢\"",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Korea Selatan",
    "introduction.snd.tag": "#CariTemanLokal",
    "introduction.snd.story": "\"Sudah 6 bulan di Korea, tapi masih mainnya dengan teman satu negara. Ingin sekali akrab dengan orang Korea, tapi bingung mulai dari mana.\"",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Korea Selatan",
    "introduction.trd.tag": "#InfoHidupLokal",
    "introduction.trd.story": "\"Lihat YouTube atau komunitas pun, info khusus lingkungan tempat tinggalku tidak ada. Buka rekening, operator seluler, rumah sakit… saat baru menetap, di mana dapat info akurat dan terbaru?\"",
    
    // App Menu Section
    "appMenu.home.local.title": "Beranda",
    "appMenu.home.local.subtitle": "Jadikan lingkungan kita hub global",
    "appMenu.home.local.description": "Gunakan pengetahuan lokalmu untuk membantu tetangga asing dan jadikan area kita komunitas global yang nyata.",
    "appMenu.home.local.points": [
      "Kenalkan tempat makan, klinik, dan fasilitas tersembunyi pada pendatang",
      "Bagikan kabar dan acara lingkungan secara real-time",
      "Pimpin indeks global dan internasionalisasi lingkungan"
    ],
    "appMenu.home.local.tip": "Info kecil yang kamu tahu bisa jadi panduan hidup penting bagi orang lain.",

    "appMenu.home.global.title": "Beranda",
    "appMenu.home.global.subtitle": "Dasbor khusus hidup di Korea",
    "appMenu.home.global.description": "Dari cuaca hari ini hingga postingan populer sekitar, lihat semua info penting dalam satu layar.",
    "appMenu.home.global.points": [
      "Rencanakan hari dengan cuaca lokal dan tips keluar rumah",
      "Utamakan cek kabar real-time dan permintaan bantuan di sekitar",
      "Jangan lewatkan cerita global yang populer di kalangan orang Korea"
    ],
    "appMenu.home.global.tip": "Cek 5 menit tiap hari bikin hidup di Korea jauh lebih mudah.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Ngobrol dengan teman global",
    "appMenu.mingl.local.description": "Jawab pertanyaan pendatang, belajar bahasa, dan berbagi budaya bersama.",
    "appMenu.mingl.local.points": [
      "Berbagi tips hidup di Korea dan rasakan manfaatnya",
      "Tingkatkan kemampuan bahasa secara alami",
      "Berteman dari berbagai budaya"
    ],
    "appMenu.mingl.local.tip": "Pertukaran budaya dimulai dari obrolan sederhana.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Berkomunikasi natural dengan orang Korea",
    "appMenu.mingl.global.description": "Tanya apa pun tanpa stres bahasa lewat terjemahan real-time dan temukan teman lokal.",
    "appMenu.mingl.global.points": [
      "Selesaikan pertanyaan tentang hidup di Korea saat itu juga",
      "Ngobrol natural berkat terjemahan AI",
      "Keluar dari gelembung sesama pendatang, dapatkan teman Korea sungguhan"
    ],
    "appMenu.mingl.global.tip": "Pelajari budaya dan menyatu alami dengan komunitas lokal.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Bantu tetangga asing & berteman",
    "appMenu.connect.local.description": "Bereskan masalah praktis pendatang dan bangun jaringan global.",
    "appMenu.connect.local.points": [
      "Bantuan nyata: bank, tempat tinggal, dokumen",
      "Bentuk koneksi global lewat saling bantu",
      "Jadi duta global bermakna di lingkunganmu"
    ],
    "appMenu.connect.local.tip": "Bantuan kecil tumbuh jadi persahabatan nyata.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Atasi masalah dengan tetangga lokal tepercaya",
    "appMenu.connect.global.description": "Urus kebutuhan mendesak seperti bank, hunian, dan visa bersama warga lokal yang bisa diandalkan.",
    "appMenu.connect.global.points": [
      "Dapatkan dukungan konkret untuk rekening & tempat tinggal",
      "Minta bantuan ke tetangga tanpa agen mahal",
      "Lepas dari gelembung pendatang dan benar-benar beradaptasi"
    ],
    "appMenu.connect.global.tip": "Saat mendesak, bantuan warga lokal paling cepat dan pasti.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Ngobrol real-time dengan tetangga asing",
    "appMenu.talk.local.description": "Dengan terjemahan real-time, nikmati chat 1:1 dan bangun pertemanan global yang nyata.",
    "appMenu.talk.local.points": [
      "Percakapan natural tanpa peduli level bahasa",
      "Relasi dari Connect berkembang jadi persahabatan",
      "Dengarkan dan bantu keluh kesah hidup di Korea"
    ],
    "appMenu.talk.local.tip": "Obrolan kecil bisa jadi koneksi global seumur hidup.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Komunikasi nyaman dengan orang Korea",
    "appMenu.talk.global.description": "Chat real-time tanpa hambatan bahasa dan dapatkan jawaban spontan.",
    "appMenu.talk.global.points": [
      "Tanya langsung pada orang Korea dan dapat jawaban cepat",
      "Ngobrol nyaman meski belum bisa bahasa Korea",
      "Tetap terhubung dengan tetangga yang ditemui via Connect"
    ],
    "appMenu.talk.global.tip": "Mulai dari pertanyaan kecil — temukan partner andal untuk hidup di Korea.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Bangun cerita globalmu",
    "appMenu.passport.local.description": "Catat aktivitas dan pengalaman lintas budaya untuk membangun identitas globalmu.",
    "appMenu.passport.local.points": [
      "Visualkan lini masa aktivitas global di lingkungan",
      "Bangun portofolio duta global dari jejak bantuan",
      "Kelola kemampuan bahasa & pengalaman pertukaran budaya"
    ],
    "appMenu.passport.local.tip": "Momen kecil pun melengkapi perjalanan globalmu.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Identitas global — kartu digital",
    "appMenu.passport.global.description": "Tunjukkan pengalaman multinasional dan bangun profil yang tepercaya.",
    "appMenu.passport.global.points": [
      "Riwayat tinggal & pengalaman global tampak seketika",
      "Bangun kredibilitas lewat bahasa & latar budaya",
      "Terhubung alami dengan mereka yang berpengalaman serupa"
    ],
    "appMenu.passport.global.tip": "Profil makin detail, bantuan lokal & pertemanan makin baik.",

    // Demo Section
    "common.viewAll": "Lihat semua",
    "common.minutesAgo": "menit lalu",

    "home.tag": "Pasar loak",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Semoga harimu menyenangkan",

    "home.weather.maxTemp": "Maks 15°",
    "home.weather.minTemp": "Min 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Cerah",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Berawan",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Sedang",

    "home.mytown.title": "Realtime sekitar kita",
    "home.mytown.places.0.name": "Pasar Ginkgo",
    "home.mytown.places.0.address": "Siheung-dong, Geumcheon-gu",
    "home.mytown.places.1.name": "Gunung Gwanak",
    "home.mytown.places.1.address": "Sillim-dong, Gwanak-gu",
    "home.mytown.places.2.name": "Plaza Serbaguna Anyangcheon",
    "home.mytown.places.2.address": "Dokseon-dong, Geumcheon-gu",

    "home.events.title": "Acara lingkungan",
    "home.events.post_title": "Ada pasar loak di Doksan-dong",
    "home.events.address": "Doksan-dong, Geumcheon-gu",

    "mingl.posts.0.category": "Info lokal",
    "mingl.posts.0.title": "Ke mana gerobak sundae di Stasiun Kantor Geumcheon?",
    "mingl.posts.0.content": "Itu sundae terenak, tapi akhir-akhir ini tak terlihat. Ada yang tahu?",

    "mingl.posts.1.category": "Info lokal",
    "mingl.posts.1.title": "Tips belanja di Pasar Tradisional Doksan",
    "mingl.posts.1.content": "Harga beda tiap hari. Strategi belanja yang oke gimana?",

    "mingl.posts.2.category": "Sehari-hari",
    "mingl.posts.2.title": "Makan siang dekat Gasan Digital Complex?",
    "mingl.posts.2.content": "Hari ini susah pilih. Biasanya karyawan sekitar makan apa?",

    "mingl.posts.3.category": "Hobi/Kelompok",
    "mingl.posts.3.title": "Meetup board game dekat Gasan — gabung yuk",
    "mingl.posts.3.content": "Setiap Jumat malam. Cari anggota!",

    "mingl.posts.4.category": "Jalan-jalan",
    "mingl.posts.4.title": "Rute jalan santai akhir pekan di Gunung Hoam",
    "mingl.posts.4.content": "Kutemukan rute ringan. Kubagikan rekomendasi!",

    "mingl.posts.5.category": "Sehari-hari",
    "mingl.posts.5.title": "Butuh kafe tenang dekat Doksan",
    "mingl.posts.5.content": "Perlu Wi-Fi & colokan untuk kerja. Rekomendasi dong!",

    "mingl.posts.6.category": "Info lokal",
    "mingl.posts.6.title": "Rekomendasi gym dekat Gasan?",
    "mingl.posts.6.content": "Cari fasilitas bagus atau iuran bulanan terjangkau.",

    "mingl.posts.7.category": "Hobi/Kelompok",
    "mingl.posts.7.title": "Mendaki Gunung Gwanak — siapa mau ikut?",
    "mingl.posts.7.content": "Akhir pekan ini. Pemula welcome!",

    // connect.titles.* (≤ 6 huruf, singkat)
    "connect.titles.0": "Bahasa",
    "connect.titles.1": "Hidup",
    "connect.titles.2": "Bekas",
    "connect.titles.3": "Kerja",
    "connect.titles.3.category": "Paruh",

    "connect.posts.0.title": "Tukar bahasa: percakapan bisnis Korea–Jepang",
    "connect.posts.0.reward": "Bahasa Jepang",
    "connect.posts.0.reward_detail": "Waktu disepakati",
    "connect.posts.0.location": "Kafe di Seongbuk-dong",

    "connect.posts.1.title": "Butuh penutur asli Spanyol untuk latihan percakapan",
    "connect.posts.1.reward": "Kartu hadiah",
    "connect.posts.1.reward_detail": "₩50.000 / sesi",
    "connect.posts.1.location": "St. Kantor Geumcheon",

    "connect.posts.2.title": "Butuh panduan kereta: Bandara Incheon → Mapo",
    "connect.posts.2.reward": "Hadiah",
    "connect.posts.2.reward_detail": "Anggur Spanyol",
    "connect.posts.2.location": "Bandara Incheon",

    "connect.posts.3.title": "Butuh pendamping tanda tangan kontrak one-room",
    "connect.posts.3.reward": "Tunai",
    "connect.posts.3.reward_detail": "₩10.000 / jam",
    "connect.posts.3.location": "Seoul Yeongdeungpo · Yangcheon",

    "connect.posts.4.title": "Pinjamkan Monkey Driver 1 hari — kuberi kkakdugi buatan sendiri",
    "connect.posts.4.reward": "Hadiah",
    "connect.posts.4.reward_detail": "Kkakdugi rumahan",
    "connect.posts.4.location": "Seogyo-dong, Mapo",

    "connect.posts.5.title": "Jual sepeda — pemakaian ringan",
    "connect.posts.5.reward": "Harga",
    "connect.posts.5.reward_detail": "₩50.000",
    "connect.posts.5.location": "Dekat St. Sinchon",

    "connect.posts.6.title": "Lowongan singkat pameran — bisa Inggris diutamakan",
    "connect.posts.6.reward": "Kerja",
    "connect.posts.6.reward_detail": "Dukungan lokasi & pandu Inggris",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "Cari barista bisa bahasa Spanyol (asing diprioritaskan)",
    "connect.posts.7.reward": "Per jam",
    "connect.posts.7.reward_detail": "Mulai ₩10.000",
    "connect.posts.7.location": "Kafe Itaewon",

    "passport.introduction": "Aku mulai belajar bahasa Korea dari acara TV dan memutuskan datang ke Korea setelah juara lomba pidato bahasa Korea di Meksiko!",
    "passport.gender": "Jenis kelamin",
    "passport.gender_detail": "Laki-laki",
    "passport.birth": "Tanggal lahir",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Kebangsaan",
    "passport.nationality_detail": "Meksiko",
    "passport.mother_tongue": "Bahasa ibu",
    "passport.mother_tongue_detail": "Spanyol",
    "passport.language": "Bahasa",
    "passport.language_detail.0": "Korea",
    "passport.language_detail.1": "Inggris",
    "passport.edit": "Edit",
    "passport.share": "Bagikan",

    // Positioned Mobile Demo Section (id)
    "positionedMobileDemo.home.description": "Seperti ‘berita lingkungan’ — lihat apa yang terjadi di sekitar Anda dengan sekali lihat",
    "positionedMobileDemo.home.features.0.description": "Jangan lewatkan berita dan acara lokal secara real-time",
    "positionedMobileDemo.home.features.1.description": "Jelajahi keseharian warga berdasarkan lokasi tertentu",
    "positionedMobileDemo.home.features.2.description": "Dengan mudah ikut festival, pertemuan, dan berbagai kegiatan di sekitar Anda",

    "positionedMobileDemo.mingl.description": "Temukan dan bagikan kehidupan nyata lingkungan berbasis lokasi",
    "positionedMobileDemo.mingl.features.0.description": "Bebas berbagi pertanyaan, info, berita, dan rekomendasi — interaksi yang natural",
    "positionedMobileDemo.mingl.features.1.description": "Terjemahan real-time untuk komunikasi global tanpa hambatan bahasa",
    "positionedMobileDemo.mingl.features.2.description": "Dunia dari sudut pandang lokal, lokal dari sudut pandang global",

    "positionedMobileDemo.connect.description": "Momen saling membantu menciptakan hubungan",
    "positionedMobileDemo.connect.features.0.description": "Temukan bantuan yang dibutuhkan dengan cepat melalui pencocokan berbasis lokasi",
    "positionedMobileDemo.connect.features.1.description": "Pilih sendiri orang yang ‘aman dan bisa dipercaya’",
    "positionedMobileDemo.connect.features.2.description": "Obrolan → Pertukaran → Hubungan lokal dan global yang berkelanjutan",

    "positionedMobileDemo.talk.description": "Temui teman dari berbagai negara tanpa khawatir soal bahasa berkat AI",
    "positionedMobileDemo.talk.features.0.description": "Percakapan tetap natural tanpa memandang kemampuan bahasa, dengan terjemahan instan",
    "positionedMobileDemo.talk.features.1.description": "Tanyakan langsung tentang kehidupan di Korea kepada warga lokal dan dapatkan jawaban segera",
    "positionedMobileDemo.talk.features.2.description": "Kembangkan hubungan yang dimulai dari Connect menjadi persahabatan jangka panjang",

    "positionedMobileDemo.passport.description": "Buat kartu digital yang menunjukkan perjalanan global Anda",
    "positionedMobileDemo.passport.features.0.description": "Catat riwayat tempat tinggal dan aktivitas Anda berdasarkan wilayah dalam bentuk timeline",
    "positionedMobileDemo.passport.features.1.description": "Tampilkan kemampuan bahasa dan gaya komunikasi Anda dengan jelas",
    "positionedMobileDemo.passport.features.2.description": "Terhubung secara alami dengan orang-orang yang memiliki pengalaman serupa",


    // Logl Video Section
    "loglVideo.title": "Video perkenalan logl",
    "loglVideo.description": "Penasaran apa itu logl? Mulai dari video ini!",
    "loglVideo.watch": "Tonton video"
    
    }
  },
  my: {
    translation: {
      // Header Section
    "header.intro": "မိတ်ဆက်",
    "header.demo": "ဒေမို",
    "header.video": "logl ရုပ်သံ",
      
      // Hero Section
    "hero.title": "ဘာသာတားကန့်ကို ဖယ်ရှားပါ",
      "hero.description": "find your",
    "hero.demo": "ဒေမို စမ်းပါ",
    "hero.prop1": "စစ်ဆေးပြီး ရောကယ်လ်ဝန်ဆောင်မှု",
      "hero.prop2": "အချိန်နှင့်တပြေးညီ AI ဘာသာပြန်",
    "hero.prop3": "မတူညီသော ရောကယ်လ်ကွန်ယက်",

    // Introduction Section
    "introduction.title": "ဒီလို စိုးရိမ်မှုရှိပါသလား?",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",

    "introduction.fst.name": "지민",
    "introduction.fst.location": "대한민국 서울",
    "introduction.fst.tag": "#ဘာသာလေ့လာမှု",
    "introduction.fst.story": "“အင်္ဂလိပ်စာလေ့လာပြီး 留学 များပြီးပါပြီ... သို့သော် အသုံးမပြုရလို့ မေ့လာတယ်။ နေ့စဉ်အသုံးပြုခွင့် ရှိလျှင် ကောင်းမယ်ို့စိတ်ပါးတယ်😢”",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "대한민국 수원",
    "introduction.snd.tag": "#ကိုရီးယားသူငယ်ချင်းလုပ်ခြင်း",
    "introduction.snd.story": "“ကိုရီးယားကို ၆ လ ရောက်ပြီ၊ ပုံမှန်အားဖြင့် တူရိယာတူမိခင်နိုင်ငံသူငယ်ချင်းတွေနဲ့ပဲ ရောနှောနေတယ်။ ကိုရီးယားသူငယ်ချင်းတွေကို တကယ့်တကယ့်ငယ်စားချင်ပေမယ့် ဘယ်လို စတင်ရမလဲ မသိဘူး။”",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "대한민국 전주",
    "introduction.trd.tag": "#ရောကယ်လ်လမ်းညွှန်",
    "introduction.trd.story": "“YouTube မှာကြည့်ပြီး ကွန်ယူနிட்டီတွေဝင်ကြည့်ပါသော်လည်း ကျွန်တော်တို့မြို့ လမ်းညွှန်မတွေ မတွေ့ရဘူး။ ဘဏင်ဖွင့်ခြင်း၊ ဖုန်းလိုင်း၊ ဆေးရုံ... စတင်နေရာချည်း အချက်အလက်မှန်ကန်နောက်ဆုံးပေါ်ကို ဘယ်မှာရမလဲ?”",

    // App Menu Section
    "appMenu.home.local.title": "홈",
    "appMenu.home.local.subtitle": "ကျွန်မတို့ မြို့ကို ဂလိုဘယ်ဟတ်ဖြစ်စေပါ",
    "appMenu.home.local.description": "သင်သိတဲ့ ရပ်ကွက်သတင်းအချက်အလက်နဲ့ နိုင်ငံခြားအိမ်နီးချင်းတွေကို ကူညီပြီး မိမိတိုင်းဒေသကို တကယ့်ဂလိုဘယ်ကွန်ယူနిటీဖြစ်စေပါ",
    "appMenu.home.local.points": [
    "ဖျောက်ကွက် အစားအသောက်ဆိုင်၊ ဆေးရုံ၊ အထောက်အပံ့ဆိုင်ရာနေရာများကို မိတ်ဆက်ပေးခြင်း",
    "ရပ်ကွက်သတင်းနှင့် အဖြစ်အပျက်များကို အချိန်နှင့်တပြေးညီ မျှဝေခြင်း",
    "ဂလိုဘယ်ညွှန်းကိန်းကို မြှင့်တင်ပြီး ဒေသအပြည်ပြည်ဆိုင်ရာဖြစ်ရပ်ကို ဦးဆောင်ခြင်း"
    ],
    "appMenu.home.local.tip": "သင်သိတဲ့ သေးငယ်သတင်းတစ်ခုပင် တစ်ယောက်ယောက်အတွက် တန်ဖိုးရှိတဲ့ လမ်းညွှန်တစ်ခု ဖြစ်နိုင်သည်",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "ကိုရီးယားဘဝ အတွက် ဒက်ရှ်ဘုတ်",
    "appMenu.home.global.description": "ယနေ့ရာသီဓာတ်မှ ရပ်ကွက်ရေပန်းစားစာမူထိ ကိုရီးယားဘဝအတွက် လိုအပ်သော အချက်အလက်အားလုံးကို စာမျက်နှာတစ်ခုထဲတွင် ကြည့်ရှုနိုင်သည်",
    "appMenu.home.global.points": [
    "ဒေသရာသီဓာတ်နှင့် ထွက်ခွာချက်လမ်းညွှန်ဖြင့် တစ်နေ့တာ စီမံရန်",
    "ရပ်ကွက်သတင်းနှင့် ကူညီခဖို့ တောင်းဆိုချက်များကို အရင်စစ်ဆေးရန်",
    "ကိုရီးယားလူမှုကွန်ယက်တွင် နာမည်ကြားနေသော ဂလိုဘယ်ပို့စ်များ မလွတ်တို့ရန်"
    ],
    "appMenu.home.global.tip": "နေ့စဉ် ၅ မိနစ် ပြန်လည်စစ်ဆေးခြင်းဖြင့် ကိုရီးယားဘဝ ပိုမိုလွယ်ကူမည်",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "ဂလိုဘယ်သူငယ်ချင်းများနှင့် စကားဝိုင်း",
    "appMenu.mingl.local.description": "နိုင်ငံခြားမေးခွန်းများကို ဖြေရှင်းပေးကာ ဘာသာလေ့လာပြီး ယဉ်ကျေးမှုကို တစ်ယောက်တည်းဝေမေှဖျော်ဆိုပါ",
    "appMenu.mingl.local.points": [
    "ကိုရီးယားဘဝ အချက်အလက်မျှဝေကာ စိတ်ကျေနပ်မှုရယူ",
    "ဘာသာစကားကျွမ်းကျင်မှု ကို သဘာဝကျတိုးတက်စေ",
    "မတူယဉ်ကျေးမှုမှ သူငယ်ချင်းများဖွဲ့ဆောက်"
    ],
    "appMenu.mingl.local.tip": "မေးခွန်းများအား ဖြေကြားကာ ဘာသာလေ့လာပြီး ယဉ်ကျေးမှုဝေမေှပါ",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "ကိုရီးယားလူများနှင့် သဘာဝကျ ဆက်သွယ်ပါ",
    "appMenu.mingl.global.description": "အချိန်နှင့်တပြေးညီ ဘာသာပြန်ဖြင့် ဘာသာစကားစိုးရိမ်မရှိဘဲ မေးခွန်းများမေးပြီး ဒေသခံသူငယ်ချင်းများ ဖန်တီးနိုင်သည်",
    "appMenu.mingl.global.points": [
    "ကိုရီးယားဘဝ အမေးအဖြေကို ချက်ချင်း ဖြေရှင်း",
    "AI ဘာသာပြန်ဖြင့် ဘာသာစကားပူပန်မှုမရှိ သဘာဝကျ စကားဝိုင်း",
    "တူနိုင်ငံဂဲတိုမှ ထွက်ကာ တကယ့်ကိုရီးယားသူငယ်ချင်း ဖန်တီး"
    ],
    "appMenu.mingl.global.tip": "ကိုရီးယားယဉ်ကျေးမှုကို သိမြင်ရင်း ဒေသခံကွန်ယူနిటీထဲ သဘာဝကျ ဖြေလျော့ဝင်ပါ",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "နိုင်ငံခြားအိမ်နီးချင်း ကူညီပြီး မိတ်ဖွဲ့ကြမယ်",
    "appMenu.connect.local.description": "ရပ်ကွက်ရှိ နိုင်ငံခြားလူမျိုးတို့၏ နေ့စဉ်ဘဝပြဿနာများကို ဖြေရှင်းကာ ဂလိုဘယ်နက်ဝေါ့ခ် တည်ဆောက်ပါ",
    "appMenu.connect.local.points": [
    "ဘဏ်၊ အိမ်၊ စာရွက်စာတမ်း တို့ကဲ့သို့ အက်ရှင်နယ်ကူညီမှု",
    "ကူညီမှုမှတစ်ဆင့် သဘာဝကျ ဂလိုဘယ် ဆက်ဆံရေးတည်ဆောက်",
    "ရပ်ကွက် ဂလိုဘယ် တာဝန်ခံအဖြစ် အားသာချက် ယူ"
    ],
    "appMenu.connect.local.tip": "သေးငယ်သော ကူညီမှုက တကယ့်သူငယ်ချင်း ခ်ိတ်ဆက်မှုဖြစ်လိမ့်မည်",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "ကိုရီးယားအိမ်နီးချင်းနှင့် ပြဿနာများ ဖြေရှင်းပါ",
    "appMenu.connect.global.description": "ဘဏ်၊ အိမ်နေရေးရေးရာ၊ ဗီဇာကိစ္စများကို ယုံကြည်စိတ်ချရသော ဒေသခံနှင့် အတူတကွ ဖြေရှင်းပါ",
    "appMenu.connect.global.points": [
    "ဘဏ်ဖွင့်ခြင်း၊ အိမ်ရှာဖွေခြင်း စသည့် အချက်အလက်ကို တိုက်ရိုက်ကူညီ",
    "အေဂျင့်မလိုဘဲ အိမ်နီးချင်းထံ လွယ်ကူစွာ အကူအညီတောင်း",
    "ဂဲတိုမှ လွတ်ကာ တကယ့် ဒေသခံဘဝသို့ ကိုက်ညီ"
    ],
    "appMenu.connect.global.tip": "အရေးပေါ်အခါအချိန်မှာ ဒေသခံအိမ်နီးချင်းကူညီမှုက မြန်ပြီး တိကျ",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "နိုင်ငံခြားအိမ်နီးချင်းနှင့် အချိန်နှင့်တပြေးညီ စကားေပြာ",
    "appMenu.talk.local.description": "AI ဘာသာပြန်ဖြင့် ဘာသာစကား စိုးရိမ်မှုမရှိ 1:1 ချတ်၊ တကယ့် ဂလိုဘယ်သူငယ်ချင်း ဖြစ်လာစေ",
    "appMenu.talk.local.points": [
    "အချိန်နှင့်တပြေးညီ ဘာသာပြန်ဖြင့် ဘာသာတတ်မှုမလို ပေါင်းသင်းနိုင်",
    "Connect ကူညီမှုမှ စတင်သော ဆက်ဆံရေးကို မိတ်ကြီးမားမှုတိုးတက်စေ",
    "နိုင်ငံခြားအိမ်နီးချင်း၏ ကိုရီးယားဘဝ စိုးရိမ်ချက်များကို တိုက်ရိုက် အကြံပေး"
    ],
    "appMenu.talk.local.tip": "သေးငယ်သော်လည်း စကားဝိုင်းတစ်ခုပင် အမြဲတမ်း ဂလိုဘယ်ကွန်ယက် ဖြစ်စေတတ်",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "ကိုရီးယားလူများနှင့် အဆင်ပြေစွာ ဆက်သွယ်ပါ",
    "appMenu.talk.global.description": "ဘာသာတားကန့်မရှိဘဲ ဒေသခံအိမ်နီးချင်းနှင့် ချက်ချင်း ချတ်ပြီး မေးခွန်းများကို အမြန် ဖြေရှင်းနိုင်သည်",
    "appMenu.talk.global.points": [
    "ကိုရီးယားဘဝ မေးခွန်းများကို ကိုရီးယားလူထံ တိုက်ရိုက်မေး၍ ချက်ချင်းအဖြေ",
    "AI ဘာသာပြန်ဖြင့် ကိုရီးယားဘာသာမတတ်လည်း သဘာဝကျ စကားစမြေး",
    "Connect တွင်တွေ့ရှိသည့် ကူညီပေးသူနှင့် ဆက်လက် ဆက်သွယ်ကာ တကယ့်သူငယ်ချင်းဖြစ်လာ"
    ],
    "appMenu.talk.global.tip": "သေးငယ်သော မေးခွန်းများမှ စတင်ပြီး ကိုရီးယားဘဝအတွက် ယုံကြည်ရသော မိတ်ဖက်ကို ရှာပါ",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "မိမိ၏ ဂလိုဘယ်သမိုင်း တည်ဆောက်ရန်",
    "appMenu.passport.local.description": "နိုင်ငံခြားသူငယ်ချင်းများနှင့် လှုပ်ရှားမှုပြုလုပ်ချက်များကို မှတ်တမ်းတင်ကာ ပတ်スポတ်မလိုဘဲ ဂလိုဘယ် အထွေထွေကို တည်ဆောက်ပါ",
    "appMenu.passport.local.points": [
    "ရပ်ကွက် ဂလိုဘယ်လှုပ်ရှားမှုကို Timeline အဖြစ် ပြသ",
    "ကူညီမှတ်တမ်းဖြင့် ဂလိုဘယ် အမ်ဘာဆဒါ ပေါ့ဖိုလိုး တည်ဆောက်",
    "ဘာသာနှင့် ယဉ်ကျေးမှု အတွေ့အကြုံများကို စနစ်တကျ စီမံ"
    ],
    "appMenu.passport.local.tip": "သေးငယ်သည့် ကူညီမှုတစ်ခုပင် သင်၏ ဂလိုဘယ်ခရီးသမိုင်းကို ပြည့်စုံစေသည်",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "ဂလိုဘယ်အမည်အပြား – ဒစ်ဂျစ်တယ် နေိမ်းကတ်",
    "appMenu.passport.global.description": "မိမိ၏ မျိုးနွယ်စုံ အတွေ့အကြုံနှင့် အပြေးအလွှားကို မြင်နိုင်အောင် ပြကာ ယုံကြည်စိတ်ချရသော ပရိုဖိုင်တစ်ခု တည်ဆောက်ပါ",
    "appMenu.passport.global.points": [
    "နေထိုင်ခရီးသွားမှတ်တမ်းနှင့် ဂလိုဘယ်အတွေ့အကြုံကို တစ်ချက်မြင်",
    "ဘာသာကျွမ်းကျင်မှုနှင့် ယဉ်ကျေးမှုနောက်ခံဖြင့် ယုံကြည်မှု တည်ဆောက်",
    "တူညီအတွေ့အကြုံရှိသူများနှင့် သဘာဝကျ ချိတ်ဆက်"
    ],
    "appMenu.passport.global.tip": "အသေးစိတ်ပရိုဖိုင်များက ပိုကောင်းသော ဒေသခံကူညီမှုနှင့် တကယ့်သူငယ်ချင်းများသို့ ခေါ်ဆောင်သည်",

    // Demo Section
    "common.viewAll": "အားလုံးကြည့်",
    "common.minutesAgo": "မိနစ် ကုန်",

    "home.tag": "ဖလီးမားကက်",
    "home.greeting_01": "Carlos 님",
    "home.greeting_02": "ယနေ့လည်း ကောင်းသောနေ့ဖြစ်ပါစေ",

    "home.weather.maxTemp": "အမြင့် 15°",
    "home.weather.minTemp": "အနိမ့် 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "မိုးကင်းကြည်လင်",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "တိမ်ထူ",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "အလတ်",

    "home.mytown.title": "အချိန်နှင့်တပြေးညီ မိမိမြို့",
    "home.mytown.places.0.name": "은행나무시장",
    "home.mytown.places.0.address": "금천구 시흥동",
    "home.mytown.places.1.name": "관악산",
    "home.mytown.places.1.address": "관악구 신림동",
    "home.mytown.places.2.name": "안양천다목적광장",
    "home.mytown.places.2.address": "금천구 독선동",

    "home.events.title": "ရပ်ကွက် イベント",
    "home.events.post_title": "독산동 플리마켓 ပြုလုပ်မည်",
    "home.events.address": "금천구 독산동",

    "mingl.posts.0.category": "ဘဝအချက်အလက်",
    "mingl.posts.0.title": "금천구청역 စွန်ဒဲ အော့စာအို တွင်ဘယ်နေရာလဲ?",
    "mingl.posts.0.content": "တကယ့်အရသာရှိတဲ့ စွန်ဒဲပါ... လတ်တလော မတွေ့ရတော့ဘူး။ ဘယ်မှာရှိလဲ သိသူရှိမလား",

    "mingl.posts.1.category": "ဘဝအချက်အလက်",
    "mingl.posts.1.title": "독산 သံတုန်းဈေးမှာ စျေးသက်သာ သင့်နည်း",
    "mingl.posts.1.content": "နေ့အလိုက် စျေးကွာခြားမှု ရှိသလို မင်းတို့ ဘယ်လို ဝယ်သလဲ အကြံပြုပါ",

    "mingl.posts.2.category": "နေ့စဉ်",
    "mingl.posts.2.title": "가산디지털단지 နေရာအနီး နေ့လည်ဘာ စားကြလဲ?",
    "mingl.posts.2.content": "ယနေ့ အစားအသောက်ရွေးရန် အလွန်ခက်တယ်။ အလုပ်သမားတွေ ဘယ်လို စားကြလဲ?",

    "mingl.posts.3.category": "ဝါသနာ/မိတ်ဆွေ",
    "mingl.posts.3.title": "가산역 ဘုတ်ဂိမ်းမိတ်ဆွေ ရှာပါသည်",
    "mingl.posts.3.content": "အပတ်စဉ် သောကြာည Gasan အနီး တွေ့မယ်။ ပါဝင်လိုသူ ဖိတ်ခေါ်ပါတယ်",

    "mingl.posts.4.category": "ခရီး/လှည့်လည်",
    "mingl.posts.4.title": "호암산 လမ်းလျှောက် ကူးမြောကွင်း အကြံပြု",
    "mingl.posts.4.content": "မတ်တပ်ရပ်တန်း ဆန်တဲ့ အပတ်အစဉ် လမ်းကြောင်းကို ရှာမိလို့ မျှဝေပါတယ်",

    "mingl.posts.5.category": "နေ့စဉ်",
    "mingl.posts.5.title": "독산동 အနီး ငြိမ်းချမ်းသော ကဖေ အကြံပြုပါ",
    "mingl.posts.5.content": "Wi-Fi ကောင်းပြီး Plug ရှိသော လုပ်ငန်းလုပ်နိုင်မည့် ကဖေကို ရှာပါသည်",

    "mingl.posts.6.category": "ဘဝအချက်အလက်",
    "mingl.posts.6.title": "가산동 အနီး Gym အကြံပြုပါ",
    "mingl.posts.6.content": "လစဉ်ကြေးသင့်တင့်၍ အဆောက်အအုံကောင်းသော နေရာများကို မိတ်ဆက်ပေးပါ",

    "mingl.posts.7.category": "ဝါသနာ/မိတ်ဆွေ",
    "mingl.posts.7.title": "관악산 တောင်လျှောက် တက်ကြမလား",
    "mingl.posts.7.content": "အပတ်ကုန် သွားမည်။ စတင်သူတို့ကို ကြိုဆိုပါသည်။ ပျော်ရွှင်စွာ လမ်းလျှောက်သွားမည်",

    // (짧게, 6글자 이내)
    "connect.titles.0": "ဘာသာ",
    "connect.titles.1": "နေ့စဉ်",
    "connect.titles.2": "လဲလှယ်",
    "connect.titles.3": "အလုပ်",
    "connect.titles.3.category": "ပိုင်း",

    "connect.posts.0.title": "ကိုရီးယား-ဂျပန် အလုပ်သုံး စကားပြော လဲလှယ်မိတ်ဖော် ရှာခြင်း",
    "connect.posts.0.reward": "ဂျပန်",
    "connect.posts.0.reward_detail": "အချိန် ဆွေးနွေး",
    "connect.posts.0.location": "성북동 ကဖေ",

    "connect.posts.1.title": "စပိန်ဘာသာ အမျိုးရိုး လူဇာတိ ကူညီပေးရန် ခေါ်သည်",
    "connect.posts.1.reward": "လက်ဆောင်ကတ်",
    "connect.posts.1.reward_detail": "၁ ကြိမ် 50,000ဝမ်",
    "connect.posts.1.location": "금천구청역",

    "connect.posts.2.title": "잉천လေဆိပ်မှ သေလ်–마포역 သွားလမ်းညွှန် လိုအပ်",
    "connect.posts.2.reward": "အ वस्तု",
    "connect.posts.2.reward_detail": "စပိန်ဝိုင်",
    "connect.posts.2.location": "인천공항",

    "connect.posts.3.title": "ဝန်လုခေါ်စာချုပ် ရေးထိုးရာသို့ အတူသွားပေးနိုင်မလား",
    "connect.posts.3.reward": "ငွေ",
    "connect.posts.3.reward_detail": "၁ နာရီ 10,000ဝမ်",
    "connect.posts.3.location": "서울 영등포 양천역",

    "connect.posts.4.title": "몽키드라이버 တစ်ရက်ချေးပါ! ကောက်တုတ်ပင် ပေးပါတယ်",
    "connect.posts.4.reward": "အ वस्तု",
    "connect.posts.4.reward_detail": "ကိုယ့်လုပ် ကောက်တုတ်",
    "connect.posts.4.location": "마포구 서교동",

    "connect.posts.5.title": "စက်ဘီး ရောင်းမည်! အသုံးအနှုန်း နည်း",
    "connect.posts.5.reward": "ဈေးနှုန်း",
    "connect.posts.5.reward_detail": "50,000ဝမ်",
    "connect.posts.5.location": "신촌역 အနီး",

    "connect.posts.6.title": "ပြပွဲ လက်လှမ်း အလုပ် အမြန် ခေါ် – အင်္ဂလိပ်တတ် ပြီး",
    "connect.posts.6.reward": "အလုပ်",
    "connect.posts.6.reward_detail": "ပြပွဲနေရာ ကူညီ & အင်္ဂလိပ်ညွှန်ကြား",
    "connect.posts.6.location": "코엑스",

    "connect.posts.7.title": "စပိန်ဘာသာတတ် ဘာရီစတာ ခေါ်ယူ (မူလနိုင်ငံသား ဦးစားပေး)",
    "connect.posts.7.reward": "နှုန်း",
    "connect.posts.7.reward_detail": "10,000ဝမ် ကနေ",
    "connect.posts.7.location": "이태원 ကဖေ",

    "passport.introduction": "ကိုရီးယား ဗာရီးတီကို ကြည့်ပြီး ကိုင်ရိုးဂျာကို ကိုယ်တိုင် လေ့လာခဲ့ပြီး မက်ခစီကိုတွင် ကျင်းပသော ကိုရီးယားစကားပြောပြိုင်ပွဲတွင် ပထမဆုရခဲ့သောအခါမှ ကိုရီးယားသို့ ရောက်လာရန် ဆုံးဖြတ်ခဲ့သည်!",
    "passport.gender": "လိင်",
    "passport.gender_detail": "အ erkek",
    "passport.birth": "မွေးနေ့",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "နိုင်ငံသား",
    "passport.nationality_detail": "Mexico",
    "passport.mother_tongue": "မိခင်ဘာသာ",
    "passport.mother_tongue_detail": "Spanish",
    "passport.language": "နိုင်ငံခြားဘာသာ",
    "passport.language_detail.0": "Korean",
    "passport.language_detail.1": "English",
    "passport.edit": "တည်းဖြတ်",
    "passport.share": "မျှဝေ",

    // Positioned Mobile Demo Section (my)
    "positionedMobileDemo.home.description": "‘ဒေသသတင်း’လိုပဲ ကျောရိုးတစ်ချက်နဲ့နယ်မြေရဲ့အခုဘယ်လိုရှိလဲ သိနိုင်ပါတယ်",
    "positionedMobileDemo.home.features.0.description": "ဒေသထဲက သတင်းတွေ၊ イベントတွေကို တခြားမလွဲဘဲ အချိန်နှင့်တပြေးညီ သတင်းမြင်",
    "positionedMobileDemo.home.features.1.description": "နေရာအလိုက် လူတွေの日常ကိစ္စတွေကြားထဲကို ဝင်မြှော",
    "positionedMobileDemo.home.features.2.description": "ထွက်ပေါ်နေတဲ့ ဂျမ်းပွဲ၊ တွေ့ဆုံပွဲ၊ သေးသေးလေးလှုပ်ရှားမှုတွေမှာလည်း လွယ်လင့်တကူ ပါဝင်",

    "positionedMobileDemo.mingl.description": "မြေပုံအခြေပြုပြီး ဒေသက အကြောင်းအရာနဲ့ တကယ့်ဘဝကို တွေ့ဆုံပြီး မျှဝေပါ",
    "positionedMobileDemo.mingl.features.0.description": "မေးမြန်းခြင်း၊ သတင်း၊ အကြံပြုချက်တွေကို 自然に မျှဝေနိုင်",
    "positionedMobileDemo.mingl.features.1.description": "リアルタイム ဘာသာပြန်အထောက်အပံ့နဲ့ ဘာသာစကားအတားအဆီးမရှိတော့",
    "positionedMobileDemo.mingl.features.2.description": "ဒေသမြင်ကွင်းကနေ 世界 ကို / グローバルမြင်ကွင်းကနေ 地方 ကို",

    "positionedMobileDemo.connect.description": "တစ်ယောက်ကို တစ်ယောက် ကူညီတဲ့အခါ ချိတ်ဆက်မှု தொடங்கတယ်",
    "positionedMobileDemo.connect.features.0.description": "အကူအညီလိုအပ်သလို ချက်ချင်း ဒေသအလိုက် လူတွေကို တွေ့ဆုံ",
    "positionedMobileDemo.connect.features.1.description": "‘ယုံကြည်လို့ရပြီး အားလုံးကောင်းစရာ’ လူကို ကိုယ်တိုင် ရွေးချယ်",
    "positionedMobileDemo.connect.features.2.description": "စကားပြော → ပြန်လှန်လှုပ်ရှားမှု → အချိန်ကြာခံ ဘော်ဒာကျော်ချိတ်ဆက်မှု",

    "positionedMobileDemo.talk.description": "AI ဘာသာပြန်နဲ့ ဘာသာစကားစိုးရိမ်စရာမရှိဘဲ အပြည်ပြည်ဆိုင်ရာသူငယ်ချင်းတွေ ချိတ်ဆက်",
    "positionedMobileDemo.talk.features.0.description": "ဘာသာစကားကျွမ်းကျင်မှုမလိုဘဲ 自然会話 ရနိုင်",
    "positionedMobileDemo.talk.features.1.description": "ကိုရီးယားဘဝအကြောင်း ဒေသသူတွေကို တန်းမေး → ချက်ချင်း 回答",
    "positionedMobileDemo.talk.features.2.description": "Connect မှ စတင်တဲ့ မိတ်ဆွေတစ်ယောက်ကို အတည်ပြုမိတ်ဆွေစည်းစုအဖြစ် တိုးတက်",

    "positionedMobileDemo.passport.description": "ကိုယ့် Global Experience ကို 담은 Digital Namecard ပြုလုပ်ပါ",
    "positionedMobileDemo.passport.features.0.description": "ဒေသအလိုက် နေထိုင်မှု + လှုပ်ရှားမှု Timeline ပုံစံဖြင့် မှတ်တမ်းတင်",
    "positionedMobileDemo.passport.features.1.description": "ဘာသာစကားစွမ်းအား + ဆက်သွယ်ပုံစံကို ထင်ရှားစွာ ပေါ်ထွက်စေ",
    "positionedMobileDemo.passport.features.2.description": "တူညီသလို အတွေ့အကြုံရှိသူများနှင့် 自然に ချိတ်ဆက်",


    // Logl Video Section
    "loglVideo.title": "logl မိတ်ဆက်ဗီဒီယို",
    "loglVideo.description": "logl ဆိုတာဘာလဲ? ဗီဒီယိုဖြင့် စတင် ကြည့်ရှုပါ!",
    "loglVideo.watch": "ဗီဒီယို သွားကြည့်"

    }
  },
  tl: {
    translation: {
      // Header Section
      "header.intro": "Intro",
      "header.demo": "Demo",
    "header.video": "logl video",
      
      // Hero Section
    "hero.title": "Alisin ang hadlang sa wika",
      "hero.description": "find your",
    "hero.demo": "Subukan ang demo",
    "hero.prop1": "Nasubok na lokal na serbisyo",
    "hero.prop2": "Real-time na AI pagsasalin",
    "hero.prop3": "Iba’t ibang lokal na komunidad",

    // Introduction Section
    "introduction.title": "Naranasan mo na ba ang ganitong problema?",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",

    "introduction.fst.name": "지민",
    "introduction.fst.location": "Seoul, Korea",
    "introduction.fst.tag": "#pag-aaral-ng-wika",
    "introduction.fst.story": "“Sobra akong nag-aral ng Ingles at nag-aral pa sa abroad… pero dahil walang magamit, nakakalimutan ko na. Sana may pagkakataon sa araw-araw na magamit ko 😢”",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Korea",
    "introduction.snd.tag": "#gawa-ng-mga-kaibigang-lokal",
    "introduction.snd.story": "“Anim na buwan na ako sa Korea pero puro kababayan pa rin ang kasama ko. Gusto kong maging tunay na malapit sa mga Koreano, pero hindi ko alam kung paano magsimula.”",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Korea",
    "introduction.trd.tag": "#impormasyong-lokal",
    "introduction.trd.story": "“Kahit sa YouTube o sa mga komunidad, walang info tungkol mismo sa aming bayan. Bank account, telecom, ospital… Saan makakakuha ng tama at napapanahong impormasyon kapag nagsisimula pa lang?”",

    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "Gawing global hub ang ating bayan",
    "appMenu.home.local.description": "Ibahagi ang alam mong impormasyon sa lugar at tulungan ang mga dayuhang kapitbahay para maging tunay na global na komunidad ang ating distrito.",
    "appMenu.home.local.points": [
      "Irekomenda ang nakatagong kainan, ospital, at pasilidad",
      "Ibahagi ang real-time na balita at mga kaganapan sa lugar",
      "Itaguyod ang internasyunalisasyon ng ating komunidad"
    ],
    "appMenu.home.local.tip": "Ang maliit mong kaalaman ay maaaring maging mahalagang gabay sa buhay ng iba.",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "Dashboard para sa pamumuhay sa Korea",
    "appMenu.home.global.description": "Mula sa lagay ng panahon hanggang sa mga sikat na post sa kapitbahay—lahat ng kailangan mo sa isang screen.",
    "appMenu.home.global.points": [
      "Planuhin ang araw gamit ang lokal na panahon at tips",
      "Unahin tingnan ang balita at mga kahilingan ng tulong",
      "’Wag palampasin ang trending na global na kuwento"
    ],
    "appMenu.home.global.tip": "5 minutong pag-check araw-araw, mas madali ang buhay sa Korea.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Makipag-usap sa global na kaibigan",
    "appMenu.mingl.local.description": "Sagot sa tanong ng dayuhan, sabay aral ng wika at palitan ng kultura.",
    "appMenu.mingl.local.points": [
      "Ibahagi ang tips sa pamumuhay sa Korea",
      "Palaguin ang kakayahan sa wika nang natural",
      "Magkaroon ng kaibigang mula sa iba’t ibang kultura"
    ],
    "appMenu.mingl.local.tip": "Sagot + pagkatuto ng wika + pagbabahagi ng kultura—sabay-sabay.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Makipag-ugnayan sa mga Koreano nang natural",
    "appMenu.mingl.global.description": "Sa real-time na pagsasalin, magtanong nang walang pangamba at gumawa ng lokal na kaibigan.",
    "appMenu.mingl.global.points": [
      "Masagot agad ang tanong sa pamumuhay sa Korea",
      "Mag-usap nang natural gamit ang AI translation",
      "Lumabas sa ‘foreigners only’ at gumawa ng tunay na Koreanong kaibigan"
    ],
    "appMenu.mingl.global.tip": "Matutunan ang kulturang Koreano at dahan-dahang sumama sa komunidad.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Tulungan ang dayuhang kapitbahay, gumawa ng kaibigan",
    "appMenu.connect.local.description": "Tugunan ang praktikal na problema ng mga dayuhan sa ating lugar at bumuo ng global network.",
    "appMenu.connect.local.points": [
      "Tulong sa bangko, bahay, at mga dokumento",
      "Gumawa ng global network sa pamamagitan ng pagtutulungan",
      "Maging makabuluhang ‘global ambassador’ ng iyong lugar"
    ],
    "appMenu.connect.local.tip": "Magsimula sa munting tulong, humantong sa tunay na pagkakaibigan.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Ayusin ang problema kasama ang lokal na Koreano",
    "appMenu.connect.global.description": "Bangko, tirahan, visa—ayusin kasama ang mapagkakatiwalaang lokal.",
    "appMenu.connect.global.points": [
      "Konkretong tulong sa pagbubukas ng bangko at paghahanap ng bahay",
      "Humingi ng casual na tulong—walang agent",
      "Lumabas sa ‘ghetto’ at makibagay sa lokal na buhay"
    ],
    "appMenu.connect.global.tip": "Kapag apurahan, tulong ng kapitbahay ang pinakamabilis at siguradong paraan.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Makipag-chat sa dayuhang kapitbahay real-time",
    "appMenu.talk.local.description": "1:1 chat na walang language barrier gamit ang AI translation—maging tunay na global friend.",
    "appMenu.talk.local.points": [
      "Natural na usapan kahit anong antas ng wika",
      "Palawigin ang ugnayang nagsimula sa Connect",
      "Makinig at magpayo sa suliranin sa buhay sa Korea"
    ],
    "appMenu.talk.local.tip": "Munting usapan → panghabambuhay na global network.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Komportableng usap sa mga Koreano",
    "appMenu.talk.global.description": "Makipag-chat sa lokal nang walang hadlang sa wika at masagot agad ang tanong.",
    "appMenu.talk.global.points": [
      "Diretsong magtanong sa Koreano at makakuha ng sagot agad",
      "Komportableng usapan kahit hindi marunong ng Korean",
      "Panatilihin ang ugnayan sa nakilalang tumutulong sa Connect"
    ],
    "appMenu.talk.global.tip": "Magsimula sa maliliit na tanong para makakita ng maaasahang katuwang sa Korea.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Gumawa ng sariling global story",
    "appMenu.passport.local.description": "I-record ang mga karanasan kasama ang dayuhang kaibigan at buuin ang iyong global identity kahit walang passport.",
    "appMenu.passport.local.points": [
      "Ipakita sa timeline ang global na aktibidad sa komunidad",
      "Portfolio bilang global ambassador mula sa mga natulungan",
      "Ayusin ang wika at karanasang pang-kultura"
    ],
    "appMenu.passport.local.tip": "Ang maliliit na tulong, kapag naitala, ay bumubuo ng iyong global journey.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Global identity — digital na calling card",
    "appMenu.passport.global.description": "Ipakita nang biswal ang multi-national na karanasan at bumuo ng mapagkakatiwalaang profile.",
    "appMenu.passport.global.points": [
      "Isang tingin sa tirahan at global na karanasan",
      "Magpatibay ng tiwala sa pamamagitan ng wika at pinanggalingang kultura",
      "Kumonekta sa mga may kahalintulad na karanasan"
    ],
    "appMenu.passport.global.tip": "Mas detalyadong profile → mas mainam na lokal na tulong at tunay na kaibigan.",

    // Demo Section
    "common.viewAll": "Tignan lahat",
    "common.minutesAgo": "min nakalipas",

    "home.tag": "Flea market",
    "home.greeting_01": "Carlos 님",
    "home.greeting_02": "Magandang araw!",

    "home.weather.maxTemp": "Mataas 15°",
    "home.weather.minTemp": "Mababa 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Maaliwalas",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Maulap",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Katamtaman",

    "home.mytown.title": "Real-time sa ating bayan",
    "home.mytown.places.0.name": "은행나무시장",
    "home.mytown.places.0.address": "금천구 시흥동",
    "home.mytown.places.1.name": "관악산",
    "home.mytown.places.1.address": "관악구 신림동",
    "home.mytown.places.2.name": "안양천다목적광장",
    "home.mytown.places.2.address": "금천구 독선동",

    "home.events.title": "Mga kaganapan sa lugar",
    "home.events.post_title": "May flea market sa Doksan-dong",
    "home.events.address": "Geumcheon-gu, Doksan-dong",

    "mingl.posts.0.category": "Impormasyon",
    "mingl.posts.0.title": "Nasaan ang sundae cart sa Geumcheon-gu Office Stn?",
    "mingl.posts.0.content": "Pinakamahusay na sundae! Matagal ko nang ’di nakikita. May nakakaalam ba kung nasaan na siya?",

    "mingl.posts.1.category": "Impormasyon",
    "mingl.posts.1.title": "Tips sa pamimili sa tradisyunal na pamilihan ng Doksan",
    "mingl.posts.1.content": "Nag-iiba ang presyo ayon sa araw. Anong paraan ang pinaka-ok?",

    "mingl.posts.2.category": "Araw-araw",
    "mingl.posts.2.title": "Anong lunch malapit sa Gasan Digital Complex?",
    "mingl.posts.2.content": "Ang hirap pumili ngayon. Ano ang kinakain ng mga office worker sa paligid?",

    "mingl.posts.3.category": "Hobby/Grupo",
    "mingl.posts.3.title": "Board game group sa Gasan Stn—sali na!",
    "mingl.posts.3.content": "Tuwing Biyernes ng gabi malapit sa Gasan. Bukas sa lahat!",

    "mingl.posts.4.category": "Lakbay/Lakad",
    "mingl.posts.4.title": "Weekend walk sa Hoamsan trail",
    "mingl.posts.4.content": "Nakadiskubre ako ng magaang ruta. Share ko rito.",

    "mingl.posts.5.category": "Araw-araw",
    "mingl.posts.5.title": "Tahimik na café malapit sa Doksan-dong",
    "mingl.posts.5.content": "Hanap ko ay may maayos na Wi-Fi at saksakan para makapagtrabaho.",

    "mingl.posts.6.category": "Impormasyon",
    "mingl.posts.6.title": "Recommend na gym malapit sa Gasan-dong",
    "mingl.posts.6.content": "Alin ang maganda ang pasilidad o sulit ang buwanang bayad?",

    "mingl.posts.7.category": "Hobby/Grupo",
    "mingl.posts.7.title": "Akyat sa Gwanaksan—sama ka?",
    "mingl.posts.7.content": "Sa weekend tayo. Welcome ang beginners; chill pace lang.",

    // (6 chars max, malayang pag-aangkop)
    "connect.titles.0": "Wika",
    "connect.titles.1": "Buhay",
    "connect.titles.2": "Benta",
    "connect.titles.3": "Gawain",
    "connect.titles.3.category": "Part",

    "connect.posts.0.title": "Hanap kapareha sa Kor-Jpn business convo (language exchange)",
    "connect.posts.0.reward": "Hapon",
    "connect.posts.0.reward_detail": "Oras—usap",
    "connect.posts.0.location": "Seongbuk-dong café",

    "connect.posts.1.title": "Kailangan ng native Spanish—tulong sa practice!",
    "connect.posts.1.reward": "Gift card",
    "connect.posts.1.reward_detail": "₩50,000 / sesyon",
    "connect.posts.1.location": "Geumcheon-gu Office Stn",

    "connect.posts.2.title": "Guide mula Incheon Airport hanggang Mapo Stn",
    "connect.posts.2.reward": "Item",
    "connect.posts.2.reward_detail": "Spanish wine",
    "connect.posts.2.location": "Incheon Airport",

    "connect.posts.3.title": "Sama ka sa pag-pirma ng kontrata sa one-room?",
    "connect.posts.3.reward": "Cash",
    "connect.posts.3.reward_detail": "₩10,000 / oras",
    "connect.posts.3.location": "Yeongdeungpo/Yangcheon Stn",

    "connect.posts.4.title": "Pahiram ng monkey driver isang araw—kapalit: kimchi kkakdugi",
    "connect.posts.4.reward": "Item",
    "connect.posts.4.reward_detail": "Homemade kkakdugi",
    "connect.posts.4.location": "Mapo-gu, Seogyo-dong",

    "connect.posts.5.title": "For sale: bisikleta—minimal gamit",
    "connect.posts.5.reward": "Presyo",
    "connect.posts.5.reward_detail": "₩50,000",
    "connect.posts.5.location": "Malapit sa Sinchon Stn",

    "connect.posts.6.title": "Short-term staff sa expo—may English advantage",
    "connect.posts.6.reward": "Gawain",
    "connect.posts.6.reward_detail": "On-site support at English guide",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "Barista na marunong sa Spanish (uuna ang native foreigners)",
    "connect.posts.7.reward": "Sahod",
    "connect.posts.7.reward_detail": "Mula ₩10,000/h",
    "connect.posts.7.location": "Itaewon café",

    "passport.introduction": "Nagsimulang mag-aral ng Korean dahil sa K-variety shows; nang manalo ako ng 1st place sa Korean speech contest sa Mexico, napag-desisyunan kong pumunta sa Korea!",
    "passport.gender": "Kasarian",
    "passport.gender_detail": "Lalaki",
    "passport.birth": "Kapanganakan",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Nasyonalidad",
    "passport.nationality_detail": "Mexico",
    "passport.mother_tongue": "Inang wika",
    "passport.mother_tongue_detail": "Espanyol",
    "passport.language": "Mga wika",
    "passport.language_detail.0": "Korean",
    "passport.language_detail.1": "English",
    "passport.edit": "I-edit",
    "passport.share": "Ibahagi",

    // Positioned Mobile Demo Section (tl)
    "positionedMobileDemo.home.description": "Parang ‘balita sa barangay’ — makita agad ang nangyayari sa paligid mo",
    "positionedMobileDemo.home.features.0.description": "Huwag ma-miss ang mga balita at event sa komunidad",
    "positionedMobileDemo.home.features.1.description": "Tuklasin ang araw-araw na kwento ng mga tao base sa lugar",
    "positionedMobileDemo.home.features.2.description": "Madaling makisama sa mga festival, meetup, at anumang lokal na aktibidad",

    "positionedMobileDemo.mingl.description": "Tuklasin at ibahagi ang tunay na buhay-komunidad gamit ang mapa",
    "positionedMobileDemo.mingl.features.0.description": "Malayang magbahagi ng tanong, impormasyon, balita at rekomendasyon — natural na ugnayan",
    "positionedMobileDemo.mingl.features.1.description": "Real-time translation para sa global na komunikasyon na walang language barrier",
    "positionedMobileDemo.mingl.features.2.description": "Ang mundo mula sa mata ng lokal, at ang lokal mula sa mata ng global",

    "positionedMobileDemo.connect.description": "Ang sandali ng pagtutulungan, nagiging koneksyon",
    "positionedMobileDemo.connect.features.0.description": "Makahanap o makapagbigay ng tulong agad gamit ang location-based matching",
    "positionedMobileDemo.connect.features.1.description": "Piliin mo mismo ang ‘mapagkakatiwalaan at ligtas’ na tao",
    "positionedMobileDemo.connect.features.2.description": "Kausap → Palitan → Tulay ng pangmatagalang lokal at global na relasyon",

    "positionedMobileDemo.talk.description": "Makipagkaibigan sa iba’t ibang bansa nang walang takot sa wika gamit ang AI translation",
    "positionedMobileDemo.talk.features.0.description": "Natural na usapan kahit anong level ng wika dahil sa instant translation",
    "positionedMobileDemo.talk.features.1.description": "Magtanong tungkol sa buhay sa Korea direkta sa mga lokal at makakuha agad ng sagot",
    "positionedMobileDemo.talk.features.2.description": "Gawing pangmatagalang pagkakaibigan ang koneksyong nagsimula sa Connect",

    "positionedMobileDemo.passport.description": "Gumawa ng digital namecard na naglalaman ng global journey mo",
    "positionedMobileDemo.passport.features.0.description": "I-record ang history ng tirahan at aktibidad mo ayon sa lugar sa isang timeline",
    "positionedMobileDemo.passport.features.1.description": "Ipakita nang malinaw ang language skills at communication style mo",
    "positionedMobileDemo.passport.features.2.description": "Kumonekta nang natural sa mga taong may katulad na karanasan",


    // Logl Video Section
    "loglVideo.title": "logl na pambungad na video",
    "loglVideo.description": "Curious sa logl? Unahin mo ang video!",
    "loglVideo.watch": "Panoorin ang video"

    }
  },
  uz: {
    translation: {
    // Header Section
    "header.intro": "Kirish",
    "header.demo": "Demo",
    "header.video": "logl video",

    // Hero Section
    "hero.title": "Til to‘siqlarini yo‘q qilamiz",
    "hero.description": "find your",
    "hero.demo": "Demo sinab ko‘rish",
    "hero.prop1": "Tasdiqlangan mahalliy xizmatlar",
    "hero.prop2": "Real vaqt AI tarjima",
    "hero.prop3": "Turli mahalliy hamjamiyatlar",

    // Introduction Section
    "introduction.title": "Bunday muammolar sizga tanishmi?",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",

    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Seul, Koreya",
    "introduction.fst.tag": "#TilO‘rganish",
    "introduction.fst.story": "“Ingliz tilini o‘rgandim, hatto chet elda o‘qidim... lekin ishlatadigan joy bo‘lmagani uchun unutib bormoqdaman. Kundalik hayotda ishlatish imkoniyati bo‘lsa yaxshi bo‘lardi😢”",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Koreya",
    "introduction.snd.tag": "#MahalliyDo‘stIzlash",
    "introduction.snd.story": "“Koreyaga kelganimga 6 oy bo‘ldi, lekin hali ham faqat o‘zimning vatandoshlarim bilan yuraman. Koreyalik do‘stlar bilan chin dildan yaqinlashishni xohlayman, lekin qanday boshlashni bilmayman.”",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Koreya",
    "introduction.trd.tag": "#MahalliyHayotMa’lumoti",
    "introduction.trd.story": "“YouTube yoki forumlarga kirsam ham, aynan mening tumanim haqidagi aniq ma’lumot yo‘q. Bank hisob ochish, telefon operatori, shifoxona... Koreyaga yangi ko‘chib kelganlar uchun eng to‘g‘ri va dolzarb ma’lumotni qayerdan olaman?”",

    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "Mahallani global markazga aylantiring",
    "appMenu.home.local.description": "Mahalliy ma’lumotlaringiz bilan qo‘shni chet elliklarga yordam bering va hududingizni chinakam global hamjamiyatga aylantiring.",
    "appMenu.home.local.points": [
      "Yashirin kafe, shifoxona, do‘konlarni chet elliklarga tanishtirish",
      "Mahalla yangiliklari va tadbirlarini baham ko‘rish",
      "Hududni xalqaro darajada rivojlantirishga hissa qo‘shish"
    ],
    "appMenu.home.local.tip": "Siz bilgan kichik ma’lumot ham kim uchundir juda qadrli bo‘lishi mumkin.",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "Koreyada kundalik hayot uchun bosh sahifa",
    "appMenu.home.global.description": "Ob-havo, mahalla yangiliklari, mashhur postlar — Koreyadagi hayotingiz uchun zarur ma’lumotlar bir joyda.",
    "appMenu.home.global.points": [
      "Ob-havo va kunlik rejalash maslahatlari",
      "Mahalliy yordam so‘rovlarini birinchi bo‘lib ko‘rish",
      "Koreyaliklar orasida mashhur global postlarni kuzatib borish"
    ],
    "appMenu.home.global.tip": "Har kuni atigi 5 daqiqa — hayot ancha osonlashadi.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Global do‘stlar bilan suhbat",
    "appMenu.mingl.local.description": "Chet elliklarning savollariga javob berib, tilni o‘rganing va madaniyat almashing.",
    "appMenu.mingl.local.points": [
      "Koreyada yashash bo‘yicha maslahatlar berish",
      "Tabiiy ravishda chet tilini rivojlantirish",
      "Turli mamlakatlardan do‘stlar topish"
    ],
    "appMenu.mingl.local.tip": "Yordam qilish — eng tabiiy aloqa boshlanishi.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Koreyslar bilan tabiiy muloqot",
    "appMenu.mingl.global.description": "AI tarjima yordamida til to‘siqlarisiz savol bering va do‘stlar orttiring.",
    "appMenu.mingl.global.points": [
      "Kundalik savollarga tez javob topish",
      "Tilni bilmasangiz ham tabiiy suhbat",
      "Faqat vatandoshlar bilan cheklanib qolmaslik"
    ],
    "appMenu.mingl.global.tip": "Mahallaga aralashish — o‘z uyidek his qilishning eng tez yo‘li.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Chet ellik qo‘shnilarga yordam",
    "appMenu.connect.local.description": "Ularning real hayotdagi muammolarini hal qilib, global do‘stlik tarmog‘ini yarating.",
    "appMenu.connect.local.points": [
      "Bank, uy, hujjatlar bo‘yicha amaliy yordam",
      "Yordam orqali tabiiy do‘stlik",
      "Mahallaning global elchisi bo‘lish"
    ],
    "appMenu.connect.local.tip": "Kichik yordam — katta do‘stlikka yo‘l.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Koreys qo‘shnilar bilan muammolarni hal qiling",
    "appMenu.connect.global.description": "Bank, uy, viza kabi muhim muammolarni ishonchli mahalliy inson bilan birga yeching.",
    "appMenu.connect.global.points": [
      "Amaliy hayotdagi aniq muammolarni yechish",
      "Vositasiz bevosita yordam so‘rash",
      "Mahallaga tabiiy moslashish"
    ],
    "appMenu.connect.global.tip": "Tez yordam kerak bo‘lsa — eng yaxshi manba mahalliy qo‘shnidir.",

    // connect.titles (<=6 chars)
    "connect.titles.0": "Til",
    "connect.titles.1": "Yordam",
    "connect.titles.2": "Sotuv",
    "connect.titles.3": "Ishlar",
    "connect.titles.3.category": "Ishchi",

    // Talk Section
    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Chet ellik qo‘shnilar bilan chat",
    "appMenu.talk.local.description": "AI tarjima orqali bemalol va samimiy suhbat qiling.",
    "appMenu.talk.local.points": [
      "Til darajasi muhim emas",
      "Do‘stlikni davom ettirish",
      "Hayotdagi qiyinchiliklarga maslahat"
    ],
    "appMenu.talk.local.tip": "Haqiqiy do‘stlik — suhbatdan boshlanadi.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Koreyslar bilan qulay chat",
    "appMenu.talk.global.description": "Savollarni darhol so‘rang va aniq javob oling.",
    "appMenu.talk.global.points": [
      "To‘g‘ridan-to‘g‘ri mahalliydan o‘rganish",
      "AI tarjima bilan bemalol suhbat",
      "Uzoq muddatli do‘stlikka yo‘l"
    ],
    "appMenu.talk.global.tip": "Kichik savoldan — katta aloqa boshlanadi.",

    // Passport
    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Sizning global hikoyangiz",
    "appMenu.passport.local.description": "Hamkorlik va tajribalarni qayd eting.",
    "appMenu.passport.local.points": [
      "Faoliyatni vaqt chizig‘ida ko‘rish",
      "Global yordamchi profili yaratish",
      "Til va madaniyat almashinuvi tajribasini boshqarish"
    ],
    "appMenu.passport.local.tip": "Har bir kichik qadam — katta hikoya bo‘laklari.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Global profil — raqamli vizitka",
    "appMenu.passport.global.description": "Ko‘p millatli tajribangizni ko‘rsatib, ishonchli profil yarating.",
    "appMenu.passport.global.points": [
      "Yashash tajribalarini ko‘rsatish",
      "Til va madaniyat bilan ishonch oshirish",
      "O‘xshash tajribali do‘stlar topish"
    ],
    "appMenu.passport.global.tip": "Profil qancha batafsil — aloqa shuncha boy.",

    // Demo / Home / Mingl / Connect / Events / Weather / Posts
    "common.viewAll": "Hammasini ko‘rish",
    "common.minutesAgo": "daqiqa oldin",

    "home.tag": "Fleamarket",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Bugun ham yaxshi kun bo‘lsin",

    "home.weather.maxTemp": "Eng yuqori 15°",
    "home.weather.minTemp": "Eng past 10°",
    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Ochiq",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Bulutli",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "O‘rtacha",

    "home.mytown.title": "Mahalla yangiliklari",
    "home.mytown.places.0.name": "Gingko bozori",
    "home.mytown.places.0.address": "Geumcheon-gu, Siheung-dong",
    "home.mytown.places.1.name": "Gwanaksan",
    "home.mytown.places.1.address": "Gwanak-gu, Sillim-dong",
    "home.mytown.places.2.name": "Anyangcheong maydoni",
    "home.mytown.places.2.address": "Geumcheon-gu, Dokseon-dong",

    "home.events.title": "Mahalla tadbirlari",
    "home.events.post_title": "Doksan-dong Flea Market bo‘ladi",
    "home.events.address": "Doksan-dong, Geumcheon-gu",

    // Mingl Posts (sample titles are adapted smoothly)
    "mingl.posts.0.category": "Hayot ma’lumoti",
    "mingl.posts.0.title": "Geumcheon stansiyasidagi Sundae aravachasi qayerda?",
    "mingl.posts.0.content": "Juda mazali edi... hozir ko‘rinmayapti. Bilgan bormi?",

    "mingl.posts.1.category": "Hayot ma’lumoti",
    "mingl.posts.1.title": "Doksan bozori xarid qilish maslahati",
    "mingl.posts.1.content": "Narxlar kuniga qarab farq qiladi. Qanday tejasa bo‘ladi?",

    "mingl.posts.2.category": "Kundalik",
    "mingl.posts.2.title": "Gasan yaqinida tushlik nima yeyish mumkin?",
    "mingl.posts.2.content": "Bugun tanlash qiyin. Maslahat bormi?",

    "mingl.posts.3.category": "Hobby",
    "mingl.posts.3.title": "Gasan stansiyada board game uchrashuvi",
    "mingl.posts.3.content": "Har juma kechqurun. Qo‘shilmoqchi bo‘lsangiz yozing.",

    "mingl.posts.4.category": "Sayohat",
    "mingl.posts.4.title": "Hoamsan sayr yo‘lagi",
    "mingl.posts.4.content": "Yengil yurish uchun yaxshi yo‘lak topdim. Tavsiya qilaman!",

    "mingl.posts.5.category": "Kundalik",
    "mingl.posts.5.title": "Doksan yaqinida sokin kafe?",
    "mingl.posts.5.content": "Wi-Fi va rozetkasi yaxshi bo‘lsa, ayting.",

    "mingl.posts.6.category": "Hayot ma’lumoti",
    "mingl.posts.6.title": "Gasan yaqinida zal tavsiya?",
    "mingl.posts.6.content": "Qaysi biri yaxshi? Narx va jihozlar haqida maslahat kerak.",

    "mingl.posts.7.category": "Hobby",
    "mingl.posts.7.title": "Gwanaksan yurish",
    "mingl.posts.7.content": "Hafta oxiri ketamiz. Yangi odamlar ham xush kelibsiz!",

    // Connect Posts
    "connect.posts.0.title": "Koreyscha-Yaponcha biznes suhbat almashish",
    "connect.posts.0.reward": "Til",
    "connect.posts.0.reward_detail": "Vaqt kelishiladi",
    "connect.posts.0.location": "Seongbuk kafe",

    "connect.posts.1.title": "Ispancha suhbat mashqi kerak!",
    "connect.posts.1.reward": "Sovg‘a kartasi",
    "connect.posts.1.reward_detail": "50,000₩",
    "connect.posts.1.location": "Geumcheon stansiya",

    "connect.posts.2.title": "Incheon aeroport → Mapo yo‘l ko‘rsatib yuboring",
    "connect.posts.2.reward": "Sovg‘a",
    "connect.posts.2.reward_detail": "Ispancha vino",
    "connect.posts.2.location": "Incheon aeroport",

    "connect.posts.3.title": "Uy shartnomasi uchun birga borishga yordam kerak",
    "connect.posts.3.reward": "Naqd",
    "connect.posts.3.reward_detail": "10,000₩/soat",
    "connect.posts.3.location": "Yeongdeungpo / Yangcheon",

    "connect.posts.4.title": "Monkey driver 1 kunga kerak — Kaktuki beraman",
    "connect.posts.4.reward": "Sovg‘a",
    "connect.posts.4.reward_detail": "Uyda tuzlangan kaktuki",
    "connect.posts.4.location": "Mapo, Seogyo-dong",

    "connect.posts.5.title": "Velosiped sotaman, yaxshi holatda",
    "connect.posts.5.reward": "Narx",
    "connect.posts.5.reward_detail": "50,000₩",
    "connect.posts.5.location": "Sinchon",

    "connect.posts.6.title": "Ko‘rgazma uchun qisqa muddatli ish, ingliz tili afzal",
    "connect.posts.6.reward": "Ish",
    "connect.posts.6.reward_detail": "Yordam va yo‘riq",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "Ispancha biladigan barista kerak (chet ellik afzal)",
    "connect.posts.7.reward": "Soatlik",
    "connect.posts.7.reward_detail": "10,000₩~",
    "connect.posts.7.location": "Itaewon kafe",

    // Passport
    "passport.introduction": "Koreys teleko‘rsatuvlarini tomosha qilib koreys tilini o‘rgandim va mexikodagi koreys tili tanlovida 1-o‘rinni oldim — shu bilan Koreyaga kelishga qaror qildim!",
    "passport.gender": "Jinsi",
    "passport.gender_detail": "Erkak",
    "passport.birth": "Tug‘ilgan sana",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Fuqaroligi",
    "passport.nationality_detail": "Meksika",
    "passport.mother_tongue": "Ona tili",
    "passport.mother_tongue_detail": "Ispancha",
    "passport.language": "Chet tillari",
    "passport.language_detail.0": "Koreyscha",
    "passport.language_detail.1": "Inglizcha",
    "passport.edit": "Tahrirlash",
    "passport.share": "Ulashish",

    // Positioned Mobile Demo Section (uz)
    "positionedMobileDemo.home.description": "Mahalliy ‘yangiliklar’ kabi — atrofda nimalar bo‘layotganini birdan ko‘ring",
    "positionedMobileDemo.home.features.0.description": "Hududdagi real vaqt yangiliklar va tadbirlarni o‘tkazib yubormang",
    "positionedMobileDemo.home.features.1.description": "Muayyan joylar atrofidagi aholining kundalik hayotini kashf eting",
    "positionedMobileDemo.home.features.2.description": "Mahalladagi bayram, uchrashuv va katta-kichik tadbirlarga oson qo‘shiling",

    "positionedMobileDemo.mingl.description": "Manzil asosida haqiqiy mahalla hayotini toping va ulashing",
    "positionedMobileDemo.mingl.features.0.description": "Savollar, ma’lumotlar, yangiliklar va tavsiyalarni erkin baham ko‘ring — tabiiy muloqot",
    "positionedMobileDemo.mingl.features.1.description": "Real vaqtli tarjima bilan til to‘siqlarisiz global aloqa",
    "positionedMobileDemo.mingl.features.2.description": "Dunyoni mahalliy nigohda, mahallani esa global nigohda ko‘ring",

    "positionedMobileDemo.connect.description": "Yordam berilgan onlarda aloqalar tug‘iladi",
    "positionedMobileDemo.connect.features.0.description": "Joylashuv asosidagi moslash orqali yordamni tez toping yoki bering",
    "positionedMobileDemo.connect.features.1.description": "‘Ishonchli va xavfsiz’ odamni o‘zingiz tanlang",
    "positionedMobileDemo.connect.features.2.description": "Suhbat → almashinuv → uzoq davom etadigan mahalliy va global munosabatlar",

    "positionedMobileDemo.talk.description": "AI tarjima bilan tilga tashvishsiz xalqaro do‘stlar orttiring",
    "positionedMobileDemo.talk.features.0.description": "Til darajangizdan qat’i nazar, real vaqt tarjima bilan tabiiy suhbatlar",
    "positionedMobileDemo.talk.features.1.description": "Koreyadagi hayot haqida mahalliy odamlardan to‘g‘ridan-to‘g‘ri so‘rab, darhol javob oling",
    "positionedMobileDemo.talk.features.2.description": "Connect orqali boshlangan tanishuvni mustahkam do‘stlikka aylantiring",

    "positionedMobileDemo.passport.description": "Global tajribangizni aks ettiruvchi raqamli vizitka yarating",
    "positionedMobileDemo.passport.features.0.description": "Hududlar bo‘yicha yashash va faoliyat tarixini vaqt chizig‘ida yozing",
    "positionedMobileDemo.passport.features.1.description": "Til ko‘nikmalari va muloqot uslubingizni aniq ko‘rsating",
    "positionedMobileDemo.passport.features.2.description": "O‘xshash tajribaga ega odamlarga tabiiy ravishda ulanib boring",


    // Logl Video Section
    "loglVideo.title": "logl video tanishtiruvi",
    "loglVideo.description": "logl nima ekanini bilmoqchimisiz? Videoni tomosha qiling!",
    "loglVideo.watch": "Videoni ko‘rish"

    },
  },
  ne: {
    translation: {
    // Header Section
    "header.intro": "परिचय",
    "header.demo": "डेमो",
    "header.video": "logl भिडियो",

    // Hero Section
    "hero.title": "भाषा अवरोध हटाऔँ",
    "hero.description": "find your",
    "hero.demo": "डेमो अनुभव गर्नुहोस्",
    "hero.prop1": "प्रमाणित स्थानीय सेवा",
    "hero.prop2": "रियल-टाइम AI अनुवाद",
    "hero.prop3": "विविध स्थानीय समुदाय",

    // Introduction Section
    "introduction.title": "यस्ता चिन्ता परेको छ?",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",

    "introduction.fst.name": "जिमिन",
    "introduction.fst.location": "सियोल, दक्षिण कोरिया",
    "introduction.fst.tag": "#भाषा_सिकाइ",
    "introduction.fst.story": "“इङ्ग्लिस धेरै पढेँ, विदेश पनि गएँ… तर प्रयोग गर्ने मौका नहुँदा बिर्सँदैछु। दैनिकीमै प्रयोग गर्न पाइने ठाउँ भए राम्रो हुन्थ्यो😢”",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "सुवन, दक्षिण कोरिया",
    "introduction.snd.tag": "#स्थानीय_साथी_बनाउने",
    "introduction.snd.story": "“कोरियामा आएको ६ महिना भयो, तर अझै आफ्नै देशका साथीसँग मात्र बस्छु। कोरियन साथीहरूसँग साँच्चिकै घुलमिल हुन चाहन्छु, कसरी सुरु गर्ने थाहा छैन।”",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "जोनजु, दक्षिण कोरिया",
    "introduction.trd.tag": "#स्थानीय_जीवन_जानकारी",
    "introduction.trd.story": "“YouTube र कम्युनिटीहरूमा खोज्दा पनि हाम्रो टोलको ठ्याक्कै जानकारी भेटिन्न। बैंक खोल्ने, टेलिकम, अस्पताल… पहिलो बसाइँमै अद्यावधिक र सही जानकारी कहाँ पाउँ?”",

    // App Menu Section – Home
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "हाम्रो टोललाई ग्लोबल हब बनाऔँ",
    "appMenu.home.local.description": "तपाईंले जान्ने स्थानीय जानकारीले विदेशी छिमेकीलाई सहयोग गर्दै समुदायलाई साँच्चिकै ग्लोबल बनाऔँ।",
    "appMenu.home.local.points": [
      "लुकेका रेस्टुरेन्ट/अस्पताल/सुविधा स्थानहरू परिचय गराउने",
      "रियल-टाइम टोल खबर र कार्यक्रम साझा गर्ने",
      "टोलको अन्तर्राष्ट्रियकरणमा नेतृत्व गर्न योगदान गर्ने"
    ],
    "appMenu.home.local.tip": "तपाईंको सानो जानकारी, कसैको दैनिकीको ठूलो मार्गदर्शन हुन सक्छ।",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "कोरिया जीवनका लागि अनुकूल ड्यासबोर्ड",
    "appMenu.home.global.description": "आजको मौसमदेखि टोलका लोकप्रिय पोस्टसम्म—आवश्यक जानकारी एउटै स्क्रिनमा।",
    "appMenu.home.global.points": [
      "स्थानीय मौसम र बाहिरिने टिप्ससँग दिनको योजना",
      "टोलका रियल-टाइम खबर र ‘मद्दत चाहियो’ पहिले हेर्ने",
      "कोरियनबीच चर्चित ग्लोबल पोस्ट नछुटाउने"
    ],
    "appMenu.home.global.tip": "दैनिक ५ मिनेट जाँच—कोरिया जीवन धेरै सजिलो।",

    // App Menu – mingl
    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "ग्लोबल साथीहरूसँग कुराकानी",
    "appMenu.mingl.local.description": "विदेशीको प्रश्नमा जवाफ दिनुहोस्, भाषा सिक्नुहोस्, र संस्कृति बाँड्नुहोस्।",
    "appMenu.mingl.local.points": [
      "कोरिया जीवन टिप्स बाँड्दा सन्तोष",
      "स्वाभाविक रूपमा भाषा सुधार",
      "विविध संस्कृतिका साथी बनाउने"
    ],
    "appMenu.mingl.local.tip": "सहयोग, सिकाइ र आदानप्रदान—एकै ठाउँमा।",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "कोरियनसँग स्वाभाविक संचार",
    "appMenu.mingl.global.description": "रियल-टाइम अनुवादका साथ भाषा चिन्ता बिना प्रश्न सोध्नुहोस् र स्थानीय साथी बनाउनुहोस्।",
    "appMenu.mingl.global.points": [
      "कोरिया जीवनका जिज्ञासा तुरुन्त समाधान",
      "AI अनुवादले बिना बोझ स्वाभाविक संवाद",
      "‘फरेनर्स मात्र’ घेराबाट बाहिरिएर साँच्चिकै कोरियन साथी"
    ],
    "appMenu.mingl.global.tip": "संस्कृति सिक्दै स्थानीय समुदायमा बिस्तारै घुलमिल।",

    // App Menu – connect
    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "विदेशी छिमेकीलाई सहयोग र मित्रता",
    "appMenu.connect.local.description": "टोलका विदेशीको वास्तविक समस्या समाधान गर्दै ग्लोबल नेटवर्क बनाऔँ।",
    "appMenu.connect.local.points": [
      "बैंक, घर, कागजपात्रो जस्ता व्यवहारिक सहयोग",
      "सहयोगमार्फत स्वाभाविक रूपमा नेटवर्क विस्तार",
      "टोलको ग्लोबल एम्बेसडरको अर्थपूर्ण भूमिका"
    ],
    "appMenu.connect.local.tip": "सानो सहयोगबाट सुरु—साँचो मित्रतामा पुग्छ।",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "कोरियन छिमेकीसँग समस्या समाधान",
    "appMenu.connect.global.description": "बैंक, घर, भिसा जस्ता आवश्यक विषय विश्वसनीय स्थानीयसँग मिलेरै समाधान गर्नुहोस्।",
    "appMenu.connect.global.points": [
      "खास समस्यामा ठोस सहयोग",
      "एजेण्ट बिना, छिमेकीसँग पछिल्लो",
      "‘विदेशी-गेटो’ बाहिरिएर वास्तविक स्थानीय जीवनमा समायोजन"
    ],
    "appMenu.connect.global.tip": "जति आपतकालीन काम, उति छिमेकीको सहयोग छरितो र भरोसायोग्य।",

    // App Menu – talk
    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "विदेशी छिमेकीसँग रियल-टाइम च्याट",
    "appMenu.talk.local.description": "AI अनुवादका साथ भाषा बाधा बिना 1:1 च्याट—साँचो ग्लोबल साथी बन्छ।",
    "appMenu.talk.local.points": [
      "भाषा स्तर नभए पनि स्वाभाविक संवाद",
      "connect बाट सुरु भएको सम्बन्धलाई दीर्घकालीन मित्रतामा",
      "कोरिया जीवनका चिन्तामा सल्लाह र साथ"
    ],
    "appMenu.talk.local.tip": "सानो कुराकानी—दीर्घकालीन ग्लोबल नेटवर्क।",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "कोरियनसँग सजिलै संवाद",
    "appMenu.talk.global.description": "भाषा अवरोध बिना छिमेकी कोरियनसँग च्याट गर्दै जिज्ञासा तुरुन्त समाधान।",
    "appMenu.talk.global.points": [
      "कोरियनलाई सिधै सोधी तत्क्षण उत्तर",
      "AI अनुवादले सहज र आरामदायी कुरा",
      "connect मा भेटिएका सहयोगी छिमेकीसँग सम्बन्ध निरन्तरता"
    ],
    "appMenu.talk.global.tip": "सानो प्रश्नबाट—जीवनभरको सहयात्री भेटिन्छ।",

    // App Menu – passport
    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "आफ्नै ग्लोबल कथा लेखौँ",
    "appMenu.passport.local.description": "विदेशी साथीहरूसँगका गतिविधि/अनुभव रेकर्ड गरी पासपोर्ट बिना पनि ग्लोबल पहिचान निर्माण।",
    "appMenu.passport.local.points": [
      "टोलको ग्लोबल गतिविधि टाइमलाइन दृश्य",
      "सहयोग रेकर्डले ग्लोबल एम्बेसडर पोर्टफोलियो",
      "भाषा क्षमतासँग सांस्कृतिक आदानप्रदान व्यवस्थापन"
    ],
    "appMenu.passport.local.tip": "सानो सहयोगहरूको निरन्तर रेकर्डले तपाईंको ग्लोबल यात्राको कथा पूरा गर्छ।",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "ग्लोबल पहिचान — डिजिटल कार्ड",
    "appMenu.passport.global.description": "बहुराष्ट्रिय अनुभव दृश्यात्मक रूपमा देखाएर भरोसायोग्य प्रोफाइल बनाउनुहोस्।",
    "appMenu.passport.global.points": [
      "बसोबास र ग्लोबल अनुभव एकै नजरमा",
      "भाषा/सांस्कृतिक पृष्ठभूमिबाट विश्वास निर्माण",
      "उस्तै अनुभव भएकासँग प्राकृतिक रूपमा जोडिने"
    ],
    "appMenu.passport.global.tip": "प्रोफाइल जति विस्तृत, समर्थन र मित्रता उति राम्रो।",

    // Demo / Common
    "common.viewAll": "सबै हेर्नुहोस्",
    "common.minutesAgo": "मिनेट अघि",

    // Home – tag & greeting
    "home.tag": "फ्लि-मार्केट",
    "home.greeting_01": "Carlos님",
    "home.greeting_02": "आजको दिन शुभ होस्",

    // Home – Weather
    "home.weather.maxTemp": "अधिकतम 15°",
    "home.weather.minTemp": "न्यूनतम 10°",
    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "खुला आकाश",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "बादल",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "मध्यम",

    // Home – Mytown
    "home.mytown.title": "रियल-टाइम हाम्रो टोल",
    "home.mytown.places.0.name": "गिङ्को बजार",
    "home.mytown.places.0.address": "गुम्चन-गु, सिहुङ-डोङ",
    "home.mytown.places.1.name": "ग्वानाक्सान",
    "home.mytown.places.1.address": "ग्वानाक-गु, सिलिम-डोङ",
    "home.mytown.places.2.name": "अन्याङछोन बहुउद्देश्यीय मैदान",
    "home.mytown.places.2.address": "गुम्चन-गु, दोक्सोन-डोङ",

    // Home – Events
    "home.events.title": "हाम्रो टोलका इभेन्ट",
    "home.events.post_title": "दोक्सान-डोङमा फ्लि-मार्केट हुँदैछ",
    "home.events.address": "गुम्चन-गु, दोक्सान-डोङ",

    // mingl – Posts
    "mingl.posts.0.category": "जीवन-जानकारी",
    "mingl.posts.0.title": "गुम्चन-गु कार्यालय स्टेशनको सुन्दे ठेला कहाँ छ?",
    "mingl.posts.0.content": "साँचै जीवनको सर्वोत्तम सुन्दे! यतिखेर देखिँदैन। कसैलाई थाहा छ?",

    "mingl.posts.1.category": "जीवन-जानकारी",
    "mingl.posts.1.title": "दोक्सान परम्परागत बजार किनमेल टिप्स",
    "mingl.posts.1.content": "बारम्बार मूल्य फरक पर्छ। कसरी किफायती किनमेल गर्ने?",

    "mingl.posts.2.category": "दैनिकी",
    "mingl.posts.2.title": "गासान डिजिटल कम्प्लेक्स वरिपरि लञ्च के खाने?",
    "mingl.posts.2.content": "आज विशेषै निर्णय गर्न गाह्रो। यहाँका अफिसरू के खान्छन्?",

    "mingl.posts.3.category": "रूचि/समूह",
    "mingl.posts.3.title": "गासान स्टेशन बोर्ड-गेम समूह—सदस्य खोजिँदै",
    "mingl.posts.3.content": "हरेक शुक्रबार बेलुका भेट्छौँ। सहभागी खोज्दैछौं।",

    "mingl.posts.4.category": "यात्रा/घुमफिर",
    "mingl.posts.4.title": "होआम्सान ट्रेल—सप्ताहन्त हिँडडुल मार्ग",
    "mingl.posts.4.content": "हल्का हिंड्न मिल्ने राम्रो रूट भेटेँ, सिफारिस गर्छु।",

    "mingl.posts.5.category": "दैनिकी",
    "mingl.posts.5.title": "दोक्सान वर शान्त क्याफे सिफारिस?",
    "mingl.posts.5.content": "उत्तम Wi-Fi र प्लग भएको, काम गर्न मिल्ने ठाउँ चाहियो।",

    "mingl.posts.6.category": "जीवन-जानकारी",
    "mingl.posts.6.title": "गासान नजिकै जिम सिफारिस गर्नुहोस्",
    "mingl.posts.6.content": "कुन ठाउँ राम्रो? मासिक शुल्क/सुविधा कस्ता छन्?",

    "mingl.posts.7.category": "रूचि/समूह",
    "mingl.posts.7.title": "ग्वानाक्सान हाइकिङ—सँगै जानुहुन्छ?",
    "mingl.posts.7.content": "यस सप्ताहन्त। नयाँहरूलाई स्वागत—सुकिलो गतिमा।",

    // connect – Titles (≤6 chars, 의역)
    "connect.titles.0": "भाषा",
    "connect.titles.1": "सहाय",
    "connect.titles.2": "बिक्री",
    "connect.titles.3": "काम",
    "connect.titles.3.category": "पार्ट",

    // connect – Posts
    "connect.posts.0.title": "कोरियन-जापानी बिजनेस वार्ता—ल्यान्ग एक्सचेन्ज पार्टनर खोज्दै",
    "connect.posts.0.reward": "भाषा",
    "connect.posts.0.reward_detail": "समय सहमति",
    "connect.posts.0.location": "सेओङबुक-डोङ क्याफे",

    "connect.posts.1.title": "स्पेनी (नेटर) चाहियो—कुराकानी अभ्यासमा मद्दत गर्नुहोस्!",
    "connect.posts.1.reward": "गिफ्ट कार्ड",
    "connect.posts.1.reward_detail": "₩50,000 / पटक",
    "connect.posts.1.location": "गुम्चनगुच्योङ स्टेशन",

    "connect.posts.2.title": "इन्चोन एयरपोर्टबाट मापो स्टेशनसम्म मार्गदर्शन चाहियो",
    "connect.posts.2.reward": "वस्तु",
    "connect.posts.2.reward_detail": "स्पेनी रक्सी",
    "connect.posts.2.location": "इन्चोन एयरपोर्ट",

    "connect.posts.3.title": "वान-रुम सम्झौतामा सँगै जान सहयोग गर्नुहुन्छ?",
    "connect.posts.3.reward": "नगद",
    "connect.posts.3.reward_detail": "₩10,000 / घण्टा",
    "connect.posts.3.location": "सियोल यङदुङपो/याङछोन",

    "connect.posts.4.title": "मङ्की-ड्राइभर 1 दिनका लागि—सट्टामा घरको काक्तुगी",
    "connect.posts.4.reward": "वस्तु",
    "connect.posts.4.reward_detail": "घरमै बनाएको काक्तुगी",
    "connect.posts.4.location": "मापो-गु, सोग्यो-डोङ",

    "connect.posts.5.title": "साइकल बिक्री—प्राय: नयाँजस्तै",
    "connect.posts.5.reward": "मूल्य",
    "connect.posts.5.reward_detail": "₩50,000",
    "connect.posts.5.location": "सिन्चोन नजिक",

    "connect.posts.6.title": "प्रदर्शनीका लागि छोटो समयको काम—इङ्ग्लिस हुनेलाई प्राथमिकता",
    "connect.posts.6.reward": "काम",
    "connect.posts.6.reward_detail": "साइट सपोर्ट र इंग्लिस सहायता",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "स्पेनी बोल्ने बारिस्ता चाहियो (नेटर विदेशी प्राथमिकता)",
    "connect.posts.7.reward": "घण्टादर",
    "connect.posts.7.reward_detail": "₩10,000 देखि",
    "connect.posts.7.location": "इटावोन क्याफे",

    // Passport – Profile
    "passport.introduction": "कोरियन मनोरञ्जन कार्यक्रममा मोहित भई स्वअध्ययनबाट कोरियन सिकेँ, मेक्सिकोमा भएको कोरियन भाषण प्रतियोगितामा प्रथम भएँ र त्यसैले कोरिया जान निर्णय गरेँ!",
    "passport.gender": "लिङ्ग",
    "passport.gender_detail": "पुरुष",
    "passport.birth": "जन्म-मिति",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "राष्ट्रियता",
    "passport.nationality_detail": "मेक्सिको",
    "passport.mother_tongue": "आम-भाषा",
    "passport.mother_tongue_detail": "स्पेनी",
    "passport.language": "विदेशी भाषा",
    "passport.language_detail.0": "कोरियन",
    "passport.language_detail.1": "अङ्ग्रेजी",
    "passport.edit": "सम्पादन",
    "passport.share": "साझा",

    // Positioned Mobile Demo Section (ne)
    "positionedMobileDemo.home.description": "‘छिमेकको समाचार’ जस्तै, आफ्नो वरिपरि के भइरहेको छ एकै नजरमा हेर्नुहोस्",
    "positionedMobileDemo.home.features.0.description": "स्थानीय समाचार र गतिविधि वास्तविक समयमा नछुटाउनुस्",
    "positionedMobileDemo.home.features.1.description": "ठाउँ अनुसार बासिन्दाहरूको दैनिक कथाहरू अन्वेषण गर्नुहोस्",
    "positionedMobileDemo.home.features.2.description": "पर्व, भेटघाट र साना–ठूला सामुदायिक गतिविधिमा सजिलै सहभागी बनौ",

    "positionedMobileDemo.mingl.description": "स्थान आधारित वास्तविक स्थानीय जीवन खोज्नुहोस् र साझा गर्नुहोस्",
    "positionedMobileDemo.mingl.features.0.description": "प्रश्न, जानकारी, समाचार र सिफारिसहरू स्वतन्त्र रूपमा साझा — प्राकृतिक संवाद",
    "positionedMobileDemo.mingl.features.1.description": "रियल–टाइम अनुवादले भाषा अवरोध बिना विश्वव्यापी सम्पर्क",
    "positionedMobileDemo.mingl.features.2.description": "स्थानीय दृष्टिले विश्व, र विश्व दृष्टिले स्थानीय",

    "positionedMobileDemo.connect.description": "सहयोगका क्षणहरूबाट सम्बन्ध सुरु हुन्छ",
    "positionedMobileDemo.connect.features.0.description": "स्थान–आधारित मिलानबाट आवश्यक सहयोग तुरुन्त खोज्नुस् वा दिनुस्",
    "positionedMobileDemo.connect.features.1.description": "‘भरोसा गर्न मिल्ने र सुरक्षित’ व्यक्ति आफैँ चयन गर्नुहोस्",
    "positionedMobileDemo.connect.features.2.description": "कुरा → आदानप्रदान → दीर्घकालीन स्थानीय र वैश्विक सम्बन्ध",

    "positionedMobileDemo.talk.description": "AI अनुवादसँग भाषा चिन्ता बिना संसारका साथीहरूसँग भेट्नुहोस्",
    "positionedMobileDemo.talk.features.0.description": "भाषा सीपभन्दा पनि प्राकृतिक संवाद, रियल–टाइम अनुवादसँग",
    "positionedMobileDemo.talk.features.1.description": "कोरियाको जीवनबारे स्थानीयसँग प्रत्यक्ष सोधेर तुरुन्त उत्तर प्राप्त",
    "positionedMobileDemo.talk.features.2.description": "Connect मा सुरु भएको चिनजानलाई दिगो मित्रतामा बढाउनुहोस्",

    "positionedMobileDemo.passport.description": "आफ्नो विश्व अनुभव समेटिएको डिजिटल नामकार्ड बनाउनुहोस्",
    "positionedMobileDemo.passport.features.0.description": "क्षेत्र अनुसार बसोबास र गतिविधि इतिहासलाई टाइमलाइनमा दर्ता गर्नुहोस्",
    "positionedMobileDemo.passport.features.1.description": "भाषा क्षमता र संचार शैली स्पष्ट रूपमा प्रस्तुत गर्नुहोस्",
    "positionedMobileDemo.passport.features.2.description": "उस्तै अनुभव भएका मानिसहरूसँग स्वाभाविक रूपमा जडान हुनुहोस्",


    // Logl Video Section
    "loglVideo.title": "logl परिचय भिडियो",
    "loglVideo.description": "logl के हो? पहिला भिडियो हेर्नुहोस्!",
    "loglVideo.watch": "भिडियो हेर्नुहोस्"

    }
  },
  it: {
    translation: {
      // Header Section
      "header.intro": "Intro",
      "header.demo": "Demo",
      "header.video": "video di logl",

      // Hero Section
      "hero.title": "Abbattiamo le barriere linguistiche",
      "hero.description": "find your",
      "hero.demo": "Prova la demo",
      "hero.prop1": "Servizi locali verificati",
      "hero.prop2": "Traduzione AI in tempo reale",
      "hero.prop3": "Varie comunità locali",

      // Introduction Section
      "introduction.title": "Hai mai avuto questi problemi?",
      "introduction.fst.role": "locale",
      "introduction.snd.role": "globale",

      "introduction.fst.name": "Jimin",
      "introduction.fst.location": "Seoul, Corea",
      "introduction.fst.tag": "#studioLingue",
      "introduction.fst.story": "“Ho studiato tanto inglese e sono anche andata all’estero... ma senza occasioni per usarlo, lo sto dimenticando. Vorrei poterlo usare nella vita di tutti i giorni 😢”",

      "introduction.snd.name": "Sophie",
      "introduction.snd.location": "Suwon, Corea",
      "introduction.snd.tag": "#fareAmiciLocali",
      "introduction.snd.story": "“Sono in Corea da 6 mesi, ma sto ancora con persone del mio paese. Vorrei davvero fare amicizia con coreani, ma non so da dove iniziare.”",

      "introduction.trd.name": "Carlos",
      "introduction.trd.location": "Jeonju, Corea",
      "introduction.trd.tag": "#infoVitaLocale",
      "introduction.trd.story": "“Anche su YouTube o nelle community non trovo info del mio quartiere. Banca, operatore mobile, ospedale... dove trovo informazioni corrette e aggiornate per stabilirmi?”",
      
      // App Menu Section
      "appMenu.home.local.title": "home",
      "appMenu.home.local.subtitle": "Rendi il tuo quartiere un hub globale",
      "appMenu.home.local.description": "Condividi ciò che conosci del quartiere per aiutare i vicini stranieri e creare una vera comunità globale.",
      "appMenu.home.local.points": [
        "Presenta ristoranti nascosti, cliniche e servizi utili agli stranieri",
        "Condividi notizie di zona ed eventi in tempo reale",
        "Aumenta l’indice globale e guida l’internazionalizzazione del quartiere"
      ],
      "appMenu.home.local.tip": "Una piccola informazione per te può essere una guida preziosa per qualcuno.",

      "appMenu.home.global.title": "home",
      "appMenu.home.global.subtitle": "Dashboard su misura per vivere in Corea",
      "appMenu.home.global.description": "Dal meteo ai post popolari del quartiere: tutto ciò che serve in un’unica schermata.",
      "appMenu.home.global.points": [
        "Organizza la giornata con meteo e consigli per l’uscita",
        "Controlla per prime notizie locali e richieste di aiuto",
        "Non perdere le storie global più popolari tra i coreani"
      ],
      "appMenu.home.global.tip": "Con 5 minuti al giorno, la vita in Corea diventa molto più semplice.",

      "appMenu.mingl.local.title": "mingl",
      "appMenu.mingl.local.subtitle": "Parla con amici globali",
      "appMenu.mingl.local.description": "Rispondi alle domande degli stranieri, impara le lingue e condividi la cultura.",
      "appMenu.mingl.local.points": [
        "Condividi consigli sulla vita in Corea e prova soddisfazione",
        "Migliora la lingua in modo naturale",
        "Fai amicizia con persone di culture diverse"
      ],
      "appMenu.mingl.local.tip": "Rispondi, impara le lingue e condividi la cultura insieme.",

      "appMenu.mingl.global.title": "mingl",
      "appMenu.mingl.global.subtitle": "Comunica naturalmente con i coreani",
      "appMenu.mingl.global.description": "Con la traduzione in tempo reale, fai domande sulla vita in Corea e trova amici locali senza preoccuparti della lingua.",
      "appMenu.mingl.global.points": [
        "Risolvi in tempo reale i dubbi sulla vita in Corea",
        "Conversazioni naturali grazie alla traduzione AI",
        "Esci dal ghetto dei soli connazionali e fai veri amici coreani"
      ],
      "appMenu.mingl.global.tip": "Impara la cultura coreana integrandoti naturalmente nella comunità locale.",

      "appMenu.connect.local.title": "connect",
      "appMenu.connect.local.subtitle": "Aiuta i vicini stranieri e fai amicizia",
      "appMenu.connect.local.description": "Risolvi problemi pratici degli stranieri nel quartiere e costruisci una rete globale.",
      "appMenu.connect.local.points": [
        "Supporto pratico per banca, casa, documenti",
        "Crea relazioni globali aiutando naturalmente",
        "Ruolo significativo come ambasciatore globale del quartiere"
      ],
      "appMenu.connect.local.tip": "Inizia da un piccolo aiuto e costruisci vere amicizie globali.",

      "appMenu.connect.global.title": "connect",
      "appMenu.connect.global.subtitle": "Risolvi problemi con i vicini coreani",
      "appMenu.connect.global.description": "Per banca, casa, visti e problemi urgenti, risolvi insieme a persone locali affidabili.",
      "appMenu.connect.global.points": [
        "Risolvi questioni pratiche come conto e casa",
        "Chiedi aiuto in modo informale, senza agenzie",
        "Esci dal ghetto degli stranieri e adattati davvero alla vita locale"
      ],
      "appMenu.connect.global.tip": "Più è urgente, più l’aiuto dei vicini è rapido e sicuro.",

      "appMenu.talk.local.title": "talk",
      "appMenu.talk.local.subtitle": "Chatta in tempo reale con i vicini stranieri",
      "appMenu.talk.local.description": "Con la traduzione AI, chatta 1:1 senza barriere linguistiche e diventa un vero amico globale.",
      "appMenu.talk.local.points": [
        "Conversazioni naturali con traduzione in tempo reale",
        "Trasforma le connessioni nate in Connect in amicizie durature",
        "Ascolta i problemi di vita in Corea e dai consigli diretti"
      ],
      "appMenu.talk.local.tip": "Una piccola conversazione può diventare una rete globale per la vita.",

      "appMenu.talk.global.title": "talk",
      "appMenu.talk.global.subtitle": "Comunica comodamente con i coreani",
      "appMenu.talk.global.description": "Chatta in tempo reale con i vicini coreani e risolvi subito i dubbi, senza barriere linguistiche.",
      "appMenu.talk.global.points": [
        "Chiedi direttamente ai coreani e ottieni risposte immediate",
        "Conversazioni naturali anche senza conoscere il coreano",
        "Diventa un vero amico con i vicini conosciuti su Connect"
      ],
      "appMenu.talk.global.tip": "Inizia dalle piccole domande e trova un solido alleato per la vita in Corea.",

      "appMenu.passport.local.title": "passport",
      "appMenu.passport.local.subtitle": "Crea la tua storia globale",
      "appMenu.passport.local.description": "Registra attività ed esperienze con amici globali e costruisci un’identità globale anche senza passaporto.",
      "appMenu.passport.local.points": [
        "Visualizza la timeline delle attività globali nel quartiere",
        "Costruisci un portfolio da ambasciatore globale con le tue azioni di aiuto",
        "Gestisci lingue ed esperienze di scambio culturale in modo sistematico"
      ],
      "appMenu.passport.local.tip": "Anche un piccolo aiuto completa la tua storia del viaggio globale.",

      "appMenu.passport.global.title": "passport",
      "appMenu.passport.global.subtitle": "Identità globale - Biglietto da visita digitale",
      "appMenu.passport.global.description": "Mostra visivamente esperienze e percorso multinazionale e crea un profilo affidabile.",
      "appMenu.passport.global.points": [
        "Visualizza a colpo d’occhio residenze ed esperienze globali",
        "Costruisci credibilità con competenze linguistiche e background culturale",
        "Connettiti naturalmente con persone dalle esperienze simili"
      ],
      "appMenu.passport.global.tip": "Più il profilo è dettagliato, migliori sono il supporto locale e le vere amicizie.",

      // Demo Section
      "common.viewAll": "Vedi tutto",
      "common.minutesAgo": "min fa",

      "home.tag": "Mercatino",
      "home.greeting_01": "Carlos",
      "home.greeting_02": "Buona giornata",
      
      "home.weather.maxTemp": "Max 15°",
      "home.weather.minTemp": "Min 10°",

      "home.weather.morning": "☀️",
      "home.weather.morningWeather": "Sereno",
      "home.weather.afternoon": "🌘",
      "home.weather.afternoonWeather": "Nuvoloso",
      "home.weather.fineDust": "💨",
      "home.weather.fineDustLevel": "Normale",

      "home.mytown.title": "Quartiere in tempo reale",
      "home.mytown.places.0.name": "은행나무시장",
      "home.mytown.places.0.address": "금천구 시흥동",
      "home.mytown.places.1.name": "관악산",
      "home.mytown.places.1.address": "관악구 신림동",
      "home.mytown.places.2.name": "안양천다목적광장",
      "home.mytown.places.2.address": "금천구 독선동",

      "home.events.title": "Eventi nel quartiere",
      "home.events.post_title": "Fleamarket a Doksan-dong",
      "home.events.address": "금천구 독산동",

      "mingl.posts.0.category": "Info pratiche",
      "mingl.posts.0.title": "Dov’è il carretto di sundae alla stazione del municipio di Geumcheon?",
      "mingl.posts.0.content": "Era il mio sundae preferito, ma non lo vedo più. Qualcuno sa dove sia?",

      "mingl.posts.1.category": "Info pratiche",
      "mingl.posts.1.title": "Consigli per fare spesa al mercato tradizionale di Doksan-dong",
      "mingl.posts.1.content": "Faccio spesso spesa lì: i prezzi cambiano secondo i giorni. Suggerimenti per risparmiare?",

      "mingl.posts.2.category": "Quotidiano",
      "mingl.posts.2.title": "Pranzo vicino al distretto digitale di Gasan?",
      "mingl.posts.2.content": "Oggi scegliere è difficile. Che cosa mangiano gli impiegati vicino a Gasan?",

      "mingl.posts.3.category": "Hobby/ritrovi",
      "mingl.posts.3.title": "Gruppo giochi da tavolo a Gasan — cerchiamo persone",
      "mingl.posts.3.content": "Ogni venerdì sera vicino alla stazione di Gasan. Chi vuole unirsi?",

      "mingl.posts.4.category": "Viaggi/Uscite",
      "mingl.posts.4.title": "Percorso leggero per il weekend a Hoamsan",
      "mingl.posts.4.content": "Ho trovato un giro facile tipo passeggiata. Condivido il percorso consigliato!",

      "mingl.posts.5.category": "Quotidiano",
      "mingl.posts.5.title": "Caffè tranquillo vicino a Doksan-dong?",
      "mingl.posts.5.content": "Cerco un posto silenzioso per lavorare: buon Wi-Fi e prese. Suggerimenti?",

      "mingl.posts.6.category": "Info pratiche",
      "mingl.posts.6.title": "Palestra consigliata vicino a Gasan-dong",
      "mingl.posts.6.content": "Qualcuno frequenta in zona Gasan Digital Complex? Quote mensili o strutture valide?",

      "mingl.posts.7.category": "Hobby/ritrovi",
      "mingl.posts.7.title": "Andiamo insieme sul Mt. Gwanak",
      "mingl.posts.7.content": "Vado questo weekend. Principianti benvenuti: passeggiata tranquilla.",

      "connect.titles.0": "Lingua",
      "connect.titles.1": "Vita",
      "connect.titles.2": "Usato",
      "connect.titles.3": "Lavoro",
      "connect.titles.3.category": "Extra",

      "connect.posts.0.title": "Scambio coreano-giapponese per conversazione business!",
      "connect.posts.0.reward": "Giapponese",
      "connect.posts.0.reward_detail": "Orari da concordare",
      "connect.posts.0.location": "Caffè a Seongbuk-dong",

      "connect.posts.1.title": "Cerco madrelingua spagnolo! Aiuto per conversazione~",
      "connect.posts.1.reward": "Buono regalo",
      "connect.posts.1.reward_detail": "50.000₩ / volta",
      "connect.posts.1.location": "Staz. Municipio di Geumcheon",

      "connect.posts.2.title": "Guida metro Incheon Aeroporto → Stazione Mapo, per favore",
      "connect.posts.2.reward": "Oggetto",
      "connect.posts.2.reward_detail": "Vino spagnolo",
      "connect.posts.2.location": "Aeroporto di Incheon",

      "connect.posts.3.title": "Qualcuno mi accompagna per il contratto di monolocale?",
      "connect.posts.3.reward": "Contanti",
      "connect.posts.3.reward_detail": "10.000₩ / ora",
      "connect.posts.3.location": "Seul Yeongdeungpo - Yangcheon",

      "connect.posts.4.title": "Presto il ‘monkey driver’ per un giorno! Offro kkakdugi fatto in casa",
      "connect.posts.4.reward": "Oggetto",
      "connect.posts.4.reward_detail": "Kkakdugi fatto in casa",
      "connect.posts.4.location": "Mapo-gu Seogyo-dong",

      "connect.posts.5.title": "Vendo bici! Poco usata",
      "connect.posts.5.reward": "Prezzo",
      "connect.posts.5.reward_detail": "50.000₩",
      "connect.posts.5.location": "Vicino a Staz. Sinchon",

      "connect.posts.6.title": "Cerchiamo staff temporaneo per fiera. Inglese preferito",
      "connect.posts.6.reward": "Lavoro",
      "connect.posts.6.reward_detail": "Supporto in fiera e guida in inglese",
      "connect.posts.6.location": "COEX",

      "connect.posts.7.title": "Cerco barista che parli spagnolo (priorità a madrelingua)",
      "connect.posts.7.reward": "Paga oraria",
      "connect.posts.7.reward_detail": "Da 10.000₩",
      "connect.posts.7.location": "Caffè a Itaewon",

      "passport.introduction": "Ho iniziato a studiare coreano guardando i varietà coreani e, dopo aver vinto un contest di lingua coreana in Messico, ho deciso di venire in Corea!",
      "passport.gender": "Sesso",
      "passport.gender_detail": "Maschio",
      "passport.birth": "Data di nascita",
      "passport.birth_detail": "1994.04.24",
      "passport.nationality": "Nazionalità",
      "passport.nationality_detail": "Messico",
      "passport.mother_tongue": "Lingua madre",
      "passport.mother_tongue_detail": "Spagnolo",
      "passport.language": "Lingue straniere",
      "passport.language_detail.0": "Coreano",
      "passport.language_detail.1": "Inglese",
      "passport.edit": "Modifica",
      "passport.share": "Condividi",

      // Positioned Mobile Demo Section (it)
      "positionedMobileDemo.home.description": "Come le ‘notizie del quartiere’ — controlla tutto ciò che accade intorno a te in un attimo",
      "positionedMobileDemo.home.features.0.description": "Non perdere notizie ed eventi locali in tempo reale",
      "positionedMobileDemo.home.features.1.description": "Esplora le storie quotidiane dei residenti intorno a luoghi specifici",
      "positionedMobileDemo.home.features.2.description": "Partecipa facilmente a festival, incontri e attività grandi o piccole nella tua zona",

      "positionedMobileDemo.mingl.description": "Scopri e condividi la vita reale del quartiere basata sul luogo",
      "positionedMobileDemo.mingl.features.0.description": "Condividi liberamente domande, informazioni, notizie e consigli — comunicazione naturale",
      "positionedMobileDemo.mingl.features.1.description": "Traduzione in tempo reale per una comunicazione globale senza barriere linguistiche",
      "positionedMobileDemo.mingl.features.2.description": "Il mondo visto dagli occhi dei locali, e il locale visto dagli occhi del globale",

      "positionedMobileDemo.connect.description": "I momenti di aiuto reciproco creano connessioni",
      "positionedMobileDemo.connect.features.0.description": "Trova o offri aiuto rapidamente grazie al matching basato sulla posizione",
      "positionedMobileDemo.connect.features.1.description": "Scegli tu stesso una persona ‘affidabile e sicura’",
      "positionedMobileDemo.connect.features.2.description": "Conversazione → Scambio → Relazioni locali e globali durature",

      "positionedMobileDemo.talk.description": "Fai amicizia con persone da tutto il mondo senza preoccuparti della lingua grazie all’AI",
      "positionedMobileDemo.talk.features.0.description": "Conversazioni naturali indipendentemente dal livello linguistico grazie alla traduzione istantanea",
      "positionedMobileDemo.talk.features.1.description": "Chiedi direttamente ai locali informazioni sulla vita in Corea e ottieni risposte immediate",
      "positionedMobileDemo.talk.features.2.description": "Trasforma una connessione nata su Connect in un’amicizia duratura",

      "positionedMobileDemo.passport.description": "Crea un biglietto da visita digitale con la tua esperienza globale",
      "positionedMobileDemo.passport.features.0.description": "Registra la tua storia di residenza e attività per area in una timeline",
      "positionedMobileDemo.passport.features.1.description": "Mostra chiaramente le tue abilità linguistiche e il tuo stile comunicativo",
      "positionedMobileDemo.passport.features.2.description": "Connettiti naturalmente con persone che hanno esperienze simili",


      // Logl Video Section
      "loglVideo.title": "Video di presentazione di logl",
      "loglVideo.description": "Che cos’è logl? Guarda prima il video!",
      "loglVideo.watch": "Guarda il video"    
    }
  },
  de: {
    translation: {
    // Header Section
    "header.intro": "Intro",
    "header.demo": "Demo",
    "header.video": "logl-Video",

    // Hero Section
    "hero.title": "Lass uns Sprachbarrieren abbauen",
    "hero.description": "find your",
    "hero.demo": "Demo testen",
    "hero.prop1": "Verifizierte lokale Services",
    "hero.prop2": "Echtzeit-KI-Übersetzung",
    "hero.prop3": "Vielfältige lokale Communities",

    // Introduction Section
    "introduction.title": "Kennst du diese Sorgen?",
    "introduction.fst.role": "lokal",
    "introduction.snd.role": "global",

    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Seoul, Südkorea",
    "introduction.fst.tag": "#FremdspracheLernen",
    "introduction.fst.story": "„Ich habe so viel Englisch gelernt, war sogar im Ausland… aber ohne es im Alltag zu nutzen, vergesse ich alles. Ich wünschte, ich hätte mehr Gelegenheiten im Alltag 😢“",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Südkorea",
    "introduction.snd.tag": "#FreundeVorOrt",
    "introduction.snd.story": "„Ich bin seit 6 Monaten in Korea und verbringe meine Zeit immer noch nur mit Leuten aus meinem Land. Ich möchte echte koreanische Freundschaften, weiß aber nicht, wie ich anfangen soll.“",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Südkorea",
    "introduction.trd.tag": "#LokaleAlltagsinfos",
    "introduction.trd.story": "„Auf YouTube und in Communities finde ich nichts Konkretes zu meinem Viertel. Bankkonto, Mobilfunk, Krankenhaus… Wo bekomme ich verlässliche, aktuelle Infos für den Start?“",
    
    // App Menu Section
    "appMenu.home.local.title": "Start",
    "appMenu.home.local.subtitle": "Mach dein Viertel zum globalen Hub",
    "appMenu.home.local.description": "Teile dein Wissen über dein Viertel, hilf ausländischen Nachbarn und baue eine echte globale Community auf.",
    "appMenu.home.local.points": [
      "Geheime Restaurants, Kliniken und Nützliches für Ausländer vorstellen",
      "News und Events aus dem Viertel in Echtzeit teilen",
      "Internationalisierung deines Viertels vorantreiben"
    ],
    "appMenu.home.local.tip": "Deine kleine Info kann für jemanden ein wertvoller Lebensleitfaden sein.",

    "appMenu.home.global.title": "Start",
    "appMenu.home.global.subtitle": "Dein Dashboard für das Leben in Korea",
    "appMenu.home.global.description": "Vom Wetter bis zu beliebten Posts aus dem Viertel – alles auf einem Screen.",
    "appMenu.home.global.points": [
      "Tag mit Wetter & Tipps planen",
      "Lokale Updates & Hilfegesuche zuerst sehen",
      "Beliebte globale Stories unter Koreanern nicht verpassen"
    ],
    "appMenu.home.global.tip": "Nur 5 Minuten täglich machen den Alltag in Korea viel einfacher.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Mit globalen Freunden sprechen",
    "appMenu.mingl.local.description": "Beantworte Fragen, lerne Sprache und teile Kultur – ganz natürlich.",
    "appMenu.mingl.local.points": [
      "Alltagstipps für das Leben in Korea teilen",
      "Sprachkenntnisse natürlich verbessern",
      "Freunde aus vielen Kulturen finden"
    ],
    "appMenu.mingl.local.tip": "Eine Unterhaltung kann eine neue Welt öffnen.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Natürlich mit Koreanern kommunizieren",
    "appMenu.mingl.global.description": "Mit Echtzeit-Übersetzung ohne Sprachdruck fragen und Freunde finden.",
    "appMenu.mingl.global.points": [
      "Alltagsfragen in Korea sofort klären",
      "Natürliche Gespräche dank KI-Übersetzung",
      "Aus dem Ausländer-Ghetto raus, echte koreanische Freunde finden"
    ],
    "appMenu.mingl.global.tip": "Kultur lernt man im Gespräch – mitten in der Community.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Nachbarn helfen & Freunde werden",
    "appMenu.connect.local.description": "Löse echte Alltagsprobleme von Ausländern im Viertel und baue ein globales Netzwerk.",
    "appMenu.connect.local.points": [
      "Praktische Hilfe bei Bank, Wohnung, Dokumenten",
      "Durch Hilfe entstehen natürliche Beziehungen",
      "Werde globaler Botschafter deines Viertels"
    ],
    "appMenu.connect.local.tip": "Kleine Hilfe – echte Freundschaft.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Probleme mit lokalen Nachbarn lösen",
    "appMenu.connect.global.description": "Bank, Wohnung, Visum & Co. – gemeinsam mit verlässlichen Locals.",
    "appMenu.connect.global.points": [
      "Konkrete Aufgaben wie Kontoeröffnung, Wohnungssuche",
      "Ohne Agentur – locker die Nachbarn fragen",
      "Raus aus dem Ghetto, rein in den echten Alltag"
    ],
    "appMenu.connect.global.tip": "Bei Dringendem hilft der Nachbar am schnellsten und sichersten.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Echtzeit-Chat mit ausländischen Nachbarn",
    "appMenu.talk.local.description": "1:1 mit KI-Übersetzung – ohne Sprachbarriere zu echten globalen Freunden.",
    "appMenu.talk.local.points": [
      "Natürliche Gespräche mit Live-Übersetzung",
      "Verbindungen aus Connect zu Freundschaften ausbauen",
      "Sorgen im Korea-Alltag anhören & beraten"
    ],
    "appMenu.talk.local.tip": "Kleine Gespräche schaffen lebenslange Netzwerke.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Locker mit Koreanern chatten",
    "appMenu.talk.global.description": "Ohne Sprachbarriere in Echtzeit chatten und Fragen sofort klären.",
    "appMenu.talk.global.points": [
      "Direkt Koreaner fragen und sofort Antworten erhalten",
      "Auch ohne Koreanisch natürlich plaudern",
      "Kontakt aus Connect pflegen – zu echten Freunden werden"
    ],
    "appMenu.talk.global.tip": "Mit kleinen Fragen anfangen, starke Alltagshelfer finden.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Deine globale Story bauen",
    "appMenu.passport.local.description": "Aktivitäten & Erfahrungen festhalten, globale Identität formen – ganz ohne Pass.",
    "appMenu.passport.local.points": [
      "Timeline deiner globalen Aktivitäten im Viertel",
      "Portfolio als globaler Botschafter aufbauen",
      "Sprachen & Kulturaustausch systematisch managen"
    ],
    "appMenu.passport.local.tip": "Auch kleine Hilfen vollenden deine Reisegeschichte.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Globale Identität – Digitale Visitenkarte",
    "appMenu.passport.global.description": "Zeige deinen multinationalen Weg visuell und erstelle ein vertrauenswürdiges Profil.",
    "appMenu.passport.global.points": [
      "Wohnorte & globale Erfahrungen auf einen Blick",
      "Glaubwürdigkeit durch Sprache & Kulturhintergrund",
      "Natürlich mit ähnlich Erfahrenen verbinden"
    ],
    "appMenu.passport.global.tip": "Je detaillierter das Profil, desto besser Support & Freundschaften.",

    // Demo Section
    "common.viewAll": "Alle ansehen",
    "common.minutesAgo": "Min. her",

    "home.tag": "Flohmarkt",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Hab einen schönen Tag",
    
    "home.weather.maxTemp": "Max 15°",
    "home.weather.minTemp": "Min 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Heiter",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Bewölkt",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Mittel",

    "home.mytown.title": "Viertel in Echtzeit",
    "home.mytown.places.0.name": "은행나무시장",
    "home.mytown.places.0.address": "금천구 시흥동",
    "home.mytown.places.1.name": "관악산",
    "home.mytown.places.1.address": "관악구 신림동",
    "home.mytown.places.2.name": "안양천다목적광장",
    "home.mytown.places.2.address": "금천구 독선동",

    "home.events.title": "Events im Viertel",
    "home.events.post_title": "Flohmarkt in Doksan-dong",
    "home.events.address": "금천구 독산동",

    "mingl.posts.0.category": "Alltagsinfo",
    "mingl.posts.0.title": "Wo ist der Sundae-Wagen an der Station Geumcheon-gucheong?",
    "mingl.posts.0.content": "War der beste Sundae! Habe ihn lange nicht gesehen – weiß jemand, wo er ist?",

    "mingl.posts.1.category": "Alltagsinfo",
    "mingl.posts.1.title": "Einkaufstipps am Traditionsmarkt Doksan-dong",
    "mingl.posts.1.content": "Ich kaufe oft dort ein; die Preise schwanken je nach Tag. Tipps fürs Sparen?",

    "mingl.posts.2.category": "Alltag",
    "mingl.posts.2.title": "Mittag beim Gasan Digital Complex – Empfehlungen?",
    "mingl.posts.2.content": "Heute schwer zu entscheiden. Was essen Angestellte rund um Gasan?",

    "mingl.posts.3.category": "Hobby/Treff",
    "mingl.posts.3.title": "Brettspiel-Gruppe an Bahnhof Gasan – Mitspieler gesucht",
    "mingl.posts.3.content": "Jeden Freitagabend nahe Station Gasan. Wer macht mit?",

    "mingl.posts.4.category": "Ausflug",
    "mingl.posts.4.title": "Leichte Wochenendroute am Hoamsan",
    "mingl.posts.4.content": "Eine entspannte Spazierroute gefunden – hier meine Empfehlung!",

    "mingl.posts.5.category": "Alltag",
    "mingl.posts.5.title": "Ruhiges Café nahe Doksan-dong gesucht",
    "mingl.posts.5.content": "Zum Arbeiten, gutes WLAN & Steckdosen – Empfehlungen?",

    "mingl.posts.6.category": "Alltagsinfo",
    "mingl.posts.6.title": "Fitnessstudio nahe Gasan-dong – Tipps?",
    "mingl.posts.6.content": "Jemand im Gasan Digital Complex? Beiträge/Anlagen empfehlenswert?",

    "mingl.posts.7.category": "Hobby/Treff",
    "mingl.posts.7.title": "Gemeinsam auf den Berg Gwanak",
    "mingl.posts.7.content": "Dieses Wochenende. Anfänger willkommen, gemütliches Tempo.",

    // Connect Titles (≤ 6 chars)
    "connect.titles.0": "Spr.",
    "connect.titles.1": "Alltag",
    "connect.titles.2": "2.Hand",
    "connect.titles.3": "Jobs",
    "connect.titles.3.category": "Minij.",

    "connect.posts.0.title": "Koreanisch–Japanisch Business-Gespräch: Sprachtausch gesucht!",
    "connect.posts.0.reward": "Japanisch",
    "connect.posts.0.reward_detail": "Zeit nach Absprache",
    "connect.posts.0.location": "Café in Seongbuk-dong",

    "connect.posts.1.title": "Suche Spanisch-Muttersprachler! Bitte Gespräch üben~",
    "connect.posts.1.reward": "Gutschein",
    "connect.posts.1.reward_detail": "50.000₩ / Termin",
    "connect.posts.1.location": "Station Geumcheon-gucheong",

    "connect.posts.2.title": "Bitte Metro-Guide Incheon Airport → Mapo Station",
    "connect.posts.2.reward": "Sachleistung",
    "connect.posts.2.reward_detail": "Spanischer Wein",
    "connect.posts.2.location": "Flughafen Incheon",

    "connect.posts.3.title": "Begleitung zum Ein-Zimmer-Mietvertrag gesucht",
    "connect.posts.3.reward": "Bar",
    "connect.posts.3.reward_detail": "10.000₩ / Std.",
    "connect.posts.3.location": "Seoul Yeongdeungpo / Yangcheon",

    "connect.posts.4.title": "„Monkey Driver“ für 1 Tag leihen? Gebe selbstgemachtes Kkakdugi",
    "connect.posts.4.reward": "Sachleistung",
    "connect.posts.4.reward_detail": "Hausgemachtes Kkakdugi",
    "connect.posts.4.location": "Mapo-gu Seogyo-dong",

    "connect.posts.5.title": "Fahrrad zu verkaufen! Wenig genutzt",
    "connect.posts.5.reward": "Preis",
    "connect.posts.5.reward_detail": "50.000₩",
    "connect.posts.5.location": "Nähe Bahnhof Sinchon",

    "connect.posts.6.title": "Kurzzeit-Job auf Messe – Englisch bevorzugt",
    "connect.posts.6.reward": "Aufgabe",
    "connect.posts.6.reward_detail": "Support vor Ort & englische Guidance",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "Barista mit Spanisch gesucht (Muttersprachler bevorzugt)",
    "connect.posts.7.reward": "Std.-Lohn",
    "connect.posts.7.reward_detail": "ab 10.000₩",
    "connect.posts.7.location": "Café in Itaewon",

    "passport.introduction": "Ich begann mit Koreanisch durch TV-Shows. Nach dem Gewinn eines Koreanisch-Wettbewerbs in Mexiko beschloss ich, nach Korea zu kommen!",
    "passport.gender": "Geschlecht",
    "passport.gender_detail": "Männlich",
    "passport.birth": "Geburtsdatum",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Staatsangehörigkeit",
    "passport.nationality_detail": "Mexiko",
    "passport.mother_tongue": "Muttersprache",
    "passport.mother_tongue_detail": "Spanisch",
    "passport.language": "Fremdsprachen",
    "passport.language_detail.0": "Koreanisch",
    "passport.language_detail.1": "Englisch",
    "passport.edit": "Bearbeiten",
    "passport.share": "Teilen",

    // Positioned Mobile Demo Section (de)
    "positionedMobileDemo.home.description": "Wie ‘Nachrichten aus der Nachbarschaft’ — sieh auf einen Blick, was in deiner Umgebung passiert",
    "positionedMobileDemo.home.features.0.description": "Verpasse keine lokalen Nachrichten und Veranstaltungen in Echtzeit",
    "positionedMobileDemo.home.features.1.description": "Entdecke Alltagsgeschichten der Bewohner rund um bestimmte Orte",
    "positionedMobileDemo.home.features.2.description": "Nimm mühelos an Festen, Treffen und großen sowie kleinen Aktivitäten teil",

    "positionedMobileDemo.mingl.description": "Entdecke und teile echtes Nachbarschaftsleben basierend auf dem Standort",
    "positionedMobileDemo.mingl.features.0.description": "Teile Fragen, Infos, News und Empfehlungen frei — natürliche Kommunikation",
    "positionedMobileDemo.mingl.features.1.description": "Echtzeit-Übersetzung für globale Kommunikation ohne Sprachbarrieren",
    "positionedMobileDemo.mingl.features.2.description": "Die Welt aus der Sicht der Locals, und die Locals aus der Sicht der Welt",

    "positionedMobileDemo.connect.description": "Momente der Unterstützung schaffen Verbindungen",
    "positionedMobileDemo.connect.features.0.description": "Finde oder erhalte Hilfe schnell über ortsbasiertes Matching",
    "positionedMobileDemo.connect.features.1.description": "Wähle selbst eine Person, die ‘vertrauenswürdig und sicher’ ist",
    "positionedMobileDemo.connect.features.2.description": "Gespräch → Austausch → Langfristige lokale und globale Beziehungen",

    "positionedMobileDemo.talk.description": "Triff internationale Freunde ohne Sprachangst dank AI-Übersetzung",
    "positionedMobileDemo.talk.features.0.description": "Natürliche Gespräche unabhängig vom Sprachniveau durch Echtzeit-Übersetzung",
    "positionedMobileDemo.talk.features.1.description": "Stelle Fragen zum Leben in Korea direkt an Einheimische und erhalte sofort Antworten",
    "positionedMobileDemo.talk.features.2.description": "Entwickle eine Connect-Bekanntschaft zu einer dauerhaften Freundschaft",

    "positionedMobileDemo.passport.description": "Erstelle eine digitale Visitenkarte mit deiner globalen Erfahrung",
    "positionedMobileDemo.passport.features.0.description": "Dokumentiere Wohnorte und Aktivitäten nach Regionen in einer Timeline",
    "positionedMobileDemo.passport.features.1.description": "Zeige Sprachfähigkeiten und Kommunikationsstil klar und verständlich",
    "positionedMobileDemo.passport.features.2.description": "Verbinde dich natürlich mit Menschen mit ähnlichen Erfahrungen",


    // Logl Video Section
    "loglVideo.title": "logl-Vorstellungsvideo",
    "loglVideo.description": "Was ist logl? Schau dir zuerst das Video an!",
    "loglVideo.watch": "Video ansehen"

    }
  },
  tr: {
    translation: {
    // Header Section
    "header.intro": "Giriş",
    "header.demo": "Demo",
    "header.video": "logl videosu",

    // Hero Section
    "hero.title": "Dil engellerini birlikte kaldıralım",
    "hero.description": "find your",
    "hero.demo": "Demoyu dene",
    "hero.prop1": "Doğrulanmış yerel hizmetler",
    "hero.prop2": "Gerçek zamanlı AI çeviri",
    "hero.prop3": "Çeşitli yerel topluluklar",

    // Introduction Section
    "introduction.title": "Bu sorunları yaşadın mı?",
    "introduction.fst.role": "yerel",
    "introduction.snd.role": "global",

    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Seul, Kore",
    "introduction.fst.tag": "#dilÇalışıyorum",
    "introduction.fst.story": "“İngilizceyi çok çalıştım, yurtdışına da gittim... ama kullanamayınca unutuyorum. Günlük hayatta kullanmak istiyorum 😢”",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Kore",
    "introduction.snd.tag": "#yerelArkadaş",
    "introduction.snd.story": "“6 aydır Kore’deyim ama hâlâ sadece kendi ülkemden insanlarla takılıyorum. Koreli arkadaşlar edinmek istiyorum ama nereden başlayacağımı bilmiyorum.”",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Kore",
    "introduction.trd.tag": "#günlükYaşamBilgisi",
    "introduction.trd.story": "“YouTube’a bakıyorum, topluluklara giriyorum ama mahallemle ilgili bilgi yok. Banka, hat, hastane... Güncel ve doğru bilgi nerede?”",
    
    // App Menu Section
    "appMenu.home.local.title": "Ana sayfa",
    "appMenu.home.local.subtitle": "Mahalleni küresel bir merkeze dönüştür",
    "appMenu.home.local.description": "Mahalleni bildiğin kadar, yabancı komşular için bir rehbersin. Gerçek bir global topluluk kuralım.",
    "appMenu.home.local.points": [
      "Gizli restoranlar, klinikler ve faydalı yerleri tanıt",
      "Mahalle haberlerini ve etkinlikleri anlık paylaş",
      "Mahallenin küresel görünürlüğünü artır"
    ],
    "appMenu.home.local.tip": "Senin küçük bilgin, başkası için hayat rehberi olabilir.",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "Kore yaşamına özel kontrol paneli",
    "appMenu.home.global.description": "Hava durumu, popüler gönderiler, mahalle akışı — hepsi tek ekranda.",
    "appMenu.home.global.points": [
      "Hava ve ipuçlarıyla gününü planla",
      "Yerel haberleri ve yardım isteklerini önce gör",
      "Koreliler arasında popüler global hikâyeleri kaçırma"
    ],
    "appMenu.home.global.tip": "Günde 5 dakika bile Kore’de yaşamını kolaylaştırır.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Global arkadaşlarla sohbet et",
    "appMenu.mingl.local.description": "Soruları yanıtla, dil öğren, kültürü paylaş.",
    "appMenu.mingl.local.points": [
      "Kore’de yaşam tüyolarını paylaş",
      "Doğal şekilde dil pratiği yap",
      "Farklı kültürlerden arkadaş edin"
    ],
    "appMenu.mingl.local.tip": "Bir konuşma yeni bir dünya açar.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Korelilerle doğal iletişim",
    "appMenu.mingl.global.description": "Gerçek zamanlı çeviriyle dil derdi olmadan sor ve bağlantı kur.",
    "appMenu.mingl.global.points": [
      "Günlük yaşam sorularını anında çöz",
      "AI çeviriyle doğal sohbet",
      "Sadece hemşehri çevresine sıkışıp kalma"
    ],
    "appMenu.mingl.global.tip": "Kültürü konuşarak öğren, mahalleye karış.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Yardım et ve arkadaş ol",
    "appMenu.connect.local.description": "Mahallendeki yabancıların gerçek sorunlarına çözüm bul ve ağ kur.",
    "appMenu.connect.local.points": [
      "Banka, ev, evrak gibi pratik destek",
      "Yardım ettikçe dostluk doğar",
      "Mahallende global elçi ol"
    ],
    "appMenu.connect.local.tip": "Küçük yardımlar gerçek bağlar kurar.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Sorunlarını yerel komşularla çöz",
    "appMenu.connect.global.description": "Banka, ev, vize gibi acil konuları güvenilir yerellerle hallet.",
    "appMenu.connect.global.points": [
      "Hesap açma, ev bulma gibi somut işler",
      "Aracısız, komşudan samimi destek",
      "Gerçek yerel yaşama uyum sağla"
    ],
    "appMenu.connect.global.tip": "Acilde en hızlı ve kesin yardım komşudan gelir.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Gerçek zamanlı sohbet",
    "appMenu.talk.local.description": "AI çeviriyle 1:1 konuş ve kalıcı dostluklar kur.",
    "appMenu.talk.local.points": [
      "Dil engeli olmadan doğal diyalog",
      "Connect’ten doğan bağı dostluğa çevir",
      "Günlük sorunları dinle, destek ol"
    ],
    "appMenu.talk.local.tip": "Basit bir sohbet kalıcı bağ olabilir.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Korelilerle rahat konuş",
    "appMenu.talk.global.description": "Gerçek zamanlı sohbetle sorularına hemen yanıt bul.",
    "appMenu.talk.global.points": [
      "Bilgiyi doğrudan Korelilerden öğren",
      "Korece bilmesen de rahat konuş",
      "Connect’te tanıştığın komşuyla bağı büyüt"
    ],
    "appMenu.talk.global.tip": "Büyük dostluklar küçük sorularla başlar.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Küresel hikâyeni oluştur",
    "appMenu.passport.local.description": "Deneyimlerini kaydet, pasaportsuz da global kimlik oluştur.",
    "appMenu.passport.local.points": [
      "Mahalledeki global etkinliklerini zaman çizelgesinde gör",
      "Yardım kayıtlarınla elçi portföyü oluştur",
      "Dil ve kültür deneyimlerini düzenli yönet"
    ],
    "appMenu.passport.local.tip": "Küçük yardımlar da hikâyeyi tamamlar.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Küresel kimlik — Dijital kart",
    "appMenu.passport.global.description": "Çok uluslu yolculuğunu görsel ve güvenilir biçimde göster.",
    "appMenu.passport.global.points": [
      "İkamet ve global deneyimi tek bakışta göster",
      "Dil yetkinliği ve kültür geçmişiyle güven ver",
      "Benzer deneyimli insanlarla doğal bağ kur"
    ],
    "appMenu.passport.global.tip": "Detaylı profil daha iyi destek ve dost getirir.",

    // Demo Section
    "common.viewAll": "Tümünü gör",
    "common.minutesAgo": "dk önce",

    "home.tag": "Bit pazarı",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Güzel bir gün olsun",
    
    "home.weather.maxTemp": "En çok 15°",
    "home.weather.minTemp": "En az 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Açık",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Bulutlu",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Orta",

    "home.mytown.title": "Mahallemizde anlık",
    "home.mytown.places.0.name": "은행나무시장",
    "home.mytown.places.0.address": "금천구 시흥동",
    "home.mytown.places.1.name": "관악산",
    "home.mytown.places.1.address": "관악구 신림동",
    "home.mytown.places.2.name": "안양천다목적광장",
    "home.mytown.places.2.address": "금천구 독선동",

    "home.events.title": "Mahalle etkinlikleri",
    "home.events.post_title": "Doksan-dong’da fleamarket",
    "home.events.address": "금천구 독산동",

    "mingl.posts.0.category": "Günlük bilgi",
    "mingl.posts.0.title": "Geumcheon belediye istasyonundaki sundae arabası nerede?",
    "mingl.posts.0.content": "Hayatımın en iyi sundaesiydi; son zamanlarda yok. Nerede bilen var mı?",

    "mingl.posts.1.category": "Günlük bilgi",
    "mingl.posts.1.title": "Doksan geleneksel pazarda alışveriş tüyoları",
    "mingl.posts.1.content": "Sık alışveriş yapıyorum; güne göre fiyatlar değişiyor. En iyi yöntem nedir?",

    "mingl.posts.2.category": "Günlük",
    "mingl.posts.2.title": "Gasan Digital kompleksi civarında öğle ne yenir?",
    "mingl.posts.2.content": "Bugün karar vermek zor. Gasan çevresindeki çalışanlar ne yiyor?",

    "mingl.posts.3.category": "Hobi/Buluşma",
    "mingl.posts.3.title": "Gasan’da kutu oyunu ekibi — katılmak ister misin?",
    "mingl.posts.3.content": "Her cuma akşamı Gasan istasyonu yakınında buluşuyoruz. Katılımcı aranır.",

    "mingl.posts.4.category": "Gezi/Gezinti",
    "mingl.posts.4.title": "Hoamsan hafta sonu yürüyüş rotası önerisi",
    "mingl.posts.4.content": "Rahat yürüyüşlük bir rota buldum; öneri rotayı paylaşıyorum.",

    "mingl.posts.5.category": "Günlük",
    "mingl.posts.5.title": "Doksan-dong yakınında sessiz kafe önerir misiniz?",
    "mingl.posts.5.content": "Çalışmaya uygun, iyi Wi-Fi ve priz olan bir yer arıyorum. Öneri lütfen.",

    "mingl.posts.6.category": "Günlük bilgi",
    "mingl.posts.6.title": "Gasan-dong civarında spor salonu önerisi",
    "mingl.posts.6.content": "Gasan Digital Complex yakınında giden var mı? Ücret veya iyi tesis önerir misiniz?",

    "mingl.posts.7.category": "Hobi/Buluşma",
    "mingl.posts.7.title": "Gwanak Dağı’na birlikte gidelim",
    "mingl.posts.7.content": "Bu hafta sonu gidiyorum. Yeni başlayanlar hoş geldiniz; rahat tempo.",

    "connect.titles.0": "Dil",
    "connect.titles.1": "Yaşam",
    "connect.titles.2": "2.El",
    "connect.titles.3": "İş",
    "connect.titles.3.category": "Ek iş",

    "connect.posts.0.title": "Korece-Japonca iş konuşması için dil değişimi!",
    "connect.posts.0.reward": "Japonca",
    "connect.posts.0.reward_detail": "Süre birlikte belirlenir",
    "connect.posts.0.location": "Seongbuk-dong kafe",

    "connect.posts.1.title": "İspanyolca ana dili olan? Konuşma pratiğine yardım eder misin?",
    "connect.posts.1.reward": "Hediye çeki",
    "connect.posts.1.reward_detail": "50.000₩ / sefer",
    "connect.posts.1.location": "Geumcheon Belediyesi İstasyonu",

    "connect.posts.2.title": "İncheon Havalimanı → Mapo İstasyonu metro rehberi rica",
    "connect.posts.2.reward": "Eşya",
    "connect.posts.2.reward_detail": "İspanyol şarabı",
    "connect.posts.2.location": "İncheon Havalimanı",

    "connect.posts.3.title": "Stüdyo kontratı için birlikte gelebilir misin?",
    "connect.posts.3.reward": "Nakit",
    "connect.posts.3.reward_detail": "10.000₩ / saat",
    "connect.posts.3.location": "Seul Yeongdeungpo - Yangcheon",

    "connect.posts.4.title": "Monkey driver’ı 1 günlüğüne ödünç verir misin? Ev yapımı kkakdugi veririm",
    "connect.posts.4.reward": "Eşya",
    "connect.posts.4.reward_detail": "Ev yapımı kkakdugi",
    "connect.posts.4.location": "Mapo-gu Seogyo-dong",

    "connect.posts.5.title": "Bisiklet satıyorum! Az kullanıldı",
    "connect.posts.5.reward": "Fiyat",
    "connect.posts.5.reward_detail": "50.000₩",
    "connect.posts.5.location": "Sinchon İstasyonu civarı",

    "connect.posts.6.title": "Fuar için kısa dönemli eleman — İngilizce bilen tercih",
    "connect.posts.6.reward": "Görev",
    "connect.posts.6.reward_detail": "Saha desteği ve İngilizce yönlendirme",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "İspanyolca bilen barista aranıyor (ana dil tercih)",
    "connect.posts.7.reward": "Saatlik",
    "connect.posts.7.reward_detail": "10.000₩’dan",
    "connect.posts.7.location": "Itaewon kafe",

    "passport.introduction": "Kore eğlence programlarıyla Koreceye başladım. Meksika’daki Korece konuşma yarışmasını kazandıktan sonra Kore’ye gelmeye karar verdim!",
    "passport.gender": "Cinsiyet",
    "passport.gender_detail": "Erkek",
    "passport.birth": "Doğum tarihi",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Uyruk",
    "passport.nationality_detail": "Meksika",
    "passport.mother_tongue": "Ana dil",
    "passport.mother_tongue_detail": "İspanyolca",
    "passport.language": "Yabancı diller",
    "passport.language_detail.0": "Korece",
    "passport.language_detail.1": "İngilizce",
    "passport.edit": "Düzenle",
    "passport.share": "Paylaş",

    // Positioned Mobile Demo Section (tr)
    "positionedMobileDemo.home.description": "‘Mahalle haberleri’ gibi — çevrende neler olup bittiğini tek bakışta gör",
    "positionedMobileDemo.home.features.0.description": "Yerel haber ve etkinlikleri gerçek zamanlı takip et",
    "positionedMobileDemo.home.features.1.description": "Belirli yerler etrafındaki günlük yaşam hikayelerini keşfet",
    "positionedMobileDemo.home.features.2.description": "Festivallere, buluşmalara ve büyük-küçük topluluk etkinliklerine kolayca katıl",

    "positionedMobileDemo.mingl.description": "Konum bazlı gerçek mahalle yaşamını keşfet ve paylaş",
    "positionedMobileDemo.mingl.features.0.description": "Sorular, bilgiler, haberler ve önerileri özgürce paylaş — doğal etkileşim",
    "positionedMobileDemo.mingl.features.1.description": "Gerçek zamanlı çeviri ile dil bariyeri olmadan küresel iletişim",
    "positionedMobileDemo.mingl.features.2.description": "Dünyayı yerelin gözünden, yereli dünyanın gözünden gör",

    "positionedMobileDemo.connect.description": "Yardım anlarından bağlantılar doğar",
    "positionedMobileDemo.connect.features.0.description": "Konum bazlı eşleştirme ile gereken yardımı hemen bul veya sun",
    "positionedMobileDemo.connect.features.1.description": "‘Güvenilir ve güvenli’ kişiyi kendin seç",
    "positionedMobileDemo.connect.features.2.description": "Sohbet → Paylaşım → Uzun süreli yerel ve küresel ilişkiler",

    "positionedMobileDemo.talk.description": "AI çeviri ile dil kaygısı olmadan dünyanın her yerinden arkadaş edin",
    "positionedMobileDemo.talk.features.0.description": "Dil seviyenden bağımsız, gerçek zamanlı çeviri ile doğal sohbet",
    "positionedMobileDemo.talk.features.1.description": "Kore’deki yaşamı yerel insanlara doğrudan sorup hemen cevap al",
    "positionedMobileDemo.talk.features.2.description": "Connect ile başlayan bağı gerçek dostluğa dönüştür",

    "positionedMobileDemo.passport.description": "Küresel deneyimini yansıtan dijital kartını oluştur",
    "positionedMobileDemo.passport.features.0.description": "Bölgeler bazında yaşam ve aktivitelerini zaman çizelgesinde kaydet",
    "positionedMobileDemo.passport.features.1.description": "Dil becerilerini ve iletişim tarzını açıkça göster",
    "positionedMobileDemo.passport.features.2.description": "Benzer deneyime sahip insanlarla doğal bir şekilde bağ kur",


    // Logl Video Section
    "loglVideo.title": "logl Tanıtım Videosu",
    "loglVideo.description": "logl nedir? Önce videoyu izleyelim!",
    "loglVideo.watch": "Videoyu izle"
    }
  },
  el: {
    translation: {
    // Header Section
    "header.intro": "Εισαγωγή",
    "header.demo": "Demo",
    "header.video": "βίντεο logl",

    // Hero Section
    "hero.title": "Ας γκρεμίσουμε τα γλωσσικά εμπόδια",
    "hero.description": "find your",
    "hero.demo": "Δοκίμασε το demo",
    "hero.prop1": "Επαληθευμένες τοπικές υπηρεσίες",
    "hero.prop2": "Ζωντανή μετάφραση με AI",
    "hero.prop3": "Ποικίλες τοπικές κοινότητες",

    // Introduction Section
    "introduction.title": "Σου έχουν τύχει αυτά;",
    "introduction.fst.role": "local",
    "introduction.snd.role": "global",

    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Σεούλ, Κορέα",
    "introduction.fst.tag": "#μαθαίνωΓλώσσες",
    "introduction.fst.story": "«Διάβασα πολύ αγγλικά, πήγα και στο εξωτερικό… αλλά χωρίς ευκαιρίες στην καθημερινότητα, τα ξεχνάω. Μακάρι να είχα περισσότερη χρήση στη ζωή μου 😢»",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Σουόν, Κορέα",
    "introduction.snd.tag": "#ντόπιοιΦίλοι",
    "introduction.snd.story": "«Είμαι 6 μήνες στην Κορέα και ακόμα κάνω παρέα μόνο με συμπατριώτες. Θέλω πραγματικούς Κορεάτες φίλους, αλλά δεν ξέρω από πού να αρχίσω.»",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Τζεοντζού, Κορέα",
    "introduction.trd.tag": "#πληροφορίεςΚαθημερινότητας",
    "introduction.trd.story": "«Και στο YouTube και σε κοινότητες, δεν βρίσκω σωστές πληροφορίες για τη γειτονιά μου. Τράπεζα, πάροχος κινητής, νοσοκομείο… Πού βρίσκω αξιόπιστες και πρόσφατες πληροφορίες για το ξεκίνημα;»",
    
    // App Menu Section
    "appMenu.home.local.title": "αρχική",
    "appMenu.home.local.subtitle": "Κάνε τη γειτονιά σου global hub",
    "appMenu.home.local.description": "Μοιράσου ό,τι ξέρεις για τη γειτονιά, βοήθα γείτονες από το εξωτερικό και χτίσε αληθινή global κοινότητα.",
    "appMenu.home.local.points": [
      "Πρότεινε κρυφά στέκια, κλινικές και χρήσιμα σημεία",
      "Μοιράσου νέα & events της γειτονιάς σε πραγματικό χρόνο",
      "Οδήγησε τη διεθνοποίηση της περιοχής σου"
    ],
    "appMenu.home.local.tip": "Μια μικρή πληροφορία για σένα, μπορεί να είναι πολύτιμος οδηγός ζωής για κάποιον άλλον.",

    "appMenu.home.global.title": "αρχική",
    "appMenu.home.global.subtitle": "Προσωπικό ταμπλό για ζωή στην Κορέα",
    "appMenu.home.global.description": "Καιρός, νέα γειτονιάς & δημοφιλή posts — όλα σε μία οθόνη.",
    "appMenu.home.global.points": [
      "Οργάνωσε τη μέρα με καιρό & tips",
      "Δες πρώτα τοπικά updates & αιτήματα βοήθειας",
      "Μην χάνεις δημοφιλείς global ιστορίες μεταξύ Κορεατών"
    ],
    "appMenu.home.global.tip": "5 λεπτά τη μέρα κάνουν τη ζωή στην Κορέα πολύ πιο εύκολη.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Μίλα με global φίλους",
    "appMenu.mingl.local.description": "Απάντησε σε ερωτήσεις, μάθε γλώσσες και μοιράσου κουλτούρα.",
    "appMenu.mingl.local.points": [
      "Μοιράσου tips για την καθημερινότητα στην Κορέα",
      "Βελτίωσε φυσικά τη γλώσσα",
      "Κάνε φίλους από πολλές κουλτούρες"
    ],
    "appMenu.mingl.local.tip": "Μια συζήτηση ανοίγει έναν νέο κόσμο.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Επικοινώνησε φυσικά με Κορεάτες",
    "appMenu.mingl.global.description": "Με ζωντανή μετάφραση, ρώτα άνετα και βρες φίλους στη γειτονιά.",
    "appMenu.mingl.global.points": [
      "Λύσε άμεσα απορίες για την καθημερινότητα στην Κορέα",
      "Φυσικές συνομιλίες χάρη στην AI μετάφραση",
      "Βγες από το «γκέτο» συμπατριωτών, κάνε αληθινούς φίλους"
    ],
    "appMenu.mingl.global.tip": "Η κουλτούρα μαθαίνεται μέσα στην κοινότητα.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Βοήθα και γίνε φίλος",
    "appMenu.connect.local.description": "Λύσε πραγματικά ζητήματα ξένων στη γειτονιά και χτίσε global δίκτυο.",
    "appMenu.connect.local.points": [
      "Πρακτική στήριξη σε τράπεζα, σπίτι, έγγραφα",
      "Μέσα από τη βοήθεια γεννιούνται σχέσεις",
      "Γίνε global πρεσβευτής της περιοχής σου"
    ],
    "appMenu.connect.local.tip": "Μικρή βοήθεια — αληθινή φιλία.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Λύσε προβλήματα με ντόπιους γείτονες",
    "appMenu.connect.global.description": "Τράπεζα, σπίτι, βίζα — μαζί με αξιόπιστους locals.",
    "appMenu.connect.global.points": [
      "Συγκεκριμένα βήματα όπως άνοιγμα λογαριασμού, εύρεση σπιτιού",
      "Χωρίς μεσάζοντες — ρώτα χαλαρά τους γείτονες",
      "Αληθινή προσαρμογή στην τοπική ζωή"
    ],
    "appMenu.connect.global.tip": "Στα επείγοντα, ο γείτονας βοηθά πιο γρήγορα και σίγουρα.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Ζωντανό chat με ξένους γείτονες",
    "appMenu.talk.local.description": "1:1 με AI μετάφραση — χωρίς εμπόδια, με αληθινούς global φίλους.",
    "appMenu.talk.local.points": [
      "Φυσικές συζητήσεις με ζωντανή μετάφραση",
      "Σχέσεις από το Connect γίνονται φιλίες",
      "Άκου & στήριξε ζητήματα της ζωής στην Κορέα"
    ],
    "appMenu.talk.local.tip": "Μικρές συζητήσεις χτίζουν μεγάλα δίκτυα.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Μίλα άνετα με Κορεάτες",
    "appMenu.talk.global.description": "Chat σε πραγματικό χρόνο και λύσεις άμεσα — χωρίς γλωσσικά εμπόδια.",
    "appMenu.talk.global.points": [
      "Ρώτα απευθείας Κορεάτες και πάρε άμεσα απαντήσεις",
      "Φυσική κουβέντα ακόμη κι αν δεν ξέρεις κορεάτικα",
      "Μεγάλωσε τον δεσμό με τον γείτονα από το Connect"
    ],
    "appMenu.talk.global.tip": "Ξεκίνα από μικρές ερωτήσεις, βρες ισχυρό σύμμαχο.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Χτίσε την global ιστορία σου",
    "appMenu.passport.local.description": "Κατέγραψε δράσεις & εμπειρίες και διαμόρφωσε global ταυτότητα — χωρίς διαβατήριο.",
    "appMenu.passport.local.points": [
      "Timeline των global δράσεών σου στη γειτονιά",
      "Portfolio ως global πρεσβευτής μέσα από τη βοήθεια",
      "Οργάνωσε γλώσσες & διαπολιτισμικές εμπειρίες"
    ],
    "appMenu.passport.local.tip": "Κάθε μικρή βοήθεια συμπληρώνει την ιστορία σου.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Global ταυτότητα — Ψηφιακή κάρτα",
    "appMenu.passport.global.description": "Δείξε οπτικά την πολυεθνική σου πορεία και φτιάξε αξιόπιστο προφίλ.",
    "appMenu.passport.global.points": [
      "Κατοικίες & global εμπειρίες με μια ματιά",
      "Αξιοπιστία μέσω γλωσσών & πολιτισμικού υπόβαθρου",
      "Σύνδεση με άτομα με παρόμοιες εμπειρίες"
    ],
    "appMenu.passport.global.tip": "Όσο πιο λεπτομερές το προφίλ, τόσο καλύτερη η στήριξη & οι φιλίες.",

    // Demo Section
    "common.viewAll": "Προβολή όλων",
    "common.minutesAgo": "λεπ πριν",

    "home.tag": "παζάρι",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Καλή σου μέρα",
    
    "home.weather.maxTemp": "Μέγ. 15°",
    "home.weather.minTemp": "Ελάχ. 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Καθαρός",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Συννεφιά",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Μέτριο",

    "home.mytown.title": "Ζωντανά από τη γειτονιά",
    "home.mytown.places.0.name": "은행나무시장",
    "home.mytown.places.0.address": "금천구 시흥동",
    "home.mytown.places.1.name": "관악산",
    "home.mytown.places.1.address": "관악구 신림동",
    "home.mytown.places.2.name": "안양천다목적광장",
    "home.mytown.places.2.address": "금천구 독선동",

    "home.events.title": "Events στη γειτονιά",
    "home.events.post_title": "Fleamarket στο Doksan-dong",
    "home.events.address": "금천구 독산동",

    "mingl.posts.0.category": "Πληροφορίες",
    "mingl.posts.0.title": "Πού είναι το καρότσι sundae στον σταθμό Geumcheon-gucheong;",
    "mingl.posts.0.content": "Ήταν το καλύτερο sundae. Τελευταία δεν φαίνεται — ξέρει κανείς πού είναι;",

    "mingl.posts.1.category": "Πληροφορίες",
    "mingl.posts.1.title": "Κόλπα για ψώνια στη λαϊκή αγορά Doksan-dong",
    "mingl.posts.1.content": "Ψωνίζω συχνά· οι τιμές αλλάζουν ανά μέρα. Συμβουλές;",

    "mingl.posts.2.category": "Καθημερινά",
    "mingl.posts.2.title": "Μεσημεριανό κοντά στο Gasan Digital Complex;",
    "mingl.posts.2.content": "Δύσκολη επιλογή σήμερα. Τι τρώνε οι υπάλληλοι γύρω από το Gasan;",

    "mingl.posts.3.category": "Χόμπι/παρέες",
    "mingl.posts.3.title": "Ομάδα επιτραπέζιων στον σταθμό Gasan — έλα μαζί",
    "mingl.posts.3.content": "Κάθε Παρασκευή βράδυ κοντά στον σταθμό Gasan. Ζητούνται συμμετέχοντες!",

    "mingl.posts.4.category": "Βόλτες",
    "mingl.posts.4.title": "Ήπια διαδρομή Σ/Κ στο Hoamsan",
    "mingl.posts.4.content": "Βρήκα χαλαρή διαδρομή για περπάτημα — μοιράζομαι την πρόταση!",

    "mingl.posts.5.category": "Καθημερινά",
    "mingl.posts.5.title": "Ήσυχο καφέ κοντά στο Doksan-dong;",
    "mingl.posts.5.content": "Για δουλειά, με καλό Wi-Fi & πρίζες. Προτάσεις;",

    "mingl.posts.6.category": "Πληροφορίες",
    "mingl.posts.6.title": "Γυμναστήριο κοντά στο Gasan-dong — προτάσεις;",
    "mingl.posts.6.content": "Κάποιος πηγαίνει κοντά στο Gasan Digital Complex; Συνδρομή / εγκαταστάσεις;",

    "mingl.posts.7.category": "Χόμπι/παρέες",
    "mingl.posts.7.title": "Πάμε μαζί στο όρος Gwanak",
    "mingl.posts.7.content": "Αυτό το Σ/Κ. Νεοεισερχόμενοι ευπρόσδεκτοι, χαλαρός ρυθμός.",

    // Connect Titles (≤ 6 chars)
    "connect.titles.0": "Γλώσσα",
    "connect.titles.1": "Ζωή",
    "connect.titles.2": "Μεταχ.",
    "connect.titles.3": "Θέσεις",
    "connect.titles.3.category": "Μερική",

    "connect.posts.0.title": "Ανταλλαγή κορεατικών-ιαπωνικών για business συζήτηση!",
    "connect.posts.0.reward": "Ιαπωνικά",
    "connect.posts.0.reward_detail": "Ώρες κατόπιν συνεννόησης",
    "connect.posts.0.location": "Καφέ στο Seongbuk-dong",

    "connect.posts.1.title": "Ψάχνω native ισπανικών! Βοήθεια για practice~",
    "connect.posts.1.reward": "Δωροκάρτα",
    "connect.posts.1.reward_detail": "50.000₩ / φορά",
    "connect.posts.1.location": "Σταθ. Δημαρχείου Geumcheon",

    "connect.posts.2.title": "Οδηγός μετρό Αερ. Incheon → Σταθμό Mapo, παρακαλώ",
    "connect.posts.2.reward": "Αντάλλαγμα",
    "connect.posts.2.reward_detail": "Ισπανικό κρασί",
    "connect.posts.2.location": "Αεροδρόμιο Incheon",

    "connect.posts.3.title": "Συνοδεία για συμβόλαιο γκαρσονιέρας;",
    "connect.posts.3.reward": "Μετρητά",
    "connect.posts.3.reward_detail": "10.000₩ / ώρα",
    "connect.posts.3.location": "Σεούλ Yeongdeungpo / Yangcheon",

    "connect.posts.4.title": "Δανείζεις το ‘monkey driver’ για 1 μέρα; Δίνω σπιτικό kkakdugi",
    "connect.posts.4.reward": "Αντάλλαγμα",
    "connect.posts.4.reward_detail": "Σπιτικό kkakdugi",
    "connect.posts.4.location": "Mapo-gu Seogyo-dong",

    "connect.posts.5.title": "Πωλείται ποδήλατο! Λίγο χρησιμοποιημένο",
    "connect.posts.5.reward": "Τιμή",
    "connect.posts.5.reward_detail": "50.000₩",
    "connect.posts.5.location": "Κοντά στον σταθμό Sinchon",

    "connect.posts.6.title": "Προσωρινή δουλειά σε έκθεση — προτιμ. αγγλικά",
    "connect.posts.6.reward": "Καθήκον",
    "connect.posts.6.reward_detail": "Υποστήριξη on-site & αγγλική καθοδήγηση",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "Ζητείται barista με ισπανικά (native προτεραιότητα)",
    "connect.posts.7.reward": "Ωρομίσθιο",
    "connect.posts.7.reward_detail": "από 10.000₩",
    "connect.posts.7.location": "Καφέ στο Itaewon",

    "passport.introduction": "Άρχισα κορεάτικα βλέποντας variety shows· αφού κέρδισα διαγωνισμό κορεάτικων στο Μεξικό, αποφάσισα να έρθω Κορέα!",
    "passport.gender": "Φύλο",
    "passport.gender_detail": "Άνδρας",
    "passport.birth": "Ημερομηνία γέννησης",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Υπηκοότητα",
    "passport.nationality_detail": "Μεξικό",
    "passport.mother_tongue": "Μητρική γλώσσα",
    "passport.mother_tongue_detail": "Ισπανικά",
    "passport.language": "Ξένες γλώσσες",
    "passport.language_detail.0": "Κορεάτικα",
    "passport.language_detail.1": "Αγγλικά",
    "passport.edit": "Επεξεργασία",
    "passport.share": "Κοινοποίηση",

    // Positioned Mobile Demo Section (el)
    "positionedMobileDemo.home.description": "Όπως τα ‘νέα της γειτονιάς’ — δες με μια ματιά τι συμβαίνει γύρω σου",
    "positionedMobileDemo.home.features.0.description": "Μη χάσεις τοπικά νέα και εκδηλώσεις σε πραγματικό χρόνο",
    "positionedMobileDemo.home.features.1.description": "Εξερεύνησε καθημερινές ιστορίες κατοίκων γύρω από συγκεκριμένα σημεία",
    "positionedMobileDemo.home.features.2.description": "Συμμετέχεις εύκολα σε φεστιβάλ, συναντήσεις και μικρές ή μεγάλες δραστηριότητες",

    "positionedMobileDemo.mingl.description": "Ανακάλυψε και μοιράσου την πραγματική ζωή της γειτονιάς με βάση τον χάρτη",
    "positionedMobileDemo.mingl.features.0.description": "Μοιράσου ερωτήσεις, πληροφορίες, νέα και προτάσεις — φυσική επικοινωνία",
    "positionedMobileDemo.mingl.features.1.description": "Μετάφραση σε πραγματικό χρόνο για παγκόσμια επικοινωνία χωρίς γλωσσικά όρια",
    "positionedMobileDemo.mingl.features.2.description": "Ο κόσμος μέσα από τα μάτια των ντόπιων, και οι ντόπιοι μέσα από τα μάτια του κόσμου",

    "positionedMobileDemo.connect.description": "Οι στιγμές βοήθειας δημιουργούν συνδέσεις",
    "positionedMobileDemo.connect.features.0.description": "Βρες ή πρόσφερε βοήθεια άμεσα με βάση την τοποθεσία",
    "positionedMobileDemo.connect.features.1.description": "Επίλεξε εσύ το άτομο που είναι ‘αξιόπιστο και ασφαλές’",
    "positionedMobileDemo.connect.features.2.description": "Συζήτηση → Ανταλλαγή → Μακροχρόνιες τοπικές και παγκόσμιες σχέσεις",

    "positionedMobileDemo.talk.description": "Γνώρισε φίλους από όλο τον κόσμο χωρίς άγχος γλώσσας χάρη στην AI μετάφραση",
    "positionedMobileDemo.talk.features.0.description": "Φυσικές συνομιλίες ανεξάρτητα από το επίπεδο γλώσσας, με άμεση μετάφραση",
    "positionedMobileDemo.talk.features.1.description": "Ρώτησε απευθείας ντόπιους για τη ζωή στην Κορέα και πάρε άμεση απάντηση",
    "positionedMobileDemo.talk.features.2.description": "Μετέτρεψε τη γνωριμία που ξεκίνησε στο Connect σε αληθινή φιλία",

    "positionedMobileDemo.passport.description": "Φτιάξε ψηφιακή κάρτα που αποτυπώνει την παγκόσμια εμπειρία σου",
    "positionedMobileDemo.passport.features.0.description": "Κατέγραψε την ιστορία διαμονής και δραστηριοτήτων ανά περιοχή σε χρονολόγιο",
    "positionedMobileDemo.passport.features.1.description": "Δείξε καθαρά τις γλωσσικές σου ικανότητες και το στυλ επικοινωνίας",
    "positionedMobileDemo.passport.features.2.description": "Συνδέσου φυσικά με άτομα με παρόμοιες εμπειρίες",


    // Logl Video Section
    "loglVideo.title": "Βίντεο γνωριμίας logl",
    "loglVideo.description": "Τι είναι το logl; Δες πρώτα το βίντεο!",
    "loglVideo.watch": "Δες το βίντεο"

    }
  },
  sv: {
    translation: {
    // Header Section
    "header.intro": "Intro",
    "header.demo": "Demo",
    "header.video": "logl-film",

    // Hero Section
    "hero.title": "Bryt språkbarriärer",
    "hero.description": "find your",
    "hero.demo": "Prova demot",
    "hero.prop1": "Verifierade lokala tjänster",
    "hero.prop2": "Direkt AI-översättning",
    "hero.prop3": "Mångsidiga lokala communities",

    // Introduction Section
    "introduction.title": "Har du känt så här?",
    "introduction.fst.role": "lokal",
    "introduction.snd.role": "global",

    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Seoul, Sydkorea",
    "introduction.fst.tag": "#språkinlärning",
    "introduction.fst.story": "”Jag pluggade engelska hårt och bodde till och med utomlands… men utan att använda språket glömmer man allt. Om jag bara fick använda det i vardagen vore det perfekt 😢”",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Sydkorea",
    "introduction.snd.tag": "#skaffalokalavänner",
    "introduction.snd.story": "”Jag har varit i Korea i sex månader och umgås fortfarande mest med landsmän. Jag vill verkligen bli vän med koreaner, men vet inte hur jag ska börja.”",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Sydkorea",
    "introduction.trd.tag": "#lokalalivstips",
    "introduction.trd.story": "”Varken YouTube eller forumen har info om just vårt område. Bank, mobilabonnemang, sjukhus… När man precis flyttar in, var hittar man korrekt och uppdaterad info?”",
    
    // App Menu Section
    "appMenu.home.local.title": "Hem",
    "appMenu.home.local.subtitle": "Gör vår stadsdel till en global hubb",
    "appMenu.home.local.description": "Hjälp utländska grannar med lokal kunskap och bygg ett verkligt globalt community i området.",
    "appMenu.home.local.points": [
      "Tipsa utlänningar om gömda matställen, kliniker och service",
      "Dela realtidsnyheter och lokala evenemang",
      "Höj den globala profilen och led vägen mot internationalisering"
    ],
    "appMenu.home.local.tip": "Din lilla insikt kan bli någon annans viktiga vardagsguide.",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "Skräddarsydd dashboard för livet i Korea",
    "appMenu.home.global.description": "Från dagens väder till trendande inlägg i kvarteret—allt du behöver på en skärm.",
    "appMenu.home.global.points": [
      "Planera dagen med lokalt väder och utegran",
      "Kolla först lokala nyheter och hjälp-förfrågningar i realtid",
      "Missa inte globala stories som trendar bland koreaner"
    ],
    "appMenu.home.global.tip": "5 min om dagen gör vardagen i Korea mycket lättare.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Prata med vänner från världen",
    "appMenu.mingl.local.description": "Svara på frågor från utlänningar, lär språk och dela kultur tillsammans.",
    "appMenu.mingl.local.points": [
      "Dela vardagstips om livet i Korea och känn mening",
      "Utveckla språket naturligt i vardagen",
      "Skaffa vänner från många kulturer"
    ],
    "appMenu.mingl.local.tip": "Svara på frågor, hjälp med språk och dela kultur—tillsammans.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Kommunicera naturligt med koreaner",
    "appMenu.mingl.global.description": "Fråga fritt om livet i Korea utan språkstress med direkt översättning och hitta lokala vänner.",
    "appMenu.mingl.global.points": [
      "Få svar på dina frågor om Korea i stunden",
      "Naturliga samtal utan språkbörda med AI-översättning",
      "Lämna ”ghettot” och skaffa riktiga koreanska vänner"
    ],
    "appMenu.mingl.global.tip": "Lär dig kulturen och smält in i det lokala communityt steg för steg.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Hjälp en utländsk granne—bli vänner",
    "appMenu.connect.local.description": "Lös konkreta vardagsproblem för utlänningar i området och bygg ditt globala nätverk.",
    "appMenu.connect.local.points": [
      "Praktiskt stöd för bank, boende och papper",
      "Bygg globalt nätverk genom att hjälpa till",
      "Var en lokal global ambassadör med meningsfull roll"
    ],
    "appMenu.connect.local.tip": "Små tjänster blir början på verklig vänskap.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Lös problem med koreanska grannar",
    "appMenu.connect.global.description": "Ta itu med akuta saker—bank, bostad, visum—tillsammans med pålitliga lokala grannar.",
    "appMenu.connect.global.points": [
      "Lös specifika vardagsärenden som konto och bostad",
      "Be om hjälp informellt av grannar, utan agent",
      "Lämna expat-bubblan och anpassa dig till det lokala livet"
    ],
    "appMenu.connect.global.tip": "Ju mer bråttom, desto snabbare och säkrare med hjälp från grannar.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Chatta i realtid med utländska grannar",
    "appMenu.talk.local.description": "1:1-chatt utan språkångest tack vare AI-översättning—bygg äkta globala vänskaper.",
    "appMenu.talk.local.points": [
      "Naturliga samtal oavsett nivå tack vare direktöversättning",
      "Fortsätt kontakten från Connect och bygg vänskap",
      "Lyssna på bekymmer om livet i Korea och ge råd"
    ],
    "appMenu.talk.local.tip": "Små samtal kan bli livslånga kontakter.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Prata avslappnat med koreaner",
    "appMenu.talk.global.description": "Chatta i realtid med koreanska grannar utan språkbarriär och få svar direkt.",
    "appMenu.talk.global.points": [
      "Fråga koreaner direkt om vardagsfrågor—få svar snabbt",
      "Bekväma samtal även utan koreanska tack vare AI-översättning",
      "Behåll kontakten med hjälpsamma grannar från Connect—bli riktiga vänner"
    ],
    "appMenu.talk.global.tip": "Börja med små frågor och hitta en trygg lokal partner.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Skapa din globala story",
    "appMenu.passport.local.description": "Dokumentera aktiviteter och upplevelser med utländska vänner och bygg global identitet utan pass.",
    "appMenu.passport.local.points": [
      "Visualisera din globala tidslinje i området",
      "Bygg en portfölj som global ambassadör med hjälphistorik",
      "Hantera språk och kulturutbyte strukturerat"
    ],
    "appMenu.passport.local.tip": "Varje liten insats fyller på din globala resa.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Global identitet – digitalt visitkort",
    "appMenu.passport.global.description": "Visa upp dina internationella erfarenheter visuellt och skapa en profil som inger förtroende.",
    "appMenu.passport.global.points": [
      "Se boendehistorik och globala erfarenheter i en vy",
      "Bygg trovärdighet med språk och kulturell bakgrund",
      "Koppla ihop dig med människor med liknande resa"
    ],
    "appMenu.passport.global.tip": "Ju mer detaljerad profil, desto bättre lokal hjälp och riktiga vänner.",

    // Demo Section
    "common.viewAll": "Visa alla",
    "common.minutesAgo": "min sen",

    "home.tag": "Loppmarknad",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Ha en bra dag",
    
    "home.weather.maxTemp": "Högst 15°",
    "home.weather.minTemp": "Lägst 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Klart",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Mulet",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Måttlig",

    "home.mytown.title": "Vårt område i realtid",
    "home.mytown.places.0.name": "Ginkgo-marknaden",
    "home.mytown.places.0.address": "금천구 시흥동",
    "home.mytown.places.1.name": "Gwanaksan",
    "home.mytown.places.1.address": "관악구 신림동",
    "home.mytown.places.2.name": "Anyangcheon torg",
    "home.mytown.places.2.address": "금천구 독선동",

    "home.events.title": "Lokala evenemang",
    "home.events.post_title": "Loppis i Doksan-dong",
    "home.events.address": "금천구 독산동",

    "mingl.posts.0.category": "Vardagsinfo",
    "mingl.posts.0.title": "Var är soppvagns-”sundae”-farbrorn vid Geumcheon-gu Office?",
    "mingl.posts.0.content": "Det var bästa soppan! Har inte sett honom på sistone—någon som vet var han står?",

    "mingl.posts.1.category": "Vardagsinfo",
    "mingl.posts.1.title": "Handla smart på den traditionella marknaden i Doksan-dong",
    "mingl.posts.1.content": "Jag handlar ofta där och priserna varierar efter veckodag. Tips på hur man handlar smart?",

    "mingl.posts.2.category": "Vardag",
    "mingl.posts.2.title": "Lunch nära Gasan Digital Complex—vad äter folk?",
    "mingl.posts.2.content": "Kan inte bestämma mig idag. Vad brukar kontorsfolk nära Gasan äta?",

    "mingl.posts.3.category": "Hobby/Träff",
    "mingl.posts.3.title": "Brädspelsgäng vid Gasan-station—vi söker folk",
    "mingl.posts.3.content": "Vi ses varje fredag kväll nära Gasan. Häng på!",

    "mingl.posts.4.category": "Resa/Utflykt",
    "mingl.posts.4.title": "Hoamsan runt—lagom helgpromenad",
    "mingl.posts.4.content": "Letade efter en lätt rutt och hittade denna slinga. Rekar en mysig promenadväg!",

    "mingl.posts.5.category": "Vardag",
    "mingl.posts.5.title": "Tyst kafé nära Doksan-dong?",
    "mingl.posts.5.content": "Söker ett lugnt ställe att jobba på. Bra Wi-Fi och eluttag uppskattas—tipsa gärna.",

    "mingl.posts.6.category": "Vardagsinfo",
    "mingl.posts.6.title": "Rekommendera gym nära Gasan?",
    "mingl.posts.6.content": "Någon som tränar nära Gasan Digital Complex? Helst bra utrustning eller rimlig månadsavgift.",

    "mingl.posts.7.category": "Hobby/Träff",
    "mingl.posts.7.title": "Häng med på vandring till Gwanaksan",
    "mingl.posts.7.content": "Sticker i helgen. Nybörjare välkomna—vi går i lugn takt.",

    "connect.titles.0": "Språk",     // ≤6 tecken (언어교환)
    "connect.titles.1": "Anpass",    // ≤6 (생활적응 → Anpass(ning) kortat)
    "connect.titles.2": "Begagn",    // ≤6 (중고거래 → Begagn(ad) kortat)
    "connect.titles.3": "Jobb",      // ≤6 (구인·구직)
    "connect.titles.3.category": "Deltid", // ≤6 (아르바이트)

    "connect.posts.0.title": "Koreanska–japanska affärssamtal: söker språkbyte-partner",
    "connect.posts.0.reward": "Japanska",
    "connect.posts.0.reward_detail": "Tid överens",
    "connect.posts.0.location": "Seongbuk-dong kafé",

    "connect.posts.1.title": "Söker spansktalande! Hjälp mig öva samtal",
    "connect.posts.1.reward": "Presentkort",
    "connect.posts.1.reward_detail": "50,000원 / tillfälle",
    "connect.posts.1.location": "Geumcheon-gu Office stn",

    "connect.posts.2.title": "Vägledning från Incheon flygplats till Mapo-station med tunnelbana",
    "connect.posts.2.reward": "Vara",
    "connect.posts.2.reward_detail": "Spanskt vin",
    "connect.posts.2.location": "Incheon Airport",

    "connect.posts.3.title": "Följa med vid skrivning av ettorums-kontrakt—någon som kan?",
    "connect.posts.3.reward": "Kontant",
    "connect.posts.3.reward_detail": "10,000원 / tim",
    "connect.posts.3.location": "Seoul Yeongdeungpo/Yangcheon stn",

    "connect.posts.4.title": "Låna Monkey Driver en dag—bjuder på hemgjord kkakdugi",
    "connect.posts.4.reward": "Vara",
    "connect.posts.4.reward_detail": "Hemgjord kkakdugi",
    "connect.posts.4.location": "Mapo-gu Seogyo-dong",

    "connect.posts.5.title": "Säljer cykel! Fint skick",
    "connect.posts.5.reward": "Pris",
    "connect.posts.5.reward_detail": "50,000원",
    "connect.posts.5.location": "Nära Sinchon stn",

    "connect.posts.6.title": "Korttidsjobb på mässa—engelska är meriterande",
    "connect.posts.6.reward": "Arbete",
    "connect.posts.6.reward_detail": "Support på plats och engelsk guidning",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "Barista som kan spanska sökes (utländska native prioriteras)",
    "connect.posts.7.reward": "Timlön",
    "connect.posts.7.reward_detail": "fr. 10,000원",
    "connect.posts.7.location": "Itaewon kafé",

    "passport.introduction": "Jag började lära mig koreanska på egen hand via koreanska program och bestämde mig för att flytta efter att ha vunnit en koreansktalstävling i Mexiko!",
    "passport.gender": "Kön",
    "passport.gender_detail": "Man",
    "passport.birth": "Födelsedatum",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Nationalitet",
    "passport.nationality_detail": "Mexiko",
    "passport.mother_tongue": "Modersmål",
    "passport.mother_tongue_detail": "Spanska",
    "passport.language": "Främmande språk",
    "passport.language_detail.0": "Koreanska",
    "passport.language_detail.1": "Engelska",
    "passport.edit": "Redigera",
    "passport.share": "Dela",

    // Positioned Mobile Demo Section (sv)
    "positionedMobileDemo.home.description": "Som ‘nyheter från kvarteret’ — se vad som händer runt dig direkt",
    "positionedMobileDemo.home.features.0.description": "Missa inte lokala nyheter och evenemang i realtid",
    "positionedMobileDemo.home.features.1.description": "Utforska invånarnas vardagsberättelser runt olika platser",
    "positionedMobileDemo.home.features.2.description": "Delta enkelt i festivaler, träffar och stora som små aktiviteter i närområdet",

    "positionedMobileDemo.mingl.description": "Upptäck och dela det verkliga kvarterslivet baserat på plats",
    "positionedMobileDemo.mingl.features.0.description": "Dela frågor, information, nyheter och tips fritt — naturlig interaktion",
    "positionedMobileDemo.mingl.features.1.description": "Översättning i realtid för global kommunikation utan språkbarriärer",
    "positionedMobileDemo.mingl.features.2.description": "Världen sedd genom lokalens ögon, och det lokala sedd genom världens",

    "positionedMobileDemo.connect.description": "Ögonblick av hjälp skapar relationer",
    "positionedMobileDemo.connect.features.0.description": "Hitta eller erbjud hjälp direkt med platsbaserad matchning",
    "positionedMobileDemo.connect.features.1.description": "Välj själv någon som är ‘pålitlig och trygg’",
    "positionedMobileDemo.connect.features.2.description": "Samtal → utbyte → långvariga lokala och globala relationer",

    "positionedMobileDemo.talk.description": "Möt vänner från hela världen utan språkoro med AI-översättning",
    "positionedMobileDemo.talk.features.0.description": "Naturliga samtal oavsett språknivå med översättning i realtid",
    "positionedMobileDemo.talk.features.1.description": "Fråga direkt om livet i Korea och få svar omedelbart",
    "positionedMobileDemo.talk.features.2.description": "Utveckla kontakten från Connect till långvarig vänskap",

    "positionedMobileDemo.passport.description": "Skapa ett digitalt kort som visar din globala resa",
    "positionedMobileDemo.passport.features.0.description": "Registrera boende- och aktivitets­historik efter område i en tidslinje",
    "positionedMobileDemo.passport.features.1.description": "Visa språkkunskaper och kommunikationsstil tydligt",
    "positionedMobileDemo.passport.features.2.description": "Knyt naturliga band med människor med liknande erfarenheter",


    // Logl Video Section
    "loglVideo.title": "logl introduktionsvideo",
    "loglVideo.description": "Vad är logl? Se videon först!",
    "loglVideo.watch": "Titta på videon"    
    }
  },
  fi: {
    translation: {
    // Header Section
    "header.intro": "Intro",
    "header.demo": "Demo",
    "header.video": "logl-video",

    // Hero Section
    "hero.title": "Murra kielimuurit",
    "hero.description": "find your",
    "hero.demo": "Kokeile demoa",
    "hero.prop1": "Varmennetut paikalliset palvelut",
    "hero.prop2": "Reaaliaikainen AI-käännös",
    "hero.prop3": "Monipuoliset paikallisyhteisöt",

    // Introduction Section
    "introduction.title": "Onko tällaista mielessä ollut?",
    "introduction.fst.role": "paikallinen",
    "introduction.snd.role": "globaali",

    "introduction.fst.name": "Jimin",
    "introduction.fst.location": "Soul, Etelä-Korea",
    "introduction.fst.tag": "#kielenopiskelu",
    "introduction.fst.story": "\"Opiskelin englantia ahkerasti ja kävin jopa kielikurssilla ulkomailla… mutta kun arjessa ei ole käyttöä, taidot unohtuvat. Olisi kiva, jos olisi tilaisuuksia käyttää kieltä😢\"",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Suwon, Etelä-Korea",
    "introduction.snd.tag": "#paikallisiaystäviä",
    "introduction.snd.story": "\"Olen ollut Koreassa 6 kuukautta, mutta vietän aikaa yhä vain samasta maasta tulleiden kanssa. Haluaisin oikeasti tutustua korealaisiin, mutta en tiedä mistä aloittaa.\"",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Jeonju, Etelä-Korea",
    "introduction.trd.tag": "#paikallistieto",
    "introduction.trd.story": "\"YouTubesta tai yhteisöistä ei löydy meidän alueen tietoa. Pankki, operaattori, sairaala… Mistä saa luotettavaa ja ajantasaista tietoa heti alkuun?\"",
    
    // App Menu Section
    "appMenu.home.local.title": "home",
    "appMenu.home.local.subtitle": "Tehdään kaupungistamme globaali hubi",
    "appMenu.home.local.description": "Auta ulkomaalaisia naapureita paikallistiedollasi ja rakenna aito globaaliyhteisö omalle alueellesi.",
    "appMenu.home.local.points": [
      "Suosittele piilossa olevia helmiä, sairaaloita ja palveluja",
      "Jaa kaupunginosan uutiset ja tapahtumat reaaliajassa",
      "Nosta alueen globaaliusastetta ja johda kansainvälistymistä"
    ],
    "appMenu.home.local.tip": "Pieni tieto sinulta voi olla toiselle korvaamaton arjen opas.",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "Korean arkeen räätälöity hallintapaneeli",
    "appMenu.home.global.description": "Näkymä yhdellä ruudulla: säästä alueen suosittuihin julkaisuihin – kaikki mitä arjessa tarvitset.",
    "appMenu.home.global.points": [
      "Suunnittele päivä paikallisen sään ja vinkkien avulla",
      "Katso heti kaupunginosan tuoreimmat uutiset ja avunpyynnöt",
      "Älä missaa paikallisten suosimia globaaleja tarinoita"
    ],
    "appMenu.home.global.tip": "Vain 5 min päivässä helpottaa Korea-arkea huomattavasti.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Juttele globaalien ystävien kanssa",
    "appMenu.mingl.local.description": "Vastaa ulkomaalaisten kysymyksiin, opi kieltä jaa kulttuuria yhdessä.",
    "appMenu.mingl.local.points": [
      "Jaa arjen vinkkejä Korea-elämään",
      "Kehitä kielitaitoa luonnollisesti",
      "Luo ystävyyksiä eri kulttuureista"
    ],
    "appMenu.mingl.local.tip": "Opit ja jaat luontevasti kieltä sekä kulttuuria arjen keskusteluissa.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Keskustele luontevasti korealaisten kanssa",
    "appMenu.mingl.global.description": "Kysy Korea-arjesta ilman kielipainetta – reaaliaikainen käännös auttaa.",
    "appMenu.mingl.global.points": [
      "Ratkaise arjen kysymykset heti",
      "Käy luontevaa keskustelua AI-tuen avulla",
      "Poistu expat-kuplasta ja solmi aitoja ystävyyksiä"
    ],
    "appMenu.mingl.global.tip": "Lähesty kulttuuria ja liity osaksi paikallista yhteisöä.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Auta ulkomaalaisia naapureita & ystävysty",
    "appMenu.connect.local.description": "Ratkaise alueen ulkomaalaisten käytännön arkihaasteita ja rakenna globaalia verkostoa.",
    "appMenu.connect.local.points": [
      "Apua pankkiin, asuntoon ja asiakirjoihin",
      "Luo verkostoja auttamisen kautta",
      "Toimi alueen globaali-lähettiläänä"
    ],
    "appMenu.connect.local.tip": "Pienestä avusta voi syntyä pitkä ystävyys.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Ratkaise haasteet yhdessä paikallisten kanssa",
    "appMenu.connect.global.description": "Hoida pankki, asunto ja viisumi luotettavan paikallisen kanssa – juuri omalla alueellasi.",
    "appMenu.connect.global.points": [
      "Ratkaisuja konkreettisiin arjen asioihin",
      "Pyydä apua rennosti ilman välikäsiä",
      "Sopeudu oikeasti paikalliseen arkeen"
    ],
    "appMenu.connect.global.tip": "Kiiretilanteessa paikallinen naapuri auttaa nopeimmin ja varmimmin.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Keskustele reaaliajassa globaalien naapurien kanssa",
    "appMenu.talk.local.description": "AI-käännöksen avulla voit ystävystyä aidosti ilman kielimuuria.",
    "appMenu.talk.local.points": [
      "Luontevaa jutustelua kielitasosta riippumatta",
      "Kehitä avusta alkaneet suhteet ystävyydeksi",
      "Neuvo ja auta suoraan Korea-arjen pulmissa"
    ],
    "appMenu.talk.local.tip": "Pieni juttuhetki voi kasvaa elinikäiseksi verkostoksi.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Juttele rennosti korealaisten kanssa",
    "appMenu.talk.global.description": "Chattaa reaaliajassa ilman kielimuureja ja saat vastaukset heti.",
    "appMenu.talk.global.points": [
      "Kysy suoraan paikallisilta ja saat vastauksen heti",
      "Keskustele luontevasti, vaikka et puhuisi koreaa",
      "Pidä yhteyttä ja rakenna aito ystävyys"
    ],
    "appMenu.talk.global.tip": "Aloita pienistä kysymyksistä – löydät pian luotettavan auttajan.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Rakenna oma globaali tarinasi",
    "appMenu.passport.local.description": "Kirjaa tekemiset globaalien ystävien kanssa ja luo globaali identiteetti ilman passia.",
    "appMenu.passport.local.points": [
      "Visualisoi alueesi globaalit tekemiset",
      "Rakenna portfolio globaalina lähettiläänä",
      "Hallitse kielitaitoa ja kulttuurivaihtoa"
    ],
    "appMenu.passport.local.tip": "Jokainen pieni teko täydentää globaalin matkasi tarinaa.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Globaali identiteetti – digitaalinen käyntikortti",
    "appMenu.passport.global.description": "Näytä monikansallinen taustasi visuaalisesti ja rakenna luotettava profiili.",
    "appMenu.passport.global.points": [
      "Asumishistoria ja kokemus yhdellä silmäyksellä",
      "Luottamus kielitaidon ja kulttuuritaustan kautta",
      "Yhdisty helposti samankaltaisia kokeneiden kanssa"
    ],
    "appMenu.passport.global.tip": "Mitä kattavampi profiili, sitä parempi paikallinen apu ja ystävyyssuhteet.",

    // Demo Section
    "common.viewAll": "Näytä kaikki",
    "common.minutesAgo": "min sitten",

    "home.tag": "Kirpputori",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Hyvää päivää",

    "home.weather.maxTemp": "Ylin 15°",
    "home.weather.minTemp": "Alin 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Selkeää",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Pilvistä",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Kohtalainen",

    "home.mytown.title": "Meidän naapurusto livenä",
    "home.mytown.places.0.name": "은행나무시장",
    "home.mytown.places.0.address": "금천구 시흥동",
    "home.mytown.places.1.name": "관악산",
    "home.mytown.places.1.address": "관악구 신림동",
    "home.mytown.places.2.name": "안양천다목적광장",
    "home.mytown.places.2.address": "금천구 독선동",

    "home.events.title": "Alueen tapahtumat",
    "home.events.post_title": "Dokksan-dongin kirpputori järjestetään!",
    "home.events.address": "금천구 독산동",

    "mingl.posts.0.category": "Arjen tieto",
    "mingl.posts.0.title": "Missä on se sundae-kärrymyyjä 금천구청역illä?",
    "mingl.posts.0.content": "Paras sundae ikinä… En ole nähnyt häntä hetkeen. Tietääkö joku?",

    "mingl.posts.1.category": "Arjen tieto",
    "mingl.posts.1.title": "Vinkkejä ostoksiin Dokksan-perinteisillä markkinoilla?",
    "mingl.posts.1.content": "Hinnat vaihtelevat viikonpäivän mukaan. Vinkkejä ostoksille?",

    "mingl.posts.2.category": "Arki",
    "mingl.posts.2.title": "Mitä syödään lounaaksi Gasan Digital Complexin lähellä?",
    "mingl.posts.2.content": "En osaa päättää tänään. Mitä syödään Gasanin lähellä?",

    "mingl.posts.3.category": "Harrasteet",
    "mingl.posts.3.title": "Haetaan pelaajia Gasanin lautapeliporukkaan!",
    "mingl.posts.3.content": "Pelit perjantai-iltaisin Gasanin asemalla. Tule mukaan!",

    "mingl.posts.4.category": "Retket",
    "mingl.posts.4.title": "Suositus: Hoamsanin kevyet viikonloppukävelyreitit",
    "mingl.posts.4.content": "Löytyi kevyt reitti Hoamsanilla. Suosittelen!",

    "mingl.posts.5.category": "Arki",
    "mingl.posts.5.title": "Suosituksia rauhallisista kahviloista Dokksanissä?",
    "mingl.posts.5.content": "Etsin rauhallista kahvilaa, hyvä Wi-Fi ja pistorasiat. Suosituksia?",

    "mingl.posts.6.category": "Arjen tieto",
    "mingl.posts.6.title": "Hyviä kuntosaleja lähellä Gasania?",
    "mingl.posts.6.content": "Onko hyvää salia Gasanin lähellä?",

    "mingl.posts.7.category": "Harrasteet",
    "mingl.posts.7.title": "Lähdetäänkö Gwanaksanille yhdessä viikonloppuna?",
    "mingl.posts.7.content": "Viikonloppuretki. Aloittelijat tervetulleita!",

    "connect.titles.0": "Kieli",
    "connect.titles.1": "Arki",
    "connect.titles.2": "Tori",
    "connect.titles.3": "Työt",
    "connect.titles.3.category": "Keikka",

    "connect.posts.0.title": "Haetaan korean–japanin bisneskielenvaihtoa!",
    "connect.posts.0.reward": "Japani",
    "connect.posts.0.reward_detail": "Aika sovittavissa",
    "connect.posts.0.location": "성북동 카페",

    "connect.posts.1.title": "Etsitään espanjan nativea – jutellaan!",
    "connect.posts.1.reward": "Lahjakortti",
    "connect.posts.1.reward_detail": "50,000원 / kerta",
    "connect.posts.1.location": "금천구청역",

    "connect.posts.2.title": "Opastus metrolla Incheonista 마포역-asemalle",
    "connect.posts.2.reward": "Tavara",
    "connect.posts.2.reward_detail": "Espanjalainen viini",
    "connect.posts.2.location": "인천공항",

    "connect.posts.3.title": "Yksiön sopimukseen mukaan – tarviin apua",
    "connect.posts.3.reward": "Käteinen",
    "connect.posts.3.reward_detail": "10,000원 / h",
    "connect.posts.3.location": "서울 영등포 양천역",

    "connect.posts.4.title": "Lainaa Monkey Driver päiväksi – tarjoan 깍두기",
    "connect.posts.4.reward": "Tavara",
    "connect.posts.4.reward_detail": "Itsetehty 깍두기",
    "connect.posts.4.location": "마포구 서교동",

    "connect.posts.5.title": "Myydään polkupyörä – vähän käytetty",
    "connect.posts.5.reward": "Hinta",
    "connect.posts.5.reward_detail": "50,000원",
    "connect.posts.5.location": "신촌역 근처",

    "connect.posts.6.title": "Messuille lyhytaikainen apulainen – englanti plussaa",
    "connect.posts.6.reward": "Työtehtävä",
    "connect.posts.6.reward_detail": "Messutuki & engl. opastus",
    "connect.posts.6.location": "코엑스",

    "connect.posts.7.title": "Barista, joka osaa espanjaa – native etusijalla",
    "connect.posts.7.reward": "Tuntipalkka",
    "connect.posts.7.reward_detail": "Alk. 10,000원",
    "connect.posts.7.location": "이태원 카페",

    "passport.introduction": "Aloin opetella koreaa katsottuani viihdeohjelmia. Voitin Korean puhekilpailun Meksikossa ja päätin muuttaa Koreaan!",
    "passport.gender": "Sukupuoli",
    "passport.gender_detail": "Mies",
    "passport.birth": "Syntymäaika",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Kansallisuus",
    "passport.nationality_detail": "Meksiko",
    "passport.mother_tongue": "Äidinkieli",
    "passport.mother_tongue_detail": "Espanja",
    "passport.language": "Vieraat kielet",
    "passport.language_detail.0": "Korea",
    "passport.language_detail.1": "englanti",
    "passport.edit": "Muokkaa",
    "passport.share": "Jaa",

    // Positioned Mobile Demo Section (fi)
    "positionedMobileDemo.home.description": "Kuin ‘naapuruston uutiset’ — näe yhdellä silmäyksellä, mitä ympärilläsi tapahtuu",
    "positionedMobileDemo.home.features.0.description": "Älä missaa paikallisia uutisia ja tapahtumia reaaliajassa",
    "positionedMobileDemo.home.features.1.description": "Tutki asukkaiden arjen tarinoita eri paikkojen ympärillä",
    "positionedMobileDemo.home.features.2.description": "Osallistu helposti festivaaleihin, tapaamisiin ja suuriin tai pieniin tapahtumiin",

    "positionedMobileDemo.mingl.description": "Löydä ja jaa todellista naapuruston elämää sijainnin perusteella",
    "positionedMobileDemo.mingl.features.0.description": "Jaa kysymyksiä, tietoa, uutisia ja suosituksia vapaasti — luonnollinen vuorovaikutus",
    "positionedMobileDemo.mingl.features.1.description": "Reaaliaikainen käännös mahdollistaa globaalin viestinnän ilman kielimuuria",
    "positionedMobileDemo.mingl.features.2.description": "Maailma paikallisen silmin, ja paikallinen maailman silmin",

    "positionedMobileDemo.connect.description": "Apuhetkistä syntyy yhteyksiä",
    "positionedMobileDemo.connect.features.0.description": "Löydä tai tarjoa apua nopeasti sijaintipohjaisen sovituksen avulla",
    "positionedMobileDemo.connect.features.1.description": "Valitse itse ‘luotettava ja turvallinen’ henkilö",
    "positionedMobileDemo.connect.features.2.description": "Keskustelu → vaihto → pitkäaikaiset paikalliset ja globaalit suhteet",

    "positionedMobileDemo.talk.description": "Tapaa ystäviä eri puolilta maailmaa ilman kielihuolta AI-käännöksen avulla",
    "positionedMobileDemo.talk.features.0.description": "Luonnollinen keskustelu kielitaidosta riippumatta reaaliaikaisella käännöksellä",
    "positionedMobileDemo.talk.features.1.description": "Kysy suoraan paikallisilta elämästä Koreassa ja saat vastauksen heti",
    "positionedMobileDemo.talk.features.2.description": "Kasvata Connectissa alkanut tuttavuus pitkäaikaiseksi ystävyydeksi",

    "positionedMobileDemo.passport.description": "Luo digitaalinen kortti, joka esittelee globaalin kokemuksesi",
    "positionedMobileDemo.passport.features.0.description": "Tallenna asumis- ja toimintahistoriasi alueittain aikajanalle",
    "positionedMobileDemo.passport.features.1.description": "Näytä kielitaitosi ja viestintätyylisi selkeästi",
    "positionedMobileDemo.passport.features.2.description": "Muodosta luonnollisia yhteyksiä saman kokemuksen jakaviin ihmisiin",


    // Logl Video Section
    "loglVideo.title": "logl-esittelyvideo",
    "loglVideo.description": "Mikä logl on? Katso video ensin!",
    "loglVideo.watch": "Katso video",
    }
  },
  mn: {
    translation: {
    // Header Section
    "header.intro": "Танилцуулга",
    "header.demo": "Демо",
    "header.video": "logl танилцуулга",

    // Hero Section
    "hero.title": "Хэлний саадыг арилгая",
    "hero.description": "find your",
    "hero.demo": "Демог турших",
    "hero.prop1": "Баталгаатай локал үйлчилгээ",
    "hero.prop2": "Бодит цагийн AI орчуулга",
    "hero.prop3": "Олон төрлийн локал комьюнити",

    // Introduction Section
    "introduction.title": "Иймэрхүү асуудалтай байсан уу?",
    "introduction.fst.role": "локал",
    "introduction.snd.role": "глобал",

    "introduction.fst.name": "Жимин",
    "introduction.fst.location": "Сөүл БНСУ",
    "introduction.fst.tag": "#гадаад_хэл",
    "introduction.fst.story": "“Англиа нэлээн хичээгээд, бүр солилцоонд ч явсан… гэхдээ хэрэглэх боломжгүй болохоор мартагдсаар байна. Өдөр тутамд ашиглах боломж л хэрэгтэй байна 😢”",

    "introduction.snd.name": "Sophie",
    "introduction.snd.location": "Сувон БНСУ",
    "introduction.snd.tag": "#дотнын_найз_хийх",
    "introduction.snd.story": "“Солонгост ирээд 6 сар боллоо. Одоо ч эх орныхонтойгоо л ихэвчлэн уулздаг. Жинхэнэ солонгос найзуудтай болохыг хүсч байна, яаж эхлэхээ л мэдэхгүй байна.”",

    "introduction.trd.name": "Carlos",
    "introduction.trd.location": "Жонжу БНСУ",
    "introduction.trd.tag": "#локал_амьдралын_мэдээлэл",
    "introduction.trd.story": "“YouTube, комьюнити бүгдийг ухлаа, гэхдээ манай хорооллын тухай бодит мэдээлэл алга. Банк нээлгэх, оператор, эмнэлэг… Эхэндээ суурьшихад яг хаанаас хамгийн шинэ, зөв мэдээлэл авах вэ?”",
    
    // App Menu Section
    "appMenu.home.local.title": "Нүүр",
    "appMenu.home.local.subtitle": "Манай хорооллыг глобал төв болгоё",
    "appMenu.home.local.description": "Мэдэх дотоод мэдээллээрээ гадаад хөршүүддээ тусалж, манай бүсийг жинхэнэ глобал комьюнити болгоорой.",
    "appMenu.home.local.points": [
      "Нууцлаг амттай газар, эмнэлэг, үйлчилгээний цэгүүдийг танилцуулах",
      "Хорооллын шуурхай мэдээ, эвентүүдийг хуваалцах",
      "Глобал индексээ өсгөж, олон улсынжихийг манлайл"
    ],
    "appMenu.home.local.tip": "Таны жижигхэн мэдээлэл хэн нэгэнд үнэт амьдралын гарын авлага болдог.",

    "appMenu.home.global.title": "home",
    "appMenu.home.global.subtitle": "Солонгос амьдралын хувийн самбар",
    "appMenu.home.global.description": "Өнөөдрийн цаг агаар, дүүргийн тренд пост хүртэл — хэрэгтэй бүхнээ нэг дэлгэцнээс.",
    "appMenu.home.global.points": [
      "Орон нутгийн цаг агаар, гадагш явах зөвлөмжөөр өдрөө төлөвлөх",
      "Манай хорооллын шуурхай мэдээ, тусламжийн хүсэлтийг түрүүлж харах",
      "Солонгосчуудын дунд тренд болж буй глобал нийтлэлийг алгасахгүй"
    ],
    "appMenu.home.global.tip": "Өдөрт 5 минут — амьдрал илүү амар болно.",

    "appMenu.mingl.local.title": "mingl",
    "appMenu.mingl.local.subtitle": "Дэлхийн найзуудтай ярилцъя",
    "appMenu.mingl.local.description": "Гадаадынхны асуултад хариулж, хэлээ хөгжүүлэн, соёлоо хамт хуваалцаарай.",
    "appMenu.mingl.local.points": [
      "Солонгос амьдралын лайфхакaa хуваалцаж урам авах",
      "Хэлээ өдөр тутам байгалйн жамаар сайжруулах",
      "Олон соёлын найз нөхөдтэй болох"
    ],
    "appMenu.mingl.local.tip": "Асуултад хариулж, хэл сурахад тусалж, соёлоо солилцъё.",

    "appMenu.mingl.global.title": "mingl",
    "appMenu.mingl.global.subtitle": "Солонгосчуудтай энгийнээр харилц",
    "appMenu.mingl.global.description": "Бодит цагийн орчуулгаар хэлний дарамтгүй асууж, ойрын найзаа ол.",
    "appMenu.mingl.global.points": [
      "Солонгос амьдралын асуултаа тэр дор нь шийдэх",
      "AI орчуулгаар ачаалалгүй, байгалийн мэт яриа",
      "Хаалттай геттог орхиод жинхэнэ солонгос найзтай болох"
    ],
    "appMenu.mingl.global.tip": "Солонгос соёлыг сураад, локал комьюнтид аажмаар уусъя.",

    "appMenu.connect.local.title": "connect",
    "appMenu.connect.local.subtitle": "Гадаад хөршдөө туслаад, найз болоё",
    "appMenu.connect.local.description": "Манай хорооллын гадаадынхны бодит амьдралын бэрхшээлийг шийдэж, глобал сүлжээгээ тэл.",
    "appMenu.connect.local.points": [
      "Банк, сууц, бичиг баримтын практик тус",
      "Туслах явцдаа глобал танилын хүрээ бий болгох",
      "Дүүргийн глобал элч болж, утга учиртай үүрэг гүйцэтгэе"
    ],
    "appMenu.connect.local.tip": "Жижиг туслалцаанаас жинхэнэ найрамдал эхэлнэ.",

    "appMenu.connect.global.title": "connect",
    "appMenu.connect.global.subtitle": "Солонгос хөрштэйгээ хамт шийдье",
    "appMenu.connect.global.description": "Банк, байр, виз зэрэг яаралтай асуудлаа найдвартай локал хүнтэй хамт шийдээрэй.",
    "appMenu.connect.global.points": [
      "Данс нээлгэх, байр олох зэрэг тодорхой ажлуудыг хамт хийх",
      "Агентгүй, хөршөөсөө энгийнээр тусламж хүсэх",
      "Геттогоос гарч, жинхэнэ локал амьдралд дасах"
    ],
    "appMenu.connect.global.tip": "Яаралтай үед локал хөршийн тус хамгийн хурдан, найдвартай.",

    "appMenu.talk.local.title": "talk",
    "appMenu.talk.local.subtitle": "Гадаад хөрштэй бодит цагт чатлах",
    "appMenu.talk.local.description": "AI орчуулгаар хэлний санаа зовнилгүй 1:1 чат — жинхэнэ глобал найз болоорой.",
    "appMenu.talk.local.points": [
      "AI орчуулгаараа хэлний түвшнээс үл хамааран байгалийн яриа",
      "Connect-оос эхэлсэн холбоогоо найрамдал болгох",
      "Гадаад хөршийн Солонгос дахь амьдралын асуудлыг сонсож зөвлөх"
    ],
    "appMenu.talk.local.tip": "Жижиг яриа — насан туршийн холбоо болдог.",

    "appMenu.talk.global.title": "talk",
    "appMenu.talk.global.subtitle": "Солонгосчуудтай тавтай ярилц",
    "appMenu.talk.global.description": "Хэлний хаалтгүйгээр солонгос хөрштэйгээ бодит цагт чатлаад, асуултаа тэр дор нь шийд.",
    "appMenu.talk.global.points": [
      "Солонгос амьдралын асуултаа шууд асууж, шуурхай хариу авах",
      "AI орчуулгаар солонгос хэл мэдэхгүй ч эвтэйхэн яриа",
      "Connect-оор танилцсан хөрштэйгээ холбоогоо үргэлжлүүлж, жинхэнэ найз болох"
    ],
    "appMenu.talk.global.tip": "Жижиг асуултаас эхлээд, найдвартай түнштэй бол.",

    "appMenu.passport.local.title": "passport",
    "appMenu.passport.local.subtitle": "Өөрийн глобал түүхээ бүтээе",
    "appMenu.passport.local.description": "Гадаад найзуудтай хийсэн үйл ажиллагаа, туршлагаа тэмдэглэж, паспортаас гадна глобал 정체шнээ бий болгоорой.",
    "appMenu.passport.local.points": [
      "Манай хорооллын глобал үйл явдлынхаа таймлайныг харагдуулах",
      "Тусалсан түүхээрээ глобал элчийн портфолио босгох",
      "Хэлний чадвар, соёлын солилцоогоо системтэй удирдах"
    ],
    "appMenu.passport.local.tip": "Жижиг тус бүр таны глобал аяллын түүхийг бүтээнэ.",

    "appMenu.passport.global.title": "passport",
    "appMenu.passport.global.subtitle": "Глобал 정체 — дижитал нэрийн хуудас",
    "appMenu.passport.global.description": "Олон улсын туршлага, аяллаа дүрслэн харуулж, итгэл төрүүлэх профайл үүсгээрэй.",
    "appMenu.passport.global.points": [
      "Оршин суусан түүх, глобал туршлагаа нэг дор үзүүлэх",
      "Хэлний чадвар, соёлын дэвсгэрээрээ итгэлцэл бий болгох",
      "Ижил замналтай хүмүүстэй хялбар холбогдох"
    ],
    "appMenu.passport.global.tip": "Дэлгэрэнгүй профайл — илүү сайн локал тус, жинхэнэ найзуулах түлхүүр.",

    // Demo Section
    "common.viewAll": "Бүгд",
    "common.minutesAgo": "мин өмнө",

    "home.tag": "Фриймаркет",
    "home.greeting_01": "Carlos",
    "home.greeting_02": "Өнөөдөр ч бас",
    
    "home.weather.maxTemp": "Дээд 15°",
    "home.weather.minTemp": "Доод 10°",

    "home.weather.morning": "☀️",
    "home.weather.morningWeather": "Тунгалаг",
    "home.weather.afternoon": "🌘",
    "home.weather.afternoonWeather": "Үүлэрхэг",
    "home.weather.fineDust": "💨",
    "home.weather.fineDustLevel": "Дунд",

    "home.mytown.title": "Манай хороолол — шуурхай",
    "home.mytown.places.0.name": "Гинкго зах",
    "home.mytown.places.0.address": "Гымчон-гу Сихын-дон",
    "home.mytown.places.1.name": "Гванаксан",
    "home.mytown.places.1.address": "Гванак-гу Шинрим-дон",
    "home.mytown.places.2.name": "Анян мөрний талбай",
    "home.mytown.places.2.address": "Гымчон-гу Доксон-дон",

    "home.events.title": "Манай дүүргийн эвент",
    "home.events.post_title": "Доксандонд фриймаркет болно",
    "home.events.address": "Гымчон-гу Доксандон",

    "mingl.posts.0.category": "Амьдрал",
    "mingl.posts.0.title": "Гымчон구청 ёогийн сундэ тэргэнцэр хаана байна?",
    "mingl.posts.0.content": "Үнэхээр амттай байсан даа. Сүүлийн үед олдохгүй юм — хаа байдаг бол?",

    "mingl.posts.1.category": "Амьдрал",
    "mingl.posts.1.title": "Доксандон уламжлалт зах — худалдан авалтын зөвлөмж",
    "mingl.posts.1.content": "Би байнга явдаг. Гэхдээ өдрөөс хамаараад үнэ зөрдөг юм байна. Яаж ухаалгаар авах вэ?",

    "mingl.posts.2.category": "Өдөр тутам",
    "mingl.posts.2.title": "Гасандижитал дүүрэгт өдрийн хоол юу иддэг вэ?",
    "mingl.posts.2.content": "Өнөөдөр сонголт хийхэд хэцүү байна. Гасан өртөө орчмын оффисынхон юу иддэг вэ?",

    "mingl.posts.3.category": "Хобби/Уулзалт",
    "mingl.posts.3.title": "Гасан өртөө — ширээний тоглоомын уулзалтанд хүн хайж байна",
    "mingl.posts.3.content": "Баасан бүрийн орой Гасан орчимд тоглоомын уулзалт хийдэг. Нэгдээрэй!",

    "mingl.posts.4.category": "Аялал/Зугаалга",
    "mingl.posts.4.title": "Хоамсан тойргийн зам — амралтын өдрийн алхалт",
    "mingl.posts.4.content": "Хялбар алхах маршрут хайгаад энэ тойргийг оллоо. Тайван алхахад тохиромжтой зам санал болгоё.",

    "mingl.posts.5.category": "Өдөр тутам",
    "mingl.posts.5.title": "Доксандон орчимд чимээ багатай кафе?",
    "mingl.posts.5.content": "Тайван ажиллах кафе хайж байна. Wi-Fi сайн, залгууртай газар санал болгоорой.",

    "mingl.posts.6.category": "Амьдрал",
    "mingl.posts.6.title": "Гасан орчимд фитнес санал болгооч",
    "mingl.posts.6.content": "Гасандижитал орчимд явдаг хүн байна уу? Төлбөр боломжийн, тоноглол сайтай газар хайж байна.",

    "mingl.posts.7.category": "Хобби/Уулзалт",
    "mingl.posts.7.title": "Гванаксан аялалд хамт явах хүн募",
    "mingl.posts.7.content": "Энэ амралтаар явна. Анхан шатныхан ч тавтай, зүгээр л алхацгаая.",

    "connect.titles.0": "Хэлсол",      // 6글자 내: 'Хэл солилцоо'를 축약
    "connect.titles.1": "Дасан",       // 6글자 내: 생활적응 → 'Дасан'
    "connect.titles.2": "Хуучин",      // 6글자 내: 중고거래 → 'Хуучин'
    "connect.titles.3": "Ажил",        // 6글자 내: 구인·구직 → 'Ажил'
    "connect.titles.3.category": "Цагийн", // 6글자 내: 아르바이트 → 'Цагийн'

    "connect.posts.0.title": "Солонгос-япон бизнес яриа — хэл солилцох хүн хайж байна!",
    "connect.posts.0.reward": "Япон хэл",
    "connect.posts.0.reward_detail": "Цагаар тохиролцоно",
    "connect.posts.0.location": "Сонбук-дон кафе",

    "connect.posts.1.title": "Испани хэлтэй хүн байна уу? Ярилцах дадлагад туслаач~",
    "connect.posts.1.reward": "Бэлгийн карт",
    "connect.posts.1.reward_detail": "50,000원 / удаа",
    "connect.posts.1.location": "Гымчонгу청 өртөө",

    "connect.posts.2.title": "Инчеон нисэхээс Сөүл-Мапо хүртэл метроор чиг заагаад өгнө үү",
    "connect.posts.2.reward": "Бараа",
    "connect.posts.2.reward_detail": "Испани дарс",
    "connect.posts.2.location": "Инчеон нисэх буудал",

    "connect.posts.3.title": "1 өрөө гэрээ хийхэд хамт явж туслах хүн байна уу?",
    "connect.posts.3.reward": "Бэлэн",
    "connect.posts.3.reward_detail": "10,000원 / цаг",
    "connect.posts.3.location": "Сөүл Ёндынпог-Янчон өртөө",

    "connect.posts.4.title": "Monkey Driver-ийг нэг өдөр түрээслүүлээч! Гар хийцийн какдүгиар дайлна",
    "connect.posts.4.reward": "Бараа",
    "connect.posts.4.reward_detail": "Гэрийн какдүги",
    "connect.posts.4.location": "Мапо-гу Согё-дон",

    "connect.posts.5.title": "Дугуй зарна! Бараг шинээрээ",
    "connect.posts.5.reward": "Үнэ",
    "connect.posts.5.reward_detail": "50,000원",
    "connect.posts.5.location": "Шинчон өртөө орчим",

    "connect.posts.6.title": "Выставкын богино хугацааны ажилтан — Англитай байвал давуу",
    "connect.posts.6.reward": "Ажил",
    "connect.posts.6.reward_detail": "Талбайн дэмжлэг, англи 안내",
    "connect.posts.6.location": "COEX",

    "connect.posts.7.title": "Испани хэлтэй бариста авна (уур амьсгалтай гадаад хүн давуу)",
    "connect.posts.7.reward": "Цагийн",
    "connect.posts.7.reward_detail": "10,000원-с",
    "connect.posts.7.location": "Итэвон кафе",

    "passport.introduction": "Монголд К-шоу үзэж байхдаа өөрөө солонгос хэл сурсан. Мексик дэх солонгос хэлний уралдаанд 1-р байр эзэлснээс хойш Солонгос явахаар шийдсэн!",
    "passport.gender": "Хүйс",
    "passport.gender_detail": "Эр",
    "passport.birth": "Төрсөн огноо",
    "passport.birth_detail": "1994.04.24",
    "passport.nationality": "Иргэншил",
    "passport.nationality_detail": "Mexico",
    "passport.mother_tongue": "Эхийн хэл",
    "passport.mother_tongue_detail": "Spanish",
    "passport.language": "Гадаад хэл",
    "passport.language_detail.0": "Korean",
    "passport.language_detail.1": "English",
    "passport.edit": "Засах",
    "passport.share": "Хуваалцах",

    // Positioned Mobile Demo Section (mn)
    "positionedMobileDemo.home.description": "“Хөршийн мэдээ” шиг — ойр орчиндоо юу болж байгааг нэг дороос хараарай",
    "positionedMobileDemo.home.features.0.description": "Орон нутгийн мэдээ, арга хэмжээг шууд цагт нь алдалгүй мэд",
    "positionedMobileDemo.home.features.1.description": "Тухайн газрын оршин суугчдын өдөр тутмын түүх, яриаг судал",
    "positionedMobileDemo.home.features.2.description": "Баяр наадам, уулзалт, жижиг том бүх үйл ажиллагаанд хялбархан нэгд",

    "positionedMobileDemo.mingl.description": "Байршилд суурилан жинхэнэ дүүргийн амьдралыг олж нээж, хуваалцаарай",
    "positionedMobileDemo.mingl.features.0.description": "Асуулт, мэдээлэл, мэдээ, санал зөвлөгөөг чөлөөтэй хуваалц — байгалийн мэт харилцаа",
    "positionedMobileDemo.mingl.features.1.description": "Бодит цагийн орчуулгаар хэлний саадгүй дэлхийн харилцаа",
    "positionedMobileDemo.mingl.features.2.description": "Дэлхийг орон нутгийн нүдээр, орон нутгийг дэлхийн нүдээр хар",

    "positionedMobileDemo.connect.description": "Бие биедээ туслах мөчөөс холбоо эхэлдэг",
    "positionedMobileDemo.connect.features.0.description": "Байршилд үндэслэсэн холболтоор хэрэгтэй тусламжийг шууд олж ав",
    "positionedMobileDemo.connect.features.1.description": "“Найдвартай, аюулгүй” хүнийг өөрөө сонго",
    "positionedMobileDemo.connect.features.2.description": "Яриа → солилцоо → удаан үргэлжлэх орон нутгийн ба дэлхийн харилцаа",

    "positionedMobileDemo.talk.description": "AI орчуулгаар хэлний бэрхшээлгүйгээр дэлхийн найзуудтай танилцаарай",
    "positionedMobileDemo.talk.features.0.description": "Хэлний түвшнээс үл хамааран бодит цагийн орчуулгаар байгалийн яриа",
    "positionedMobileDemo.talk.features.1.description": "Солонгост амьдрах тухайг орон нутгийн хүнээс шууд асуугаад шууд хариу ав",
    "positionedMobileDemo.talk.features.2.description": "Connect-оос эхэлсэн холбоог удаан үргэлжлэх найрамдал болго",

    "positionedMobileDemo.passport.description": "Дэлхийн туршлагаа илэрхийлсэн дижитал нэрийн хуудас бүтээ",
    "positionedMobileDemo.passport.features.0.description": "Бүсчилсэн оршин суусан болон үйл ажиллагааны түүхийг цагийн дарааллаар тэмдэглэ",
    "positionedMobileDemo.passport.features.1.description": "Хэлний чадвар, харилцааны хэв маягаа тодорхой илэрхийл",
    "positionedMobileDemo.passport.features.2.description": "Ижил төстэй туршлагатай хүмүүстэй байгалийн жамаар холбогд",


    // Logl Video Section
    "loglVideo.title": "logl танилцуулга видео",
    "loglVideo.description": "logl гэж юу вэ? Эхлээд видеог үзээрэй!",
    "loglVideo.watch": "Видеог үзэх"
    
    }
  }
};

// Language detection configuration
const detectionOptions = {
  // Detection priority: navigator (브라우저 언어) 우선, 그 다음 저장된 설정
  // 첫 방문자는 navigator가 우선 적용되도록 설정
  order: ['querystring', 'navigator', 'htmlTag', 'sessionStorage', 'localStorage', 'cookie', 'path', 'subdomain'],
  
  // Cache user language (per-frame, no cross-frame sync)
  // 단, navigator는 캐시하지 않아서 항상 최신 브라우저 언어를 확인
  caches: ['sessionStorage', 'localStorage'],
  
  // Don't cache the language detection
  excludeCacheFor: ['cimode'],
  
  // Lookup options
  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupSessionStorage: 'i18nextLng',
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,
  
  // Optional conversion map (supports full country code like ko-KR to ko)
  convertDetectedLanguage: (lng) => {
    if (!lng) return 'en';
    
    // Convert country-specific codes to base language codes
    const languageMap = {
      'ko-KR': 'ko','ko-KP': 'ko','ja-JP': 'ja','en-US': 'en','en-GB': 'en','en-CA': 'en','en-AU': 'en',
      'fr-FR': 'fr','fr-CA': 'fr','th-TH': 'th','ar-SA': 'ar','ar-AE': 'ar','ru-RU': 'ru','zh-CN': 'zh','zh-TW': 'zh-TW',
      'pt-PT': 'pt','pt-BR': 'pt','hi-IN': 'hi','id-ID': 'id','my-MM': 'my','tl-PH': 'tl','sw-KE': 'sw','sw-TZ': 'sw'
    };
    
    return languageMap?.[lng] || lng?.split('-')?.[0] || 'en';
  }
};

// Initialize i18next
// Pass the i18n instance to react-i18next.
// Load language detection plugin
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: detectionOptions,
    fallbackLng: 'en',
    ns: ['translation'],
    defaultNS: 'translation',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
 